import { computed, openBlock, createElementBlock, createElementVNode, normalizeClass, unref, Fragment, renderList, toDisplayString as toDisplayString$1, createCommentVNode, defineComponent, h, getCurrentInstance, inject, onMounted, onUnmounted, watch, ref, shallowRef, createVNode, Text, createTextVNode, normalizeStyle, withDirectives, vModelText, createBlock, Transition, withCtx, resolveDynamicComponent, onBeforeUnmount, nextTick, resolveComponent, vModelSelect, vShow, withModifiers, vModelCheckbox, toRaw, onUpdated, onBeforeMount, reactive, withKeys, mergeProps, createApp, Teleport, renderSlot } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { c as useAlertStore, y as joinProducts, k as db, E as registerMercureEvent, u as useSessionStore, b as useConfigStore, a as useAuthStore, p as parameter, v as logger, o as formkitExtension, e as useProdselStore, I as generateShortUUID, A as addressSchema, q as glob, O as getFolderSvgFallback, n as apiResponse, h as ppapiClient, g as globalize, t as registerPpShopEvent, j as uploadModal, D as DROPZONE_UPLOAD_EVENT, m as mediaModal } from './prodsel.store-B-MQAyQE.mjs';
import { storeToRefs } from 'pinia';
import { p as psModal, v as getMediaDocumentErrors, n as getFlagEmoji, j as acceptArray, a as getSelectedProductOptions, q as quantityPrice, g as getSelectedOptionPrices, u as detectMobileContext, i as imgsource, m as mediasource, h as fetchTemplate, b as getBase64FromUrl, s as svgToDataUrl, f as fitin, d as color2hex, k as debounce, r as createOrderMediaPreview, t as createOrderPurchasePreview, o as pageLoaderIcon, x as xhrGet } from './mediaDocumentChecks-8KYeaHAT.mjs';
import { k as previewResourceSizes, e as productSelectorUploadMenu, p as preFilterDef, f as filterDef, m as mediaSelector, r as resolutionConfirmation, s as specialPriceDisplay, i as galleryFolderActions, d as previewMaps, u as userOrderDetailsItemParameterDisplay } from './pp-product-config-DylFCRxi.mjs';
import { MerkleJson } from 'merkle-json';
import { _ } from 'lodash';
import { A as AutoQueue, C as CheckMediaCondition, P as ProductSelector, a as MediaManager, O as OrderManager } from './AutoQueue-Cbuqf1LW.mjs';
import { liveQuery } from 'dexie';
import { useObservable } from '@vueuse/rxjs';
import { FormKitSchema } from '@formkit/vue';
import { r as requiresResolutionConfirmation, n as needsFormatAdjustment, g as getWorstResolutionLevel, a as getResolutionWarnings, b as getFitinResource } from './imageResolution-BoTJnVec.mjs';
import { Array as Array$1, SVG } from '@svgdotjs/svg.js';
import { Form, Field } from 'vee-validate';
import { Dashboard } from '@uppy/vue';
import Uppy from '@uppy/core';
import Webcam from '@uppy/webcam';
import XHR from '@uppy/xhr-upload';
import German from '@uppy/locales/lib/de_DE.js';
import English from '@uppy/locales/lib/en_US.js';
import uniqueId from 'lodash/uniqueId';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/webcam/dist/style.css';
import { Collapse } from 'vue-collapsed';
import { c as createCdnConfig } from './cdnConfig-BEsWrmsJ.mjs';
import '@svgdotjs/svg.draggable.js';
import 'path-data-polyfill';
import * as ImageTracer from 'imagetracerjs';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { useLoading } from 'vue-loading-overlay';
import { isObject as isObject$2, useMouse, useMousePressed, onClickOutside, useEventListener } from '@vueuse/core';
import { Quill } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, EffectCoverflow, EffectCards } from 'swiper/modules';
import { vTooltip, Dropdown } from 'floating-vue';
import 'floating-vue/dist/style.css';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';
import { r as registerDeveloperProductSelector } from './developerConsoleState-B9_P2zPY.mjs';

const _hoisted_1$G = { key: 0 };
const _hoisted_2$A = { class: "uk-text-bold" };


var script$M = {
  __name: 'Alert',
  props: {
    // Kanal, unter dem alertStore.success()/.error() aufgerufen wurde. Erlaubt mehrere
    // unabhängige Alert-Instanzen (z.B. global + inline in einem Formular).
    scope: {
        type: String,
        default: 'global'
    }
},
  setup(__props) {

const props = __props;

const alertStore = useAlertStore();
const alert = computed(() => alertStore.alertsByScope[props.scope] || null);

const errorCodeDynamicTranslations = {
    plabCountryMissing: [/^Cannot resolve plab_id for country (.+)\.$/, ['countryCode']],
    plabCountryFilialMissing: [/^Cannot resolve plab_id after filial filter for country (.+)\.$/, ['countryCode']],
    plabPidCountryMissing: [/^Cannot resolve plab_id for pid (.+) and country (.+)\.$/, ['pid', 'countryCode']],
    plabWeightedCountryMissing: [/^Cannot resolve weighted plab selection for country (.+)\.$/, ['countryCode']]
};

const dynamicTranslations = [
    [/^Invalid credentials\.$/, 'apiErrors.invalidCredentials'],
    [/^Invalid JSON body: (.+)$/, 'apiErrors.invalidJsonDetail', 'detail'],
    [/^set (.+) is not allowed by configuration$/, 'apiErrors.fieldNotAllowed', 'field'],
    [/^Key @update missing for (Folder|Image)MultiUpdate$/, 'apiErrors.multiUpdateKeyMissing', 'resource'],
    [/^Key path missing for id entry in (Folder|Image)MultiUpdate$/, 'apiErrors.multiUpdatePathMissing', 'resource'],
    [/^Source returned HTTP (\d+).$/, 'apiErrors.sourceHttp', 'statusCode'],
    [/^Cannot resolve plab_id for country (.+).$/, 'apiErrors.plabCountryMissing', 'countryCode'],
    [/^Cannot resolve plab_id after filial filter for country (.+).$/, 'apiErrors.plabCountryFilialMissing', 'countryCode'],
    [/^Cannot resolve plab_id for pid (.+) and country (.+).$/, 'apiErrors.plabPidCountryMissing', ['pid', 'countryCode']],
    [/^Cannot resolve weighted plab selection for country (.+).$/, 'apiErrors.plabWeightedCountryMissing', 'countryCode']
];

function normalizeMessage(message) {
    if (message instanceof Error) {
        return { message: message.message, errorCode: message.errorCode };
    }
    if (message === null || message === undefined) return '';
    if (typeof message === 'string' || typeof message === 'number') return String(message);
    if (typeof message === 'object') {
        return {
            message: message.message || message.error || String(message),
            errorCode: message.errorCode
        };
    }
    return String(message);
}

function translateMessage(message) {
    if (message && typeof message === 'object' && message.errorCode) {
        const code = message.errorCode;
        const dynamicTranslation = errorCodeDynamicTranslations[message.errorCode];
        if (dynamicTranslation) {
            const [pattern, parameterNames] = dynamicTranslation;
            const match = message.message?.match(pattern);
            if (match) {
                const params = Object.fromEntries(
                    parameterNames.map((name, index) => [name, match[index + 1]])
                );
                return { key: `apiErrors.${code}`, params, fallback: message.message };
            }
        }
        return { key: `apiErrors.${code}`, fallback: message.message };
    }

    const text = typeof message === 'object' ? message.message : message;
    for (const [pattern, key, parameterNames] of dynamicTranslations) {
        const match = text.match(pattern);
        if (!match) continue;
        if (!parameterNames) return { key };

        const names = Array.isArray(parameterNames) ? parameterNames : [parameterNames];
        const params = Object.fromEntries(names.map((name, index) => [name, match[index + 1]]));
        return { key, params };
    }

    return { key: text };
}

const alertMessages = computed(() => {
    const message = alert.value?.message;
    const messages = Array.isArray(message)
        ? message.map(normalizeMessage).filter(Boolean)
        : [normalizeMessage(message)].filter(Boolean);
    return messages.map(translateMessage);
});

return (_ctx, _cache) => {
  return (alert.value)
    ? (openBlock(), createElementBlock("div", _hoisted_1$G, [
        createElementVNode("div", _hoisted_2$A, [
          createElementVNode("div", {
            class: normalizeClass(["uk-alert", alert.value.type])
          }, [
            createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = $event => (unref(alertStore).clear(__props.scope))),
              class: "uk-alert-close"
            }, "×"),
            (openBlock(true), createElementBlock(Fragment, null, renderList(alertMessages.value, (message, i) => {
              return (openBlock(), createElementBlock("div", { key: i }, toDisplayString$1(_ctx.$te(message.key) ? _ctx.$t(message.key, message.params) : (message.fallback || message.key)), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ])
      ]))
    : createCommentVNode("v-if", true)
}
}

};

script$M.__file = "src/components/Alert.vue";

/*!
  * shared v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */
const inBrowser$1 = typeof window !== 'undefined';
if ((process.env.NODE_ENV !== 'production')) ;
const RE_ARGS$1 = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */
function format$2(message, ...args) {
    if (args.length === 1 && isObject$1(args[0])) {
        args = args[0];
    }
    if (!args || !args.hasOwnProperty) {
        args = {};
    }
    return message.replace(RE_ARGS$1, (match, identifier) => {
        return args.hasOwnProperty(identifier) ? args[identifier] : '';
    });
}
const makeSymbol = (name, shareable = false) => !shareable ? Symbol(name) : Symbol.for(name);
const isNumber$1 = (val) => typeof val === 'number' && isFinite(val);
const isRegExp$1 = (val) => toTypeString$1(val) === '[object RegExp]';
const isEmptyObject$1 = (val) => isPlainObject$1(val) && Object.keys(val).length === 0;
const assign$1 = Object.assign;
const _create$1 = Object.create;
const create$1 = (obj = null) => _create$1(obj);
let _globalThis$1;
const getGlobalThis$1 = () => {
    // prettier-ignore
    return (_globalThis$1 ||
        (_globalThis$1 =
            typeof globalThis !== 'undefined'
                ? globalThis
                : typeof self !== 'undefined'
                    ? self
                    : typeof window !== 'undefined'
                        ? window
                        : typeof global !== 'undefined'
                            ? global
                            : create$1()));
};
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function hasOwn$1(obj, key) {
    return hasOwnProperty$1.call(obj, key);
}
/* eslint-enable */
/**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */
const isArray$1 = Array.isArray;
const isFunction$1 = (val) => typeof val === 'function';
const isString$1 = (val) => typeof val === 'string';
const isBoolean$1 = (val) => typeof val === 'boolean';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isObject$1 = (val) => val !== null && typeof val === 'object';
const objectToString$1 = Object.prototype.toString;
const toTypeString$1 = (value) => objectToString$1.call(value);
const isPlainObject$1 = (val) => toTypeString$1(val) === '[object Object]';

function warn$1(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */
        if (err) {
            console.warn(err.stack);
        }
    }
}

/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */
/**
 * Create a event emitter
 *
 * @returns An event emitter
 */
function createEmitter() {
    const events = new Map();
    const emitter = {
        events,
        on(event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) {
                events.set(event, [handler]);
            }
        },
        off(event, handler) {
            const handlers = events.get(event);
            if (handlers) {
                handlers.splice(handlers.indexOf(handler) >>> 0, 1);
            }
        },
        emit(event, payload) {
            (events.get(event) || [])
                .slice()
                .map(handler => handler(payload));
            (events.get('*') || [])
                .slice()
                .map(handler => handler(event, payload));
        }
    };
    return emitter;
}

const isNotObjectOrIsArray = (val) => !isObject$1(val) || isArray$1(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function deepCopy(src, des) {
    // src and des should both be objects, and none of them can be a array
    if (isNotObjectOrIsArray(src) || isNotObjectOrIsArray(des)) {
        throw new Error('Invalid value');
    }
    const stack = [{ src, des }];
    while (stack.length) {
        const { src, des } = stack.pop();
        // using `Object.keys` which skips prototype properties
        Object.keys(src).forEach(key => {
            if (key === '__proto__') {
                return;
            }
            // if src[key] is an object/array, set des[key]
            // to empty object/array to prevent setting by reference
            if (isObject$1(src[key]) && !isObject$1(des[key])) {
                des[key] = Array.isArray(src[key]) ? [] : create$1();
            }
            if (isNotObjectOrIsArray(des[key]) || isNotObjectOrIsArray(src[key])) {
                // replace with src[key] when:
                // src[key] or des[key] is not an object, or
                // src[key] or des[key] is an array
                des[key] = src[key];
            }
            else {
                // src[key] and des[key] are both objects, merge them
                stack.push({ src: src[key], des: des[key] });
            }
        });
    }
}

/*!
  * shared v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */
const inBrowser = typeof window !== 'undefined';
let mark;
let measure;
if ((process.env.NODE_ENV !== 'production')) {
    const perf = inBrowser && window.performance;
    if (perf &&
        perf.mark &&
        perf.measure &&
        perf.clearMarks &&
        // @ts-ignore browser compat
        perf.clearMeasures) {
        mark = (tag) => {
            perf.mark(tag);
        };
        measure = (name, startTag, endTag) => {
            perf.measure(name, startTag, endTag);
            perf.clearMarks(startTag);
            perf.clearMarks(endTag);
        };
    }
}
const RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */
function format$1(message, ...args) {
    if (args.length === 1 && isObject(args[0])) {
        args = args[0];
    }
    if (!args || !args.hasOwnProperty) {
        args = {};
    }
    return message.replace(RE_ARGS, (match, identifier) => {
        return args.hasOwnProperty(identifier) ? args[identifier] : '';
    });
}
const generateFormatCacheKey = (locale, key, source) => friendlyJSONstringify({ l: locale, k: key, s: source });
const friendlyJSONstringify = (json) => JSON.stringify(json)
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
    .replace(/\u0027/g, '\\u0027');
const isNumber = (val) => typeof val === 'number' && isFinite(val);
const isDate = (val) => toTypeString(val) === '[object Date]';
const isRegExp = (val) => toTypeString(val) === '[object RegExp]';
const isEmptyObject = (val) => isPlainObject(val) && Object.keys(val).length === 0;
const assign = Object.assign;
const _create = Object.create;
const create = (obj = null) => _create(obj);
let _globalThis;
const getGlobalThis = () => {
    // prettier-ignore
    return (_globalThis ||
        (_globalThis =
            typeof globalThis !== 'undefined'
                ? globalThis
                : typeof self !== 'undefined'
                    ? self
                    : typeof window !== 'undefined'
                        ? window
                        : typeof global !== 'undefined'
                            ? global
                            : create()));
};
function escapeHtml(rawText) {
    return rawText
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
const hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/* eslint-enable */
/**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */
const isArray = Array.isArray;
const isFunction = (val) => typeof val === 'function';
const isString = (val) => typeof val === 'string';
const isBoolean = (val) => typeof val === 'boolean';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isObject = (val) => val !== null && typeof val === 'object';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isPromise = (val) => {
    return isObject(val) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const isPlainObject = (val) => toTypeString(val) === '[object Object]';
// for converting list and named values to displayed strings.
const toDisplayString = (val) => {
    return val == null
        ? ''
        : isArray(val) || (isPlainObject(val) && val.toString === objectToString)
            ? JSON.stringify(val, null, 2)
            : String(val);
};
function join(items, separator = '') {
    return items.reduce((str, item, index) => (index === 0 ? str + item : str + separator + item), '');
}
const RANGE = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for (let i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (let j = i - RANGE; j <= i + RANGE || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                }
                else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}

function warn(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */
        if (err) {
            console.warn(err.stack);
        }
    }
}
const hasWarned = {};
function warnOnce(msg) {
    if (!hasWarned[msg]) {
        hasWarned[msg] = true;
        warn(msg);
    }
}

/*!
  * message-compiler v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function createPosition(line, column, offset) {
    return { line, column, offset };
}
function createLocation(start, end, source) {
    const loc = { start, end };
    if (source != null) {
        loc.source = source;
    }
    return loc;
}

const CompileErrorCodes = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16
};
// Special value for higher-order compilers to pick up the last code
// to avoid collision of error codes.
// This should always be kept as the last item.
const COMPILE_ERROR_CODES_EXTEND_POINT = 17;
/** @internal */
const errorMessages$2 = {
    // tokenizer error messages
    [CompileErrorCodes.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [CompileErrorCodes.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [CompileErrorCodes.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function createCompileError(code, loc, options = {}) {
    const { domain, messages, args } = options;
    const msg = (process.env.NODE_ENV !== 'production')
        ? format$1((messages || errorMessages$2)[code] || '', ...(args || []))
        : code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) {
        error.location = loc;
    }
    error.domain = domain;
    return error;
}
/** @internal */
function defaultOnError(error) {
    throw error;
}

// eslint-disable-next-line no-useless-escape
const RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const detectHtmlTag = (source) => RE_HTML_TAG.test(source);

const CHAR_SP = ' ';
const CHAR_CR = '\r';
const CHAR_LF = '\n';
const CHAR_LS = String.fromCharCode(0x2028);
const CHAR_PS = String.fromCharCode(0x2029);
function createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index) => _buf[index] === CHAR_CR && _buf[index + 1] === CHAR_LF;
    const isLF = (index) => _buf[index] === CHAR_LF;
    const isPS = (index) => _buf[index] === CHAR_PS;
    const isLS = (index) => _buf[index] === CHAR_LS;
    const isLineEnd = (index) => isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = () => _index;
    const line = () => _line;
    const column = () => _column;
    const peekOffset = () => _peekOffset;
    const charAt = (offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? CHAR_LF : _buf[offset];
    const currentChar = () => charAt(_index);
    const currentPeek = () => charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) {
            _index++;
        }
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) {
            _peekOffset++;
        }
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        while (target !== _index) {
            next();
        }
        _peekOffset = 0;
    }
    return {
        index,
        line,
        column,
        peekOffset,
        charAt,
        currentChar,
        currentPeek,
        next,
        peek,
        reset,
        resetPeek,
        skipToPeek
    };
}

const EOF = undefined;
const DOT = '.';
const LITERAL_DELIMITER = "'";
const ERROR_DOMAIN$3 = 'tokenizer';
function createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = createScanner(source);
    const currentOffset = () => _scnr.index();
    const currentPosition = () => createPosition(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 13 /* TokenTypes.EOF */,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 13 /* TokenTypes.EOF */,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ''
    };
    const context = () => _context;
    const { onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? createLocation(ctx.startLoc, pos) : null;
            const err = createCompileError(code, loc, {
                domain: ERROR_DOMAIN$3,
                args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = { type };
        if (location) {
            token.loc = createLocation(context.startLoc, context.endLoc);
        }
        if (value != null) {
            token.value = value;
        }
        return token;
    }
    const getEndToken = (context) => getToken(context, 13 /* TokenTypes.EOF */);
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        }
        else {
            emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return '';
        }
    }
    function peekSpaces(scnr) {
        let buf = '';
        while (scnr.currentPeek() === CHAR_SP || scnr.currentPeek() === CHAR_LF) {
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            cc === 95 // _
        );
    }
    function isNumberStart(ch) {
        if (ch === EOF) {
            return false;
        }
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === '-' ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 7 /* TokenTypes.LinkedAlias */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedDot */) {
            return false;
        }
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType } = context;
        if (!(currentType === 7 /* TokenTypes.LinkedAlias */ ||
            currentType === 11 /* TokenTypes.LinkedModifier */)) {
            return false;
        }
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDelimiter */) {
            return false;
        }
        const fn = () => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */) {
                return isIdentifierStart(scnr.peek());
            }
            else if (ch === "@" /* TokenChars.LinkedAlias */ ||
                ch === "|" /* TokenChars.Pipe */ ||
                ch === ":" /* TokenChars.LinkedDelimiter */ ||
                ch === "." /* TokenChars.LinkedDot */ ||
                ch === CHAR_SP ||
                !ch) {
                return false;
            }
            else if (ch === CHAR_LF) {
                scnr.peek();
                return fn();
            }
            else {
                // other characters
                return isTextStart(scnr, false);
            }
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */;
        scnr.resetPeek();
        return ret;
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = '') => {
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */) {
                return hasSpace;
            }
            else if (ch === "@" /* TokenChars.LinkedAlias */ || !ch) {
                return hasSpace;
            }
            else if (ch === "|" /* TokenChars.Pipe */) {
                return !(prev === CHAR_SP || prev === CHAR_LF);
            }
            else if (ch === CHAR_SP) {
                scnr.peek();
                return fn(true, CHAR_SP);
            }
            else if (ch === CHAR_LF) {
                scnr.peek();
                return fn(true, CHAR_LF);
            }
            else {
                return true;
            }
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === EOF) {
            return EOF;
        }
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            (cc >= 48 && cc <= 57) || // 0-9
            cc === 95 || // _
            cc === 36 // $
        );
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return ((cc >= 97 && cc <= 122) || // a-z
            (cc >= 65 && cc <= 90) || // A-Z
            (cc >= 48 && cc <= 57) || // 0-9
            cc === 95 || // _
            cc === 36 || // $
            cc === 45 // -
        );
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return ((cc >= 48 && cc <= 57) || // 0-9
            (cc >= 65 && cc <= 70) || // A-F
            (cc >= 97 && cc <= 102)); // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = '';
        let num = '';
        while ((ch = takeDigit(scnr))) {
            num += ch;
        }
        return num;
    }
    function readText(scnr) {
        let buf = '';
        while (true) {
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */ ||
                ch === "}" /* TokenChars.BraceRight */ ||
                ch === "@" /* TokenChars.LinkedAlias */ ||
                ch === "|" /* TokenChars.Pipe */ ||
                !ch) {
                break;
            }
            else if (ch === CHAR_SP || ch === CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                }
                else if (isPluralStart(scnr)) {
                    break;
                }
                else {
                    buf += ch;
                    scnr.next();
                }
            }
            else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let name = '';
        while ((ch = takeNamedIdentifierChar(scnr))) {
            name += ch;
        }
        if (scnr.currentChar() === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = '';
        if (scnr.currentChar() === '-') {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        }
        else {
            value += getDigits(scnr);
        }
        if (scnr.currentChar() === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        return value;
    }
    function isLiteral(ch) {
        return ch !== LITERAL_DELIMITER && ch !== CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = '';
        let literal = '';
        while ((ch = takeChar(scnr, isLiteral))) {
            if (ch === '\\') {
                literal += readEscapeSequence(scnr);
            }
            else {
                literal += ch;
            }
        }
        const current = scnr.currentChar();
        if (current === CHAR_LF || current === EOF) {
            emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch (ch) {
            case '\\':
            case `\'`: // eslint-disable-line no-useless-escape
                scnr.next();
                return `\\${ch}`;
            case 'u':
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case 'U':
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return '';
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = '';
        for (let i = 0; i < digits; i++) {
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return (ch !== "{" /* TokenChars.BraceLeft */ &&
            ch !== "}" /* TokenChars.BraceRight */ &&
            ch !== CHAR_SP &&
            ch !== CHAR_LF);
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let identifiers = '';
        while ((ch = takeChar(scnr, isInvalidIdentifier))) {
            identifiers += ch;
        }
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = '';
        let name = '';
        while ((ch = takeIdentifierChar(scnr))) {
            name += ch;
        }
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf) => {
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */ ||
                ch === "@" /* TokenChars.LinkedAlias */ ||
                ch === "|" /* TokenChars.Pipe */ ||
                ch === "(" /* TokenChars.ParenLeft */ ||
                ch === ")" /* TokenChars.ParenRight */ ||
                !ch) {
                return buf;
            }
            else if (ch === CHAR_SP) {
                return buf;
            }
            else if (ch === CHAR_LF || ch === DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
            else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn('');
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */);
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* TokenChars.BraceLeft */:
                if (context.braceNest >= 1) {
                    emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */, "{" /* TokenChars.BraceLeft */);
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */:
                if (context.braceNest > 0 &&
                    context.currentType === 2 /* TokenTypes.BraceLeft */) {
                    emitError(CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0);
                }
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */, "}" /* TokenChars.BraceRight */);
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) {
                    context.inLinked = false;
                }
                return token;
            case "@" /* TokenChars.LinkedAlias */:
                if (context.braceNest > 0) {
                    emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                }
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default: {
                let validNamedIdentifier = true;
                let validListIdentifier = true;
                let validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) {
                        emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    }
                    token = getToken(context, 1 /* TokenTypes.Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 &&
                    (context.currentType === 4 /* TokenTypes.Named */ ||
                        context.currentType === 5 /* TokenTypes.List */ ||
                        context.currentType === 6 /* TokenTypes.Literal */)) {
                    emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if ((validNamedIdentifier = isNamedIdentifierStart(scnr, context))) {
                    token = getToken(context, 4 /* TokenTypes.Named */, readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validListIdentifier = isListIdentifierStart(scnr, context))) {
                    token = getToken(context, 5 /* TokenTypes.List */, readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if ((validLiteral = isLiteralStart(scnr, context))) {
                    token = getToken(context, 6 /* TokenTypes.Literal */, readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 12 /* TokenTypes.InvalidPlace */, readInvalidIdentifier(scnr));
                    emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
            }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 7 /* TokenTypes.LinkedAlias */ ||
            currentType === 8 /* TokenTypes.LinkedDot */ ||
            currentType === 11 /* TokenTypes.LinkedModifier */ ||
            currentType === 9 /* TokenTypes.LinkedDelimiter */) &&
            (ch === CHAR_LF || ch === CHAR_SP)) {
            emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
        }
        switch (ch) {
            case "@" /* TokenChars.LinkedAlias */:
                scnr.next();
                token = getToken(context, 7 /* TokenTypes.LinkedAlias */, "@" /* TokenChars.LinkedAlias */);
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 8 /* TokenTypes.LinkedDot */, "." /* TokenChars.LinkedDot */);
            case ":" /* TokenChars.LinkedDelimiter */:
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDelimiter */, ":" /* TokenChars.LinkedDelimiter */);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) ||
                    isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 11 /* TokenTypes.LinkedModifier */, readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */) {
                        // scan the placeholder
                        return readTokenInPlaceholder(scnr, context) || token;
                    }
                    else {
                        return getToken(context, 10 /* TokenTypes.LinkedKey */, readLinkedRefer(scnr));
                    }
                }
                if (currentType === 7 /* TokenTypes.LinkedAlias */) {
                    emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
                }
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = { type: 13 /* TokenTypes.EOF */ };
        if (context.braceNest > 0) {
            return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        }
        if (context.inLinked) {
            return readTokenInLinked(scnr, context) || getEndToken(context);
        }
        const ch = scnr.currentChar();
        switch (ch) {
            case "{" /* TokenChars.BraceLeft */:
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */:
                emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */, "}" /* TokenChars.BraceRight */);
            case "@" /* TokenChars.LinkedAlias */:
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default: {
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */, readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isTextStart(scnr)) {
                    return getToken(context, 0 /* TokenTypes.Text */, readText(scnr));
                }
                break;
            }
        }
        return token;
    }
    function nextToken() {
        const { currentType, offset, startLoc, endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === EOF) {
            return getToken(_context, 13 /* TokenTypes.EOF */);
        }
        return readToken(_scnr, _context);
    }
    return {
        nextToken,
        currentOffset,
        currentPosition,
        context
    };
}

const ERROR_DOMAIN$2 = 'parser';
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(match, codePoint4, codePoint6) {
    switch (match) {
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default: {
            const codePoint = parseInt(codePoint4 || codePoint6, 16);
            if (codePoint <= 0xd7ff || codePoint >= 0xe000) {
                return String.fromCodePoint(codePoint);
            }
            // invalid ...
            // Replace them with U+FFFD REPLACEMENT CHARACTER.
            return '�';
        }
    }
}
function createParser(options = {}) {
    const location = options.location !== false;
    const { onError } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? createLocation(start, end) : null;
            const err = createCompileError(code, loc, {
                domain: ERROR_DOMAIN$2,
                args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        const node = { type };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = { start: loc, end: loc };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (location) {
            node.end = offset;
            if (node.loc) {
                node.loc.end = pos;
            }
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */, offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */, offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */, offset, loc);
        node.value = value.replace(KNOWN_ESCAPES, fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */, offset, loc);
        if (token.type !== 11 /* TokenTypes.LinkedModifier */) {
            // empty modifier
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = '';
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node
            };
        }
        // check token
        if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        node.value = token.value || '';
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */, context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */, context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 8 /* TokenTypes.LinkedDot */) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 9 /* TokenTypes.LinkedDelimiter */) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */) {
            token = tokenizer.nextToken();
        }
        switch (token.type) {
            case 10 /* TokenTypes.LinkedKey */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseLinkedKey(tokenizer, token.value || '');
                break;
            case 4 /* TokenTypes.Named */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseNamed(tokenizer, token.value || '');
                break;
            case 5 /* TokenTypes.List */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseList(tokenizer, token.value || '');
                break;
            case 6 /* TokenTypes.Literal */:
                if (token.value == null) {
                    emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                }
                linkedNode.key = parseLiteral(tokenizer, token.value || '');
                break;
            default: {
                // empty key
                emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                const nextContext = tokenizer.context();
                const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */, nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = '';
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
            }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */
            ? tokenizer.currentOffset()
            : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */
            ? context.endLoc
            : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */, startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch (token.type) {
                case 0 /* TokenTypes.Text */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseText(tokenizer, token.value || ''));
                    break;
                case 5 /* TokenTypes.List */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseList(tokenizer, token.value || ''));
                    break;
                case 4 /* TokenTypes.Named */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseNamed(tokenizer, token.value || ''));
                    break;
                case 6 /* TokenTypes.Literal */:
                    if (token.value == null) {
                        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
                    }
                    node.items.push(parseLiteral(tokenizer, token.value || ''));
                    break;
                case 7 /* TokenTypes.LinkedAlias */: {
                    const parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
                }
            }
        } while (context.currentType !== 13 /* TokenTypes.EOF */ &&
            context.currentType !== 1 /* TokenTypes.Pipe */);
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */
            ? context.lastOffset
            : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */
            ? context.lastEndLoc
            : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */, offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) {
                hasEmptyMessage = msg.items.length === 0;
            }
            node.cases.push(msg);
        } while (context.currentType !== 13 /* TokenTypes.EOF */);
        if (hasEmptyMessage) {
            emitError(tokenizer, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset, startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 13 /* TokenTypes.EOF */) {
            return msgNode;
        }
        else {
            return parsePlural(tokenizer, offset, startLoc, msgNode);
        }
    }
    function parse(source) {
        const tokenizer = createTokenizer(source, assign({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */, context.offset, context.startLoc);
        if (location && node.loc) {
            node.loc.source = source;
        }
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) {
            node.cacheKey = options.onCacheKey(source);
        }
        // assert whether achieved to EOF
        if (context.currentType !== 13 /* TokenTypes.EOF */) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || '');
        }
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return { parse };
}
function getTokenCaption(token) {
    if (token.type === 13 /* TokenTypes.EOF */) {
        return 'EOF';
    }
    const name = (token.value || '').replace(/\r?\n/gu, '\\n');
    return name.length > 10 ? name.slice(0, 9) + '…' : name;
}

function createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast,
        helpers: new Set()
    };
    const context = () => _context;
    const helper = (name) => {
        _context.helpers.add(name);
        return name;
    };
    return { context, helper };
}
function traverseNodes(nodes, transformer) {
    for (let i = 0; i < nodes.length; i++) {
        traverseNode(nodes[i], transformer);
    }
}
function traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch (node.type) {
        case 1 /* NodeTypes.Plural */:
            traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */);
            break;
        case 2 /* NodeTypes.Message */:
            traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */: {
            const linked = node;
            traverseNode(linked.key, transformer);
            transformer.helper("linked" /* HelperNameMap.LINKED */);
            transformer.helper("type" /* HelperNameMap.TYPE */);
            break;
        }
        case 5 /* NodeTypes.List */:
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */);
            transformer.helper("list" /* HelperNameMap.LIST */);
            break;
        case 4 /* NodeTypes.Named */:
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */);
            transformer.helper("named" /* HelperNameMap.NAMED */);
            break;
    }
    // TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function transform(ast, options = {} // eslint-disable-line
) {
    const transformer = createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */);
    // traverse
    ast.body && traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}

function optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */) {
        optimizeMessageNode(body);
    }
    else {
        body.cases.forEach(c => optimizeMessageNode(c));
    }
    return ast;
}
function optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */ || item.type === 9 /* NodeTypes.Literal */) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    }
    else {
        const values = [];
        for (let i = 0; i < message.items.length; i++) {
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */ || item.type === 9 /* NodeTypes.Literal */)) {
                break;
            }
            if (item.value == null) {
                break;
            }
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = join(values);
            for (let i = 0; i < message.items.length; i++) {
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */ || item.type === 9 /* NodeTypes.Literal */) {
                    delete item.value; // optimization for size
                }
            }
        }
    }
}

const ERROR_DOMAIN$1 = 'minifier';
/* eslint-disable @typescript-eslint/no-explicit-any */
function minify(node) {
    node.t = node.type;
    switch (node.type) {
        case 0 /* NodeTypes.Resource */: {
            const resource = node;
            minify(resource.body);
            resource.b = resource.body;
            delete resource.body;
            break;
        }
        case 1 /* NodeTypes.Plural */: {
            const plural = node;
            const cases = plural.cases;
            for (let i = 0; i < cases.length; i++) {
                minify(cases[i]);
            }
            plural.c = cases;
            delete plural.cases;
            break;
        }
        case 2 /* NodeTypes.Message */: {
            const message = node;
            const items = message.items;
            for (let i = 0; i < items.length; i++) {
                minify(items[i]);
            }
            message.i = items;
            delete message.items;
            if (message.static) {
                message.s = message.static;
                delete message.static;
            }
            break;
        }
        case 3 /* NodeTypes.Text */:
        case 9 /* NodeTypes.Literal */:
        case 8 /* NodeTypes.LinkedModifier */:
        case 7 /* NodeTypes.LinkedKey */: {
            const valueNode = node;
            if (valueNode.value) {
                valueNode.v = valueNode.value;
                delete valueNode.value;
            }
            break;
        }
        case 6 /* NodeTypes.Linked */: {
            const linked = node;
            minify(linked.key);
            linked.k = linked.key;
            delete linked.key;
            if (linked.modifier) {
                minify(linked.modifier);
                linked.m = linked.modifier;
                delete linked.modifier;
            }
            break;
        }
        case 5 /* NodeTypes.List */: {
            const list = node;
            list.i = list.index;
            delete list.index;
            break;
        }
        case 4 /* NodeTypes.Named */: {
            const named = node;
            named.k = named.key;
            delete named.key;
            break;
        }
        default:
            if ((process.env.NODE_ENV !== 'production')) {
                throw createCompileError(CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE, null, {
                    domain: ERROR_DOMAIN$1,
                    args: [node.type]
                });
            }
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const ERROR_DOMAIN = 'parser';
function createCodeGenerator(ast, options) {
    const { sourceMap, filename, breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename,
        code: '',
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) {
        _context.source = ast.loc.source;
    }
    const context = () => _context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : '';
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key) => `_${key}`;
    const needIndent = () => _context.needIndent;
    return {
        context,
        push,
        indent,
        deindent,
        newline,
        helper,
        needIndent
    };
}
function generateLinkedNode(generator, node) {
    const { helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */)}(`);
    generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        generateNode(generator, node.modifier);
        generator.push(`, _type`);
    }
    else {
        generator.push(`, undefined, _type`);
    }
    generator.push(`)`);
}
function generateMessageNode(generator, node) {
    const { helper, needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */)}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for (let i = 0; i < length; i++) {
        generateNode(generator, node.items[i]);
        if (i === length - 1) {
            break;
        }
        generator.push(', ');
    }
    generator.deindent(needIndent());
    generator.push('])');
}
function generatePluralNode(generator, node) {
    const { helper, needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */)}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for (let i = 0; i < length; i++) {
            generateNode(generator, node.cases[i]);
            if (i === length - 1) {
                break;
            }
            generator.push(', ');
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function generateResource(generator, node) {
    if (node.body) {
        generateNode(generator, node.body);
    }
    else {
        generator.push('null');
    }
}
function generateNode(generator, node) {
    const { helper } = generator;
    switch (node.type) {
        case 0 /* NodeTypes.Resource */:
            generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */:
            generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */:
            generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */:
            generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */:
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */)}(${helper("list" /* HelperNameMap.LIST */)}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */:
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */)}(${helper("named" /* HelperNameMap.NAMED */)}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */:
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */:
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
            if ((process.env.NODE_ENV !== 'production')) {
                throw createCompileError(CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE, null, {
                    domain: ERROR_DOMAIN,
                    args: [node.type]
                });
            }
    }
}
// generate code from AST
const generate = (ast, options = {}) => {
    const mode = isString(options.mode) ? options.mode : 'normal';
    const filename = isString(options.filename)
        ? options.filename
        : 'message.intl';
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null
        ? options.breakLineCode
        : mode === 'arrow'
            ? ';'
            : '\n';
    const needIndent = options.needIndent ? options.needIndent : mode !== 'arrow';
    const helpers = ast.helpers || [];
    const generator = createCodeGenerator(ast, {
        mode,
        filename,
        sourceMap,
        breakLineCode,
        needIndent
    });
    generator.push(mode === 'normal' ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${join(helpers.map(s => `${s}: _${s}`), ', ')} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code, map } = generator.context();
    return {
        ast,
        code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};

function baseCompile$1(source, options = {}) {
    const assignedOptions = assign({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = createParser(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        transform(ast, assignedOptions);
        // generate javascript codes
        return generate(ast, assignedOptions);
    }
    else {
        // optimize ASTs
        enambeOptimize && optimize(ast);
        // minimize ASTs
        enalbeMinify && minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return { ast, code: '' };
    }
}

/*!
  * core-base v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */

/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function initFeatureFlags$1() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') {
        getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    }
}

function format(ast) {
    const msg = (ctx) => formatParts(ctx, ast);
    return msg;
}
function formatParts(ctx, ast) {
    const body = resolveBody(ast);
    if (body == null) {
        throw createUnhandleNodeError(0 /* NodeTypes.Resource */);
    }
    const type = resolveType(body);
    if (type === 1 /* NodeTypes.Plural */) {
        const plural = body;
        const cases = resolveCases(plural);
        return ctx.plural(cases.reduce((messages, c) => [
            ...messages,
            formatMessageParts(ctx, c)
        ], []));
    }
    else {
        return formatMessageParts(ctx, body);
    }
}
const PROPS_BODY = ['b', 'body'];
function resolveBody(node) {
    return resolveProps(node, PROPS_BODY);
}
const PROPS_CASES = ['c', 'cases'];
function resolveCases(node) {
    return resolveProps(node, PROPS_CASES, []);
}
function formatMessageParts(ctx, node) {
    const static_ = resolveStatic(node);
    if (static_ != null) {
        return ctx.type === 'text'
            ? static_
            : ctx.normalize([static_]);
    }
    else {
        const messages = resolveItems(node).reduce((acm, c) => [...acm, formatMessagePart(ctx, c)], []);
        return ctx.normalize(messages);
    }
}
const PROPS_STATIC = ['s', 'static'];
function resolveStatic(node) {
    return resolveProps(node, PROPS_STATIC);
}
const PROPS_ITEMS = ['i', 'items'];
function resolveItems(node) {
    return resolveProps(node, PROPS_ITEMS, []);
}
function formatMessagePart(ctx, node) {
    const type = resolveType(node);
    switch (type) {
        case 3 /* NodeTypes.Text */: {
            return resolveValue$1(node, type);
        }
        case 9 /* NodeTypes.Literal */: {
            return resolveValue$1(node, type);
        }
        case 4 /* NodeTypes.Named */: {
            const named = node;
            if (hasOwn(named, 'k') && named.k) {
                return ctx.interpolate(ctx.named(named.k));
            }
            if (hasOwn(named, 'key') && named.key) {
                return ctx.interpolate(ctx.named(named.key));
            }
            throw createUnhandleNodeError(type);
        }
        case 5 /* NodeTypes.List */: {
            const list = node;
            if (hasOwn(list, 'i') && isNumber(list.i)) {
                return ctx.interpolate(ctx.list(list.i));
            }
            if (hasOwn(list, 'index') && isNumber(list.index)) {
                return ctx.interpolate(ctx.list(list.index));
            }
            throw createUnhandleNodeError(type);
        }
        case 6 /* NodeTypes.Linked */: {
            const linked = node;
            const modifier = resolveLinkedModifier(linked);
            const key = resolveLinkedKey(linked);
            return ctx.linked(formatMessagePart(ctx, key), modifier ? formatMessagePart(ctx, modifier) : undefined, ctx.type);
        }
        case 7 /* NodeTypes.LinkedKey */: {
            return resolveValue$1(node, type);
        }
        case 8 /* NodeTypes.LinkedModifier */: {
            return resolveValue$1(node, type);
        }
        default:
            throw new Error(`unhandled node on format message part: ${type}`);
    }
}
const PROPS_TYPE = ['t', 'type'];
function resolveType(node) {
    return resolveProps(node, PROPS_TYPE);
}
const PROPS_VALUE = ['v', 'value'];
function resolveValue$1(node, type) {
    const resolved = resolveProps(node, PROPS_VALUE);
    if (resolved) {
        return resolved;
    }
    else {
        throw createUnhandleNodeError(type);
    }
}
const PROPS_MODIFIER = ['m', 'modifier'];
function resolveLinkedModifier(node) {
    return resolveProps(node, PROPS_MODIFIER);
}
const PROPS_KEY = ['k', 'key'];
function resolveLinkedKey(node) {
    const resolved = resolveProps(node, PROPS_KEY);
    if (resolved) {
        return resolved;
    }
    else {
        throw createUnhandleNodeError(6 /* NodeTypes.Linked */);
    }
}
function resolveProps(node, props, defaultValue) {
    for (let i = 0; i < props.length; i++) {
        const prop = props[i];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (hasOwn(node, prop) && node[prop] != null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return node[prop];
        }
    }
    return defaultValue;
}
function createUnhandleNodeError(type) {
    return new Error(`unhandled node type: ${type}`);
}

const WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && detectHtmlTag(source)) {
        warn(format$1(WARN_MESSAGE, { source }));
    }
}
const defaultOnCacheKey = (message) => message;
let compileCache = create();
function isMessageAST(val) {
    return (isObject(val) &&
        resolveType(val) === 0 &&
        (hasOwn(val, 'b') || hasOwn(val, 'body')));
}
function baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || defaultOnError;
    options.onError = (err) => {
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return { ...baseCompile$1(message, options), detectError };
}
/* #__NO_SIDE_EFFECTS__ */
function compile(message, context) {
    if ((!__INTLIFY_DROP_MESSAGE_COMPILER__) &&
        isString(message)) {
        // check HTML message
        const warnHtmlMessage = isBoolean(context.warnHtmlMessage)
            ? context.warnHtmlMessage
            : true;
        (process.env.NODE_ENV !== 'production') && checkHtmlMessage(message, warnHtmlMessage);
        // check caches
        const onCacheKey = context.onCacheKey || defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = compileCache[cacheKey];
        if (cached) {
            return cached;
        }
        // compile with JIT mode
        const { ast, detectError } = baseCompile(message, {
            ...context,
            location: (process.env.NODE_ENV !== 'production'),
            jit: true
        });
        // compose message function from AST
        const msg = format(ast);
        // if occurred compile error, don't cache
        return !detectError
            ? (compileCache[cacheKey] = msg)
            : msg;
    }
    else {
        if ((process.env.NODE_ENV !== 'production') && !isMessageAST(message)) {
            warn(`the message that is resolve with key '${context.key}' is not supported for jit compilation`);
            return (() => message);
        }
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = compileCache[cacheKey];
            if (cached) {
                return cached;
            }
            // compose message function from message (AST)
            return (compileCache[cacheKey] =
                format(message));
        }
        else {
            return format(message);
        }
    }
}

let devtools = null;
function setDevToolsHook(hook) {
    devtools = hook;
}
function initI18nDevTools(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    devtools &&
        devtools.emit('i18n:init', {
            timestamp: Date.now(),
            i18n,
            version,
            meta
        });
}
const translateDevTools = 
/* #__PURE__*/ createDevToolsHook('function:translate');
function createDevToolsHook(hook) {
    return (payloads) => devtools && devtools.emit(hook, payloads);
}

const CoreErrorCodes = {
    INVALID_ARGUMENT: COMPILE_ERROR_CODES_EXTEND_POINT, // 17
    INVALID_DATE_ARGUMENT: 18,
    INVALID_ISO_DATE_ARGUMENT: 19,
    NOT_SUPPORT_NON_STRING_MESSAGE: 20,
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
    NOT_SUPPORT_LOCALE_TYPE: 23
};
const CORE_ERROR_CODES_EXTEND_POINT = 24;
function createCoreError(code) {
    return createCompileError(code, null, (process.env.NODE_ENV !== 'production') ? { messages: errorMessages$1 } : undefined);
}
/** @internal */
const errorMessages$1 = {
    [CoreErrorCodes.INVALID_ARGUMENT]: 'Invalid arguments',
    [CoreErrorCodes.INVALID_DATE_ARGUMENT]: 'The date provided is an invalid Date object.' +
        'Make sure your Date represents a valid date.',
    [CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT]: 'The argument provided is not a valid ISO date string',
    [CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE]: 'Not support non-string message',
    [CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: 'cannot support promise value',
    [CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: 'cannot support async function',
    [CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE]: 'cannot support locale type'
};

/** @internal */
function getLocale(context, options) {
    return options.locale != null
        ? resolveLocale(options.locale)
        : resolveLocale(context.locale);
}
let _resolveLocale;
/** @internal */
function resolveLocale(locale) {
    if (isString(locale)) {
        return locale;
    }
    else {
        if (isFunction(locale)) {
            if (locale.resolvedOnce && _resolveLocale != null) {
                return _resolveLocale;
            }
            else if (locale.constructor.name === 'Function') {
                const resolve = locale();
                if (isPromise(resolve)) {
                    throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                }
                return (_resolveLocale = resolve);
            }
            else {
                throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
            }
        }
        else {
            throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);
        }
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */
function fallbackWithSimple(ctx, fallback, start) {
    // prettier-ignore
    return [...new Set([
            start,
            ...(isArray(fallback)
                ? fallback
                : isObject(fallback)
                    ? Object.keys(fallback)
                    : isString(fallback)
                        ? [fallback]
                        : [start])
        ])];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */
function fallbackWithLocaleChain(ctx, fallback, start) {
    const startLocale = isString(start) ? start : DEFAULT_LOCALE;
    const context = ctx;
    if (!context.__localeChainCache) {
        context.__localeChainCache = new Map();
    }
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [start];
        // while any intervening block found
        while (isArray(block)) {
            block = appendBlockToChain(chain, block, fallback);
        }
        // prettier-ignore
        // last block defined by default
        const defaults = isArray(fallback) || !isPlainObject(fallback)
            ? fallback
            : fallback['default']
                ? fallback['default']
                : null;
        // convert defaults to array
        block = isString(defaults) ? [defaults] : defaults;
        if (isArray(block)) {
            appendBlockToChain(chain, block, false);
        }
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for (let i = 0; i < block.length && isBoolean(follow); i++) {
        const locale = block[i];
        if (isString(locale)) {
            follow = appendLocaleToChain(chain, block[i], blocks);
        }
    }
    return follow;
}
function appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split('-');
    do {
        const target = tokens.join('-');
        follow = appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    } while (tokens.length && follow === true);
    return follow;
}
function appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== '!';
            const locale = target.replace(/!/g, '');
            chain.push(locale);
            if ((isArray(blocks) || isPlainObject(blocks)) &&
                blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                follow = blocks[locale];
            }
        }
    }
    return follow;
}

const pathStateMachine = [];
pathStateMachine[0 /* States.BEFORE_PATH */] = {
    ["w" /* PathCharTypes.WORKSPACE */]: [0 /* States.BEFORE_PATH */],
    ["i" /* PathCharTypes.IDENT */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [4 /* States.IN_SUB_PATH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: [7 /* States.AFTER_PATH */]
};
pathStateMachine[1 /* States.IN_PATH */] = {
    ["w" /* PathCharTypes.WORKSPACE */]: [1 /* States.IN_PATH */],
    ["." /* PathCharTypes.DOT */]: [2 /* States.BEFORE_IDENT */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [4 /* States.IN_SUB_PATH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: [7 /* States.AFTER_PATH */]
};
pathStateMachine[2 /* States.BEFORE_IDENT */] = {
    ["w" /* PathCharTypes.WORKSPACE */]: [2 /* States.BEFORE_IDENT */],
    ["i" /* PathCharTypes.IDENT */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["0" /* PathCharTypes.ZERO */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */]
};
pathStateMachine[3 /* States.IN_IDENT */] = {
    ["i" /* PathCharTypes.IDENT */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["0" /* PathCharTypes.ZERO */]: [3 /* States.IN_IDENT */, 0 /* Actions.APPEND */],
    ["w" /* PathCharTypes.WORKSPACE */]: [1 /* States.IN_PATH */, 1 /* Actions.PUSH */],
    ["." /* PathCharTypes.DOT */]: [2 /* States.BEFORE_IDENT */, 1 /* Actions.PUSH */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [4 /* States.IN_SUB_PATH */, 1 /* Actions.PUSH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: [7 /* States.AFTER_PATH */, 1 /* Actions.PUSH */]
};
pathStateMachine[4 /* States.IN_SUB_PATH */] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */]: [5 /* States.IN_SINGLE_QUOTE */, 0 /* Actions.APPEND */],
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */]: [6 /* States.IN_DOUBLE_QUOTE */, 0 /* Actions.APPEND */],
    ["[" /* PathCharTypes.LEFT_BRACKET */]: [
        4 /* States.IN_SUB_PATH */,
        2 /* Actions.INC_SUB_PATH_DEPTH */
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */]: [1 /* States.IN_PATH */, 3 /* Actions.PUSH_SUB_PATH */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: 8 /* States.ERROR */,
    ["l" /* PathCharTypes.ELSE */]: [4 /* States.IN_SUB_PATH */, 0 /* Actions.APPEND */]
};
pathStateMachine[5 /* States.IN_SINGLE_QUOTE */] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */]: [4 /* States.IN_SUB_PATH */, 0 /* Actions.APPEND */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: 8 /* States.ERROR */,
    ["l" /* PathCharTypes.ELSE */]: [5 /* States.IN_SINGLE_QUOTE */, 0 /* Actions.APPEND */]
};
pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */] = {
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */]: [4 /* States.IN_SUB_PATH */, 0 /* Actions.APPEND */],
    ["o" /* PathCharTypes.END_OF_FAIL */]: 8 /* States.ERROR */,
    ["l" /* PathCharTypes.ELSE */]: [6 /* States.IN_DOUBLE_QUOTE */, 0 /* Actions.APPEND */]
};
/**
 * Check if an expression is a literal value.
 */
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
    return literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */
function stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */
function getPathCharType(ch) {
    if (ch === undefined || ch === null) {
        return "o" /* PathCharTypes.END_OF_FAIL */;
    }
    const code = ch.charCodeAt(0);
    switch (code) {
        case 0x5b: // [
        case 0x5d: // ]
        case 0x2e: // .
        case 0x22: // "
        case 0x27: // '
            return ch;
        case 0x5f: // _
        case 0x24: // $
        case 0x2d: // -
            return "i" /* PathCharTypes.IDENT */;
        case 0x09: // Tab (HT)
        case 0x0a: // Newline (LF)
        case 0x0d: // Return (CR)
        case 0xa0: // No-break space (NBSP)
        case 0xfeff: // Byte Order Mark (BOM)
        case 0x2028: // Line Separator (LS)
        case 0x2029: // Paragraph Separator (PS)
            return "w" /* PathCharTypes.WORKSPACE */;
    }
    return "i" /* PathCharTypes.IDENT */;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */
function formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(parseInt(path))) {
        return false;
    }
    return isLiteral(trimmed)
        ? stripQuotes(trimmed)
        : "*" /* PathCharTypes.ASTARISK */ + trimmed;
}
/**
 * Parse a string path into an array of segments
 */
function parse(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */] = () => {
        if (key === undefined) {
            key = newChar;
        }
        else {
            key += newChar;
        }
    };
    actions[1 /* Actions.PUSH */] = () => {
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */] = () => {
        actions[0 /* Actions.APPEND */]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */] = () => {
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */;
            actions[0 /* Actions.APPEND */]();
        }
        else {
            subPathDepth = 0;
            if (key === undefined) {
                return false;
            }
            key = formatSubPath(key);
            if (key === false) {
                return false;
            }
            else {
                actions[1 /* Actions.PUSH */]();
            }
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if ((mode === 5 /* States.IN_SINGLE_QUOTE */ &&
            nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */) ||
            (mode === 6 /* States.IN_DOUBLE_QUOTE */ &&
                nextChar === "\"" /* PathCharTypes.DOUBLE_QUOTE */)) {
            index++;
            newChar = '\\' + nextChar;
            actions[0 /* Actions.APPEND */]();
            return true;
        }
    }
    while (mode !== null) {
        index++;
        c = path[index];
        if (c === '\\' && maybeUnescapeQuote()) {
            continue;
        }
        type = getPathCharType(c);
        typeMap = pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */] || 8 /* States.ERROR */;
        // check parse error
        if (transition === 8 /* States.ERROR */) {
            return;
        }
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) {
                    return;
                }
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */) {
            return keys;
        }
    }
}
// path token cache
const cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function resolveWithKeyValue(obj, path) {
    return isObject(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */
function resolveValue(obj, path) {
    // check object
    if (!isObject(obj)) {
        return null;
    }
    // parse path
    let hit = cache.get(path);
    if (!hit) {
        hit = parse(path);
        if (hit) {
            cache.set(path, hit);
        }
    }
    // check hit
    if (!hit) {
        return null;
    }
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while (i < len) {
        const val = last[hit[i]];
        if (val === undefined) {
            return null;
        }
        if (isFunction(last)) {
            return null;
        }
        last = val;
        i++;
    }
    return last;
}

const CoreWarnCodes = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
};
const CORE_WARN_CODES_EXTEND_POINT = 8;
/** @internal */
const warnMessages$1 = {
    [CoreWarnCodes.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [CoreWarnCodes.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [CoreWarnCodes.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [CoreWarnCodes.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [CoreWarnCodes.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function getWarnMessage$1(code, ...args) {
    return format$1(warnMessages$1[code], ...args);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Intlify core-base version
 * @internal
 */
const VERSION$1 = '10.0.5';
const NOT_REOSLVED = -1;
const DEFAULT_LOCALE = 'en-US';
const MISSING_RESOLVE_VALUE = '';
const capitalize = (str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function getDefaultLinkedModifiers() {
    return {
        upper: (val, type) => {
            // prettier-ignore
            return type === 'text' && isString(val)
                ? val.toUpperCase()
                : type === 'vnode' && isObject(val) && '__v_isVNode' in val
                    ? val.children.toUpperCase()
                    : val;
        },
        lower: (val, type) => {
            // prettier-ignore
            return type === 'text' && isString(val)
                ? val.toLowerCase()
                : type === 'vnode' && isObject(val) && '__v_isVNode' in val
                    ? val.children.toLowerCase()
                    : val;
        },
        capitalize: (val, type) => {
            // prettier-ignore
            return (type === 'text' && isString(val)
                ? capitalize(val)
                : type === 'vnode' && isObject(val) && '__v_isVNode' in val
                    ? capitalize(val.children)
                    : val);
        }
    };
}
let _compiler;
function registerMessageCompiler(compiler) {
    _compiler = compiler;
}
let _resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */
function registerMessageResolver(resolver) {
    _resolver = resolver;
}
let _fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */
function registerLocaleFallbacker(fallbacker) {
    _fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let _additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */
const setAdditionalMeta = (meta) => {
    _additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */
const getAdditionalMeta = () => _additionalMeta;
let _fallbackContext = null;
const setFallbackContext = (context) => {
    _fallbackContext = context;
};
const getFallbackContext = () => _fallbackContext;
// ID for CoreContext
let _cid = 0;
function createCoreContext(options = {}) {
    // setup options
    const onWarn = isFunction(options.onWarn) ? options.onWarn : warn;
    const version = isString(options.version) ? options.version : VERSION$1;
    const locale = isString(options.locale) || isFunction(options.locale)
        ? options.locale
        : DEFAULT_LOCALE;
    const _locale = isFunction(locale) ? DEFAULT_LOCALE : locale;
    const fallbackLocale = isArray(options.fallbackLocale) ||
        isPlainObject(options.fallbackLocale) ||
        isString(options.fallbackLocale) ||
        options.fallbackLocale === false
        ? options.fallbackLocale
        : _locale;
    const messages = isPlainObject(options.messages)
        ? options.messages
        : createResources(_locale);
    const datetimeFormats = isPlainObject(options.datetimeFormats)
            ? options.datetimeFormats
            : createResources(_locale)
        ;
    const numberFormats = isPlainObject(options.numberFormats)
            ? options.numberFormats
            : createResources(_locale)
        ;
    const modifiers = assign(create(), options.modifiers, getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || create();
    const missing = isFunction(options.missing) ? options.missing : null;
    const missingWarn = isBoolean(options.missingWarn) || isRegExp(options.missingWarn)
        ? options.missingWarn
        : true;
    const fallbackWarn = isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn)
        ? options.fallbackWarn
        : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = isFunction(options.postTranslation)
        ? options.postTranslation
        : null;
    const processor = isPlainObject(options.processor) ? options.processor : null;
    const warnHtmlMessage = isBoolean(options.warnHtmlMessage)
        ? options.warnHtmlMessage
        : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = isFunction(options.messageCompiler)
        ? options.messageCompiler
        : _compiler;
    if ((process.env.NODE_ENV !== 'production') &&
        !false &&
        !false &&
        isFunction(options.messageCompiler)) {
        warnOnce(getWarnMessage$1(CoreWarnCodes.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
    }
    const messageResolver = isFunction(options.messageResolver)
        ? options.messageResolver
        : _resolver || resolveWithKeyValue;
    const localeFallbacker = isFunction(options.localeFallbacker)
        ? options.localeFallbacker
        : _fallbacker || fallbackWithSimple;
    const fallbackContext = isObject(options.fallbackContext)
        ? options.fallbackContext
        : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = isObject(internalOptions.__datetimeFormatters)
            ? internalOptions.__datetimeFormatters
            : new Map()
        ;
    const __numberFormatters = isObject(internalOptions.__numberFormatters)
            ? internalOptions.__numberFormatters
            : new Map()
        ;
    const __meta = isObject(internalOptions.__meta) ? internalOptions.__meta : {};
    _cid++;
    const context = {
        version,
        cid: _cid,
        locale,
        fallbackLocale,
        messages,
        modifiers,
        pluralRules,
        missing,
        missingWarn,
        fallbackWarn,
        fallbackFormat,
        unresolving,
        postTranslation,
        processor,
        warnHtmlMessage,
        escapeParameter,
        messageCompiler,
        messageResolver,
        localeFallbacker,
        fallbackContext,
        onWarn,
        __meta
    };
    {
        context.datetimeFormats = datetimeFormats;
        context.numberFormats = numberFormats;
        context.__datetimeFormatters = __datetimeFormatters;
        context.__numberFormatters = __numberFormatters;
    }
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production')) {
        context.__v_emitter =
            internalOptions.__v_emitter != null
                ? internalOptions.__v_emitter
                : undefined;
    }
    // NOTE: experimental !!
    if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
        initI18nDevTools(context, version, __meta);
    }
    return context;
}
const createResources = (locale) => ({ [locale]: create() });
/** @internal */
function isTranslateFallbackWarn(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */
function isTranslateMissingWarn(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */
function handleMissing(context, key, locale, missingWarn, type) {
    const { missing, onWarn } = context;
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production')) {
        const emitter = context.__v_emitter;
        if (emitter) {
            emitter.emit('missing', {
                locale,
                key,
                type,
                groupId: `${type}:${key}`
            });
        }
    }
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return isString(ret) ? ret : key;
    }
    else {
        if ((process.env.NODE_ENV !== 'production') && isTranslateMissingWarn(missingWarn, key)) {
            onWarn(getWarnMessage$1(CoreWarnCodes.NOT_FOUND_KEY, { key, locale }));
        }
        return key;
    }
}
/** @internal */
function updateFallbackLocale(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */
function isAlmostSameLocale(locale, compareLocale) {
    if (locale === compareLocale)
        return false;
    return locale.split('-')[0] === compareLocale.split('-')[0];
}
/** @internal */
function isImplicitFallback(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) {
        return false;
    }
    for (let i = index + 1; i < locales.length; i++) {
        if (isAlmostSameLocale(targetLocale, locales[i])) {
            return true;
        }
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */

const intlDefined = typeof Intl !== 'undefined';
const Availabilities = {
    dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
    numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
};

// implementation of `datetime` function
function datetime(context, ...args) {
    const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __datetimeFormatters } = context;
    if ((process.env.NODE_ENV !== 'production') && !Availabilities.dateTimeFormat) {
        onWarn(getWarnMessage$1(CoreWarnCodes.CANNOT_FORMAT_DATE));
        return MISSING_RESOLVE_VALUE;
    }
    const [key, value, options, overrides] = parseDateTimeArgs(...args);
    const missingWarn = isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = getLocale(context, options);
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!isString(key) || key === '') {
        return new Intl.DateTimeFormat(locale, overrides).format(value);
    }
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'datetime format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if ((process.env.NODE_ENV !== 'production') &&
            locale !== targetLocale &&
            isTranslateFallbackWarn(fallbackWarn, key)) {
            onWarn(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_DATE_FORMAT, {
                key,
                target: targetLocale
            }));
        }
        // for vue-devtools timeline event
        if ((process.env.NODE_ENV !== 'production') && locale !== targetLocale) {
            const emitter = context.__v_emitter;
            if (emitter) {
                emitter.emit('fallback', {
                    type,
                    key,
                    from,
                    to,
                    groupId: `${type}:${key}`
                });
            }
        }
        datetimeFormat =
            datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if (isPlainObject(format))
            break;
        handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!isPlainObject(format) || !isString(targetLocale)) {
        return unresolving ? NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, assign({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */
const DATETIME_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'formatMatcher',
    'hour12',
    'timeZone',
    'dateStyle',
    'timeStyle',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'hourCycle',
    'fractionalSecondDigits'
];
/** @internal */
function parseDateTimeArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = create();
    let overrides = create();
    let value;
    if (isString(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) {
            throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3]
            ? matches[3].trim().startsWith('T')
                ? `${matches[1].trim()}${matches[3].trim()}`
                : `${matches[1].trim()}T${matches[3].trim()}`
            : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        }
        catch {
            throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
        }
    }
    else if (isDate(arg1)) {
        if (isNaN(arg1.getTime())) {
            throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
        }
        value = arg1;
    }
    else if (isNumber(arg1)) {
        value = arg1;
    }
    else {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    if (isString(arg2)) {
        options.key = arg2;
    }
    else if (isPlainObject(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (DATETIME_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (isString(arg3)) {
        options.locale = arg3;
    }
    else if (isPlainObject(arg3)) {
        overrides = arg3;
    }
    if (isPlainObject(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function clearDateTimeFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) {
            continue;
        }
        context.__datetimeFormatters.delete(id);
    }
}

// implementation of `number` function
function number(context, ...args) {
    const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
    const { __numberFormatters } = context;
    if ((process.env.NODE_ENV !== 'production') && !Availabilities.numberFormat) {
        onWarn(getWarnMessage$1(CoreWarnCodes.CANNOT_FORMAT_NUMBER));
        return MISSING_RESOLVE_VALUE;
    }
    const [key, value, options, overrides] = parseNumberArgs(...args);
    const missingWarn = isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const part = !!options.part;
    const locale = getLocale(context, options);
    const locales = localeFallbacker(context, // eslint-disable-line @typescript-eslint/no-explicit-any
    fallbackLocale, locale);
    if (!isString(key) || key === '') {
        return new Intl.NumberFormat(locale, overrides).format(value);
    }
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'number format';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if ((process.env.NODE_ENV !== 'production') &&
            locale !== targetLocale &&
            isTranslateFallbackWarn(fallbackWarn, key)) {
            onWarn(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_NUMBER_FORMAT, {
                key,
                target: targetLocale
            }));
        }
        // for vue-devtools timeline event
        if ((process.env.NODE_ENV !== 'production') && locale !== targetLocale) {
            const emitter = context.__v_emitter;
            if (emitter) {
                emitter.emit('fallback', {
                    type,
                    key,
                    from,
                    to,
                    groupId: `${type}:${key}`
                });
            }
        }
        numberFormat =
            numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if (isPlainObject(format))
            break;
        handleMissing(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!isPlainObject(format) || !isString(targetLocale)) {
        return unresolving ? NOT_REOSLVED : key;
    }
    let id = `${targetLocale}__${key}`;
    if (!isEmptyObject(overrides)) {
        id = `${id}__${JSON.stringify(overrides)}`;
    }
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, assign({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */
const NUMBER_FORMAT_OPTIONS_KEYS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'currencySign',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'compactDisplay',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'roundingMode',
    'roundingPriority',
    'roundingIncrement',
    'trailingZeroDisplay'
];
/** @internal */
function parseNumberArgs(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = create();
    let overrides = create();
    if (!isNumber(arg1)) {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    const value = arg1;
    if (isString(arg2)) {
        options.key = arg2;
    }
    else if (isPlainObject(arg2)) {
        Object.keys(arg2).forEach(key => {
            if (NUMBER_FORMAT_OPTIONS_KEYS.includes(key)) {
                overrides[key] = arg2[key];
            }
            else {
                options[key] = arg2[key];
            }
        });
    }
    if (isString(arg3)) {
        options.locale = arg3;
    }
    else if (isPlainObject(arg3)) {
        overrides = arg3;
    }
    if (isPlainObject(arg4)) {
        overrides = arg4;
    }
    return [options.key || '', value, options, overrides];
}
/** @internal */
function clearNumberFormat(ctx, locale, format) {
    const context = ctx;
    for (const key in format) {
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) {
            continue;
        }
        context.__numberFormatters.delete(id);
    }
}

const DEFAULT_MODIFIER = (str) => str;
const DEFAULT_MESSAGE = (ctx) => ''; // eslint-disable-line
const DEFAULT_MESSAGE_DATA_TYPE = 'text';
const DEFAULT_NORMALIZE = (values) => values.length === 0 ? '' : join(values);
const DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) {
        // prettier-ignore
        return choice
            ? choice > 1
                ? 1
                : 0
            : 1;
    }
    return choice ? Math.min(choice, 2) : 0;
}
function getPluralIndex(options) {
    // prettier-ignore
    const index = isNumber(options.pluralIndex)
        ? options.pluralIndex
        : -1;
    // prettier-ignore
    return options.named && (isNumber(options.named.count) || isNumber(options.named.n))
        ? isNumber(options.named.count)
            ? options.named.count
            : isNumber(options.named.n)
                ? options.named.n
                : index
        : index;
}
function normalizeNamed(pluralIndex, props) {
    if (!props.count) {
        props.count = pluralIndex;
    }
    if (!props.n) {
        props.n = pluralIndex;
    }
}
function createMessageContext(options = {}) {
    const locale = options.locale;
    const pluralIndex = getPluralIndex(options);
    const pluralRule = isObject(options.pluralRules) &&
        isString(locale) &&
        isFunction(options.pluralRules[locale])
        ? options.pluralRules[locale]
        : pluralDefault;
    const orgPluralRule = isObject(options.pluralRules) &&
        isString(locale) &&
        isFunction(options.pluralRules[locale])
        ? pluralDefault
        : undefined;
    const plural = (messages) => {
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index) => _list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || create();
    isNumber(options.pluralIndex) && normalizeNamed(pluralIndex, _named);
    const named = (key) => _named[key];
    function message(key, useLinked) {
        // prettier-ignore
        const msg = isFunction(options.messages)
            ? options.messages(key, !!useLinked)
            : isObject(options.messages)
                ? options.messages[key]
                : false;
        return !msg
            ? options.parent
                ? options.parent.message(key) // resolve from parent messages
                : DEFAULT_MESSAGE
            : msg;
    }
    const _modifier = (name) => options.modifiers
        ? options.modifiers[name]
        : DEFAULT_MODIFIER;
    const normalize = isPlainObject(options.processor) && isFunction(options.processor.normalize)
        ? options.processor.normalize
        : DEFAULT_NORMALIZE;
    const interpolate = isPlainObject(options.processor) &&
        isFunction(options.processor.interpolate)
        ? options.processor.interpolate
        : DEFAULT_INTERPOLATE;
    const type = isPlainObject(options.processor) && isString(options.processor.type)
        ? options.processor.type
        : DEFAULT_MESSAGE_DATA_TYPE;
    const linked = (key, ...args) => {
        const [arg1, arg2] = args;
        let type = 'text';
        let modifier = '';
        if (args.length === 1) {
            if (isObject(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            }
            else if (isString(arg1)) {
                modifier = arg1 || modifier;
            }
        }
        else if (args.length === 2) {
            if (isString(arg1)) {
                modifier = arg1 || modifier;
            }
            if (isString(arg2)) {
                type = arg2 || type;
            }
        }
        const ret = message(key, true)(ctx);
        const msg = 
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === 'vnode' && isArray(ret) && modifier
            ? ret[0]
            : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */]: list,
        ["named" /* HelperNameMap.NAMED */]: named,
        ["plural" /* HelperNameMap.PLURAL */]: plural,
        ["linked" /* HelperNameMap.LINKED */]: linked,
        ["message" /* HelperNameMap.MESSAGE */]: message,
        ["type" /* HelperNameMap.TYPE */]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */]: normalize,
        ["values" /* HelperNameMap.VALUES */]: assign(create(), _list, _named)
    };
    return ctx;
}

const NOOP_MESSAGE_FUNCTION = () => '';
const isMessageFunction = (val) => isFunction(val);
// implementation of `translate` function
function translate(context, ...args) {
    const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context;
    const [key, options] = parseTranslateArgs(...args);
    const missingWarn = isBoolean(options.missingWarn)
        ? options.missingWarn
        : context.missingWarn;
    const fallbackWarn = isBoolean(options.fallbackWarn)
        ? options.fallbackWarn
        : context.fallbackWarn;
    const escapeParameter = isBoolean(options.escapeParameter)
        ? options.escapeParameter
        : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = isString(options.default) || isBoolean(options.default) // default by function option
        ? !isBoolean(options.default)
            ? options.default
            : (!messageCompiler ? () => key : key)
        : fallbackFormat // default by `fallbackFormat` option
            ? (!messageCompiler ? () => key : key)
            : null;
    const enableDefaultMsg = fallbackFormat ||
        (defaultMsgOrKey != null &&
            (isString(defaultMsgOrKey) || isFunction(defaultMsgOrKey)));
    const locale = getLocale(context, options);
    // escape params
    escapeParameter && escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage
        ? resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn)
        : [
            key,
            locale,
            messages[locale] || create()
        ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage &&
        !(isString(format) ||
            isMessageAST(format) ||
            isMessageFunction(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage &&
        (!(isString(format) ||
            isMessageAST(format) ||
            isMessageFunction(format)) ||
            !isString(targetLocale))) {
        return unresolving ? NOT_REOSLVED : key;
    }
    // TODO: refactor
    if ((process.env.NODE_ENV !== 'production') && isString(format) && context.messageCompiler == null) {
        warn(`The message format compilation is not supported in this build. ` +
            `Because message compiler isn't included. ` +
            `You need to pre-compilation all message format. ` +
            `So translate function return '${key}'.`);
        return key;
    }
    // setup compile error detecting
    let occurred = false;
    const onError = () => {
        occurred = true;
    };
    // compile message format
    const msg = !isMessageFunction(format)
        ? compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError)
        : format;
    // if occurred compile error, return the message format
    if (occurred) {
        return format;
    }
    // evaluate message with context
    const ctxOptions = getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = createMessageContext(ctxOptions);
    const messaged = evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation
        ? postTranslation(messaged, key)
        : messaged;
    // NOTE: experimental !!
    if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: isString(key)
                ? key
                : isMessageFunction(format)
                    ? format.key
                    : '',
            locale: targetLocale || (isMessageFunction(format)
                ? format.locale
                : ''),
            format: isString(format)
                ? format
                : isMessageFunction(format)
                    ? format.source
                    : '',
            message: ret
        };
        payloads.meta = assign({}, context.__meta, getAdditionalMeta() || {});
        translateDevTools(payloads);
    }
    return ret;
}
function escapeParams(options) {
    if (isArray(options.list)) {
        options.list = options.list.map(item => isString(item) ? escapeHtml(item) : item);
    }
    else if (isObject(options.named)) {
        Object.keys(options.named).forEach(key => {
            if (isString(options.named[key])) {
                options.named[key] = escapeHtml(options.named[key]);
            }
        });
    }
}
function resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages, onWarn, messageResolver: resolveValue, localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = create();
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'translate';
    for (let i = 0; i < locales.length; i++) {
        targetLocale = to = locales[i];
        if ((process.env.NODE_ENV !== 'production') &&
            locale !== targetLocale &&
            !isAlmostSameLocale(locale, targetLocale) &&
            isTranslateFallbackWarn(fallbackWarn, key)) {
            onWarn(getWarnMessage$1(CoreWarnCodes.FALLBACK_TO_TRANSLATE, {
                key,
                target: targetLocale
            }));
        }
        // for vue-devtools timeline event
        if ((process.env.NODE_ENV !== 'production') && locale !== targetLocale) {
            const emitter = context.__v_emitter;
            if (emitter) {
                emitter.emit('fallback', {
                    type,
                    key,
                    from,
                    to,
                    groupId: `${type}:${key}`
                });
            }
        }
        message =
            messages[targetLocale] || create();
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((process.env.NODE_ENV !== 'production') && inBrowser) {
            start = window.performance.now();
            startTag = 'intlify-message-resolve-start';
            endTag = 'intlify-message-resolve-end';
            mark && mark(startTag);
        }
        if ((format = resolveValue(message, key)) === null) {
            // if null, resolve with object key path
            format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        }
        // for vue-devtools timeline event
        if ((process.env.NODE_ENV !== 'production') && inBrowser) {
            const end = window.performance.now();
            const emitter = context.__v_emitter;
            if (emitter && start && format) {
                emitter.emit('message-resolve', {
                    type: 'message-resolve',
                    key,
                    message: format,
                    time: end - start,
                    groupId: `${type}:${key}`
                });
            }
            if (startTag && endTag && mark && measure) {
                mark(endTag);
                measure('intlify message resolve', startTag, endTag);
            }
        }
        if (isString(format) || isMessageAST(format) || isMessageFunction(format)) {
            break;
        }
        if (!isImplicitFallback(targetLocale, locales)) {
            const missingRet = handleMissing(context, // eslint-disable-line @typescript-eslint/no-explicit-any
            key, targetLocale, missingWarn, type);
            if (missingRet !== key) {
                format = missingRet;
            }
        }
        from = to;
    }
    return [format, targetLocale, message];
}
function compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler, warnHtmlMessage } = context;
    if (isMessageFunction(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = (() => format);
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if ((process.env.NODE_ENV !== 'production') && inBrowser) {
        start = window.performance.now();
        startTag = 'intlify-message-compilation-start';
        endTag = 'intlify-message-compilation-end';
        mark && mark(startTag);
    }
    const msg = messageCompiler(format, getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production') && inBrowser) {
        const end = window.performance.now();
        const emitter = context.__v_emitter;
        if (emitter && start) {
            emitter.emit('message-compilation', {
                type: 'message-compilation',
                message: format,
                time: end - start,
                groupId: `${'translate'}:${key}`
            });
        }
        if (startTag && endTag && mark && measure) {
            mark(endTag);
            measure('intlify message compilation', startTag, endTag);
        }
    }
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    if ((process.env.NODE_ENV !== 'production') && inBrowser) {
        start = window.performance.now();
        startTag = 'intlify-message-evaluation-start';
        endTag = 'intlify-message-evaluation-end';
        mark && mark(startTag);
    }
    const messaged = msg(msgCtx);
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production') && inBrowser) {
        const end = window.performance.now();
        const emitter = context.__v_emitter;
        if (emitter && start) {
            emitter.emit('message-evaluation', {
                type: 'message-evaluation',
                value: messaged,
                time: end - start,
                groupId: `${'translate'}:${msg.key}`
            });
        }
        if (startTag && endTag && mark && measure) {
            mark(endTag);
            measure('intlify message evaluation', startTag, endTag);
        }
    }
    return messaged;
}
/** @internal */
function parseTranslateArgs(...args) {
    const [arg1, arg2, arg3] = args;
    const options = create();
    if (!isString(arg1) &&
        !isNumber(arg1) &&
        !isMessageFunction(arg1) &&
        !isMessageAST(arg1)) {
        throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
    }
    // prettier-ignore
    const key = isNumber(arg1)
        ? String(arg1)
        : isMessageFunction(arg1)
            ? arg1
            : arg1;
    if (isNumber(arg2)) {
        options.plural = arg2;
    }
    else if (isString(arg2)) {
        options.default = arg2;
    }
    else if (isPlainObject(arg2) && !isEmptyObject(arg2)) {
        options.named = arg2;
    }
    else if (isArray(arg2)) {
        options.list = arg2;
    }
    if (isNumber(arg3)) {
        options.plural = arg3;
    }
    else if (isString(arg3)) {
        options.default = arg3;
    }
    else if (isPlainObject(arg3)) {
        assign(options, arg3);
    }
    return [key, options];
}
function getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale,
        key,
        warnHtmlMessage,
        onError: (err) => {
            onError && onError(err);
            if ((process.env.NODE_ENV !== 'production')) {
                const _source = getSourceForCodeFrame(source);
                const message = `Message compilation error: ${err.message}`;
                const codeFrame = err.location &&
                    _source &&
                    generateCodeFrame(_source, err.location.start.offset, err.location.end.offset);
                const emitter = context.__v_emitter;
                if (emitter && _source) {
                    emitter.emit('compile-error', {
                        message: _source,
                        error: err.message,
                        start: err.location && err.location.start.offset,
                        end: err.location && err.location.end.offset,
                        groupId: `${'translate'}:${key}`
                    });
                }
                console.error(codeFrame ? `${message}\n${codeFrame}` : message);
            }
            else {
                throw err;
            }
        },
        onCacheKey: (source) => generateFormatCacheKey(locale, key, source)
    };
}
function getSourceForCodeFrame(source) {
    if (isString(source)) {
        return source;
    }
    else {
        if (source.loc && source.loc.source) {
            return source.loc.source;
        }
    }
}
function getMessageContextOptions(context, locale, message, options) {
    const { modifiers, pluralRules, messageResolver: resolveValue, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context;
    const resolveMessage = (key, useLinked) => {
        let val = resolveValue(message, key);
        // fallback
        if (val == null && (fallbackContext || useLinked)) {
            const [, , message] = resolveMessageFormat(fallbackContext || context, // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
            key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if (isString(val) || isMessageAST(val)) {
            let occurred = false;
            const onError = () => {
                occurred = true;
            };
            const msg = compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred
                ? msg
                : NOOP_MESSAGE_FUNCTION;
        }
        else if (isMessageFunction(val)) {
            return val;
        }
        else {
            // TODO: should be implemented warning message
            return NOOP_MESSAGE_FUNCTION;
        }
    };
    const ctxOptions = {
        locale,
        modifiers,
        pluralRules,
        messages: resolveMessage
    };
    if (context.processor) {
        ctxOptions.processor = context.processor;
    }
    if (options.list) {
        ctxOptions.list = options.list;
    }
    if (options.named) {
        ctxOptions.named = options.named;
    }
    if (isNumber(options.plural)) {
        ctxOptions.pluralIndex = options.plural;
    }
    return ctxOptions;
}

{
    initFeatureFlags$1();
}

/*!
  * vue-i18n v10.0.5
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */

/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */
const VERSION = '10.0.5';
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */
function initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== 'boolean') {
        getGlobalThis$1().__VUE_I18N_FULL_INSTALL__ = true;
    }
    if (typeof __VUE_I18N_LEGACY_API__ !== 'boolean') {
        getGlobalThis$1().__VUE_I18N_LEGACY_API__ = true;
    }
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') {
        getGlobalThis$1().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    }
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') {
        getGlobalThis$1().__INTLIFY_PROD_DEVTOOLS__ = false;
    }
}

const I18nWarnCodes = {
    FALLBACK_TO_ROOT: CORE_WARN_CODES_EXTEND_POINT, // 8
    NOT_FOUND_PARENT_SCOPE: 9,
    IGNORE_OBJ_FLATTEN: 10,
    DEPRECATE_TC: 11
};
const warnMessages = {
    [I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [I18nWarnCodes.DEPRECATE_TC]: `'tc' and '$tc' has been deprecated in v10. Use 't' or '$t' instead. 'tc' and '$tc’ are going to remove in v11.`
};
function getWarnMessage(code, ...args) {
    return format$2(warnMessages[code], ...args);
}

const I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: CORE_ERROR_CODES_EXTEND_POINT, // 24
    // legacy module errors
    INVALID_ARGUMENT: 25,
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: 26,
    NOT_INSTALLED: 27,
    // directive module errors
    REQUIRED_VALUE: 28,
    INVALID_VALUE: 29,
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
    NOT_INSTALLED_WITH_PROVIDE: 31,
    // unexpected error
    UNEXPECTED_ERROR: 32,
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function createI18nError(code, ...args) {
    return createCompileError(code, null, (process.env.NODE_ENV !== 'production') ? { messages: errorMessages, args } : undefined);
}
const errorMessages = {
    [I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: 'Unexpected return type in composer',
    [I18nErrorCodes.INVALID_ARGUMENT]: 'Invalid argument',
    [I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: 'Must be called at the top of a `setup` function',
    [I18nErrorCodes.NOT_INSTALLED]: 'Need to install with `app.use` function',
    [I18nErrorCodes.UNEXPECTED_ERROR]: 'Unexpected error',
    [I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: 'Need to install with `provide` function',
    [I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: 'Not compatible legacy VueI18n.',
    [I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: 'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly'
};

const TranslateVNodeSymbol = 
/* #__PURE__*/ makeSymbol('__translateVNode');
const DatetimePartsSymbol = /* #__PURE__*/ makeSymbol('__datetimeParts');
const NumberPartsSymbol = /* #__PURE__*/ makeSymbol('__numberParts');
const EnableEmitter = /* #__PURE__*/ makeSymbol('__enableEmitter');
const DisableEmitter = /* #__PURE__*/ makeSymbol('__disableEmitter');
const SetPluralRulesSymbol = makeSymbol('__setPluralRules');
const InejctWithOptionSymbol = 
/* #__PURE__*/ makeSymbol('__injectWithOption');
const DisposeSymbol = /* #__PURE__*/ makeSymbol('__dispose');

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Transform flat json in obj to normal json in obj
 */
function handleFlatJson(obj) {
    // check obj
    if (!isObject$1(obj)) {
        return obj;
    }
    for (const key in obj) {
        // check key
        if (!hasOwn$1(obj, key)) {
            continue;
        }
        // handle for normal json
        if (!key.includes('.')) {
            // recursive process value if value is also a object
            if (isObject$1(obj[key])) {
                handleFlatJson(obj[key]);
            }
        }
        // handle for flat json, transform to normal json
        else {
            // go to the last object
            const subKeys = key.split('.');
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for (let i = 0; i < lastIndex; i++) {
                if (!(subKeys[i] in currentObj)) {
                    currentObj[subKeys[i]] = create$1();
                }
                if (!isObject$1(currentObj[subKeys[i]])) {
                    (process.env.NODE_ENV !== 'production') &&
                        warn$1(getWarnMessage(I18nWarnCodes.IGNORE_OBJ_FLATTEN, {
                            key: subKeys[i]
                        }));
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                currentObj[subKeys[lastIndex]] = obj[key];
                delete obj[key];
            }
            // recursive process value if value is also a object
            if (isObject$1(currentObj[subKeys[lastIndex]])) {
                handleFlatJson(currentObj[subKeys[lastIndex]]);
            }
        }
    }
    return obj;
}
function getLocaleMessages(locale, options) {
    const { messages, __i18n, messageResolver, flatJson } = options;
    // prettier-ignore
    const ret = (isPlainObject$1(messages)
        ? messages
        : isArray$1(__i18n)
            ? create$1()
            : { [locale]: create$1() });
    // merge locale messages of i18n custom block
    if (isArray$1(__i18n)) {
        __i18n.forEach(custom => {
            if ('locale' in custom && 'resource' in custom) {
                const { locale, resource } = custom;
                if (locale) {
                    ret[locale] = ret[locale] || create$1();
                    deepCopy(resource, ret[locale]);
                }
                else {
                    deepCopy(resource, ret);
                }
            }
            else {
                isString$1(custom) && deepCopy(JSON.parse(custom), ret);
            }
        });
    }
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for (const key in ret) {
            if (hasOwn$1(ret, key)) {
                handleFlatJson(ret[key]);
            }
        }
    }
    return ret;
}
function getComponentOptions(instance) {
    return instance.type;
}
function adjustI18nResources(gl, options, componentOptions) {
    // prettier-ignore
    let messages = isObject$1(options.messages)
        ? options.messages
        : create$1();
    if ('__i18nGlobal' in componentOptions) {
        messages = getLocaleMessages(gl.locale.value, {
            messages,
            __i18n: componentOptions.__i18nGlobal
        });
    }
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) {
        locales.forEach(locale => {
            gl.mergeLocaleMessage(locale, messages[locale]);
        });
    }
    {
        // merge datetime formats
        if (isObject$1(options.datetimeFormats)) {
            const locales = Object.keys(options.datetimeFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
                });
            }
        }
        // merge number formats
        if (isObject$1(options.numberFormats)) {
            const locales = Object.keys(options.numberFormats);
            if (locales.length) {
                locales.forEach(locale => {
                    gl.mergeNumberFormat(locale, options.numberFormats[locale]);
                });
            }
        }
    }
}
function createTextNode(key) {
    return createVNode(Text, null, key, 0);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
// extend VNode interface
const DEVTOOLS_META = '__INTLIFY_META__';
const NOOP_RETURN_ARRAY = () => [];
const NOOP_RETURN_FALSE = () => false;
let composerID = 0;
function defineCoreMissingHandler(missing) {
    return ((ctx, locale, key, type) => {
        return missing(locale, key, getCurrentInstance() || undefined, type);
    });
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */
const getMetaInfo = () => {
    const instance = getCurrentInstance();
    let meta = null;
    return instance && (meta = getComponentOptions(instance)[DEVTOOLS_META])
        ? { [DEVTOOLS_META]: meta }
        : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */
function createComposer(options = {}) {
    const { __root, __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = inBrowser$1 ? ref : shallowRef;
    let _inheritLocale = isBoolean$1(options.inheritLocale)
        ? options.inheritLocale
        : true;
    const _locale = _ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.locale.value
        : isString$1(options.locale)
            ? options.locale
            : DEFAULT_LOCALE);
    const _fallbackLocale = _ref(
    // prettier-ignore
    __root && _inheritLocale
        ? __root.fallbackLocale.value
        : isString$1(options.fallbackLocale) ||
            isArray$1(options.fallbackLocale) ||
            isPlainObject$1(options.fallbackLocale) ||
            options.fallbackLocale === false
            ? options.fallbackLocale
            : _locale.value);
    const _messages = _ref(getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref(isPlainObject$1(options.datetimeFormats)
            ? options.datetimeFormats
            : { [_locale.value]: {} })
        ;
    // prettier-ignore
    const _numberFormats = _ref(isPlainObject$1(options.numberFormats)
            ? options.numberFormats
            : { [_locale.value]: {} })
        ;
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root
        ? __root.missingWarn
        : isBoolean$1(options.missingWarn) || isRegExp$1(options.missingWarn)
            ? options.missingWarn
            : true;
    // prettier-ignore
    let _fallbackWarn = __root
        ? __root.fallbackWarn
        : isBoolean$1(options.fallbackWarn) || isRegExp$1(options.fallbackWarn)
            ? options.fallbackWarn
            : true;
    // prettier-ignore
    let _fallbackRoot = __root
        ? __root.fallbackRoot
        : isBoolean$1(options.fallbackRoot)
            ? options.fallbackRoot
            : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = isFunction$1(options.missing) ? options.missing : null;
    let _runtimeMissing = isFunction$1(options.missing)
        ? defineCoreMissingHandler(options.missing)
        : null;
    // postTranslation handler
    let _postTranslation = isFunction$1(options.postTranslation)
        ? options.postTranslation
        : null;
    // prettier-ignore
    let _warnHtmlMessage = __root
        ? __root.warnHtmlMessage
        : isBoolean$1(options.warnHtmlMessage)
            ? options.warnHtmlMessage
            : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root
        ? __root.modifiers
        : isPlainObject$1(options.modifiers)
            ? options.modifiers
            : {};
    // pluralRules
    let _pluralRules = options.pluralRules || (__root && __root.pluralRules);
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = () => {
        _isGlobal && setFallbackContext(null);
        const ctxOptions = {
            version: VERSION,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: { framework: 'vue' }
        };
        {
            ctxOptions.datetimeFormats = _datetimeFormats.value;
            ctxOptions.numberFormats = _numberFormats.value;
            ctxOptions.__datetimeFormatters = isPlainObject$1(_context)
                ? _context.__datetimeFormatters
                : undefined;
            ctxOptions.__numberFormatters = isPlainObject$1(_context)
                ? _context.__numberFormatters
                : undefined;
        }
        if ((process.env.NODE_ENV !== 'production')) {
            ctxOptions.__v_emitter = isPlainObject$1(_context)
                ? _context.__v_emitter
                : undefined;
        }
        const ctx = createCoreContext(ctxOptions);
        _isGlobal && setFallbackContext(ctx);
        return ctx;
    };
    _context = getCoreContext();
    updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
                _locale.value,
                _fallbackLocale.value,
                _messages.value,
                _datetimeFormats.value,
                _numberFormats.value
            ]
            ;
    }
    // locale
    const locale = computed({
        get: () => _locale.value,
        set: val => {
            _locale.value = val;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = computed({
        get: () => _fallbackLocale.value,
        set: val => {
            _fallbackLocale.value = val;
            _context.fallbackLocale = _fallbackLocale.value;
            updateFallbackLocale(_context, _locale.value, val);
        }
    });
    // messages
    const messages = computed(() => _messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ computed(() => _datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ computed(() => _numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return isFunction$1(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler) {
        _postTranslation = handler;
        _context.postTranslation = handler;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler) {
        if (handler !== null) {
            _runtimeMissing = defineCoreMissingHandler(handler);
        }
        _missing = handler;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg) {
        return type !== 'translate' || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) => {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
                setAdditionalMeta(getMetaInfo());
            }
            if (!_isGlobal) {
                _context.fallbackContext = __root
                    ? getFallbackContext()
                    : undefined;
            }
            ret = fn(_context);
        }
        finally {
            if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) ;
            if (!_isGlobal) {
                _context.fallbackContext = undefined;
            }
        }
        if ((warnType !== 'translate exists' && // for not `te` (e.g `t`)
            isNumber$1(ret) &&
            ret === NOT_REOSLVED) ||
            (warnType === 'translate exists' && !ret) // for `te`
        ) {
            const [key, arg2] = argumentParser();
            if ((process.env.NODE_ENV !== 'production') &&
                __root &&
                isString$1(key) &&
                isResolvedTranslateMessage(warnType, arg2)) {
                if (_fallbackRoot &&
                    (isTranslateFallbackWarn(_fallbackWarn, key) ||
                        isTranslateMissingWarn(_missingWarn, key))) {
                    warn$1(getWarnMessage(I18nWarnCodes.FALLBACK_TO_ROOT, {
                        key,
                        type: warnType
                    }));
                }
                // for vue-devtools timeline event
                if ((process.env.NODE_ENV !== 'production')) {
                    const { __v_emitter: emitter } = _context;
                    if (emitter && _fallbackRoot) {
                        emitter.emit('fallback', {
                            type: warnType,
                            key,
                            to: 'global',
                            groupId: `${warnType}:${key}`
                        });
                    }
                }
            }
            return __root && _fallbackRoot
                ? fallbackSuccess(__root)
                : fallbackFail(key);
        }
        else if (successCondition(ret)) {
            return ret;
        }
        else {
            /* istanbul ignore next */
            throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
        }
    };
    // t
    function t(...args) {
        return wrapWithDeps(context => Reflect.apply(translate, null, [context, ...args]), () => parseTranslateArgs(...args), 'translate', root => Reflect.apply(root.t, root, [...args]), key => key, val => isString$1(val));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !isObject$1(arg3)) {
            throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        return t(...[arg1, arg2, assign$1({ resolvedMessage: true }, arg3 || {})]);
    }
    // d
    function d(...args) {
        return wrapWithDeps(context => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), 'datetime format', root => Reflect.apply(root.d, root, [...args]), () => MISSING_RESOLVE_VALUE, val => isString$1(val));
    }
    // n
    function n(...args) {
        return wrapWithDeps(context => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), 'number format', root => Reflect.apply(root.n, root, [...args]), () => MISSING_RESOLVE_VALUE, val => isString$1(val));
    }
    // for custom processor
    function normalize(values) {
        return values.map(val => isString$1(val) || isNumber$1(val) || isBoolean$1(val)
            ? createTextNode(String(val))
            : val);
    }
    const interpolate = (val) => val;
    const processor = {
        normalize,
        interpolate,
        type: 'vnode'
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps(context => {
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply(translate, null, [_context, ...args]);
            }
            finally {
                _context.processor = null;
            }
            return ret;
        }, () => parseTranslateArgs(...args), 'translate', root => root[TranslateVNodeSymbol](...args), key => [createTextNode(key)], val => isArray$1(val));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps(context => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), 'number format', root => root[NumberPartsSymbol](...args), NOOP_RETURN_ARRAY, val => isString$1(val) || isArray$1(val));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps(context => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), 'datetime format', root => root[DatetimePartsSymbol](...args), NOOP_RETURN_ARRAY, val => isString$1(val) || isArray$1(val));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(() => {
            if (!key) {
                return false;
            }
            const targetLocale = isString$1(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return (isMessageAST(resolved) ||
                isMessageFunction(resolved) ||
                isString$1(resolved));
        }, () => [key], 'translate exists', root => {
            return Reflect.apply(root.te, root, [key, locale]);
        }, NOOP_RETURN_FALSE, val => isBoolean$1(val));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
        for (let i = 0; i < locales.length; i++) {
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null
            ? messages
            : __root
                ? __root.tm(key) || {}
                : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return (_messages.value[locale] || {});
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = { [locale]: message };
            for (const key in _message) {
                if (hasOwn$1(_message, key)) {
                    handleFlatJson(_message[key]);
                }
            }
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = { [locale]: message };
        if (flatJson) {
            for (const key in _message) {
                if (hasOwn$1(_message, key)) {
                    handleFlatJson(_message[key]);
                }
            }
        }
        message = _message[locale];
        deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = assign$1(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        clearDateTimeFormat(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = assign$1(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        clearNumberFormat(_context, locale, format);
    }
    // for debug
    composerID++;
    // watch root locale & fallbackLocale
    if (__root && inBrowser$1) {
        watch(__root.locale, (val) => {
            if (_inheritLocale) {
                _locale.value = val;
                _context.locale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
        watch(__root.fallbackLocale, (val) => {
            if (_inheritLocale) {
                _fallbackLocale.value = val;
                _context.fallbackLocale = val;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: composerID,
        locale,
        fallbackLocale,
        get inheritLocale() {
            return _inheritLocale;
        },
        set inheritLocale(val) {
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales() {
            return Object.keys(_messages.value).sort();
        },
        messages,
        get modifiers() {
            return _modifiers;
        },
        get pluralRules() {
            return _pluralRules || {};
        },
        get isGlobal() {
            return _isGlobal;
        },
        get missingWarn() {
            return _missingWarn;
        },
        set missingWarn(val) {
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn() {
            return _fallbackWarn;
        },
        set fallbackWarn(val) {
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot() {
            return _fallbackRoot;
        },
        set fallbackRoot(val) {
            _fallbackRoot = val;
        },
        get fallbackFormat() {
            return _fallbackFormat;
        },
        set fallbackFormat(val) {
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage() {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage(val) {
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter() {
            return _escapeParameter;
        },
        set escapeParameter(val) {
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t,
        getLocaleMessage,
        setLocaleMessage,
        mergeLocaleMessage,
        getPostTranslationHandler,
        setPostTranslationHandler,
        getMissingHandler,
        setMissingHandler,
        [SetPluralRulesSymbol]: setPluralRules
    };
    {
        composer.datetimeFormats = datetimeFormats;
        composer.numberFormats = numberFormats;
        composer.rt = rt;
        composer.te = te;
        composer.tm = tm;
        composer.d = d;
        composer.n = n;
        composer.getDateTimeFormat = getDateTimeFormat;
        composer.setDateTimeFormat = setDateTimeFormat;
        composer.mergeDateTimeFormat = mergeDateTimeFormat;
        composer.getNumberFormat = getNumberFormat;
        composer.setNumberFormat = setNumberFormat;
        composer.mergeNumberFormat = mergeNumberFormat;
        composer[InejctWithOptionSymbol] = __injectWithOption;
        composer[TranslateVNodeSymbol] = translateVNode;
        composer[DatetimePartsSymbol] = datetimeParts;
        composer[NumberPartsSymbol] = numberParts;
    }
    // for vue-devtools timeline event
    if ((process.env.NODE_ENV !== 'production')) {
        composer[EnableEmitter] = (emitter) => {
            _context.__v_emitter = emitter;
        };
        composer[DisableEmitter] = () => {
            _context.__v_emitter = undefined;
        };
    }
    return composer;
}
function addTimelineEvent(event, payload) {
}

const baseFormatProps = {
    tag: {
        type: [String, Object]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val /* ComponentI18nScope */) => val === 'parent' || val === 'global',
        default: 'parent' /* ComponentI18nScope */
    },
    i18n: {
        type: Object
    }
};

function getInterpolateArg(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots }, // SetupContext,
keys) {
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current) => {
            return [
                ...slot,
                // prettier-ignore
                ...(current.type === Fragment ? current.children : [current])
            ];
        }, []);
    }
    else {
        // named slots
        return keys.reduce((arg, key) => {
            const slot = slots[key];
            if (slot) {
                arg[key] = slot();
            }
            return arg;
        }, create$1());
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getFragmentableTag() {
    return Fragment;
}

/*#__PURE__*/ defineComponent({
    /* eslint-disable */
    name: 'i18n-t',
    props: assign$1({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [Number, String],
            validator: (val) => isNumber$1(val) || !isNaN(val)
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const { slots, attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return () => {
            const keys = Object.keys(slots).filter(key => key !== '_');
            const options = create$1();
            if (props.locale) {
                options.locale = props.locale;
            }
            if (props.plural !== undefined) {
                options.plural = isString$1(props.plural) ? +props.plural : props.plural;
            }
            const arg = getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = assign$1(create$1(), attrs);
            const tag = isString$1(props.tag) || isObject$1(props.tag)
                ? props.tag
                : getFragmentableTag();
            return h(tag, assignedAttrs, children);
        };
    }
});

function isVNode(target) {
    return isArray$1(target) && !isString$1(target[0]);
}
function renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots, attrs } = context;
    return () => {
        const options = { part: true };
        let overrides = create$1();
        if (props.locale) {
            options.locale = props.locale;
        }
        if (isString$1(props.format)) {
            options.key = props.format;
        }
        else if (isObject$1(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (isString$1(props.format.key)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                options.key = props.format.key;
            }
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop) => {
                return slotKeys.includes(prop)
                    ? assign$1(create$1(), options, { [prop]: props.format[prop] }) // eslint-disable-line @typescript-eslint/no-explicit-any
                    : options;
            }, create$1());
        }
        const parts = partFormatter(...[props.value, options, overrides]);
        let children = [options.key];
        if (isArray$1(parts)) {
            children = parts.map((part, index) => {
                const slot = slots[part.type];
                const node = slot
                    ? slot({ [part.type]: part.value, index, parts })
                    : [part.value];
                if (isVNode(node)) {
                    node[0].key = `${part.type}-${index}`;
                }
                return node;
            });
        }
        else if (isString$1(parts)) {
            children = [parts];
        }
        const assignedAttrs = assign$1(create$1(), attrs);
        const tag = isString$1(props.tag) || isObject$1(props.tag)
            ? props.tag
            : getFragmentableTag();
        return h(tag, assignedAttrs, children);
    };
}

/*#__PURE__*/ defineComponent({
    /* eslint-disable */
    name: 'i18n-n',
    props: assign$1({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return renderFormatter(props, context, NUMBER_FORMAT_OPTIONS_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[NumberPartsSymbol](...args));
    }
});

/* #__PURE__*/ defineComponent({
    /* eslint-disable */
    name: 'i18n-d',
    props: assign$1({
        value: {
            type: [Number, Date],
            required: true
        },
        format: {
            type: [String, Object]
        }
    }, baseFormatProps),
    /* eslint-enable */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup(props, context) {
        const i18n = props.i18n ||
            useI18n({
                useScope: props.scope,
                __useComponent: true
            });
        return renderFormatter(props, context, DATETIME_FORMAT_OPTIONS_KEYS, (...args) => 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n[DatetimePartsSymbol](...args));
    }
});

/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */
const I18nInjectionKey = 
/* #__PURE__*/ makeSymbol('global-vue-i18n');
function useI18n(options = {}) {
    const instance = getCurrentInstance();
    if (instance == null) {
        throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    }
    if (!instance.isCE &&
        instance.appContext.app != null &&
        !instance.appContext.app.__VUE_I18N_SYMBOL__) {
        throw createI18nError(I18nErrorCodes.NOT_INSTALLED);
    }
    const i18n = getI18nInstance(instance);
    const gl = getGlobalComposer(i18n);
    const componentOptions = getComponentOptions(instance);
    const scope = getScope(options, componentOptions);
    if (scope === 'global') {
        adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = getComposer(i18n, instance, options.__useComponent);
        if (composer == null) {
            if ((process.env.NODE_ENV !== 'production')) {
                warn$1(getWarnMessage(I18nWarnCodes.NOT_FOUND_PARENT_SCOPE));
            }
            composer = gl;
        }
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = assign$1({}, options);
        if ('__i18n' in componentOptions) {
            composerOptions.__i18n = componentOptions.__i18n;
        }
        if (gl) {
            composerOptions.__root = gl;
        }
        composer = createComposer(composerOptions);
        if (i18nInternal.__composerExtend) {
            composer[DisposeSymbol] =
                i18nInternal.__composerExtend(composer);
        }
        setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
function getI18nInstance(instance) {
    const i18n = inject(!instance.isCE
        ? instance.appContext.app.__VUE_I18N_SYMBOL__
        : I18nInjectionKey);
    /* istanbul ignore if */
    if (!i18n) {
        throw createI18nError(!instance.isCE
            ? I18nErrorCodes.UNEXPECTED_ERROR
            : I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
    }
    return i18n;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getScope(options, componentOptions) {
    // prettier-ignore
    return isEmptyObject$1(options)
        ? ('__i18n' in componentOptions)
            ? 'local'
            : 'global'
        : !options.useScope
            ? 'local'
            : options.useScope;
}
function getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition'
        ? i18n.global
        : i18n.global.__composer;
}
function getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = getParentComponentInstance(target, useComponent);
    while (current != null) {
        const i18nInternal = i18n;
        if (i18n.mode === 'composition') {
            composer = i18nInternal.__getInstance(current);
        }
        else {
            if (__VUE_I18N_LEGACY_API__) {
                const vueI18n = i18nInternal.__getInstance(current);
                if (vueI18n != null) {
                    composer = vueI18n
                        .__composer;
                    if (useComponent &&
                        composer &&
                        !composer[InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                    ) {
                        composer = null;
                    }
                }
            }
        }
        if (composer != null) {
            break;
        }
        if (root === current) {
            break;
        }
        current = current.parent;
    }
    return composer;
}
function getParentComponentInstance(target, useComponent = false) {
    if (target == null) {
        return null;
    }
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent
        ? target.parent
        : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    onMounted(() => {
        // inject composer instance to DOM for intlify-devtools
        if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) &&
            !false &&
            target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = createEmitter();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[EnableEmitter] && _composer[EnableEmitter](emitter);
            emitter.on('*', addTimelineEvent);
        }
    }, target);
    onUnmounted(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (((process.env.NODE_ENV !== 'production') || __VUE_PROD_DEVTOOLS__) &&
            !false &&
            target.vnode.el &&
            target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off('*', addTimelineEvent);
            _composer[DisableEmitter] && _composer[DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[DisposeSymbol];
        }
    }, target);
}

{
    initFeatureFlags();
}
// register message compiler at vue-i18n
registerMessageCompiler(compile);
// register message resolver at vue-i18n
registerMessageResolver(resolveValue);
// register fallback locale at vue-i18n
registerLocaleFallbacker(fallbackWithLocaleChain);
// NOTE: experimental !!
if ((process.env.NODE_ENV !== 'production') || __INTLIFY_PROD_DEVTOOLS__) {
    const target = getGlobalThis$1();
    target.__INTLIFY__ = true;
    setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
if ((process.env.NODE_ENV !== 'production')) ;

const _hoisted_1$F = { class: "uk-card uk-card-body uk-align-center" };
const _hoisted_2$z = { class: "uk-list" };
const _hoisted_3$u = { key: 0 };
const _hoisted_4$s = ["onClick"];
const _hoisted_5$q = { class: "uk-card uk-card-body uk-align-center" };


var script$L = {
  __name: 'Offer',
  setup(__props) {

const { locale } = useI18n();


//const { date, offset, uncertainty } = await getServerDate();
//var curdate = serverDate.toISOString()

var curdate = new Date().toISOString();

const prices = useObservable(
    liveQuery(() => {
        joinProducts(db.prices.where("priceGroup").anyOf(["DE_1"]).and(item => item.promotionBegin < curdate).and(item => item.promotionEnd > curdate)).then((p) => {
            prices.value = p;
        });
    })
);

const currencyFormatter = computed(() => new Intl.NumberFormat(locale.value, { style: 'currency', currency: 'EUR' }));

function selectProduct(prod) {
    psModal({
        useProd: prod,
        bcView: true
    });
}

function orderPostcard() {
    psModal({
        useProd: { pid: 'PK2' },
        bcView: true
    });
}


function orderPoster() {
    psModal({ 
        usePgrId: 4,
        bcView: true,
        layout: 'standard'
        });
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$F, [
      createElementVNode("div", null, toDisplayString$1(_ctx.$t('offer.currentOffers')), 1 /* TEXT */),
      createElementVNode("ul", _hoisted_2$z, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(prices), (item) => {
          return (openBlock(), createElementBlock("li", {
            key: item.id
          }, [
            createTextVNode(toDisplayString$1(item.pid) + " ", 1 /* TEXT */),
            (item.product)
              ? (openBlock(), createElementBlock("span", _hoisted_3$u, toDisplayString$1(item.product.label) + " " + toDisplayString$1(item.product.format), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            createTextVNode(" " + toDisplayString$1(currencyFormatter.value.format(item.price)) + " ", 1 /* TEXT */),
            createElementVNode("button", {
              id: "show-modal",
              onClick: $event => (selectProduct(item.product)),
              class: "uk-button uk-button-default uk-button-small uk-button-primary"
            }, toDisplayString$1(_ctx.$t('offer.order')), 9 /* TEXT, PROPS */, _hoisted_4$s)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    createElementVNode("div", _hoisted_5$q, [
      createElementVNode("button", {
        id: "show-modal",
        onClick: _cache[0] || (_cache[0] = $event => (orderPoster())),
        class: "uk-button uk-button-default uk-button-small uk-button-primary"
      }, toDisplayString$1(_ctx.$t('offer.orderPosterNow')), 1 /* TEXT */),
      _cache[1] || (_cache[1] = createTextVNode("  ")),
      createElementVNode("button", {
        id: "show-modal",
        onClick: orderPostcard,
        class: "uk-button uk-button-default uk-button-small uk-button-primary"
      }, toDisplayString$1(_ctx.$t('offer.customPostcard')), 1 /* TEXT */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$L.__file = "src/components/Offer.vue";

const _hoisted_1$E = { "uk-dropnav": "mode: click" };
const _hoisted_2$y = { class: "uk-subnav uk-margin-small-bottom" };
const _hoisted_3$t = { href: "" };
const _hoisted_4$r = ["uk-icon"];
const _hoisted_5$p = {
  key: 1,
  class: "add-filter"
};
const _hoisted_6$l = { class: "uk-dropdown" };
const _hoisted_7$k = { class: "uk-nav uk-dropdown-nav" };
const _hoisted_8$h = ["onClick"];
const _hoisted_9$h = { class: "uk-active" };
const _hoisted_10$g = { class: "chips-box" };
const _hoisted_11$g = ["onClick"];


var script$K = {
  __name: 'ChipsFilter',
  props: {
    filterItems: Object,
    ignoreItems: Object,
    addFilterIcon: String
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const filterItems = ref([]);

const props = __props;

const emit = __emit;

if (props.filterItems) filterItems.value = props.filterItems;

if (props.ignoreItems) {
    for (var i in props.ignoreItems) {
        filterItems.value = filterItems.value.filter(item => item[i] !== props.ignoreItems[i]);
    }
}


function activate(item) {
   item.active = true;
   emit("change", filterItems);
}

function deactivate(item) {
    item.active = false;
    emit("change", filterItems);
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("nav", _hoisted_1$E, [
    createElementVNode("ul", _hoisted_2$y, [
      createElementVNode("li", null, [
        createElementVNode("a", _hoisted_3$t, [
          (props.addFilterIcon)
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                "uk-icon": 'icon: ' + props.addFilterIcon
              }, null, 8 /* PROPS */, _hoisted_4$r))
            : (openBlock(), createElementBlock("span", _hoisted_5$p))
        ]),
        createElementVNode("div", _hoisted_6$l, [
          createElementVNode("ul", _hoisted_7$k, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(filterItems.value, (item, fid) => {
              return (openBlock(), createElementBlock("li", { key: fid }, [
                createElementVNode("a", {
                  class: "uk-drop-close",
                  href: "#",
                  onClick: $event => (activate(item))
                }, toDisplayString$1(item.name), 9 /* TEXT, PROPS */, _hoisted_8$h)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      createElementVNode("li", _hoisted_9$h, [
        createElementVNode("div", _hoisted_10$g, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(filterItems.value.filter((item) => item.active), (chip, index) => {
            return (openBlock(), createElementBlock("div", {
              class: "uk-badge chip",
              key: index
            }, [
              createTextVNode(toDisplayString$1(chip.name) + " ", 1 /* TEXT */),
              createElementVNode("a", {
                href: "#",
                onClick: $event => (deactivate(chip))
              }, [...(_cache[0] || (_cache[0] = [
                createElementVNode("span", {
                  class: "",
                  "uk-icon": "close"
                }, null, -1 /* HOISTED */)
              ]))], 8 /* PROPS */, _hoisted_11$g)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}
}

};

script$K.__file = "src/components/ui/ChipsFilter.vue";

const _hoisted_1$D = ["min", "max"];
const _hoisted_2$x = { key: 1 };

const sizeDefault = 20;

// CSS Custom Properties für Höhe und Font-Größe

var script$J = {
  __name: 'NumInput',
  props: {
    num: [Number, String],
    min: [Number, String],
    max: [Number, String],
    size: [Number, String],
    width: [Number, String],
    showInput: {
        type: Boolean,
        default: false,
    },
    className: {
        type: String,
        default: "",
    },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const props = __props;

const elementStyle = computed(() => {
    let outWidth = {};
    let outSize = {};

    if (typeof props.width != "undefined") {
        outWidth = {
            '--input-width': `${props.width}px`,
        };
    }
    if (typeof props.size != "undefined") {
        const scale = Math.round(props.size/sizeDefault * 100)/100;
        outSize = {
            '--input-height': `${props.size}px`,
            '--input-font-scale': scale,
        };
    }
    return { ...outWidth, ...outSize }
});

const constraints = { min: 0, max: null };
if (typeof props.min != "undefined") constraints.min = parseInt(props.min);
if (typeof props.max != "undefined") constraints.max = parseInt(props.max);

const emit = __emit;

const input = ref(props.num);

function normalizeNumber(value) {
    const parsed = parseInt(value);
    if (Number.isNaN(parsed)) return constraints.min

    if (constraints.max != null && parsed > constraints.max) return constraints.max
    if (constraints.min != null && parsed < constraints.min) return constraints.min
    return parsed
}

watch(() => props.num, (value) => {
    input.value = normalizeNumber(value);
});

function numInc() {
    let max = constraints.max;
    const current = normalizeNumber(input.value);
    if (max == null || current < max) input.value = current + 1;
}

function numDec() {
    let min = constraints.min;
    const current = normalizeNumber(input.value);
    if (min == null || current > min) input.value = current - 1;
}

function onInputBlur() {
    input.value = normalizeNumber(input.value);
}

watch(input, (v) => {
    emit("change", normalizeNumber(v));
});


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["num-input", __props.className]),
    style: normalizeStyle(elementStyle.value)
  }, [
    createElementVNode("button", {
      onClick: numDec,
      class: "num-dec",
      type: "button",
      "aria-label": "Verringern"
    }, _cache[1] || (_cache[1] = [
      createElementVNode("span", { class: "num-btn-symbol" }, "-", -1 /* HOISTED */)
    ])),
    (__props.showInput)
      ? withDirectives((openBlock(), createElementBlock("input", {
          key: 0,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((input).value = $event)),
          inputmode: "numeric",
          min: constraints.min,
          max: constraints.max,
          class: "num-input-field",
          onBlur: onInputBlur
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1$D)), [
          [vModelText, input.value]
        ])
      : (openBlock(), createElementBlock("span", _hoisted_2$x, toDisplayString$1(input.value), 1 /* TEXT */)),
    createElementVNode("button", {
      onClick: numInc,
      class: "num-inc",
      type: "button",
      "aria-label": "Erhöhen"
    }, _cache[2] || (_cache[2] = [
      createElementVNode("span", { class: "num-btn-symbol" }, "+", -1 /* HOISTED */)
    ]))
  ], 6 /* CLASS, STYLE */))
}
}

};

script$J.__file = "src/components/ui/NumInput.vue";

var script$I = {
  __name: 'InfiniteLoader',
  props: {
    width: "Number"
},
  setup(__props) {


const props = __props;

let width = 500;
if (props.width) width = props.width;


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: "infinite-loader",
    style: normalizeStyle('width:' + unref(width) + 'px')
  }, _cache[0] || (_cache[0] = [
    createElementVNode("div", { class: "loaderBar" }, null, -1 /* HOISTED */)
  ]), 4 /* STYLE */))
}
}

};

script$I.__scopeId = "data-v-b6c5893c";
script$I.__file = "src/components/ui/InfiniteLoader.vue";

var script$H = {
  __name: 'ArrowBox',
  props: {
    content: String,
    delay: Number,
    arrow: {
      type: String,
      default: 'arrow-top'
    }
},
  setup(__props) {


const props = __props;

const isVisible = ref(false);

let delay = 0;
if (props.delay) delay = props.delay;
onMounted(() => {
  setTimeout(() => {
    isVisible.value = true;
  }, delay);
});


return (_ctx, _cache) => {
  return (openBlock(), createBlock(Transition, null, {
    default: withCtx(() => [
      (isVisible.value)
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["box", props.arrow])
          }, toDisplayString$1(props.content), 3 /* TEXT, CLASS */))
        : createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

};

script$H.__file = "src/components/ui/ArrowBox.vue";

const _hoisted_1$C = {
  class: "uk-slideshow-items",
  "uk-height-viewport": "offset-top: true; offset-bottom: 20"
};
const _hoisted_2$w = { class: "slide center" };
const _hoisted_3$s = {
  key: 0,
  class: "uk-overlay uk-overlay-primary uk-position-bottom info-box"
};
const _hoisted_4$q = { class: "uk-inline pages" };
const _hoisted_5$o = {
  key: 0,
  class: "uk-overlay uk-overlay-primary uk-position-bottom info-box"
};
const _hoisted_6$k = {
  key: 2,
  class: "page-control"
};
const _hoisted_7$j = {
  key: 0,
  class: "page-info"
};
const _hoisted_8$g = {
  key: 1,
  class: "page-info"
};
const _hoisted_9$g = ["uk-icon"];


var script$G = {
  __name: 'SlideShow',
  props: {
    height: {
        type: String,
        default: "400px"
    },
    width: {
        type: String,
        default: "400px"
    },
    slides: Array,
    resource: {
        type: String,
        default: 'gal'
    },
    images: Array,
    index: {
        type: Number,
        default: 0
    },
    infoComponent: {
        type: String,
        default: ""
    }
},
  setup(__props) {

const slideList = ref([]);
const slideshow = ref();
const singlePage = ref(true);
const galleryPreviewSize = String(previewResourceSizes.gallery);
// Auf Mobile bleibt :hover nach einem Touch aktiv, deshalb per Klick umschaltbar
const infoVisible = ref(false);

function toggleInfo() {
    infoVisible.value = !infoVisible.value;
}

const props = __props;

if  (props.slides) slideList.value = props.slides;

// Definition aller möglichen Komponenten für Infobox
// Auswahl der dynamischen Komponente erfolgt über props.infoComponent
const info = {
    FileInfo: script$7
};
let infoModel = false;
if (info[props.infoComponent]) infoModel = shallowRef(info[props.infoComponent]);


if (props.images) {
    slideList.value = [];
    props.images.forEach((image) => {
        slideList.value.push({
            ...image,
            currentPage: 1
        });
    });

}

const pageIcon = computed(() => {
    let name = (singlePage.value)?'thumbnails':'file';
    return "icon: " + name
});

function setPage(slide,val) {
    if (val < 1) return
    if (val > slide.pages) return
    slide.currentPage = val;
}


onMounted(() => {
    UIkit.slideshow(slideshow.value).show(props.index);
    // Info-Box beim Wechsel des Slides wieder ausblenden
    UIkit.util.on(slideshow.value, 'itemshow', () => {
        infoVisible.value = false;
    });
});


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    ref_key: "slideshow",
    ref: slideshow,
    class: "uk-position-relative uk-visible-toggle uk-light",
    "uk-slideshow": "",
    tabindex: "-1"
  }, [
    createElementVNode("div", _hoisted_1$C, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(slideList.value, (slide, id) => {
        return (openBlock(), createElementBlock("div", { key: id }, [
          createElementVNode("div", _hoisted_2$w, [
            (singlePage.value)
              ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass(["uk-inline", { 'info-visible': infoVisible.value }]),
                  onClick: toggleInfo
                }, [
                  createVNode(unref(script$5), {
                    loading: "lazy",
                    mediaElement: slide,
                    resource: slide.resource || props.resource,
                    size: slide.resource ? unref(galleryPreviewSize) : null,
                    alt: "",
                    "uk-contain": ""
                  }, null, 8 /* PROPS */, ["mediaElement", "resource", "size"]),
                  (props.infoComponent)
                    ? (openBlock(), createElementBlock("div", _hoisted_3$s, [
                        (openBlock(), createBlock(resolveDynamicComponent(unref(infoModel)), { elem: slide }, null, 8 /* PROPS */, ["elem"]))
                      ]))
                    : createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              : (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: normalizeClass(["uk-inline multi-page", { 'info-visible': infoVisible.value }]),
                  onClick: toggleInfo
                }, [
                  createElementVNode("div", _hoisted_4$q, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(slide.pages, (index) => {
                      return (openBlock(), createBlock(unref(script$5), {
                        key: index,
                        loading: "lazy",
                        mediaElement: slide,
                        page: index,
                        resource: slide.resource || 'th',
                        alt: "",
                        "uk-contain": ""
                      }, null, 8 /* PROPS */, ["mediaElement", "page", "resource"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  (props.infoComponent)
                    ? (openBlock(), createElementBlock("div", _hoisted_5$o, [
                        (openBlock(), createBlock(resolveDynamicComponent(unref(infoModel)), { elem: slide }, null, 8 /* PROPS */, ["elem"]))
                      ]))
                    : createCommentVNode("v-if", true)
                ], 2 /* CLASS */)),
            (slide.pages && slide.currentPage)
              ? (openBlock(), createElementBlock("div", _hoisted_6$k, [
                  (singlePage.value)
                    ? (openBlock(), createElementBlock("div", _hoisted_7$j, [
                        createElementVNode("span", null, toDisplayString$1(_ctx.$t("Page")), 1 /* TEXT */),
                        createVNode(unref(script$J), {
                          class: "page-inc",
                          size: 25,
                          num: slide.currentPage,
                          min: 1,
                          max: slide.pages,
                          onChange: (val) => setPage(slide,val)
                        }, null, 8 /* PROPS */, ["num", "max", "onChange"]),
                        createElementVNode("span", null, toDisplayString$1(_ctx.$t("of") + " " + slide.pages), 1 /* TEXT */)
                      ]))
                    : (openBlock(), createElementBlock("span", _hoisted_8$g, toDisplayString$1(_ctx.$t("n pages", slide.pages)), 1 /* TEXT */)),
                  createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = $event => (singlePage.value = !singlePage.value)),
                    class: "icon",
                    "uk-icon": pageIcon.value
                  }, null, 8 /* PROPS */, _hoisted_9$g)
                ]))
              : createCommentVNode("v-if", true)
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _cache[1] || (_cache[1] = createElementVNode("a", {
      class: "uk-position-center-left uk-position-small uk-hidden-hover",
      href: "",
      "uk-slidenav-previous": "",
      "uk-slideshow-item": "previous"
    }, null, -1 /* HOISTED */)),
    _cache[2] || (_cache[2] = createElementVNode("a", {
      class: "uk-position-center-right uk-position-small uk-hidden-hover",
      href: "",
      "uk-slidenav-next": "",
      "uk-slideshow-item": "next"
    }, null, -1 /* HOISTED */))
  ], 512 /* NEED_PATCH */))
}
}

};

script$G.__file = "src/components/ui/SlideShow.vue";

const _hoisted_1$B = { class: "warning product-mismatch-warning uk-margin-small-bottom" };
const _hoisted_2$v = {
  key: 0,
  class: "warning-prefix"
};
const _hoisted_3$r = {
  key: 1,
  class: "b warning-size"
};
const _hoisted_4$p = { key: 0 };
const _hoisted_5$n = {
  key: 2,
  class: "warning-closest"
};
const _hoisted_6$j = { class: "b" };
const _hoisted_7$i = {
  key: 3,
  class: "warning-suffix"
};


var script$F = {
  __name: 'ProductMismatchWarning',
  props: {
    file: {
        type: Object,
        default: null
    },
    titleKey: {
        type: String,
        default: 'no product match'
    },
    sizeKey: {
        type: String,
        default: 'your size'
    },
    closestLabelKey: {
        type: String,
        default: 'closest product label'
    },
    closestDetailsKey: {
        type: String,
        default: 'closest product details'
    }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const closestProduct = ref(null);

const hasDimensions = computed(() => {
    return Boolean(props.file && (props.file.width || props.file.height));
});

const formattedSize = computed(() => {
    if (!hasDimensions.value) return '';
    return t(props.sizeKey, {
        width: props.file?.width ?? '-',
        height: props.file?.height ?? '-'
    });
});

const formattedPages = computed(() => {
    const pages = Number(props.file?.pages);
    return Number.isFinite(pages) ? t('n pages', pages) : '';
});

async function findClosestProduct(file) {
    if (!file?.width || !file?.height) {
        closestProduct.value = null;
        return;
    }

    const mediaW = Number(file.width);
    const mediaH = Number(file.height);
    const mediaType = file.type || file['@type'];
    const mediaPages = Number(file.pages);

    try {
        let collection = db.products.where('state').equals('verfügbar');

        if (mediaType === 'application/pdf') {
            collection = collection.and(item => {
                const notAuxiliary = !['VP', 'AP', 'ZP'].includes(String(item.pid).substring(0, 2));
                return notAuxiliary;
            });
        }

        const products = await collection.toArray();

        let bestPageMatch = null;
        let minPageMatchDistance = Infinity;
        let bestFallback = null;
        let minFallbackDistance = Infinity;

        for (const prod of products) {
            if (!prod.widthMM || !prod.heightMM) continue;

            const trim = Number(prod.trimAbs ?? 0);
            const targetW = Number(prod.widthMM) + trim * 2;
            const targetH = Number(prod.heightMM) + trim * 2;

            const distNormal = Math.hypot(targetW - mediaW, targetH - mediaH);
            const distRotated = Math.hypot(targetH - mediaW, targetW - mediaH);

            const distance = Math.min(distNormal, distRotated);
            const minPages = Number(prod.pageMin ?? 0);
            const maxPages = Number(prod.pageMax ?? Number.MAX_SAFE_INTEGER);
            const fallbackCandidate = {
                product: prod,
                width: targetW,
                height: targetH,
                distance,
                minPages,
                maxPages
            };

            if (distance < minFallbackDistance) {
                minFallbackDistance = distance;
                bestFallback = fallbackCandidate;
            }

            const pageMatches = !Number.isFinite(mediaPages)
                || (mediaPages >= minPages && mediaPages <= maxPages);

            if (pageMatches && distance < minPageMatchDistance) {
                minPageMatchDistance = distance;
                bestPageMatch = fallbackCandidate;
            }
        }

        closestProduct.value = bestPageMatch || bestFallback;
    } catch {
        closestProduct.value = null;
    }
}

watch(() => props.file, (newFile) => {
    findClosestProduct(newFile);
}, { immediate: true, deep: true });

const closestProductDetails = computed(() => {
    if (!closestProduct.value) return '';
    const { product, width, height } = closestProduct.value;
    const pages = closestProduct.value.minPages === closestProduct.value.maxPages
        ? closestProduct.value.minPages
        : `${closestProduct.value.minPages}-${closestProduct.value.maxPages}`;
    return t(props.closestDetailsKey, {
        label: product.label || '',
        format: product.format || '',
        width,
        height,
        pages
    });
});

const messageParts = computed(() => {
    const raw = t(props.titleKey, ['__SIZE_SLOT__']);
    if (raw.includes('__SIZE_SLOT__')) {
        const [prefix, suffix] = raw.split('__SIZE_SLOT__');
        return {
            prefix: prefix.trim(),
            suffix: suffix.trim()
        };
    }
    return {
        prefix: raw,
        suffix: ''
    };
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$B, [
    (messageParts.value.prefix)
      ? (openBlock(), createElementBlock("div", _hoisted_2$v, toDisplayString$1(messageParts.value.prefix), 1 /* TEXT */))
      : createCommentVNode("v-if", true),
    (formattedSize.value)
      ? (openBlock(), createElementBlock("p", _hoisted_3$r, [
          createTextVNode(toDisplayString$1(formattedSize.value), 1 /* TEXT */),
          (formattedPages.value)
            ? (openBlock(), createElementBlock("span", _hoisted_4$p, ", " + toDisplayString$1(formattedPages.value), 1 /* TEXT */))
            : createCommentVNode("v-if", true)
        ]))
      : createCommentVNode("v-if", true),
    (closestProductDetails.value)
      ? (openBlock(), createElementBlock("p", _hoisted_5$n, [
          createTextVNode(toDisplayString$1(_ctx.$t(__props.closestLabelKey)) + " ", 1 /* TEXT */),
          _cache[0] || (_cache[0] = createElementVNode("br", null, null, -1 /* HOISTED */)),
          createElementVNode("span", _hoisted_6$j, toDisplayString$1(closestProductDetails.value), 1 /* TEXT */)
        ]))
      : createCommentVNode("v-if", true),
    (messageParts.value.suffix)
      ? (openBlock(), createElementBlock("div", _hoisted_7$i, toDisplayString$1(messageParts.value.suffix), 1 /* TEXT */))
      : createCommentVNode("v-if", true)
  ]))
}
}

};

script$F.__scopeId = "data-v-6dfb861a";
script$F.__file = "src/components/ui/ProductMismatchWarning.vue";

const _hoisted_1$A = {
  key: 0,
  class: "media-error-warning uk-alert uk-alert-danger uk-margin-small-bottom"
};
const _hoisted_2$u = { class: "uk-margin-small-top uk-margin-remove-bottom" };


var script$E = {
  __name: 'MediaErrorWarning',
  props: {
    media: {
        type: Object,
        default: null
    }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const errors = computed(() => getMediaDocumentErrors(props.media));
const errorMessages = computed(() => errors.value.map((error) => {
    const key = `mediaErrors.${error.key}`;
    return t(key, { value: error.value });
}));

return (_ctx, _cache) => {
  return (errors.value.length)
    ? (openBlock(), createElementBlock("div", _hoisted_1$A, [
        createElementVNode("strong", null, toDisplayString$1(_ctx.$t('mediaErrors.title')), 1 /* TEXT */),
        createElementVNode("ul", _hoisted_2$u, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(errorMessages.value, (message, index) => {
            return (openBlock(), createElementBlock("li", { key: index }, toDisplayString$1(message), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    : createCommentVNode("v-if", true)
}
}

};

script$E.__scopeId = "data-v-6a847da6";
script$E.__file = "src/components/ui/MediaErrorWarning.vue";

function useProductSelectorInlineUpload({
    psList,
    inlineUploadListId,
    fileSelector,
    configStore,
    refreshQueue,
    readMediaSelection,
    checkConditionsProduct,
    refreshForm,
    editFile,
    emit,
}) {
    const CONNECT_UPLOAD_ACTION = 'inline-upload-connect';
    const INLINE_UPLOAD_EVENT_DEDUP_TTL_MS = 10000;
    const INLINE_UPLOAD_EVENT_DEDUP_MAX_SIZE = 500;
    const appliedUploadIds = new Map();
    const seenInlineUploadEventIds = new Map();
    let releaseInlineImageUploadListener = null;
    let releaseInlineMediaUploadListener = null;

    function resolveUploadTargetListId() {
        if (inlineUploadListId.value !== false) return inlineUploadListId.value
        if (fileSelector.value !== false) return fileSelector.value
        return false
    }

    function resolveUploadEventId(payload) {
        if (!payload || typeof payload != 'object') return ''
        return payload._eventId || payload.eventId || ''
    }

    function cleanupInlineUploadEventIds(now = Date.now()) {
        seenInlineUploadEventIds.forEach((seenAt, eventId) => {
            if (now - seenAt > INLINE_UPLOAD_EVENT_DEDUP_TTL_MS) {
                seenInlineUploadEventIds.delete(eventId);
            }
        });
    }

    function shouldProcessInlineUploadSse(payload) {
        const eventId = resolveUploadEventId(payload);
        if (!eventId) return true

        const now = Date.now();
        cleanupInlineUploadEventIds(now);

        if (seenInlineUploadEventIds.has(eventId)) {
            return false
        }

        // Mark before async processing so closely spaced duplicates are dropped reliably.
        seenInlineUploadEventIds.set(eventId, now);

        if (seenInlineUploadEventIds.size > INLINE_UPLOAD_EVENT_DEDUP_MAX_SIZE) {
            const oldestEventId = seenInlineUploadEventIds.keys().next().value;
            if (oldestEventId) seenInlineUploadEventIds.delete(oldestEventId);
        }

        return true
    }

    function resolveUploadAction(payload) {
        if (!payload || typeof payload != 'object') return ''

        const actionObjectCandidates = [
            payload.action,
            payload.data?.action,
            payload.item?.action,
            payload.media?.action,
            payload.meta?.action,
        ];

        const uploadActionFromActionObject = actionObjectCandidates
            .find((actionObject) => actionObject && typeof actionObject == 'object' && typeof actionObject.uploadAction == 'string')
            ?.uploadAction;

        return uploadActionFromActionObject || ''
    }

    function getUploadIdentity(item) {
        if (!item || typeof item != 'object') return ''
        const type = item['@type'] || item.type || 'item';
        const id = item.id || item.jid || item.bid || item.uuid || item.name;
        if (!id) return ''
        return `${type}:${id}`
    }

    function cleanupAppliedUploadIds() {
        const now = Date.now();
        appliedUploadIds.forEach((timestamp, key) => {
            if (now - timestamp > 30000) {
                appliedUploadIds.delete(key);
            }
        });
    }

    function markUploadApplied(item) {
        const identity = getUploadIdentity(item);
        if (!identity) return
        cleanupAppliedUploadIds();
        appliedUploadIds.set(identity, Date.now());
    }

    function hasUploadBeenApplied(item) {
        const identity = getUploadIdentity(item);
        if (!identity) return false
        cleanupAppliedUploadIds();
        return appliedUploadIds.has(identity)
    }

    function resolveRedesignMenuItem(psEl) {
        const redesignConfig = productSelectorUploadMenu?.redesign;
        if (!redesignConfig) return null

        const selectorState = psEl?.ps?.status;
        const selectedCategory = selectorState?.form?.cat;

        let actionConfig = redesignConfig.defaultAction;

        if (!selectorState?.product) {
            const noSelectionConfig = redesignConfig.whenNoSelection;

            if (noSelectionConfig === true || typeof noSelectionConfig == 'undefined') {
                actionConfig = redesignConfig.defaultAction;
            } else if (noSelectionConfig === false || noSelectionConfig === null) {
                actionConfig = false;
            } else {
                actionConfig = noSelectionConfig;
            }
        }

        if (selectedCategory && redesignConfig.byCategory && Object.prototype.hasOwnProperty.call(redesignConfig.byCategory, selectedCategory)) {
            const categoryActionConfig = redesignConfig.byCategory[selectedCategory];

            // Explizit leere Kategorie-Konfiguration (z.B. {}) unterdrückt den Menüeintrag.
            if (categoryActionConfig && typeof categoryActionConfig == 'object' && !categoryActionConfig.id) {
                return null
            }

            actionConfig = categoryActionConfig;
        }

        if (!actionConfig) {
            if (redesignConfig.hideWhenUnavailable) return null
            return {
                id: 'redesign-disabled',
                action: '',
                label: redesignConfig.label || 'neu gestalten',
            }
        }

        if (typeof actionConfig == 'string') {
            return {
                id: `redesign-${actionConfig}`,
                action: actionConfig,
                label: redesignConfig.label || 'neu gestalten',
            }
        }

        return {
            id: actionConfig.id || 'custom',
            action: typeof actionConfig.action == 'string' ? actionConfig.action : '',
            label: actionConfig.label || redesignConfig.label || 'neu gestalten',
        }
    }

    function resolveConfiguredMenuItems(psEl, listId) {
        const configuredMenuItems = productSelectorUploadMenu?.menuItems;
        if (!configuredMenuItems) return null

        const selectedCategory = psEl?.ps?.status?.form?.cat;

        const selectorState = _.cloneDeep(psEl?.ps?.status || {});
        const menuItemsSource = typeof configuredMenuItems === 'function'
            ? configuredMenuItems({
                configStore,
                listId,
                selectorId: psEl?.id,
                selectorStatus: selectorState,
                document,
                window,
            })
            : configuredMenuItems;

        if (!Array.isArray(menuItemsSource)) return null

        const applyCategoryOverride = function (item) {
            if (!item || typeof item != 'object') return null

            const hasCategoryOverride = selectedCategory
                && item.byCategory
                && Object.prototype.hasOwnProperty.call(item.byCategory, selectedCategory);

            if (!hasCategoryOverride) return item

            const categoryOverride = item.byCategory[selectedCategory];

            if (categoryOverride === false || categoryOverride === null) return null

            if (typeof categoryOverride == 'string') {
                return {
                    ...item,
                    label: categoryOverride,
                }
            }

            if (typeof categoryOverride == 'object') {
                return {
                    ...item,
                    ...categoryOverride,
                }
            }

            return item
        };

        return menuItemsSource
            .filter((item) => item && typeof item == 'object')
            .map((item) => applyCategoryOverride(item))
            .filter((item) => item && typeof item == 'object')
            .map((item, index) => ({
                id: item.id || `upload-menu-${index}`,
                action: typeof item.action == 'string' ? item.action : '',
                label: item.label || '',
            }))
            .filter((item) => item.label)
    }

    const uploadMenuItems = computed(() => {
        const listId = resolveUploadTargetListId();
        if (listId === false) return []

        const psEl = psList.value[listId];
        if (!psEl) return []

        const configuredMenuItems = resolveConfiguredMenuItems(psEl, listId);
        const menuItems = Array.isArray(configuredMenuItems)
            ? [...configuredMenuItems]
            : [{
                id: 'open-gallery',
                action: 'open-gallery',
                label: 'aus Galerie',
            }];

        const redesignMenuItem = resolveRedesignMenuItem(psEl);
        if (redesignMenuItem && !menuItems.some((menuItem) => menuItem.id == redesignMenuItem.id)) {
            menuItems.push(redesignMenuItem);
        }

        return menuItems
    });

    function onUploadMenuAction(menuItem) {
        const action = menuItem?.action;
        const listId = resolveUploadTargetListId();
        if (listId === false) return

        if (action == 'open-gallery') {
            inlineUploadListId.value = false;
            fileSelector.value = listId;
            return
        }

        if (!action) return

        const psEl = psList.value[listId];
        if (!psEl) return

        if (action == 'calendar-editor') {
            if (configStore?.calendarEditPath) {
                document.location.href = configStore.calendarEditPath;
            }
            return
        }

        emit('redesign-action', {
            action,
            listId,
            selectorId: psEl.id,
            selectorStatus: _.cloneDeep(psEl.ps?.status || {}),
        });

        const hasMedia = Array.isArray(psEl.ps?.status?.media) && psEl.ps.status.media.length > 0;
        if (hasMedia) {
            inlineUploadListId.value = false;
            fileSelector.value = false;
            editFile(listId);
        }
    }

    function extractUploadedMediaItem(payload) {
        if (!payload) return null

        const candidates = [
            payload.data,
            payload.item,
            payload.media,
            payload,
        ];

        for (const candidate of candidates) {
            if (Array.isArray(candidate)) {
                const found = candidate.find((item) => item && typeof item == 'object');
                if (found) return found
                continue
            }
            if (candidate && typeof candidate == 'object') {
                const hasIdentity = !!(candidate.id || candidate.jid || candidate.bid);
                if (hasIdentity) return candidate
            }
        }

        return null
    }

    function extractUploadedMediaItems(payload) {
        if (!payload) return []

        const hasCompletePayload = Array.isArray(payload?.successful);
        const completeCandidates = hasCompletePayload
            ? payload.successful.map((file) => file?.response?.body).filter(Boolean)
            : [];

        const fallbackCandidates = hasCompletePayload ? [] : [payload];
        const allCandidates = [...completeCandidates, ...fallbackCandidates];
        const items = [];

        allCandidates.forEach((candidate) => {
            const item = extractUploadedMediaItem(candidate);
            if (item) items.push(item);
        });

        const deduplicated = [];
        const knownIds = new Set();

        items.forEach((item) => {
            const identity = getUploadIdentity(item);
            if (identity && knownIds.has(identity)) return
            if (identity) knownIds.add(identity);
            deduplicated.push(item);
        });

        return deduplicated
    }

    async function applyUploadedMediaToSelector(uploadPayload, listId) {
        const psEl = psList.value[listId];
        if (!psEl) return

        const uploadedItem = extractUploadedMediaItem(uploadPayload);
        if (!uploadedItem) return

        if (hasUploadBeenApplied(uploadedItem)) return

        psEl.ps.status.media = readMediaSelection([uploadedItem]);
        checkConditionsProduct(psEl);
        psEl.schema = false;
        markUploadApplied(uploadedItem);

        await nextTick();
        psEl.previewUC += 1;
        refreshQueue.enqueue(() => refreshForm(psEl));

        inlineUploadListId.value = false;
    }

    async function applyUploadedMediaBatchToSelector(uploadPayload, listId) {
        const psEl = psList.value[listId];
        if (!psEl) return

        const uploadedItems = extractUploadedMediaItems(uploadPayload);
        if (!uploadedItems.length) return

        const freshItems = uploadedItems.filter((item) => !hasUploadBeenApplied(item));
        if (!freshItems.length) return

        psEl.ps.status.media = readMediaSelection(freshItems);
        checkConditionsProduct(psEl);
        psEl.schema = false;
        freshItems.forEach((item) => markUploadApplied(item));

        await nextTick();
        psEl.previewUC += 1;
        refreshQueue.enqueue(() => refreshForm(psEl));

        inlineUploadListId.value = false;
    }

    async function onInlineUploadComplete(uploadPayload, listId) {
        await applyUploadedMediaBatchToSelector(uploadPayload, listId);
    }

    async function onInlineUploadSse(payload) {
        const listId = resolveUploadTargetListId();
        if (listId === false) return

        const uploadAction = resolveUploadAction(payload);
        if (uploadAction != CONNECT_UPLOAD_ACTION) {
            return
        }

        if (!shouldProcessInlineUploadSse(payload)) return

        await applyUploadedMediaToSelector(payload, listId);
    }

    onMounted(() => {
        releaseInlineImageUploadListener = registerMercureEvent('image', (payload) => {
            onInlineUploadSse(payload);
        });
        releaseInlineMediaUploadListener = registerMercureEvent('media', (payload) => {
            onInlineUploadSse(payload);
        });
    });

    onBeforeUnmount(() => {
        if (typeof releaseInlineImageUploadListener == 'function') {
            releaseInlineImageUploadListener();
            releaseInlineImageUploadListener = null;
        }
        if (typeof releaseInlineMediaUploadListener == 'function') {
            releaseInlineMediaUploadListener();
            releaseInlineMediaUploadListener = null;
        }
    });

    return {
        uploadMenuItems,
        onUploadMenuAction,
        onInlineUploadComplete,
    }
}

const _hoisted_1$z = {
  key: 0,
  class: "ps-modal-content"
};
const _hoisted_2$t = {
  key: 0,
  class: "uk-grid"
};
const _hoisted_3$q = { class: "uk-modal-header" };
const _hoisted_4$o = ["disabled"];
const _hoisted_5$m = {
  key: 1,
  class: "uk-modal-header modal-header"
};
const _hoisted_6$i = { class: "inline" };
const _hoisted_7$h = ["uk-tooltip"];
const _hoisted_8$f = {
  for: "country-select",
  class: "uk-form-label"
};
const _hoisted_9$f = ["disabled"];
const _hoisted_10$f = ["value"];
const _hoisted_11$f = ["id", "onClick"];
const _hoisted_12$f = {
  class: "product-preview",
  pselact: "1"
};
const _hoisted_13$e = { class: "active-preview" };
const _hoisted_14$c = {
  key: 0,
  class: "preview-upload-panel uk-padding-small"
};
const _hoisted_15$c = { class: "preview-upload-panel-head uk-margin-small-bottom uk-text-right" };
const _hoisted_16$b = ["aria-label"];
const _hoisted_17$9 = {
  key: 0,
  id: "file-selector",
  class: "uk-inline"
};
const _hoisted_18$9 = ["onClick"];
const _hoisted_19$9 = { key: 1 };
const _hoisted_20$8 = { class: "preview-container" };
const _hoisted_21$8 = { class: "preview-title uk-padding-small uk-padding-remove-bottom" };
const _hoisted_22$7 = { key: 0 };
const _hoisted_23$7 = { class: "select-count" };
const _hoisted_24$7 = ["uk-tooltip", "onClick"];
const _hoisted_25$7 = { class: "preview-image-wrapper" };
const _hoisted_26$6 = { class: "preview-image-tools" };
const _hoisted_27$6 = {
  key: 0,
  class: "preview-method-chooser"
};
const _hoisted_28$6 = { class: "uk-inline" };
const _hoisted_29$4 = {
  class: "methodButton uk-button-small uk-button-default uk-background-default",
  type: "button"
};
const _hoisted_30$4 = { "uk-dropdown": "mode: click; pos: top-center" };
const _hoisted_31$4 = { class: "uk-nav uk-dropdown-nav" };
const _hoisted_32$3 = ["value"];
const _hoisted_33$3 = ["onClick"];
const _hoisted_34$2 = { class: "preview-actions" };
const _hoisted_35$2 = { class: "uk-inline file-buttons" };
const _hoisted_36$2 = ["onClick"];
const _hoisted_37$2 = ["onClick"];
const _hoisted_38$2 = ["onClick"];
const _hoisted_39$2 = ["onClick"];
const _hoisted_40$2 = { key: 2 };
const _hoisted_41$2 = {
  class: "preview-container",
  pselact: "1"
};
const _hoisted_42$2 = { class: "inline" };
const _hoisted_43$2 = {
  class: "file-buttons small inline",
  pselact: "1"
};
const _hoisted_44$2 = ["onClick"];
const _hoisted_45$2 = ["onClick"];
const _hoisted_46$2 = ["onClick"];
const _hoisted_47$2 = ["onClick"];
const _hoisted_48$2 = {
  class: "product-selector uk-padding-small",
  pselact: "1"
};
const _hoisted_49$2 = {
  key: 2,
  class: "breadcrumbs-slider"
};
const _hoisted_50$2 = { "uk-slider": "finite: true" };
const _hoisted_51$2 = { class: "uk-slider-items" };
const _hoisted_52$1 = ["onClick"];
const _hoisted_53$1 = ["onClick"];
const _hoisted_54$1 = ["onChangeCapture"];
const _hoisted_55$1 = {
  key: 0,
  class: "final-product-info"
};
const _hoisted_56$1 = {
  key: 1,
  class: "resolution-confirmation"
};
const _hoisted_57$1 = ["onUpdate:modelValue"];
const _hoisted_58$1 = {
  key: 2,
  class: "format-adjustment-notice"
};
const _hoisted_59$1 = ["onClick"];
const _hoisted_60$1 = { class: "prod-small" };
const _hoisted_61$1 = { style: {"font-size":"12px","height":"12px"} };
const _hoisted_62$1 = { key: 0 };
const _hoisted_63$1 = { class: "qs align-right" };
const _hoisted_64$1 = { class: "qs-container" };
const _hoisted_65$1 = {
  key: 0,
  class: "ps-small"
};
const _hoisted_66$1 = {
  class: "product-select-form",
  pselact: "1"
};
const _hoisted_67$1 = ["uk-tooltip"];
const _hoisted_68$1 = {
  key: 0,
  pselact: "1"
};
const _hoisted_69$1 = {
  key: 1,
  pselact: "1"
};
const _hoisted_70$1 = { class: "uk-align-right align-right qs-container" };
const _hoisted_71$1 = { class: "ps-footer" };
const _hoisted_72$1 = { class: "cart-button-container" };
const _hoisted_73$1 = { class: "abort-large" };
const _hoisted_74$1 = { class: "uk-align-right" };
const _hoisted_75$1 = { key: 1 };
const _hoisted_76$1 = { class: "uk-modal-header" };
const _hoisted_77$1 = { class: "added-to-cart-messge uk-padding" };
const _hoisted_78$1 = {
  key: 0,
  class: "uk-margin-small-top uk-text-warning"
};
const _hoisted_79$1 = { class: "uk-margin-top" };


var script$D = {
  __name: 'ProductSelector',
  props: {
    useProd: Object,
    usePgrId: String,
    useMedia: Object,
    psId: String,
    bcView: Boolean,
    stepByStep: Boolean,
    autoSelect: Boolean,
    psList: Array,
    scroll: Number,
    modalSize: Object,
    layout: String,
    fromCart: Boolean
},
  emits: ['close', 'redesign-action'],
  setup(__props, { emit: __emit }) {


/**
 * @module components/ProductSelector
 * @description This is a Vue component that creates a Product selector filtering all registered Products.
 *
 */

const mj = new MerkleJson();
const {t} = useI18n();
getCurrentInstance().appContext.app.component('ProductInfoButton', script$k);

const sessionStore = useSessionStore();
const configStore = useConfigStore();
const authStore = useAuthStore();


const { checkout, cart } = storeToRefs(sessionStore);
sessionStore.normalizeCart();
const cartItems = computed(() => Array.isArray(cart.value) ? cart.value : (cart.value?.items || []));

/** The list of countries */
const countryList = ref({});
const destinationCountry = ref(checkout.value.destinationCountry);  // aktuelles Zielland
const fileSelector = ref(false);    // Zustand: geöffneter Dateiselektor
const fileSelectorCondition = ref(false);  // Filter für Datewähler bezüglich resourcetype und modul
const currentPgrClass = ref("pgr0");
const selectedMedia = ref([]);      // Liste der gewählten Medien (Bilder, Kalender, Bücher etc). Enthält immer die Elemente der letzten Auswahl
const psList = ref();               // Liste der Produktselektoren
const finished = ref(false);        // Zustand: finished = true bedeutet ende der Auswahl (Artikel zum WK hinzugefügt)
const savedPrice = ref({ int: 0, fmt: "0" });   // Gesamtpreis der hinzugefügten Artikel
const increasedCopiesCount = ref(0);
const selectedItemNumber = ref();   // aktives Item in Swiper
const productBgImages = ref({});    // Hintergrundbilder pro psEl.id
const refreshQueue = new AutoQueue();
const generatingSchema = ref(false);
const preFilterItems = ref(Object.values(preFilterDef)); // Verfügbare Elemente des Prefilters
const selectorHeightAnimations = new WeakMap();

let psElCount = 0;

let stopListen = false;

let currentPricegroup = false;

let pricegroupDef = {};

const inlineUploadListId = ref(false);
const productPreviewRefs = new Map();

function setProductPreviewRef(listId, component) {
    if (component) productPreviewRefs.set(listId, component);
    else productPreviewRefs.delete(listId);
}

function openProductPreview(listId) {
    productPreviewRefs.get(listId)?.openZoom();
}

const emit = __emit;

const props = __props;


// psList ist eine Liste von Produktselektoren für ein oder mehrere
// Motive
// Referenz bleibt identisch mit props.psList (z.B. Pinia-Store psm.psList), da andere Stellen
// (z.B. getCumulatedQuantity) direkt auf diese Store-Liste inkl. .ps zugreifen.
// TODO: psList als single-source-of-truth behandeln und immer über pinia-Store verwalten
//       Aktuell wird psList direkt aus den Props initialisiert und manipuliert.
//       Mutations von props ist eigentlich nicht vue konform. Es funktioniert aber zuverlässig solange
//       es keinen Referenzbruch gibt. Deshalb ist replacePsListInPlace notwendig, um die Liste in-place zu ersetzen.

psList.value = (props.psList)?props.psList:[{ active: true }];

const unregisterDeveloperProductSelector = registerDeveloperProductSelector(psList);
onUnmounted(unregisterDeveloperProductSelector);

function replacePsListInPlace(nextItems) {
    if (!Array.isArray(psList.value)) psList.value = [];
    psList.value.splice(0, psList.value.length, ...(Array.isArray(nextItems) ? nextItems : []));
}

function cloneSelectorState(source) {
    if (!isObject$2(source)) return source

    const next = { ...source };

    if (isObject$2(next.form)) next.form = { ...next.form };
    if (isObject$2(next.properties)) next.properties = { ...next.properties };
    if (Array.isArray(next.media)) next.media = [...next.media];
    if (Array.isArray(next.productOptionsHash)) next.productOptionsHash = [...next.productOptionsHash];
    if (isObject$2(next.productOptionsHash)) next.productOptionsHash = { ...next.productOptionsHash };
    if (Array.isArray(next.optionPrices)) next.optionPrices = [...next.optionPrices];
    if (isObject$2(next.mediaSettings)) next.mediaSettings = { ...next.mediaSettings };
    if (isObject$2(next.product)) next.product = { ...next.product };

    return next
}

function resolveSelectorSource(psEl) {
    if (!isObject$2(psEl)) return undefined
    if (isObject$2(psEl.ps?.status)) return psEl.ps.status

    const hasStatusPayload = ['form', 'properties', 'product', 'media', 'productOptionsHash', 'optionPrices', 'mediaSettings']
        .some((key) => typeof psEl[key] != 'undefined');

    if (hasStatusPayload) {
        return cloneSelectorState({
            form: psEl.form,
            properties: psEl.properties,
            product: psEl.product,
            media: psEl.media,
            productOptionsHash: psEl.productOptionsHash,
            optionPrices: psEl.optionPrices,
            mediaSettings: psEl.mediaSettings,
        })
    }

    return undefined
}

psList.value.forEach((psEl) => {
    Object.assign(psEl, createSelector(resolveSelectorSource(psEl)));
});


const cmc = new CheckMediaCondition();

/**
 * Erstellt den Selector eines Listenelements
 * Wird source übergeben, wird ein Klon des entsprechenden Listenelements erstellt
 * @member components/ProductSelector
 * @function createSelector
 * @param {Object} source - Quelle für den Selector
 * @returns {Object} - Selector
 *
 * TODO: Eventuell in KLasse umwandeln
*/
function createSelector(source) {

    psElCount++;
    const selector = {
        id: `${props.psId}-${psElCount}`,
        schemaVersion: 0,
        breadcrumbs: [],
        preserveInitialQuantity: props.fromCart,
        resolutionLevel: null,
        resolutionConfirmed: false
    };

    let currentSel = false;

    if (typeof source == "number" && psList.value[source]) {
        currentSel = cloneSelectorState(psList.value[source].ps.status);
    } else if (typeof source == "object") {
        currentSel = cloneSelectorState(source?.ps?.status || source);
    } else {
        currentSel = {
            form: {
                preFilter:preFilterItems
            },
            properties: { copies: 1 },
            product: false
        };

        if (props.usePgrId) {
            currentPgrClass.value = "pgr" + props.usePgrId;
            currentSel.form.pgrId = props.usePgrId;
        }
        if (props.useProd) {
            currentPgrClass.value = "pgr" + props.useProd.pgrId;
            currentSel.form.pgrId = props.useProd.pgrId;
        }
    }

    selector.previewUC = ref(0); // Preview Update Counter als Trigger

    let layout = "auto";
    if (props.layout) layout = props.layout;
    let ps = new ProductSelector(layout);
    ps.t = t;

    if (typeof props.stepByStep !== 'undefined') {
        ps.stepByStep = props.stepByStep;
    }
    if (typeof props.autoSelect !== 'undefined') {
        ps.autoSelect = props.autoSelect;
    }

    if (props.bcView) {
        ps.showFinalProduct = true;
        ps.autoSelect = false;
        ps.slideshow = true;
        ps.stepByStep = true;
    }

    ps.status = currentSel;
    if (Array.isArray(currentSel?.media)) {
        ps.setMedia(currentSel.media);
    }
    selector.ps = ps;

    // Wenn Slideshow definiert ist, kann mit dieser Funktion zum letzten slide bewegt werden
    selector.slideLast = function () {

        if (ps.slideshow) {

            // das ausblenden des Nextbuttons verhindert ein kurzes aufflackern während des slidens
            let sNext = document.querySelector('#' + selector.id + ' .uk-slidenav-next');
            if (sNext) {
                sNext.style.display = "none";
            }
            // Warten ist notwendig, da slideshow dom erst geladen wird
            setTimeout(
                () => {
                    let slide = UIkit.slideshow('#' + selector.id + ' .uk-slideshow');
                    if (slide) {
                        slide.show(slide.length - 1);
                    }
                    if (sNext) sNext.style.display = "initial";
                },
                100);
        }
    };


    return selector

}


// Parameter einlesen ist asyncron
// Erst wenn diese Werte da sind, das Formular starten

const initialize = parameter.country;

initialize.then((data) => {
    let opt = [];
    const hasCountryPayload = data && typeof data === 'object';

    if (hasCountryPayload) {
        pricegroupDef = data.pricegroup_def || {};
        if (pricegroupDef[destinationCountry.value]) currentPricegroup = pricegroupDef[destinationCountry.value];
        for (let i in data.country_list) {
            opt.push({ text: data.country_list[i], value: i });
        }
    } else {
        logger.warn('productSelector: parameter.country nicht verfügbar, verwende Fallback');
        pricegroupDef = {};
    }

    if (!opt.length) {
        opt.push({ text: 'Deutschland', value: 'DE' });
    }

    countryList.value = opt;

    // Initiales starten des Formulars
    logger.debug(["init form"]);
        if (props.useMedia) {

        let useMedia = props.useMedia;
        if (!Array.isArray(props.useMedia)) useMedia = [props.useMedia];

        const mediaItems = useMedia.filter((item) => !isImageSelectionItem(item));

        if (mediaItems.length > 1) {
            const nextSelectors = mediaItems.map((item, index) => {
                const selector = createSelector({
                    form: { preFilter: preFilterItems },
                    properties: { copies: 1 },
                    product: false,
                    media: [item],
                });
                selector.active = index === 0;
                selector.previewUC.value = 1;
                return selector
            });
            replacePsListInPlace(nextSelectors);
        } else {
            psList.value[0].ps.setMedia(readMediaSelection(mediaItems.length ? mediaItems : useMedia));
            bumpPreviewUC(psList.value[0]);
        }

        }

    // TODO eventuell mit debunce kombinieren um wiederholungen zu reduzieren
    psList.value.forEach((psEl) => {
        refreshQueue.enqueue(() => refreshForm(psEl));
    });
});


watch(destinationCountry, (nv, ov) => {
    checkout.value.destinationCountry = nv;
    if (pricegroupDef[destinationCountry.value]) currentPricegroup = pricegroupDef[destinationCountry.value];
    psList.value.forEach(psEl => {
        refreshQueue.enqueue(() => refreshForm(psEl));
    });

});

const productMatch = ref({noMatch:false});
// previewUC kann je nach Reaktivitätskontext ein Ref oder ein bereits
// entpackter (plain) Wert sein, siehe createSelector()
function bumpPreviewUC(psEl) {
    if (psEl.previewUC?.__v_isRef) psEl.previewUC.value += 1;
    else psEl.previewUC = (psEl.previewUC || 0) + 1;
}

function getPreviewUC(psEl) {
    return psEl?.previewUC?.__v_isRef ? psEl.previewUC.value : (psEl?.previewUC || 0)
}

function getSelectorGrid(psEl) {
    return document.getElementById(psEl?.id)?.querySelector(':scope > .grid')
}

function freezeSelectorGridHeight(psEl) {
    const grid = getSelectorGrid(psEl);
    if (!grid) return 0

    const frozenHeight = grid.getBoundingClientRect().height;
    selectorHeightAnimations.get(grid)?.cancel();
    grid.style.height = `${frozenHeight}px`;
    grid.style.overflow = 'clip';
    return frozenHeight
}

function waitForStableLayout() {
    return new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
    })
}

async function releaseSelectorGridHeight(psEl, frozenHeight) {
    if (!frozenHeight) return

    await nextTick();
    const grid = getSelectorGrid(psEl);
    if (!grid) return

    await waitForStableLayout();

    grid.style.height = 'auto';
    grid.style.overflow = '';
    const targetHeight = grid.getBoundingClientRect().height;
    grid.style.height = `${frozenHeight}px`;
    grid.style.overflow = 'clip';

    if (Math.abs(targetHeight - frozenHeight) < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        grid.style.height = '';
        grid.style.overflow = '';
        return
    }

    grid.getBoundingClientRect();
    grid.style.height = `${targetHeight}px`;

    const animation = grid.animate([
        { height: `${frozenHeight}px`, overflow: 'clip' },
        { height: `${targetHeight}px`, overflow: 'clip' }
    ], {
        duration: 600,
        easing: 'ease'
    });

    selectorHeightAnimations.set(grid, animation);
    const clearAnimation = () => {
        if (selectorHeightAnimations.get(grid) === animation) {
            selectorHeightAnimations.delete(grid);
            grid.style.height = '';
            grid.style.overflow = '';
        }
    };
    animation.onfinish = clearAnimation;
    animation.oncancel = () => {
        if (selectorHeightAnimations.get(grid) === animation) {
            selectorHeightAnimations.delete(grid);
        }
    };
}

function checkFkSchema(psEl,data) {
    productMatch.value.noMatch = false;
    if (Array.isArray(data) && data.length == 0) {
        if (psEl.ps?.status?.fileFilter) {
            productMatch.value.noMatch = true;
            if (psEl.ps.status.media) productMatch.value.file = psEl.ps.status.media[0];
        }
    }
}

// Sobald preset einmal eingestellt wurde, wird presetDone wahr
let presetDone = false;

/** refreshForm aktualisiert das Formular eines Elements der ProductSelector Liste */
async function refreshForm(psEl, reset, form) {

    // Sollte eigentlich nicht vorkommen, dass refreshForm doppelt läuft
    // Dies wird durch AutoQueue gewährleistet.
    // Falls doch (z.B. HMR), wird es hier abgefangen um endless loop zu vermeiden
    if (!psEl || psEl?.refreshing) {
        return
    }
    var isFinished;
    let promise = new Promise(function (resolve) {
        isFinished = resolve;
    });

    var savedForm = {};
    let previousLayoutHeight = 0;
    let currentSel = psEl.ps.status;
    let ps = psEl.ps;
    psEl.refreshing = true;
    let shouldTriggerProdChanged = false;

    if (currentPricegroup) ps.prgFilter = currentPricegroup;
    // Um doppelte refreshs zu vermeiden, unwatch während des updates
    if (psEl.unwatch) psEl.unwatch();

    previousLayoutHeight = freezeSelectorGridHeight(psEl);

    if (typeof currentSel.product == "undefined" || reset) currentSel.product = false;

    // Falls übermittelt: Formulardaten setzen
    if (isObject$2(form)) {
        for (var par in form) {
            ps.status.form[par] = form[par];
        }
    }

    // wenn props.useProd gesetzt ist wird getFkSchema zweimal durchlaufen.
    // Erstmalig mit dem Zusatzfliter "pid" um alle Selektoren auf diese pid einzustellen
    // Danach erneut im normalen Modus, damit alle Menüs vollständig sind (die Auswahl bleibt automatisch erhalten)
    // Für media.options.product_tag gilt derselbe Initial-Flow, aber nur wenn noch kein echter pid gesetzt ist.

    if (!presetDone) {
        const mediaProductTag = currentSel.media?.[0]?.options?.product_tag;

        if (props.useProd?.pid) {
            await ps.getFkSchema(props.useProd.pid, true);
            presetDone = true;
        } else if (mediaProductTag && !currentSel.form?.pid) {
            const matchingProduct = await db.products
                .where('state')
                .equals('verfügbar')
                .and(item => Array.isArray(item.tags) && item.tags.includes("#" + mediaProductTag))
                .first();

            if (matchingProduct) {
                currentSel.form.pid = matchingProduct.pid;
                await ps.getFkSchema(matchingProduct.pid, true);
                presetDone = true;
            }
        }
    }

    generatingSchema.value = true;

    ps.getFkSchema().then((data) => {
        // schema für FormKit

        // Damit Formkit beim Wechseln des schemas funtioniert müssen alle Elemente eine unterschiedlichen "key" haben
        // Dadurch wird jedoch das Model (v-model)  geändert, sobald das layout wechselt
        // Um die Werte des Models zu erhalten, werden sie hier geklont ...
        savedForm = { ...currentSel.form };

        checkFkSchema(psEl,data);

        // if (!window.cnt) window.cnt = 1
        // window.cnt++
        // data.key = window.cnt
        psEl.schema = data;
        psEl.schemaVersion = (psEl.schemaVersion || 0) + 1;

        logger.debug("schema hash " + mj.hash(data));
    }).then(async () => {
        // ... und hier wiederhergestllt

        currentSel.form = savedForm;
        const breadcrumbsState = updateBreadcrumbCache(psEl);
        await releaseSelectorGridHeight(psEl, previousLayoutHeight);

        psEl.slideLast();
        if (breadcrumbsState.changed) {
            await nextTick();
            scrollBreadcrumbSliderToEnd(psEl);
        }

        // wenn Produkt eindeutig bestimmt => Preis abfragen
        const hasProduct = !!currentSel.product;
        if (hasProduct) {
            const currentPid = currentSel.product.pid;
            const pidChanged = currentSel.lastPid != currentPid;

            // Produktpreis
            db.prices.where("pid").equals(currentPid).and(item => item.priceGroup == currentPricegroup).toArray(p => {
                currentSel.product.prices = p;
            });
            // Optionspreise
            for (let i in ps.status.optionPrices) {
                db.prices.where("pid").equals(ps.status.optionPrices[i].pid).and(item => item.priceGroup == currentPricegroup).toArray(p => {
                    ps.status.optionPrices[i].prices = p;
                });
            }

            if (currentSel.product.setupName) {
                if (!currentSel.product.setup) {
                    db.productSetup.where("name").equals(currentSel.product.setupName).toArray(s => {
                        if (!s[0]) s[0] = {};
                        currentSel.product.setup = s[0].data;
                        // dont use shouldTriggerProdChanged here, because it is async
                        logger.debug("ps-status: prod changed");
                        prodChanged(psEl);

                    });
                } else if (pidChanged) {
                    shouldTriggerProdChanged = true;
                }
            } else {
                currentSel.product.setup = {};
                shouldTriggerProdChanged = true;
            }
            currentSel.lastPid = currentPid;
        } else {
            if (currentSel.lastPid) shouldTriggerProdChanged = true;
            currentSel.lastPid = false;
        }


        currentPgrClass.value = "pgr" + currentSel.form.pgrId;

        if (shouldTriggerProdChanged) {
            logger.debug("ps-status: prod changed");
            prodChanged(psEl);
        }
        fetchProductBgImage(psEl);
        psEl.refreshing = false;

       await nextTick();
       generatingSchema.value = false;
         isFinished();
         watchForm(psEl);

    });

    return promise
}

async function watchForm(psEl,savedForm) {

    await nextTick();

    psEl.unwatch = watch(() => psEl.ps.status.form, (form,oldform) => {
            // altered state of the form can be detected here (not used yet)
            //let odiff = ObjectUtils.diff(oldform,form)
            //let altered = {...odiff.added, ...odiff.updated, ...odiff.removed}

            if (stopListen || !isConfirmed(psEl)) return
            psEl.preserveInitialQuantity = false;
            refreshQueue.enqueue(() => refreshForm(psEl, true));
    });
}

// prüft ob es nicht bestätigte Formularfelder gibt
function isConfirmed(psEl) {

    for (var i in psEl.ps.status.form) {
        if ( i.indexOf("confirm_") == 0 && psEl.ps.status.form[i] === false) return false
    }

    return true
}

function prodChanged(psEl) {

    checkConditionsProduct(psEl);

    psEl.resolutionConfirmed = false;

    // trigger Update der Vorschau
    bumpPreviewUC(psEl);
}

function matchProductSetupCondition(product, file) {
    const accept = product?.setup?.condition?.accept;
    if (!accept || !file) return true

    const contentTypes = acceptArray(accept.contentType)
        .filter(Boolean)
        .map((value) => String(value).toLowerCase().replace(/s$/, ''));
    const fileContentType = String(file['@type'] || file.type || '').toLowerCase().replace(/s$/, '');

    if (contentTypes.length && !contentTypes.includes(fileContentType)) {
        return {
            pid: product.pid,
            property: '@type',
            value: fileContentType,
            condition: 'unsupportedContentType',
            required: contentTypes,
        }
    }

    const modules = acceptArray(accept.modules || accept.module).filter(Boolean);
    if (modules.length && !modules.includes(file.module)) {
        return {
            pid: product.pid,
            property: 'module',
            value: file.module,
            condition: 'accept.modules',
            required: modules,
        }
    }

    return true
}

function checkConditionsProduct(psEl) {

    if (!psEl.ps?.status?.product) return null
    if (!psEl.ps?.status?.media) return null

    cmc.product = psEl.ps.status.product;

    const file = psEl.ps.status.media[0];
    const conditionCheck = matchProductSetupCondition(cmc.product, file);
    const check = cmc.matchProduct(file);

    if (conditionCheck !== true) {
        file._mismatch = conditionCheck;
    }

    logger.debug({"checkConditionsProduct": check, "setupCondition": conditionCheck});

    return check && conditionCheck === true
}

const psListContainer = ref();
const psScrollContent = ref();
const $loading = useLoading({
    isFullPage: false,
    loader: 'dots'
});


function inCart(data) {
    // TODO Schleife über alle Listenelemente to unwatch all
    logger.info(["in Warenkorb:", data]);

    if (data?.replaceMode) {
        emit('close');
        return
    }

    savedPrice.value = data.price;
    increasedCopiesCount.value = Number(data?.increasedCopiesCount) || 0;
    psList.value.length = 0;
    finished.value = true;


}

let vidgeLoader = false;
let vidgeLoaderState = false;

function resolveEditorMediaUid(mediaItem) {
    const directUid = `${mediaItem?.uid ?? ''}`.trim();
    if (directUid) return directUid

    const jsonLdId = `${mediaItem?.['@id'] ?? ''}`.trim();
    if (!jsonLdId) return ''

    const normalized = jsonLdId.split('?')[0].replace(/\/+$/, '');
    const segments = normalized.split('/').filter(Boolean);
    return segments[segments.length - 1] || ''
}

async function editFile(listId) {
    psList.value[listId].active = true;
    await nextTick();
    const mediaItem = psList.value[listId].ps.status.media[0];
    if (mediaItem.type == "application/pdf") {

        psList.value[listId].editMode = "pdf";

        return
    }
    if (mediaItem.module == "calendar") {
        psList.value[listId].editMode = "editor";
        const mediaUid = resolveEditorMediaUid(mediaItem);
        if (!mediaUid) {
            logger.warn('[ProductSelector] calendar editor requires media uid but none was found', mediaItem);
            return
        }
        document.location.href = document.location.origin + configStore.calendarEditPath + "?media=" + encodeURIComponent(mediaUid) + "&dbkey=" + authStore.setup?.dbKey + "&session=" + authStore.setup?.sessionId;
        return
    }
    psList.value[listId].editMode = "vidge";
    vidgeLoaderState = true;
    vidgeLoader = false;
    // Loader nur dann anzeigen, wenn des laden länger als 0,2 Sekunden dauert
    setTimeout(() => {
        if (vidgeLoaderState) {
            vidgeLoader = $loading.show({ container: psListContainer.value, canCancel: true });
        }
    }, 200);
}



function vidgeLoaded() {
    vidgeLoaderState = false;
    if (vidgeLoader) {
        vidgeLoader.hide();
    }
}

function selectFile(listId,psEl) {
    selectedMedia.value = [];
    inlineUploadListId.value = listId;
    fileSelector.value = false;
    fileSelectorCondition.value = mediaSelector.default;

    psList.value.forEach((listEl) => {
        listEl.active = false;
    });
    psEl.active = true;

    if (psEl.ps.status.product?.setup?.condition) {

        _(psEl.ps.status.product.setup.condition).each((val,par) => {
            fileSelectorCondition.value[par] = val;
        });
    }
    logger.debug(fileSelectorCondition.value);
}

const { uploadMenuItems, onUploadMenuAction, onInlineUploadComplete } = useProductSelectorInlineUpload({
    psList,
    inlineUploadListId,
    fileSelector,
    configStore,
    getClientId: () => authStore.getClientId(),
    refreshQueue,
    readMediaSelection,
    checkConditionsProduct,
    refreshForm,
    editFile,
    emit,
});

function updateSelectedMedia(data) {
    selectedMedia.value = data;
}

function setCopies(listId, num) {
    psList.value[listId].ps.status.properties.copies = num;
}

/**
 * Hintergrundbild für den no-media-placeholder vom Strapi-Server laden.
 * Selektoren werden aus psEl.ps.status.form extrahiert (cat, pgrId, orientation, surface, ...).
 */

function getProductBgImageUrl(psEl) {
    const imageUrl = productBgImages.value[psEl.id]?.imageUrl;
    const contentBase = configStore.contentBase;
    if (!imageUrl || !contentBase) return ''

    return contentBase.replace(/\/+$/, '') + imageUrl
}

async function fetchProductBgImage(psEl) {
    const contentBase = configStore.contentBase;
    if (!contentBase) return

    const form = psEl.ps?.status?.form;
    const productPid = psEl.ps?.status?.product?.pid;
    if (!form) return

    const params = new URLSearchParams();
    const SKIP_KEYS = new Set(['preFilter', 'pid']);
    const SKIP_PREFIXES = ['confirm_', 'po_'];

    for (const [key, value] of Object.entries(form)) {
        if (SKIP_KEYS.has(key)) continue
        if (SKIP_PREFIXES.some(p => key.startsWith(p))) continue
        if (value === null || value === undefined || value === '') continue
        if (typeof value !== 'string' && typeof value !== 'number') continue
        params.set(key, String(value));
    }

    if (productPid) {
        params.set('pid', String(productPid));
    }

    try {
        const base = contentBase.replace(/\/+$/, '');
        const query = params.toString();
        const url = query ? `${base}/api/products/images?${query}` : `${base}/api/products/images`;
        const resp = await fetch(url);
        if (!resp.ok) { productBgImages.value[psEl.id] = null; return }
        const json = await resp.json();
        productBgImages.value[psEl.id] = json.data || null;
    } catch {
        productBgImages.value[psEl.id] = null;
    }
}



async function saveSelectedMedia() {

    let listId = 0;
    if (fileSelector.value) listId = fileSelector.value;

    // Speichere Medienauswahl in ps.status und löse den Media-Change-Handler aus
    psList.value[listId].ps.setMedia(readMediaSelection(selectedMedia.value));
    psList.value[listId].resolutionConfirmed = false;

    // setze Vorauswahl bei Formular nach mediaType
    // depricated
    //await setFormByMediaType(psList.value[listId])

    // prüfe Produktkompatibilität der Datei(en)
    checkConditionsProduct(psList.value[listId]);

    fileSelector.value = false;

    // Schema zurücksetzen um Form neu zu laden (wichtig bei Änderung der Medien)
    psList.value[listId].schema = false;
    // Preview verwendet Vici, das direkte DOM-Zugriffe macht
    // daher wird mittels nextTick() auf das aktualisierte DOM gewartet
    await nextTick();

    // preview Counter hochzählen als Trigger für refresh
    bumpPreviewUC(psList.value[listId]);

    refreshForm(psList.value[listId]);

}

function readMediaSelection(selectedMedia) {

    const mediaCollection = [];
    selectedMedia.forEach((item) => {
        mediaCollection.push(item);
    });

    return mediaCollection

}

function bcSelect(psEl, filter) {

    const currentSel = psEl?.ps?.status;
    if (!currentSel?.form) return

    let filterArg = Object.keys(filter)[0];
    // Selektion über Breadcrumb Filter
    // Ab dem gewählten Element wird die Auswahl zurückgesetzt
    let unset = false;
    if (filterArg == "root") unset = true;
    _(currentSel.form).each((element, i) => {
        // Prefilter ist vom typ objekt und soll erhalten bleiben
        if (unset && typeof currentSel.form[i] != "object") delete currentSel.form[i];
        if (i == filterArg) unset = true;

    });

    refreshQueue.enqueue(() => refreshForm(psEl, true));
}

function bcShow(filter) {

    let filterArg = Object.keys(filter)[0];
    let filterVal = filter[filterArg];
    if (typeof filterVal != "string") return
    if (filterDef[filterArg] && filterDef[filterArg][filterVal]) return filterDef[filterArg][filterVal]["label"]
    else return filterVal
}

function breadcrumbItemKey(filter) {
    if (!filter || typeof filter != 'object') return ''
    const filterArg = Object.keys(filter)[0];
    const filterVal = filterArg ? filter[filterArg] : '';
    return `${filterArg}:${String(filterVal)}`
}

function updateBreadcrumbCache(psEl) {
    const filterList = psEl?.ps?.currentFilterList;
    const source = Array.isArray(filterList) ? filterList : [];
    const previous = Array.isArray(psEl?.breadcrumbs) ? psEl.breadcrumbs : [];

    const previousByKey = new Map(previous.map((item) => [item.key, item]));

    const next = source.map((filter) => {
        const key = breadcrumbItemKey(filter);
        const cached = previousByKey.get(key);
        if (cached) {
            cached.filter = filter;
            return cached
        }
        return { key, filter }
    });

    const changed = previous.length != next.length || previous.some((item, index) => item.key != next[index]?.key);
    if (changed) {
        psEl.breadcrumbs = next;
    }

    return {
        changed,
        grew: next.length > previous.length,
        shrunk: next.length < previous.length
    }
}

function scrollBreadcrumbSliderToEnd(psEl) {
    if (!props.bcView || !psEl?.id) return

    const tryScroll = (attemptsLeft = 8) => {
        const rootEl = document.getElementById(psEl.id);
        const sliderEl = rootEl?.querySelector('.breadcrumbs-slider .uk-slider');
        const itemsEl = sliderEl?.querySelector('.uk-slider-items');
        if (!sliderEl || !itemsEl) {
            if (attemptsLeft > 0) requestAnimationFrame(() => tryScroll(attemptsLeft - 1));
            return
        }

        const lastIndex = itemsEl.children.length - 1;
        if (lastIndex < 0) return

        const slider = UIkit.slider(sliderEl);
        slider.show(lastIndex);

        const lastItem = itemsEl.children[lastIndex];
        const isShown = !!lastItem && (
            lastItem.classList.contains('uk-active') ||
            lastItem.getAttribute('aria-hidden') == 'false'
        );

        if (!isShown && attemptsLeft > 0) {
            requestAnimationFrame(() => tryScroll(attemptsLeft - 1));
        }
    };

    requestAnimationFrame(() => tryScroll());
}

/*
* Mehrfach-Medienauswahl auftrennen in einzelne Produktselektoren
* psList ist die Liste der Produktselektoren
*/

function separate(listId) {
    const currentSelector = psList.value[listId];
    const psListMedia = currentSelector?.ps?.status?.media;

    if (!Array.isArray(psListMedia) || psListMedia.length <= 1) return

    const basePreviewUC = getPreviewUC(currentSelector);
    const sourceStatus = currentSelector.ps.status || {};
    const nextSelectors = psListMedia.map((sm, index) => {
        const copiedStatus = {
            ...(sourceStatus || {}),
            media: [sm],
            form: { ...(sourceStatus.form || {}), preFilter: sourceStatus.form?.preFilter || preFilterItems },
            properties: { ...(sourceStatus.properties || {}), copies: sourceStatus.properties?.copies || 1 },
        };

        const newSelector = createSelector(copiedStatus);
        newSelector.active = index === 0;
        newSelector.previewUC.value = basePreviewUC + index + 1;
        return newSelector
    });

    psList.value.splice(listId, 1, ...nextSelectors);

    psList.value.forEach((psEl) => {
        refreshQueue.enqueue(() => refreshForm(psEl));
    });
}

/*
* Element aus psList löschen
*/

async function deletePsElem(listId) {
    // Solange die Liste neu aufgebaut wird den listener für Form-refresh ausschalten
    // Dies führt sonst zu zwischenzeitlich falschen Voransichten
    stopListen = true;
    psList.value.splice(listId, 1);
    await nextTick();
    stopListen = false;
    psList.value.forEach(listEl => {
        bumpPreviewUC(listEl);
    });
}

/*
* Listenelement aktivieren (Großansicht)
*/
function activate(psEl, event) {

    if (!event.target.hasAttribute("pselact")) return false

    psList.value.forEach(listEl => {
        listEl.active = false;
    });

    psEl.active = true;
    refreshQueue.enqueue(() => refreshForm(psEl));
}

async function expandSelector(psEl, listId) {
    psList.value.forEach((listEl) => {
        listEl.active = false;
    });
    psEl.active = true;

    await nextTick();

    const scrollContainer = psScrollContent.value;
    const selectorElement = psListContainer.value?.children[listId];
    if (!scrollContainer || !selectorElement) return

    const containerRect = scrollContainer.getBoundingClientRect();
    const selectorRect = selectorElement.getBoundingClientRect();
    const visibleHeight = scrollContainer.clientHeight;
    let scrollOffset = 0;

    if (selectorRect.height >= visibleHeight || selectorRect.top < containerRect.top) {
        scrollOffset = selectorRect.top - containerRect.top;
    } else if (selectorRect.bottom > containerRect.bottom) {
        scrollOffset = selectorRect.bottom - containerRect.bottom;
    }

    if (scrollOffset) {
        scrollContainer.scrollBy({ top: scrollOffset, behavior: 'smooth' });
    }
}

function setDM(DM, listId) {

    psList.value[listId].displayMedia = DM;

}
function setResolutionLevel(psEl, level) {
    if (psEl.resolutionLevel !== level) {
        psEl.resolutionLevel = level;
        psEl.resolutionConfirmed = false;
    }
}

function needsResolutionConfirmation(psEl) {
    return resolutionConfirmation.enabled && !!psEl.ps?.status?.product
        && requiresResolutionConfirmation(psEl.resolutionLevel, resolutionConfirmation.fromLevel)
}

function hasFormatAdjustment(psEl) {
    const product = psEl.ps?.status?.product;
    const media = psEl.ps?.status?.media;
    return !!product && Array.isArray(media) && media.some((item) => needsFormatAdjustment(item, product))
}
/*
* Fixierung des Ziellandes wenn Warenkorb Arikel enthält
*/

function destinationLock() {
    if (cartItems.value.length > 0) {
        return t('productSelector.destinationLock')
    }
}

function isImageSelectionItem(item) {
    const type = String(item?.type || item?.['@type'] || '').toLowerCase();
    const module = String(item?.module || '').toLowerCase();
    const bintyp = String(item?.bintyp || '').toLowerCase();

    return type.includes('image') || module.includes('image') || bintyp.includes('image')
}

function isMediaRequired(psEl) {
    return psEl?.ps?.status?.product?.setup?.media?.required !== false
}

/*
* VIC Dokument aus vidge in psList status speichern (media[id].obj)
*/

function saveVic(listId, mediaId, vicJSON) {

    const media = psList.value[listId].ps.status.media[mediaId];

    let object = {
        type: "vic",
        vic: vicJSON
    };

    media.settings = { printMethod: "vic" };
    media.obj = { ...object };
}

// Item Number Auswahl von swiper
function setItemNumber(itemNumber) {
    selectedItemNumber.value = itemNumber;
}

// Methode wählen und Dropdown schließen
function selectMethod(psEl, name, event) {
    psEl.selectedMethod = name;
    const dropdownEl = event.target.closest('[uk-dropdown]');
    if (dropdownEl) UIkit.dropdown(dropdownEl).hide(false);
}

// function rootClasses(sectionKey,node) {
//    if (node.type == "select")  {
//     return {['uk-select']: true }
//    }
//     return {['']: true }
// }

const inputMissing = computed(() => {

    // TODO Enable Button wenn für currentSel keine Mediendatei benötigt wird

    let prodMissing = false;
    let mediaMissing = false;
    let mediaMismatch = false;
    const mediaDocumentErrors = [];

    if (Array.isArray(psList.value)) {
        psList.value.forEach((psEl) => {
            if (!(psEl.ps && psEl.ps.status && psEl.ps.status.product)) {
                prodMissing = true;
            }
            const hasMedia = Array.isArray(psEl?.ps?.status?.media) && psEl.ps.status.media.length > 0;
            if (isMediaRequired(psEl) && !hasMedia) {
                mediaMissing = true;
            }
            if (hasMedia) {
                mediaMismatch = psEl.ps.status.media.reduce((ac,el) => { if (el._mismatch) return el._mismatch },'');
                psEl.ps.status.media.forEach((media) => {
                    getMediaDocumentErrors(media).forEach((error) => {
                        mediaDocumentErrors.push(t(`mediaErrors.${error.key}`, { value: error.value }));
                    });
                });
            }
        });
    }

    let missing = [];
    if (prodMissing) {
        missing.push(t('productSelector.missingProduct'));
    }
    if (mediaMissing) {
        missing.push(t('productSelector.missingMedia'));
    }
    if (mediaMismatch) {
        missing.push(t('productSelector.missingMatchingFile'));
    }
    if (psList.value.some((psEl) => needsResolutionConfirmation(psEl) && !psEl.resolutionConfirmed)) {
        missing.push(t('productSelector.acceptLowResolution'));
    }
    missing.push(...mediaDocumentErrors);



    //return "title: " + missing.join("<br>") + "; pos: bottom"

    return {
        mismatch: mediaMismatch,
        warnings: missing
    }

});

// Prüfe ob es sichtbare preFilterItems gibt (nicht public:false)
const hasVisiblePreFilterItems = computed(() => {
    return Array.isArray(preFilterItems.value) && preFilterItems.value.some(item => item.public !== false)
});

function bcSliderNav(n,event) {

    let sliderEl = event.currentTarget.parentNode.querySelector(".uk-slider");

    // nicht weiter machen, wenn alle elemente sichtbar sind (TODO: scheint nicht wirklich zu gehen)
    let slides = sliderEl.querySelectorAll('.breadcrumbs-slider .uk-slider-items div[aria-hidden]');
    if (n=="next" && slides && slides[slides.length-1].getAttribute("aria-hidden") == "false") {
        return
    }
    UIkit.slider(sliderEl).show(n);

}

function noMatchingProducts() {
    return productMatch.value && productMatch.value.noMatch;
}


return (_ctx, _cache) => {
  const _component_FormKit = resolveComponent("FormKit");
  const _component_router_link = resolveComponent("router-link");

  return (openBlock(), createElementBlock("div", {
    ref: "dialog",
    class: normalizeClass((generatingSchema.value)?'gen-schema':'')
  }, [
    (!finished.value)
      ? (openBlock(), createElementBlock("div", _hoisted_1$z, [
          createElementVNode("div", {
            class: "ps-scroll-content",
            ref_key: "psScrollContent",
            ref: psScrollContent
          }, [
            createCommentVNode(" Medienselector  "),
            (fileSelector.value !== false)
              ? (openBlock(), createElementBlock("div", _hoisted_2$t, [
                  createElementVNode("div", null, [
                    createElementVNode("div", _hoisted_3$q, [
                      createElementVNode("h3", null, toDisplayString$1(_ctx.$t('productSelector.selectFiles')), 1 /* TEXT */),
                      createElementVNode("button", {
                        class: "uk-button uk-button-default uk-button-small",
                        onClick: _cache[0] || (_cache[0] = $event => (fileSelector.value = false))
                      }, toDisplayString$1(_ctx.$t('productSelector.cancel')), 1 /* TEXT */),
                      _cache[9] || (_cache[9] = createTextVNode("  ")),
                      createElementVNode("button", {
                        class: "uk-button uk-button-default uk-button-small uk-button-primary",
                        disabled: !selectedMedia.value.length,
                        onClick: _cache[1] || (_cache[1] = $event => (saveSelectedMedia()))
                      }, toDisplayString$1((selectedMedia.value.length) ? selectedMedia.value.length : '') + " " + toDisplayString$1(_ctx.$t('productSelector.applySelection')), 9 /* TEXT, PROPS */, _hoisted_4$o)
                    ]),
                    createVNode(unref(script$v), {
                      condition: fileSelectorCondition.value,
                      "extra-upload-menu-items": unref(uploadMenuItems),
                      onUploadMenuAction: unref(onUploadMenuAction),
                      onSelectedMedia: updateSelectedMedia
                    }, null, 8 /* PROPS */, ["condition", "extra-upload-menu-items", "onUploadMenuAction"])
                  ])
                ]))
              : (openBlock(), createElementBlock("div", _hoisted_5$m, [
                  createElementVNode("div", _hoisted_6$i, [
                    createElementVNode("h3", null, toDisplayString$1(_ctx.$t('productSelector.title')), 1 /* TEXT */)
                  ]),
                  (countryList.value)
                    ? (openBlock(), createElementBlock("div", {
                        key: 0,
                        class: "country-select uk-align-right",
                        "uk-tooltip": destinationLock()
                      }, [
                        createElementVNode("label", _hoisted_8$f, toDisplayString$1(_ctx.$t('productSelector.deliveryArea')), 1 /* TEXT */),
                        withDirectives(createElementVNode("select", {
                          id: "country-select",
                          disabled: cartItems.value.length > 0,
                          class: "uk-select uk-form-small",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((destinationCountry).value = $event))
                        }, [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(countryList.value, (country, code) => {
                            return (openBlock(), createElementBlock("option", {
                              key: code,
                              value: country.value
                            }, toDisplayString$1(unref(getFlagEmoji)(country.value)) + "    " + toDisplayString$1(country.text), 9 /* TEXT, PROPS */, _hoisted_10$f))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_9$f), [
                          [vModelSelect, destinationCountry.value]
                        ])
                      ], 8 /* PROPS */, _hoisted_7$h))
                    : createCommentVNode("v-if", true)
                ])),
            createCommentVNode(" Produktselektor Liste "),
            withDirectives(createElementVNode("div", {
              class: "ps-list",
              ref_key: "psListContainer",
              ref: psListContainer
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(psList.value, (psEl, listId) => {
                return (openBlock(), createElementBlock("div", {
                  class: normalizeClass(["ps-element", psEl.active ? 'expanded' : '']),
                  key: listId
                }, [
                  createElementVNode("div", {
                    id: psEl.id,
                    onClick: $event => (activate(psEl, $event))
                  }, [
                    withDirectives(createElementVNode("div", {
                      pselact: "1",
                      class: normalizeClass(["grid", psEl.active ? 'active' : ''])
                    }, [
                      createElementVNode("div", _hoisted_12$f, [
                        (psEl.editMode == 'vidge')
                          ? (openBlock(), createBlock(unref(script$f), {
                              key: 0,
                              psEl: psEl,
                              listId: listId,
                              itemNumber: selectedItemNumber.value,
                              onClose: $event => (psEl.editMode = false),
                              onVidgeLoaded: vidgeLoaded,
                              onSaveVic: saveVic
                            }, null, 8 /* PROPS */, ["psEl", "listId", "itemNumber", "onClose"]))
                          : createCommentVNode("v-if", true),
                        (psEl.editMode == 'pdf')
                          ? (openBlock(), createBlock(unref(script$e), {
                              key: 1,
                              psEl: psEl,
                              listId: listId,
                              itemNumber: selectedItemNumber.value,
                              onClose: $event => (_ctx.onExternalEditorClose(psEl))
                            }, null, 8 /* PROPS */, ["psEl", "listId", "itemNumber", "onClose"]))
                          : createCommentVNode("v-if", true),
                        withDirectives(createElementVNode("div", _hoisted_13$e, [
                          (inlineUploadListId.value === listId)
                            ? (openBlock(), createElementBlock("div", _hoisted_14$c, [
                                createElementVNode("div", _hoisted_15$c, [
                                  createElementVNode("button", {
                                    type: "button",
                                    class: "uk-icon-button",
                                    "uk-close": "",
                                    "aria-label": _ctx.$t('productSelector.cancel'),
                                    onClick: _cache[3] || (_cache[3] = $event => (inlineUploadListId.value = false))
                                  }, null, 8 /* PROPS */, _hoisted_16$b)
                                ]),
                                createVNode(unref(script$y), {
                                  extraMenuItems: unref(uploadMenuItems),
                                  onMenuAction: unref(onUploadMenuAction),
                                  onOnUploadComplete: (payload) => unref(onInlineUploadComplete)(payload, listId)
                                }, null, 8 /* PROPS */, ["extraMenuItems", "onMenuAction", "onOnUploadComplete"])
                              ]))
                            : createCommentVNode("v-if", true),
                          createCommentVNode(" aktive Ansicht ohne gewähltes Druckmotiv "),
                          withDirectives(createElementVNode("div", {
                            class: normalizeClass(["no-media-placeholder", { 'has-bg-image': !!getProductBgImageUrl(psEl) }])
                          }, [
                            createVNode(Transition, { name: "product-bg-fade" }, {
                              default: withCtx(() => [
                                (getProductBgImageUrl(psEl))
                                  ? (openBlock(), createElementBlock("div", {
                                      key: getProductBgImageUrl(psEl),
                                      class: "product-bg-image-layer",
                                      style: normalizeStyle({ backgroundImage: 'url(' + getProductBgImageUrl(psEl) + ')' })
                                    }, null, 4 /* STYLE */))
                                  : createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            (isMediaRequired(psEl))
                              ? (openBlock(), createElementBlock("div", _hoisted_17$9, [
                                  createElementVNode("button", {
                                    onClick: $event => (selectFile(listId,psEl)),
                                    class: "printfile-select uk-button uk-button-default uk-button-small uk-button-primary"
                                  }, [
                                    _cache[10] || (_cache[10] = createElementVNode("i", {
                                      "uk-icon": "icon: image",
                                      class: "uk-icon"
                                    }, null, -1 /* HOISTED */)),
                                    createTextVNode(" " + toDisplayString$1(_ctx.$t('productSelector.fileSelection')), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_18$9)
                                ]))
                              : createCommentVNode("v-if", true)
                          ], 2 /* CLASS */), [
                            [vShow, inlineUploadListId.value !== listId && (!psEl.ps || !psEl.ps.status.media || psEl.ps.status.media.length == 0)]
                          ]),
                          createCommentVNode(" aktive Ansicht mit ausgewähltem Druckmotiv "),
                          (psEl.active)
                            ? withDirectives((openBlock(), createElementBlock("div", _hoisted_19$9, [
                                createElementVNode("div", _hoisted_20$8, [
                                  createElementVNode("div", _hoisted_21$8, [
                                    (psEl.ps && psEl.ps.status.media && psEl.ps.status.media.length > 1)
                                      ? (openBlock(), createElementBlock("div", _hoisted_22$7, [
                                          createElementVNode("div", _hoisted_23$7, toDisplayString$1(_ctx.$t('productSelector.motifsCount', { count: psEl.ps.status.media.length })), 1 /* TEXT */),
                                          createElementVNode("div", {
                                            class: "separate-button",
                                            "uk-tooltip": _ctx.$t('productSelector.configureMotifsSeparately'),
                                            onClick: $event => (separate(listId))
                                          }, [...(_cache[11] || (_cache[11] = [
                                            createElementVNode("i", {
                                              "uk-icon": "icon: list",
                                              class: "uk-icon"
                                            }, null, -1 /* HOISTED */)
                                          ]))], 8 /* PROPS */, _hoisted_24$7)
                                        ]))
                                      : createCommentVNode("v-if", true)
                                  ]),
                                  createElementVNode("div", _hoisted_25$7, [
                                    createVNode(unref(script$l), {
                                      ref_for: true,
                                      ref: (component) => setProductPreviewRef(listId, component),
                                      id: 'preview-' + listId,
                                      psElement: psEl,
                                      listId: listId,
                                      missing: inputMissing.value,
                                      zoomable: "",
                                      selectedMethod: psEl.selectedMethod,
                                      onUpdateMethods: (data) => { psEl.availableMethods = data.methods; psEl.selectedMethod = psEl.selectedMethod || data.selected; },
                                      onDisplayMedia: setDM,
                                      onChangeItem: setItemNumber,
                                      onResolutionWarning: (level) => setResolutionLevel(psEl, level)
                                    }, null, 8 /* PROPS */, ["id", "psElement", "listId", "missing", "selectedMethod", "onUpdateMethods", "onResolutionWarning"])
                                  ]),
                                  createElementVNode("div", _hoisted_26$6, [
                                    (psEl.availableMethods && psEl.availableMethods.length > 1)
                                      ? (openBlock(), createElementBlock("div", _hoisted_27$6, [
                                          createElementVNode("div", _hoisted_28$6, [
                                            createElementVNode("button", _hoisted_29$4, [
                                              createTextVNode(toDisplayString$1(_ctx.$t('productPreview.methods.' + psEl.availableMethods[psEl.selectedMethod]?.labelKey)) + " ", 1 /* TEXT */),
                                              _cache[12] || (_cache[12] = createElementVNode("span", { "uk-icon": "chevron-down" }, null, -1 /* HOISTED */))
                                            ]),
                                            createElementVNode("div", _hoisted_30$4, [
                                              createElementVNode("ul", _hoisted_31$4, [
                                                (openBlock(true), createElementBlock(Fragment, null, renderList(psEl.availableMethods, (method, name) => {
                                                  return (openBlock(), createElementBlock("li", {
                                                    value: name,
                                                    key: name
                                                  }, [
                                                    createElementVNode("a", {
                                                      onClick: $event => (selectMethod(psEl, name, $event))
                                                    }, toDisplayString$1(_ctx.$t('productPreview.methods.' + method.labelKey)), 9 /* TEXT, PROPS */, _hoisted_33$3)
                                                  ], 8 /* PROPS */, _hoisted_32$3))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : createCommentVNode("v-if", true),
                                    createElementVNode("div", _hoisted_34$2, [
                                      createElementVNode("div", _hoisted_35$2, [
                                        (isMediaRequired(psEl))
                                          ? (openBlock(), createElementBlock("button", {
                                              key: 0,
                                              onClick: $event => (selectFile(listId,psEl)),
                                              class: "uk-button uk-button-default uk-button-small uk-background-default"
                                            }, [...(_cache[13] || (_cache[13] = [
                                              createElementVNode("i", {
                                                "uk-icon": "icon: image",
                                                class: "uk-icon"
                                              }, null, -1 /* HOISTED */)
                                            ]))], 8 /* PROPS */, _hoisted_36$2))
                                          : createCommentVNode("v-if", true),
                                        createElementVNode("button", {
                                          onClick: $event => (deletePsElem(listId)),
                                          class: "uk-button uk-button-default uk-button-small uk-background-default"
                                        }, [...(_cache[14] || (_cache[14] = [
                                          createElementVNode("i", {
                                            "uk-icon": "icon: trash",
                                            class: "uk-icon"
                                          }, null, -1 /* HOISTED */)
                                        ]))], 8 /* PROPS */, _hoisted_37$2),
                                        createCommentVNode(" <button @click=\"todoCopyHandler(listId)\"\n                                                            class=\"uk-button uk-button-default uk-button-small uk-background-default\"><i\n                                                                uk-icon=\"icon: copy\" class=\"uk-icon\"></i></button> "),
                                        createElementVNode("button", {
                                          onClick: $event => (editFile(listId)),
                                          class: "uk-button uk-button-default uk-button-small uk-background-default"
                                        }, [...(_cache[15] || (_cache[15] = [
                                          createElementVNode("i", {
                                            "uk-icon": "icon: file-edit",
                                            class: "uk-icon"
                                          }, null, -1 /* HOISTED */)
                                        ]))], 8 /* PROPS */, _hoisted_38$2),
                                        createElementVNode("button", {
                                          onClick: $event => (psEl.active = false),
                                          class: "uk-button uk-button-default uk-button-small uk-background-default"
                                        }, [...(_cache[16] || (_cache[16] = [
                                          createElementVNode("i", {
                                            "uk-icon": "icon: shrink",
                                            class: "uk-icon"
                                          }, null, -1 /* HOISTED */)
                                        ]))], 8 /* PROPS */, _hoisted_39$2)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 512 /* NEED_PATCH */)), [
                                [vShow, inlineUploadListId.value !== listId && psEl.ps && psEl.ps.status.media && psEl.ps.status.media.length > 0]
                              ])
                            : createCommentVNode("v-if", true)
                        ], 512 /* NEED_PATCH */), [
                          [vShow, psEl.active]
                        ]),
                        (!psEl.active)
                          ? (openBlock(), createElementBlock("div", _hoisted_40$2, [
                              createCommentVNode(" inaktive (kleine) Ansicht "),
                              createElementVNode("div", _hoisted_41$2, [
                                createElementVNode("div", _hoisted_42$2, [
                                  createVNode(unref(script$l), {
                                    psElement: psEl,
                                    listId: listId,
                                    previewSize: [80, 80],
                                    missing: inputMissing.value,
                                    onResolutionWarning: (level) => setResolutionLevel(psEl, level)
                                  }, null, 8 /* PROPS */, ["psElement", "listId", "missing", "onResolutionWarning"])
                                ]),
                                createElementVNode("div", _hoisted_43$2, [
                                  (isMediaRequired(psEl))
                                    ? (openBlock(), createElementBlock("button", {
                                        key: 0,
                                        onClick: $event => (selectFile(listId,psEl)),
                                        class: "uk-button uk-button-default uk-button-small uk-background-default"
                                      }, [...(_cache[17] || (_cache[17] = [
                                        createElementVNode("i", {
                                          "uk-icon": "icon: image",
                                          class: "uk-icon"
                                        }, null, -1 /* HOISTED */)
                                      ]))], 8 /* PROPS */, _hoisted_44$2))
                                    : createCommentVNode("v-if", true),
                                  createElementVNode("button", {
                                    onClick: $event => (deletePsElem(listId)),
                                    class: "uk-button uk-button-default uk-button-small uk-background-default"
                                  }, [...(_cache[18] || (_cache[18] = [
                                    createElementVNode("i", {
                                      "uk-icon": "icon: trash",
                                      class: "uk-icon"
                                    }, null, -1 /* HOISTED */)
                                  ]))], 8 /* PROPS */, _hoisted_45$2),
                                  createCommentVNode("<button @click=\"todoCopyHandler(listId)\"\n                                                class=\"uk-button uk-button-default uk-button-small uk-background-default\"><i\n                                                    uk-icon=\"icon: copy\" class=\"uk-icon\"></i></button>"),
                                  createElementVNode("button", {
                                    onClick: $event => (editFile(listId)),
                                    class: "uk-button uk-button-default uk-button-small uk-background-default"
                                  }, [...(_cache[19] || (_cache[19] = [
                                    createElementVNode("i", {
                                      "uk-icon": "icon: file-edit",
                                      class: "uk-icon"
                                    }, null, -1 /* HOISTED */)
                                  ]))], 8 /* PROPS */, _hoisted_46$2),
                                  createElementVNode("button", {
                                    onClick: withModifiers($event => (expandSelector(psEl, listId)), ["stop"]),
                                    class: "uk-button uk-button-default uk-button-small uk-background-default"
                                  }, [...(_cache[20] || (_cache[20] = [
                                    createElementVNode("i", {
                                      "uk-icon": "icon: expand",
                                      class: "uk-icon"
                                    }, null, -1 /* HOISTED */)
                                  ]))], 8 /* PROPS */, _hoisted_47$2)
                                ])
                              ])
                            ]))
                          : createCommentVNode("v-if", true)
                      ]),
                      createCommentVNode(" Produktselektor "),
                      createElementVNode("div", _hoisted_48$2, [
                        createElementVNode("div", null, [
                          createCommentVNode(" aktive (große) Ansicht "),
                          withDirectives(createElementVNode("div", {
                            class: normalizeClass(["product-select-form active", { 'bc-view': props.bcView }])
                          }, [
                            (hasVisiblePreFilterItems.value)
                              ? (openBlock(), createBlock(unref(script$K), {
                                  key: 0,
                                  filterItems: preFilterItems.value,
                                  ignoreItems: {public:false},
                                  addFilterIcon: "settings"
                                }, null, 8 /* PROPS */, ["filterItems"]))
                              : createCommentVNode("v-if", true),
                            createVNode(unref(script$E), {
                              media: psEl.ps.status.media?.[0]
                            }, null, 8 /* PROPS */, ["media"]),
                            (noMatchingProducts())
                              ? (openBlock(), createBlock(unref(script$F), {
                                  key: 1,
                                  file: productMatch.value.file
                                }, null, 8 /* PROPS */, ["file"]))
                              : createCommentVNode("v-if", true),
                            createCommentVNode(" breadcrumbs selector"),
                            (props.bcView)
                              ? (openBlock(), createElementBlock("div", _hoisted_49$2, [
                                  createElementVNode("button", {
                                    class: "bc-nav num-dec",
                                    onClick: _cache[4] || (_cache[4] = $event => (bcSliderNav('previous',$event)))
                                  }, [...(_cache[21] || (_cache[21] = [
                                    createElementVNode("i", { "uk-icon": "icon: chevron-left" }, null, -1 /* HOISTED */)
                                  ]))]),
                                  createElementVNode("div", _hoisted_50$2, [
                                    createElementVNode("div", _hoisted_51$2, [
                                      createElementVNode("div", null, [
                                        createElementVNode("a", {
                                          href: "#",
                                          onClick: $event => (bcSelect(psEl, {'root':''}))
                                        }, [
                                          createTextVNode(toDisplayString$1(_ctx.$t('productSelector.products')), 1 /* TEXT */),
                                          _cache[22] || (_cache[22] = createElementVNode("i", { "uk-icon": "icon: chevron-right" }, null, -1 /* HOISTED */))
                                        ], 8 /* PROPS */, _hoisted_52$1)
                                      ]),
                                      (openBlock(true), createElementBlock(Fragment, null, renderList(psEl.breadcrumbs || [], (bcItem) => {
                                        return (openBlock(), createElementBlock("div", {
                                          key: bcItem.key
                                        }, [
                                          (Object.keys(bcItem.filter)[0] && typeof (bcItem.filter[Object.keys(bcItem.filter)[0]]) == 'string')
                                            ? (openBlock(), createElementBlock("a", {
                                                key: 0,
                                                href: "#",
                                                onClick: $event => (bcSelect(psEl, bcItem.filter))
                                              }, [
                                                createTextVNode(toDisplayString$1(bcShow(bcItem.filter)) + " ", 1 /* TEXT */),
                                                _cache[23] || (_cache[23] = createElementVNode("i", { "uk-icon": "icon: chevron-right" }, null, -1 /* HOISTED */))
                                              ], 8 /* PROPS */, _hoisted_53$1))
                                            : createCommentVNode("v-if", true)
                                        ]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                  ]),
                                  createElementVNode("button", {
                                    class: "bc-nav num-inc",
                                    onClick: _cache[5] || (_cache[5] = $event => (bcSliderNav('next',$event)))
                                  }, [...(_cache[24] || (_cache[24] = [
                                    createElementVNode("i", { "uk-icon": "icon: chevron-right" }, null, -1 /* HOISTED */)
                                  ]))])
                                ]))
                              : createCommentVNode("v-if", true),
                            createCommentVNode(" standard selector "),
                            (psEl.ps && psEl.ps.status && psEl.schema)
                              ? (openBlock(), createElementBlock("div", {
                                  key: 3,
                                  class: "ps-form",
                                  onChangeCapture: $event => (freezeSelectorGridHeight(psEl))
                                }, [
                                  (openBlock(), createBlock(_component_FormKit, {
                                    key: `${psEl.id}-${psEl.schemaVersion}`,
                                    plugins: [unref(formkitExtension)],
                                    type: "form",
                                    modelValue: psEl.ps.status.form,
                                    "onUpdate:modelValue": $event => ((psEl.ps.status.form) = $event),
                                    actions: false
                                  }, {
                                    default: withCtx(() => [
                                      createVNode(unref(FormKitSchema), {
                                        class: "ps-main-container",
                                        schema: psEl.schema
                                      }, null, 8 /* PROPS */, ["schema"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["plugins", "modelValue", "onUpdate:modelValue"])),
                                  (psEl.ps.status.product)
                                    ? (openBlock(), createElementBlock("div", _hoisted_55$1, [
                                        createElementVNode("div", null, toDisplayString$1(psEl.ps.status.product.label), 1 /* TEXT */),
                                        createElementVNode("div", null, [
                                          createTextVNode(toDisplayString$1(psEl.ps.status.product.format) + " " + toDisplayString$1(psEl.ps.status.product.surface) + " ", 1 /* TEXT */),
                                          createVNode(unref(script$k), {
                                            class: "product-info-button",
                                            pid: psEl.ps.status.product.pid
                                          }, null, 8 /* PROPS */, ["pid"])
                                        ])
                                      ]))
                                    : createCommentVNode("v-if", true),
                                  (needsResolutionConfirmation(psEl))
                                    ? (openBlock(), createElementBlock("label", _hoisted_56$1, [
                                        withDirectives(createElementVNode("input", {
                                          type: "checkbox",
                                          class: "uk-checkbox",
                                          "onUpdate:modelValue": $event => ((psEl.resolutionConfirmed) = $event)
                                        }, null, 8 /* PROPS */, _hoisted_57$1), [
                                          [vModelCheckbox, psEl.resolutionConfirmed]
                                        ]),
                                        createTextVNode(" " + toDisplayString$1(_ctx.$t('productSelector.acceptLowResolution')), 1 /* TEXT */)
                                      ]))
                                    : createCommentVNode("v-if", true),
                                  (hasFormatAdjustment(psEl))
                                    ? (openBlock(), createElementBlock("div", _hoisted_58$1, [
                                        createTextVNode(toDisplayString$1(_ctx.$t('productSelector.formatAdjusted')) + " ", 1 /* TEXT */),
                                        createElementVNode("a", {
                                          href: "#",
                                          onClick: withModifiers($event => (openProductPreview(listId)), ["prevent"])
                                        }, toDisplayString$1(_ctx.$t('productSelector.checkPreview')), 9 /* TEXT, PROPS */, _hoisted_59$1)
                                      ]))
                                    : createCommentVNode("v-if", true),
                                  createElementVNode("div", _hoisted_60$1, [
                                    createElementVNode("div", _hoisted_61$1, [
                                      (psEl.ps.status.product)
                                        ? (openBlock(), createElementBlock("span", _hoisted_62$1, toDisplayString$1(psEl.ps.status.product.pid), 1 /* TEXT */))
                                        : createCommentVNode("v-if", true)
                                    ])
                                  ])
                                ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_54$1))
                              : createCommentVNode("v-if", true),
                            createElementVNode("div", _hoisted_63$1, [
                              createElementVNode("div", _hoisted_64$1, [
                                createVNode(unref(script$A), {
                                  onCopies: setCopies,
                                  listId: listId,
                                  psEl: psEl,
                                  preserveInitialQuantity: psEl.preserveInitialQuantity
                                }, null, 8 /* PROPS */, ["listId", "psEl", "preserveInitialQuantity"])
                              ])
                            ])
                          ], 2 /* CLASS */), [
                            [vShow, psEl.active]
                          ]),
                          createCommentVNode(" inaktiver selector "),
                          (!psEl.active && psEl.ps && psEl.ps.status)
                            ? (openBlock(), createElementBlock("div", _hoisted_65$1, [
                                createElementVNode("div", _hoisted_66$1, [
                                  createElementVNode("div", {
                                    class: "prod-small",
                                    pselact: "1",
                                    "uk-tooltip": _ctx.$t('productSelector.change')
                                  }, [
                                    (psEl.ps.status.product)
                                      ? (openBlock(), createElementBlock("span", _hoisted_68$1, [
                                          createTextVNode(toDisplayString$1(unref(filterDef)["pgrId"][psEl.ps.status.product.pgrId]["labelSingular"]) + " " + toDisplayString$1(psEl.ps.status.product.surface), 1 /* TEXT */),
                                          _cache[25] || (_cache[25] = createElementVNode("br", null, null, -1 /* HOISTED */)),
                                          createTextVNode(" " + toDisplayString$1(psEl.ps.status.product.label) + " " + toDisplayString$1(psEl.ps.status.product.format), 1 /* TEXT */)
                                        ]))
                                      : (openBlock(), createElementBlock("span", _hoisted_69$1, toDisplayString$1(_ctx.$t('productSelector.chooseProduct')), 1 /* TEXT */))
                                  ], 8 /* PROPS */, _hoisted_67$1),
                                  createElementVNode("div", _hoisted_70$1, [
                                    createVNode(unref(script$A), {
                                      onCopies: setCopies,
                                      listId: listId,
                                      psEl: psEl,
                                      preserveInitialQuantity: psEl.preserveInitialQuantity
                                    }, null, 8 /* PROPS */, ["listId", "psEl", "preserveInitialQuantity"])
                                  ])
                                ])
                              ]))
                            : createCommentVNode("v-if", true)
                        ])
                      ])
                    ], 2 /* CLASS */), [
                      [vShow, fileSelector.value === false]
                    ])
                  ], 8 /* PROPS */, _hoisted_11$f)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [vShow, fileSelector.value === false]
            ])
          ], 512 /* NEED_PATCH */),
          createElementVNode("div", _hoisted_71$1, [
            createElementVNode("div", _hoisted_72$1, [
              (fileSelector.value === false)
                ? (openBlock(), createElementBlock("button", {
                    key: 0,
                    class: "abort-button uk-button uk-button-default",
                    onClick: _cache[6] || (_cache[6] = $event => (emit('close')))
                  }, [
                    _cache[26] || (_cache[26] = createElementVNode("i", {
                      "uk-icon": "close",
                      class: "abort-small uk-icon"
                    }, null, -1 /* HOISTED */)),
                    createElementVNode("span", _hoisted_73$1, toDisplayString$1(_ctx.$t('productSelector.cancel')), 1 /* TEXT */)
                  ]))
                : createCommentVNode("v-if", true),
              createElementVNode("div", _hoisted_74$1, [
                createVNode(unref(script$B), {
                  psList: psList.value,
                  missing: inputMissing.value,
                  disabled: fileSelector.value !== false,
                  onInCart: inCart
                }, null, 8 /* PROPS */, ["psList", "missing", "disabled"])
              ])
            ])
          ])
        ]))
      : (openBlock(), createElementBlock("div", _hoisted_75$1, [
          createCommentVNode(" Ergebnis der Warenkorbablage "),
          createElementVNode("div", _hoisted_76$1, [
            createElementVNode("h3", null, toDisplayString$1(_ctx.$t('productSelector.productInCart')), 1 /* TEXT */)
          ]),
          createElementVNode("div", _hoisted_77$1, [
            createTextVNode(toDisplayString$1(_ctx.$t('productSelector.addedToCartMessage', { value: savedPrice.value.fmt })) + " ", 1 /* TEXT */),
            (increasedCopiesCount.value > 0)
              ? (openBlock(), createElementBlock("div", _hoisted_78$1, toDisplayString$1(_ctx.$t('A matching item was already in your basket. The number of copies was increased.')), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_79$1, [
              createElementVNode("button", {
                class: "cart-button uk-button uk-button-default uk-button-small",
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.$emit('close')))
              }, toDisplayString$1(_ctx.$t('productSelector.continueShopping')), 1 /* TEXT */),
              _cache[27] || (_cache[27] = createTextVNode("  ")),
              createVNode(_component_router_link, { to: "/shop/cart" }, {
                default: withCtx(() => [
                  createElementVNode("button", {
                    class: "cart-button uk-button uk-button-default uk-button-small uk-button-primary uk-margin-right",
                    onClick: _cache[8] || (_cache[8] = $event => (_ctx.$emit('close')))
                  }, toDisplayString$1(_ctx.$t('productSelector.toCheckout')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ]))
  ], 2 /* CLASS */))
}
}

};

script$D.__file = "src/components/ProductSelector.vue";

var script$C = {
  __name: 'ProductSelectorModal',
  setup(__props) {

const prodselStore = useProdselStore();
const { psm } = storeToRefs(prodselStore);



return (_ctx, _cache) => {
  return (unref(psm).showModal)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "product-selector-modal uk-modal uk-open ps-modal",
        style: {"display":"block"},
        onWheel: _cache[3] || (_cache[3] = withModifiers(() => {}, ["prevent","self"])),
        onTouchmove: _cache[4] || (_cache[4] = withModifiers(() => {}, ["prevent","self"]))
      }, [
        createElementVNode("div", {
          id: "product-selector-dialog",
          class: "modal-view uk-modal-dialog",
          onWheel: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"])),
          onTouchmove: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"]))
        }, [
          createVNode(unref(script$D), {
            psId: unref(psm).psId,
            psList: unref(psm).psList,
            layout: unref(psm).layout,
            usePgrId: unref(psm).usePgrId,
            useProd: unref(psm).useProd,
            useMedia: unref(psm).useMedia,
            bcView: unref(psm).bcView,
            stepByStep: unref(psm).stepByStep,
            autoSelect: unref(psm).autoSelect,
            fromCart: Number.isInteger(unref(psm).editCartIndex),
            onClose: _cache[0] || (_cache[0] = $event => (unref(psm).showModal = false))
          }, null, 8 /* PROPS */, ["psId", "psList", "layout", "usePgrId", "useProd", "useMedia", "bcView", "stepByStep", "autoSelect", "fromCart"])
        ], 32 /* NEED_HYDRATION */)
      ], 32 /* NEED_HYDRATION */))
    : createCommentVNode("v-if", true)
}
}

};

script$C.__file = "src/components/ProductSelectorModal.vue";

const _hoisted_1$y = ["uk-tooltip", "disabled"];
 

var script$B = {
  __name: 'CartButton',
  props: {
    missing: Object,
    disabled: {
        type: Boolean,
        default: false,
    },
    psList: {
        type: Object,
    }
},
  emits: ['in-cart'],
  setup(__props, { emit: __emit }) {

const sessionStore = useSessionStore();
const prodselStore = useProdselStore();
const authStore = useAuthStore();
const { cart } = storeToRefs(sessionStore);
const { psm } = storeToRefs(prodselStore);

sessionStore.normalizeCart();

const cartItems = computed(() => Array$1.isArray(cart.value) ? cart.value : (cart.value?.items || []));

//window.cart = cart // Debug

const props = __props;

const emit = __emit;

const price = computed({
    get() {

        let price = 0;
        let p = 0;
        let currency = "EUR";
        props.psList.forEach((psEl) => {
            if (psEl.ps && psEl.ps.status && psEl.ps.status.product && psEl.ps.status.product.prices && psEl.ps.status.properties && psEl.ps.status.properties.copies) {

                let media_count = 1;
                let pages = 0;
                if (psEl.ps.status.media) {
                    if (psEl.ps.status.media.length) media_count = psEl.ps.status.media.length;
                    if (psEl.ps.status.media[0]) pages = psEl.ps.status.media[0].pages;
                }

                let config = {
                    pages: pages, 
                    media: psEl.ps.status.media,
                    optionsHash: psEl.ps.status.productOptionsHash,
                    options: getSelectedProductOptions(psEl),
                    productSelector: "psm"
                };

                p = quantityPrice(psEl.ps.status.product, psEl.ps.status.properties.copies * media_count, config, getSelectedOptionPrices(psEl));
                currency = p.currency;
                price += p.current;
            }
        });


        let fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency });
        let priceFormatted = "";
        if (!isNaN(price)) priceFormatted = fmt.format(price);
        
        return { int: price, fmt: priceFormatted }
    }
});


const changing = ref(false);
let changeTimeout;

watch(price, () => {
    changing.value = true;
    clearTimeout(changeTimeout);
    changeTimeout = setTimeout(() => {
        changing.value = false;
    }, 200);
}, { deep: true });

// const totalQuantity = computed({
//   get() {
//     if (props.currentSel.media) return cartform.value.copies * props.currentSel.media.length
//     return cartform.value.copies
//   }
// })

function getMediaIdentity(media) {
    if (!Array$1.isArray(media)) return ""

    return media
        .map((item) => item?.id)
        .filter((id) => typeof id !== "undefined" && id !== null)
        .map((id) => String(id))
        .sort()
        .join("|")
}

function stripPricesFromProduct(product) {
    if (!product || typeof product !== 'object') return product
    const sanitizedProduct = _.cloneDeep(product);
    if (typeof sanitizedProduct.prices !== 'undefined') {
        delete sanitizedProduct.prices;
    }
    return sanitizedProduct
}

function stripPricesFromSelectedOptionPrices(selectedOptionPrices) {
    if (!Array$1.isArray(selectedOptionPrices)) return []
    return selectedOptionPrices.map((optionPrice) => {
        if (!optionPrice || typeof optionPrice !== 'object') return optionPrice
        const sanitizedOptionPrice = _.cloneDeep(optionPrice);
        if (typeof sanitizedOptionPrice.prices !== 'undefined') {
            delete sanitizedOptionPrice.prices;
        }
        return sanitizedOptionPrice
    })
}

function stripPricesFromSelectorState(selectorState) {
    if (!selectorState || typeof selectorState !== 'object') return selectorState
    const sanitizedState = _.cloneDeep(selectorState);

    if (sanitizedState.product && typeof sanitizedState.product === 'object' && typeof sanitizedState.product.prices !== 'undefined') {
        delete sanitizedState.product.prices;
    }

    if (sanitizedState.optionPrices && typeof sanitizedState.optionPrices === 'object') {
        Object.values(sanitizedState.optionPrices).forEach((optionPrice) => {
            if (!optionPrice || typeof optionPrice !== 'object') return
            if (typeof optionPrice.prices !== 'undefined') {
                delete optionPrice.prices;
            }
        });
    }

    return sanitizedState
}

function toCart() {

    let currentCart = toRaw(cartItems.value);
    let currenPrice = toRaw(price.value);

    if (!Array$1.isArray(cart.value) && !cart.value?.sessionId) {
        cart.value.sessionId = authStore.getSessionId();
    }

    // CartIndex ist einfacher Zähler von 0 beginnend
    let ci = (currentCart.length) ? currentCart.length : 0;

    let newEntries = [];
    let increasedCopiesCount = 0;
    const rawEditCartIndex = psm.value?.editCartIndex;
    const replaceMode = Number.isInteger(rawEditCartIndex)
        && rawEditCartIndex >= 0
        && rawEditCartIndex < cartItems.value.length;
    const editCartIndex = replaceMode ? rawEditCartIndex : -1;
    let replaceOffset = 0;

    props.psList.forEach(psEl => {

        if (typeof psEl.unwatch != "undefined") psEl.unwatch();
        let currentSel = psEl.ps.status;
        const mediaList = Array$1.isArray(currentSel.media) ? currentSel.media : [];

        //  get selected options
        let productOptions = getSelectedProductOptions(psEl);

        let config = {
            pages: mediaList[0]?.pages,
            options: productOptions,
            optionsHash: psEl.ps.status.productOptionsHash,
        };
       
        // options can be stored in media
        if (mediaList.length > 0) config.media = mediaList;

        // im Warenkorb wird Produkt/Preis Objekt und Mengenangabe gespeichert
        let quantity = currentSel.properties.copies * (mediaList.length || 1);

        

        // Preise von ausgewählten (kostenpflichtigen) Optionen hinzufügen	
        const selectedOptionPricesRaw = getSelectedOptionPrices(psEl);
        const selectedOptionPrices = stripPricesFromSelectedOptionPrices(selectedOptionPricesRaw);

        const cartItemPayload = {
            product: stripPricesFromProduct(currentSel.product),
            selectedOptionPrices: selectedOptionPrices,
            media: mediaList,
            mediaSettings: currentSel.mediaSettings,
            quantity: quantity,
            properties: { ...currentSel.properties, ...{ options: productOptions }, ...{ optionsHash: currentSel.productOptionsHash } },
            selectorState: stripPricesFromSelectorState(currentSel),
            priceCalc: quantityPrice(psEl.ps.status.product, quantity, config, selectedOptionPricesRaw),
            revision: generateShortUUID()
        };

        if (replaceMode) {
            if (replaceOffset == 0) {
                cartItems.value.splice(editCartIndex, 1, cartItemPayload);
            } else {
                cartItems.value.splice(editCartIndex + replaceOffset, 0, cartItemPayload);
            }
            newEntries.push(editCartIndex + replaceOffset);
            replaceOffset += 1;
            return
        }

        let currentMediaIdentity = getMediaIdentity(currentSel.media);
        let existingIndex = cartItems.value.findIndex((cartItem) => {
            if (!currentMediaIdentity) return false
            return cartItem?.product?.pid == currentSel.product?.pid
                && cartItem?.properties?.optionsHash == currentSel.productOptionsHash
                && getMediaIdentity(cartItem?.media) == currentMediaIdentity
        });

        if (existingIndex !== -1) {
            let existingItem = cartItems.value[existingIndex];
            existingItem.properties.copies = (Number(existingItem?.properties?.copies) || 0) + 1;
            existingItem.quantity = existingItem.properties.copies * ((existingItem.media?.length) || 1);

            let existingConfig = {
                pages: existingItem.media[0]?.pages,
                options: existingItem.properties.options,
                optionsHash: existingItem.properties.optionsHash,
            };

            if (existingItem.media) existingConfig.media = existingItem.media;

            existingItem.priceCalc = quantityPrice(
                psEl.ps.status.product,
                existingItem.quantity,
                existingConfig,
                selectedOptionPricesRaw
            );
            existingItem.selectedOptionPrices = selectedOptionPrices;

            existingItem.selectorState = stripPricesFromSelectorState(currentSel);
            existingItem.selectorState.properties = {
                ...(existingItem.selectorState.properties || {}),
                copies: existingItem.properties.copies
            };
            existingItem.revision = generateShortUUID();

            newEntries.push(existingIndex);
            increasedCopiesCount += 1;
            return
        }
        
        cartItems.value[ci] = cartItemPayload;

        newEntries.push(ci);

        ci++;
    });
    // TODO Druckdaten speichern

    if (replaceMode) {
        psm.value.editCartIndex = null;
    }

    sessionStore.scheduleCartPush();

    emit("in-cart", {
        cart: cart,
        newEntries: newEntries,
        price: currenPrice,
        replaceMode: replaceMode,
        increasedCopiesCount: increasedCopiesCount,
        hasIncreasedCopies: increasedCopiesCount > 0
    });

}


const inputMissing = computed(() => {
   
    if (!Array$1.isArray(props.missing.warnings) || props.missing.warnings.length == 0) return null

    return "title: " + props.missing.warnings.join("<br>") + "; pos: bottom"

   }
);

const isEditMode = computed(() => {
    const index = psm.value?.editCartIndex;
    return Number.isInteger(index) && index >= 0 && index < cartItems.value.length
});
//window.im = inputMissing

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = $event => (toCart())),
    "uk-tooltip": inputMissing.value,
    disabled: props.disabled || inputMissing.value !== null,
    class: "in-cart-button uk-button uk-button-default uk-button-primary"
  }, [
    createElementVNode("span", {
      class: normalizeClass(["price", (changing.value)?'loader':''])
    }, toDisplayString$1((changing.value)?'':price.value.fmt), 3 /* TEXT, CLASS */),
    createTextVNode("     " + toDisplayString$1(_ctx.$t(isEditMode.value ? 'productSelector.applySelection' : 'checkout.common.addToCart')), 1 /* TEXT */)
  ], 8 /* PROPS */, _hoisted_1$y))
}
}

};

script$B.__file = "src/components/CartButton.vue";

const _hoisted_1$x = ["disabled"];
const _hoisted_2$s = { class: "copies-selector" };
const _hoisted_3$p = ["value"];
const _hoisted_4$n = {
  key: 0,
  class: "standard-price"
};
const _hoisted_5$l = ["uk-tooltip"];

var script$A = {
  __name: 'QuantitySelector',
  props: {
    psEl: {
        type: Object,
    },
    listId: {
        type: Number
    },
    preserveInitialQuantity: {
        type: Boolean,
        default: false
    }
},
  emits: ["copies"],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n();

const sessionStore = useSessionStore();
storeToRefs(sessionStore);


const props = __props;

const emit = __emit;


// properties muss lokal definiert werden da die status.properties aus "props" read-only sind.
// geänderte Werte werden dann mittels emit an den parent gesendet
const properties = ref({ copies: 1 });

function importParameter() {
    if (props.psEl.ps.status.properties?.copies) {
        properties.value.copies = props.psEl.ps.status.properties.copies;
    }
}

// Importiert die Menge, sobald sich der zugrunde liegende psEl-Status ändert (z.B. beim Laden aus dem Warenkorb).
// Muss vor dem quantityModel-Watcher registriert werden, damit dieser bereits den importierten Wert sieht.
watch(() => props.psEl.ps.status.properties?.copies, () => {
    importParameter();
}, { immediate: true });

// geänderte Werte an parent senden
watch(properties, (p) => {
    emit("copies", props.listId, p.copies);
}, { deep: true });

const quantityModel = computed(() => {
    const currentSel = props.psEl.ps.status;
    const model = {
        qts: [],
        min: 1,
    };

    if (currentSel.product.quantityMin) {
        model.min = currentSel.product.quantityMin;
    }
    if (currentSel.product.quantityMax) {
        model.max = currentSel.product.quantityMax;
    }

    if (currentSel.product?.setup?.quantities) {
        let quantities = currentSel.product.setup.quantities;
        if (Array.isArray(quantities)) {
            model.qts = objCopy(quantities);
        } 
    }
    return model
});

// Menge auf einen für das aktuelle Mengenmodell gültigen Wert korrigieren (deckt auch den Wechsel diskret/frei ab)
watch(quantityModel, (model, previousModel) => {
    if (props.preserveInitialQuantity) return

    const copies = Number(properties.value.copies) || 0;
    const quantityModeChanged = previousModel && (previousModel.qts.length > 0) !== (model.qts.length > 0);

    if (model.qts.length > 0) {
        const numericQts = model.qts.map(Number);
        if (quantityModeChanged || !numericQts.includes(copies)) {
            properties.value.copies = String(Math.min(...numericQts));
        }
    } else if (quantityModeChanged || copies < model.min) {
        properties.value.copies = model.min;
    }
}, { immediate: true });

// Preisberechnung
const price = computed(() => {

    let calculatedPrice = "";
    const currentSel = props.psEl.ps.status;
    const copies = Math.max(Number(properties.value.copies) || 1, quantityModel.value.min);
    const mediaCount = Array.isArray(currentSel.media) && currentSel.media.length ? currentSel.media.length : 1;

    let quantity = copies * mediaCount;

    const config = {
        productSelector: "psm",
        options: getSelectedProductOptions(props.psEl),
        optionsHash: props.psEl.ps.status.productOptionsHash
    };

    if (Array.isArray(props.psEl.ps.status?.media) && props.psEl.ps.status.media.length) {
        config.media = props.psEl.ps.status.media;
        if (props.psEl.ps.status.media[0]?.pages) config.pages = props.psEl.ps.status.media[0].pages;
    }

    if (currentSel.product?.prices) {
        calculatedPrice = quantityPrice(currentSel.product, quantity, config, getSelectedOptionPrices(props.psEl));
    }

    return calculatedPrice
});

const showSpecialPrice = computed(() => specialPriceDisplay?.enabled && price.value?.isOffer);

// Klone objekt und wandle Werte in String
function objCopy(obj) {
    if (Array.isArray(obj)) {
        var copy = [];
    } else {
        copy = {};
    }
    for (let i in obj) {
        copy[i] = obj[i].toString();
    }
    return copy
}



const priceDetails = computed(() => {
    let explain = price.value.explain;
    let details = t("unit price") + ":<br>";
    let currency = "EUR";
    if (price.value.currency) currency = price.value.currency;
    let fmt = new Intl.NumberFormat(locale.value, { style: 'currency', currency: currency });
    for (let i in explain) {
        let quantity = explain[i].quantity;
        let optName = explain[i].name || explain[i].option;
        if (optName) {
            details += t("option") + ": ";
            if (quantity>1)  details += quantity + " x "; 
            details += t("product." + optName) + "<br>";
        } 
        if (explain[i].offer) details += t("special offer") + ": ";
        else details += t("price") + ": ";
        details += fmt.format(explain[i].price/explain[i].quantity);
        details += " (" + t("fromCountPiece", explain[i].quantityLevel) + ")<br>";
    }
    return details
});


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    disabled: !__props.psEl.ps.status.product.pid,
    class: normalizeClass(["price-display", { 'has-special-price': showSpecialPrice.value }])
  }, [
    createElementVNode("div", null, toDisplayString$1(_ctx.$t('checkout.cart.copies')) + ":", 1 /* TEXT */),
    createElementVNode("div", _hoisted_2$s, [
      (quantityModel.value.qts.length === 0)
        ? (openBlock(), createBlock(unref(script$J), {
            key: 0,
            num: properties.value.copies,
            min: quantityModel.value.min,
            showInput: true,
            size: 22,
            className: "combined",
            onChange: _cache[0] || (_cache[0] = (val) => properties.value.copies = val)
          }, null, 8 /* PROPS */, ["num", "min"]))
        : withDirectives((openBlock(), createElementBlock("select", {
            key: 1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((properties.value.copies) = $event)),
            class: "uk-select uk-form-small"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(quantityModel.value.qts, (qty) => {
              return (openBlock(), createElementBlock("option", {
                key: qty,
                value: qty
              }, toDisplayString$1(qty), 9 /* TEXT, PROPS */, _hoisted_3$p))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */)), [
            [vModelSelect, properties.value.copies]
          ])
    ]),
    createElementVNode("div", null, toDisplayString$1(_ctx.$t(showSpecialPrice.value ? "special offer" : "unit price")) + ":", 1 /* TEXT */),
    createElementVNode("div", {
      class: normalizeClass(["unit-price", { 'has-special-price': showSpecialPrice.value }])
    }, [
      createElementVNode("span", {
        class: normalizeClass({ 'special-price': showSpecialPrice.value })
      }, toDisplayString$1(price.value.currentSingleFmt), 3 /* TEXT, CLASS */),
      (showSpecialPrice.value)
        ? (openBlock(), createElementBlock("span", _hoisted_4$n, toDisplayString$1(price.value.standardSingleFmt), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      createElementVNode("i", {
        "uk-icon": "icon: info",
        "uk-tooltip": 'title: ' + priceDetails.value,
        class: "uk-icon"
      }, null, 8 /* PROPS */, _hoisted_5$l)
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1$x))
}
}

};

script$A.__file = "src/components/QuantitySelector.vue";

const _hoisted_1$w = { class: "uk-width-1-1" };
const _hoisted_2$r = { value: "label" };
const _hoisted_3$o = {
  class: "uk-text-small",
  value: "0"
};
const _hoisted_4$m = ["value"];
const _hoisted_5$k = { style: {"display":"none"} };
const _hoisted_6$h = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_7$g = {
  class: "uk-form-label",
  for: "order-addr-firstname"
};
const _hoisted_8$e = { class: "uk-form-danger" };
const _hoisted_9$e = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_10$e = {
  class: "uk-form-label",
  for: "order-addr-lastname"
};
const _hoisted_11$e = { class: "uk-form-danger" };
const _hoisted_12$e = { class: "uk-width-1-1" };
const _hoisted_13$d = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_14$b = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_15$b = { class: "uk-form-controls uk-width-1-1" };
const _hoisted_16$a = {
  class: "uk-form-label",
  for: "order-addr-street"
};
const _hoisted_17$8 = { class: "uk-form-danger" };
const _hoisted_18$8 = { class: "uk-form-controls uk-width-1-1" };
const _hoisted_19$8 = { class: "uk-form-controls uk-width-1-3@s" };
const _hoisted_20$7 = {
  class: "uk-form-label",
  for: "order-addr-zip"
};
const _hoisted_21$7 = { class: "uk-form-danger" };
const _hoisted_22$6 = { class: "uk-form-controls uk-width-2-3@s" };
const _hoisted_23$6 = {
  class: "uk-form-label",
  for: "order-addr-city"
};
const _hoisted_24$6 = { class: "uk-form-danger" };
const _hoisted_25$6 = { class: "uk-form-controls uk-width-1-1" };
const _hoisted_26$5 = {
  class: "uk-form-label",
  for: "order-addr-country"
};
const _hoisted_27$5 = { class: "uk-form-danger" };
const _hoisted_28$5 = ["value"];


var script$z = {
  __name: 'AddressForm',
  props: {
    addresses: Object,
    addrId: [Number,String]
},
  emits: ["on-select","is-valid"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

//window.useValidateForm = useValidateForm()
//window.useFieldError = useFieldError

const metaRef = ref(null);
const addrOpt = ref("label");
const addr = ref({});
const showBusinessFields = ref(false);
//window.addrOpt = addrOpt
let current_selection = _.find(props.addresses.data(), { sid: props.addrId });
if (current_selection) addr.value = _.clone(current_selection);

const countries = ref({});
parameter.country.then(data => {
    countries.value = data.country_list;
});

//Watch auf metaRef.value?.valid
watch(
  () => metaRef.value && metaRef.value.valid,
  (val) => {
    if (val !== undefined) {
        emit('is-valid', val);
    } 
  }
);

watch(() => props.addrId, () => {
    if (props.addresses.loaded) {
        if (props.addrId) {
            let addrFound =  props.addresses.data().find(el => typeof el != "undefined" && el.sid == props.addrId );
            if (addrFound) {
                addr.value = addrFound;
                showBusinessFields.value = Boolean(addr.value?.company || addr.value?.ustid);
            }
        } 
    } 
});

watch(() => props.addresses, () => {
    if (props.addresses.loaded) {
        if (props.addrId) {
            let addrFound = props.addresses.data().find(el => typeof el != "undefined" && el.sid == props.addrId );
            if (addrFound) {
                addr.value = addrFound;
                showBusinessFields.value = Boolean(addr.value?.company || addr.value?.ustid);
            }
        } 
    } 
}, { deep: true });


function addrSelected(evt) {
   emit('on-select', {sid: addrOpt.value});
   evt.target.value = "label"; 
}

function addrEdited() {
    emit('on-select', {address: addr.value});
}

function toggleBusinessFields() {
    showBusinessFields.value = !showBusinessFields.value;
    if (!showBusinessFields.value) {
        addr.value.company = '';
        addr.value.ustid = '';
        addrEdited();
    }
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$w, [
      withDirectives(createElementVNode("select", {
        class: "uk-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((addrOpt).value = $event)),
        onChange: addrSelected
      }, [
        createElementVNode("option", _hoisted_2$r, toDisplayString$1(_ctx.$t('checkout.addressForm.selectOrCreate')), 1 /* TEXT */),
        createElementVNode("option", _hoisted_3$o, toDisplayString$1(_ctx.$t('checkout.addressForm.newOption')), 1 /* TEXT */),
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.addresses.data().filter((el) => el), (item, index) => {
          return (openBlock(), createElementBlock("option", {
            class: "uk-text-small",
            key: index,
            value: item.sid
          }, toDisplayString$1(item.firstname) + " " + toDisplayString$1(item.lastname) + " " + toDisplayString$1(item.street) + " " + toDisplayString$1(item.zip) + " " + toDisplayString$1(item.city), 9 /* TEXT, PROPS */, _hoisted_4$m))
        }), 128 /* KEYED_FRAGMENT */))
      ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
        [vModelSelect, addrOpt.value]
      ])
    ]),
    (__props.addresses.loaded)
      ? (openBlock(), createBlock(unref(Form), {
          key: 0,
          name: "address",
          onChange: addrEdited,
          id: "order-addr",
          class: "uk-grid-small uk-form-stacked",
          "uk-grid": "",
          "validation-schema": unref(addressSchema)
        }, {
          default: withCtx(({ errors, meta }) => [
            createElementVNode("div", _hoisted_5$k, toDisplayString$1((metaRef.value = meta) && '' /* this is used to trigger the is-valid emit using a watcher on metaRef*/), 1 /* TEXT */),
            createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_6$h, [
              createElementVNode("label", _hoisted_7$g, [
                createTextVNode(toDisplayString$1(_ctx.$t('checkout.addressForm.firstName')) + " ", 1 /* TEXT */),
                createElementVNode("span", _hoisted_8$e, toDisplayString$1(errors.firstname), 1 /* TEXT */)
              ]),
              createVNode(unref(Field), {
                id: "order-addr-firstname",
                class: normalizeClass(["uk-input", { 'is-invalid': errors.firstname }]),
                modelValue: addr.value.firstname,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((addr.value.firstname) = $event)),
                name: "firstname",
                type: "text",
                validateOnModelUpdate: false
              }, null, 8 /* PROPS */, ["modelValue", "class"])
            ]),
            createElementVNode("div", _hoisted_9$e, [
              createElementVNode("label", _hoisted_10$e, [
                createTextVNode(toDisplayString$1(_ctx.$t('checkout.addressForm.lastName')) + " ", 1 /* TEXT */),
                createElementVNode("span", _hoisted_11$e, toDisplayString$1(errors.lastname), 1 /* TEXT */)
              ]),
              createVNode(unref(Field), {
                id: "order-addr-lastname",
                class: normalizeClass(["uk-input", { 'is-invalid': errors.lastname }]),
                modelValue: addr.value.lastname,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((addr.value.lastname) = $event)),
                name: "lastname",
                type: "text",
                validateOnModelUpdate: false
              }, null, 8 /* PROPS */, ["modelValue", "class"])
            ]),
            createElementVNode("div", _hoisted_12$e, [
              createElementVNode("button", {
                class: "uk-button uk-button-text uk-button-small business-toggle",
                type: "button",
                onClick: toggleBusinessFields
              }, toDisplayString$1(showBusinessFields.value ? 'Firmendaten ausblenden' : 'Firmendaten angeben'), 1 /* TEXT */)
            ]),
            (showBusinessFields.value)
              ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createElementVNode("div", _hoisted_13$d, [
                    _cache[11] || (_cache[11] = createElementVNode("label", {
                      class: "uk-form-label",
                      for: "order-addr-company"
                    }, "Firma", -1 /* HOISTED */)),
                    createVNode(unref(Field), {
                      id: "order-addr-company",
                      class: normalizeClass(["uk-input", { 'is-invalid': errors.company }]),
                      modelValue: addr.value.company,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((addr.value.company) = $event)),
                      name: "company",
                      type: "text",
                      validateOnModelUpdate: false
                    }, null, 8 /* PROPS */, ["modelValue", "class"])
                  ]),
                  createElementVNode("div", _hoisted_14$b, [
                    _cache[12] || (_cache[12] = createElementVNode("label", {
                      class: "uk-form-label",
                      for: "order-addr-ustid"
                    }, "USt-IdNr.", -1 /* HOISTED */)),
                    createVNode(unref(Field), {
                      id: "order-addr-ustid",
                      class: normalizeClass(["uk-input", { 'is-invalid': errors.ustid }]),
                      modelValue: addr.value.ustid,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((addr.value.ustid) = $event)),
                      name: "ustid",
                      type: "text",
                      validateOnModelUpdate: false
                    }, null, 8 /* PROPS */, ["modelValue", "class"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_15$b, [
              createElementVNode("label", _hoisted_16$a, [
                createTextVNode(toDisplayString$1(_ctx.$t('checkout.addressForm.street')) + " ", 1 /* TEXT */),
                createElementVNode("span", _hoisted_17$8, toDisplayString$1(errors.street), 1 /* TEXT */)
              ]),
              createVNode(unref(Field), {
                id: "order-addr-street",
                class: normalizeClass(["uk-input", { 'is-invalid': errors.street }]),
                modelValue: addr.value.street,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((addr.value.street) = $event)),
                name: "street",
                type: "text",
                validateOnModelUpdate: false
              }, null, 8 /* PROPS */, ["modelValue", "class"])
            ]),
            createElementVNode("div", _hoisted_18$8, [
              _cache[13] || (_cache[13] = createElementVNode("label", {
                class: "uk-form-label",
                for: "order-addr-supplement"
              }, "Zusatz (optional)", -1 /* HOISTED */)),
              createVNode(unref(Field), {
                id: "order-addr-supplement",
                class: normalizeClass(["uk-input", { 'is-invalid': errors.supplement }]),
                modelValue: addr.value.supplement,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((addr.value.supplement) = $event)),
                name: "supplement",
                type: "text",
                validateOnModelUpdate: false
              }, null, 8 /* PROPS */, ["modelValue", "class"])
            ]),
            createElementVNode("div", _hoisted_19$8, [
              createElementVNode("label", _hoisted_20$7, [
                createTextVNode(toDisplayString$1(_ctx.$t('checkout.addressForm.zip')) + " ", 1 /* TEXT */),
                createElementVNode("span", _hoisted_21$7, toDisplayString$1(errors.zip), 1 /* TEXT */)
              ]),
              createVNode(unref(Field), {
                id: "order-addr-zip",
                class: normalizeClass(["uk-input", { 'is-invalid': errors.zip }]),
                modelValue: addr.value.zip,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((addr.value.zip) = $event)),
                name: "zip",
                type: "text",
                validateOnModelUpdate: false
              }, null, 8 /* PROPS */, ["modelValue", "class"])
            ]),
            createElementVNode("div", _hoisted_22$6, [
              createElementVNode("label", _hoisted_23$6, [
                createTextVNode(toDisplayString$1(_ctx.$t('checkout.addressForm.city')) + " ", 1 /* TEXT */),
                createElementVNode("span", _hoisted_24$6, toDisplayString$1(errors.city), 1 /* TEXT */)
              ]),
              createVNode(unref(Field), {
                id: "order-addr-city",
                class: normalizeClass(["uk-input", { 'is-invalid': errors.city }]),
                modelValue: addr.value.city,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((addr.value.city) = $event)),
                name: "city",
                type: "text",
                validateOnModelUpdate: false
              }, null, 8 /* PROPS */, ["modelValue", "class"])
            ]),
            createElementVNode("div", _hoisted_25$6, [
              createElementVNode("label", _hoisted_26$5, [
                createTextVNode(toDisplayString$1(_ctx.$t('checkout.addressForm.country')) + " ", 1 /* TEXT */),
                createElementVNode("span", _hoisted_27$5, toDisplayString$1(errors.countryISO), 1 /* TEXT */)
              ]),
              createVNode(unref(Field), {
                as: "select",
                id: "order-addr-country",
                class: normalizeClass(["uk-select", { 'is-invalid': errors.countryISO }]),
                modelValue: addr.value.countryISO,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((addr.value.countryISO) = $event)),
                name: "countryISO",
                validateOnModelUpdate: false
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(countries.value, (country, code) => {
                    return (openBlock(), createElementBlock("option", {
                      key: code,
                      value: code
                    }, toDisplayString$1(country), 9 /* TEXT, PROPS */, _hoisted_28$5))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "class"])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["validation-schema"]))
      : createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$z.__scopeId = "data-v-075c14d8";
script$z.__file = "src/components/AddressForm.vue";

/*!
 * qrcode.vue v3.6.0
 * A Vue.js component to generate QRCode. Both support Vue 2 and Vue 3
 * © 2017-PRESENT @scopewu(https://github.com/scopewu)
 * MIT License.
 */

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*
 * QR Code generator library (TypeScript)
 *
 * Copyright (c) Project Nayuki. (MIT License)
 * https://www.nayuki.io/page/qr-code-generator-library
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 * - The above copyright notice and this permission notice shall be included in
 *   all copies or substantial portions of the Software.
 * - The Software is provided "as is", without warranty of any kind, express or
 *   implied, including but not limited to the warranties of merchantability,
 *   fitness for a particular purpose and noninfringement. In no event shall the
 *   authors or copyright holders be liable for any claim, damages or other
 *   liability, whether in an action of contract, tort or otherwise, arising from,
 *   out of or in connection with the Software or the use or other dealings in the
 *   Software.
 */
var qrcodegen;
(function (qrcodegen) {
    /*---- QR Code symbol class ----*/
    /*
     * A QR Code symbol, which is a type of two-dimension barcode.
     * Invented by Denso Wave and described in the ISO/IEC 18004 standard.
     * Instances of this class represent an immutable square grid of dark and light cells.
     * The class provides static factory functions to create a QR Code from text or binary data.
     * The class covers the QR Code Model 2 specification, supporting all versions (sizes)
     * from 1 to 40, all 4 error correction levels, and 4 character encoding modes.
     *
     * Ways to create a QR Code object:
     * - High level: Take the payload data and call QrCode.encodeText() or QrCode.encodeBinary().
     * - Mid level: Custom-make the list of segments and call QrCode.encodeSegments().
     * - Low level: Custom-make the array of data codeword bytes (including
     *   segment headers and final padding, excluding error correction codewords),
     *   supply the appropriate version number, and call the QrCode() constructor.
     * (Note that all ways require supplying the desired error correction level.)
     */
    var QrCode = /** @class */ (function () {
        /*-- Constructor (low level) and fields --*/
        // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        function QrCode(
        // The version number of this QR Code, which is between 1 and 40 (inclusive).
        // This determines the size of this barcode.
        version, 
        // The error correction level used in this QR Code.
        errorCorrectionLevel, dataCodewords, msk) {
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            // Check scalar arguments
            if (version < QrCode.MIN_VERSION || version > QrCode.MAX_VERSION)
                throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7)
                throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            // Initialize both grids to be size*size arrays of Boolean false
            var row = [];
            for (var i = 0; i < this.size; i++)
                row.push(false);
            for (var i = 0; i < this.size; i++) {
                this.modules.push(row.slice()); // Initially all light
                this.isFunction.push(row.slice());
            }
            // Compute ECC, draw modules
            this.drawFunctionPatterns();
            var allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            // Do masking
            if (msk == -1) { // Automatically choose best mask
                var minPenalty = 1000000000;
                for (var i = 0; i < 8; i++) {
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    var penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i); // Undoes the mask due to XOR
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk); // Apply the final choice of mask
            this.drawFormatBits(msk); // Overwrite old format bits
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/
        // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        QrCode.encodeText = function (text, ecl) {
            var segs = qrcodegen.QrSegment.makeSegments(text);
            return QrCode.encodeSegments(segs, ecl);
        };
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        QrCode.encodeBinary = function (data, ecl) {
            var seg = qrcodegen.QrSegment.makeBytes(data);
            return QrCode.encodeSegments([seg], ecl);
        };
        /*-- Static factory functions (mid level) --*/
        // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        QrCode.encodeSegments = function (segs, ecl, minVersion, maxVersion, mask, boostEcl) {
            if (minVersion === void 0) { minVersion = 1; }
            if (maxVersion === void 0) { maxVersion = 40; }
            if (mask === void 0) { mask = -1; }
            if (boostEcl === void 0) { boostEcl = true; }
            if (!(QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= QrCode.MAX_VERSION)
                || mask < -1 || mask > 7)
                throw new RangeError("Invalid value");
            // Find the minimal version number to use
            var version;
            var dataUsedBits;
            for (version = minVersion;; version++) {
                var dataCapacityBits_1 = QrCode.getNumDataCodewords(version, ecl) * 8; // Number of data bits available
                var usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits_1) {
                    dataUsedBits = usedBits;
                    break; // This version number is found to be suitable
                }
                if (version >= maxVersion) // All versions in the range could not fit the given data
                    throw new RangeError("Data too long");
            }
            // Increase the error correction level while the data still fits in the current version number
            for (var _i = 0, _a = [QrCode.Ecc.MEDIUM, QrCode.Ecc.QUARTILE, QrCode.Ecc.HIGH]; _i < _a.length; _i++) { // From low to high
                var newEcl = _a[_i];
                if (boostEcl && dataUsedBits <= QrCode.getNumDataCodewords(version, newEcl) * 8)
                    ecl = newEcl;
            }
            // Concatenate all segments to create the data bit string
            var bb = [];
            for (var _b = 0, segs_1 = segs; _b < segs_1.length; _b++) {
                var seg = segs_1[_b];
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (var _c = 0, _d = seg.getData(); _c < _d.length; _c++) {
                    var b = _d[_c];
                    bb.push(b);
                }
            }
            assert(bb.length == dataUsedBits);
            // Add terminator and pad up to a byte if applicable
            var dataCapacityBits = QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            // Pad with alternating bytes until data capacity is reached
            for (var padByte = 0xEC; bb.length < dataCapacityBits; padByte ^= 0xEC ^ 0x11)
                appendBits(padByte, 8, bb);
            // Pack bits into bytes in big endian
            var dataCodewords = [];
            while (dataCodewords.length * 8 < bb.length)
                dataCodewords.push(0);
            bb.forEach(function (b, i) {
                return dataCodewords[i >>> 3] |= b << (7 - (i & 7));
            });
            // Create the QR Code object
            return new QrCode(version, ecl, dataCodewords, mask);
        };
        /*-- Accessor methods --*/
        // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        QrCode.prototype.getModule = function (x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        };
        QrCode.prototype.getModules = function () {
            return this.modules;
        };
        /*-- Private helper methods for constructor: Drawing function modules --*/
        // Reads this object's version field, and draws and marks all function modules.
        QrCode.prototype.drawFunctionPatterns = function () {
            // Draw horizontal and vertical timing patterns
            for (var i = 0; i < this.size; i++) {
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            // Draw 3 finder patterns (all corners except bottom right; overwrites some timing modules)
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            // Draw numerous alignment patterns
            var alignPatPos = this.getAlignmentPatternPositions();
            var numAlign = alignPatPos.length;
            for (var i = 0; i < numAlign; i++) {
                for (var j = 0; j < numAlign; j++) {
                    // Don't draw on the three finder corners
                    if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0))
                        this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
                }
            }
            // Draw configuration data
            this.drawFormatBits(0); // Dummy mask value; overwritten later in the constructor
            this.drawVersion();
        };
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        QrCode.prototype.drawFormatBits = function (mask) {
            // Calculate error correction code and pack bits
            var data = this.errorCorrectionLevel.formatBits << 3 | mask; // errCorrLvl is uint2, mask is uint3
            var rem = data;
            for (var i = 0; i < 10; i++)
                rem = (rem << 1) ^ ((rem >>> 9) * 0x537);
            var bits = (data << 10 | rem) ^ 0x5412; // uint15
            assert(bits >>> 15 == 0);
            // Draw first copy
            for (var i = 0; i <= 5; i++)
                this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for (var i = 9; i < 15; i++)
                this.setFunctionModule(14 - i, 8, getBit(bits, i));
            // Draw second copy
            for (var i = 0; i < 8; i++)
                this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for (var i = 8; i < 15; i++)
                this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true); // Always dark
        };
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        QrCode.prototype.drawVersion = function () {
            if (this.version < 7)
                return;
            // Calculate error correction code and pack bits
            var rem = this.version; // version is uint6, in the range [7, 40]
            for (var i = 0; i < 12; i++)
                rem = (rem << 1) ^ ((rem >>> 11) * 0x1F25);
            var bits = this.version << 12 | rem; // uint18
            assert(bits >>> 18 == 0);
            // Draw two copies
            for (var i = 0; i < 18; i++) {
                var color = getBit(bits, i);
                var a = this.size - 11 + i % 3;
                var b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        };
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        QrCode.prototype.drawFinderPattern = function (x, y) {
            for (var dy = -4; dy <= 4; dy++) {
                for (var dx = -4; dx <= 4; dx++) {
                    var dist = Math.max(Math.abs(dx), Math.abs(dy)); // Chebyshev/infinity norm
                    var xx = x + dx;
                    var yy = y + dy;
                    if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size)
                        this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
                }
            }
        };
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        QrCode.prototype.drawAlignmentPattern = function (x, y) {
            for (var dy = -2; dy <= 2; dy++) {
                for (var dx = -2; dx <= 2; dx++)
                    this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
            }
        };
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        QrCode.prototype.setFunctionModule = function (x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        };
        /*-- Private helper methods for constructor: Codewords and masking --*/
        // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        QrCode.prototype.addEccAndInterleave = function (data) {
            var ver = this.version;
            var ecl = this.errorCorrectionLevel;
            if (data.length != QrCode.getNumDataCodewords(ver, ecl))
                throw new RangeError("Invalid argument");
            // Calculate parameter numbers
            var numBlocks = QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            var blockEccLen = QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            var rawCodewords = Math.floor(QrCode.getNumRawDataModules(ver) / 8);
            var numShortBlocks = numBlocks - rawCodewords % numBlocks;
            var shortBlockLen = Math.floor(rawCodewords / numBlocks);
            // Split data into blocks and append ECC to each block
            var blocks = [];
            var rsDiv = QrCode.reedSolomonComputeDivisor(blockEccLen);
            for (var i = 0, k = 0; i < numBlocks; i++) {
                var dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                var ecc = QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks)
                    dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            // Interleave (not concatenate) the bytes from every block into a single sequence
            var result = [];
            var _loop_1 = function (i) {
                blocks.forEach(function (block, j) {
                    // Skip the padding byte in short blocks
                    if (i != shortBlockLen - blockEccLen || j >= numShortBlocks)
                        result.push(block[i]);
                });
            };
            for (var i = 0; i < blocks[0].length; i++) {
                _loop_1(i);
            }
            assert(result.length == rawCodewords);
            return result;
        };
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        QrCode.prototype.drawCodewords = function (data) {
            if (data.length != Math.floor(QrCode.getNumRawDataModules(this.version) / 8))
                throw new RangeError("Invalid argument");
            var i = 0; // Bit index into the data
            // Do the funny zigzag scan
            for (var right = this.size - 1; right >= 1; right -= 2) { // Index of right column in each column pair
                if (right == 6)
                    right = 5;
                for (var vert = 0; vert < this.size; vert++) { // Vertical counter
                    for (var j = 0; j < 2; j++) {
                        var x = right - j; // Actual x coordinate
                        var upward = ((right + 1) & 2) == 0;
                        var y = upward ? this.size - 1 - vert : vert; // Actual y coordinate
                        if (!this.isFunction[y][x] && i < data.length * 8) {
                            this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                            i++;
                        }
                        // If this QR Code has any remainder bits (0 to 7), they were assigned as
                        // 0/false/light by the constructor and are left unchanged by this method
                    }
                }
            }
            assert(i == data.length * 8);
        };
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        QrCode.prototype.applyMask = function (mask) {
            if (mask < 0 || mask > 7)
                throw new RangeError("Mask value out of range");
            for (var y = 0; y < this.size; y++) {
                for (var x = 0; x < this.size; x++) {
                    var invert = void 0;
                    switch (mask) {
                        case 0:
                            invert = (x + y) % 2 == 0;
                            break;
                        case 1:
                            invert = y % 2 == 0;
                            break;
                        case 2:
                            invert = x % 3 == 0;
                            break;
                        case 3:
                            invert = (x + y) % 3 == 0;
                            break;
                        case 4:
                            invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                            break;
                        case 5:
                            invert = x * y % 2 + x * y % 3 == 0;
                            break;
                        case 6:
                            invert = (x * y % 2 + x * y % 3) % 2 == 0;
                            break;
                        case 7:
                            invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                            break;
                        default: throw new Error("Unreachable");
                    }
                    if (!this.isFunction[y][x] && invert)
                        this.modules[y][x] = !this.modules[y][x];
                }
            }
        };
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        QrCode.prototype.getPenaltyScore = function () {
            var result = 0;
            // Adjacent modules in row having same color, and finder-like patterns
            for (var y = 0; y < this.size; y++) {
                var runColor = false;
                var runX = 0;
                var runHistory = [0, 0, 0, 0, 0, 0, 0];
                for (var x = 0; x < this.size; x++) {
                    if (this.modules[y][x] == runColor) {
                        runX++;
                        if (runX == 5)
                            result += QrCode.PENALTY_N1;
                        else if (runX > 5)
                            result++;
                    }
                    else {
                        this.finderPenaltyAddHistory(runX, runHistory);
                        if (!runColor)
                            result += this.finderPenaltyCountPatterns(runHistory) * QrCode.PENALTY_N3;
                        runColor = this.modules[y][x];
                        runX = 1;
                    }
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * QrCode.PENALTY_N3;
            }
            // Adjacent modules in column having same color, and finder-like patterns
            for (var x = 0; x < this.size; x++) {
                var runColor = false;
                var runY = 0;
                var runHistory = [0, 0, 0, 0, 0, 0, 0];
                for (var y = 0; y < this.size; y++) {
                    if (this.modules[y][x] == runColor) {
                        runY++;
                        if (runY == 5)
                            result += QrCode.PENALTY_N1;
                        else if (runY > 5)
                            result++;
                    }
                    else {
                        this.finderPenaltyAddHistory(runY, runHistory);
                        if (!runColor)
                            result += this.finderPenaltyCountPatterns(runHistory) * QrCode.PENALTY_N3;
                        runColor = this.modules[y][x];
                        runY = 1;
                    }
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * QrCode.PENALTY_N3;
            }
            // 2*2 blocks of modules having same color
            for (var y = 0; y < this.size - 1; y++) {
                for (var x = 0; x < this.size - 1; x++) {
                    var color = this.modules[y][x];
                    if (color == this.modules[y][x + 1] &&
                        color == this.modules[y + 1][x] &&
                        color == this.modules[y + 1][x + 1])
                        result += QrCode.PENALTY_N2;
                }
            }
            // Balance of dark and light modules
            var dark = 0;
            for (var _i = 0, _a = this.modules; _i < _a.length; _i++) {
                var row = _a[_i];
                dark = row.reduce(function (sum, color) { return sum + (color ? 1 : 0); }, dark);
            }
            var total = this.size * this.size; // Note that size is odd, so dark/total != 1/2
            // Compute the smallest integer k >= 0 such that (45-5k)% <= dark/total <= (55+5k)%
            var k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888); // Non-tight upper bound based on default values of PENALTY_N1, ..., N4
            return result;
        };
        /*-- Private helper functions --*/
        // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        QrCode.prototype.getAlignmentPatternPositions = function () {
            if (this.version == 1)
                return [];
            else {
                var numAlign = Math.floor(this.version / 7) + 2;
                var step = Math.floor((this.version * 8 + numAlign * 3 + 5) / (numAlign * 4 - 4)) * 2;
                var result = [6];
                for (var pos = this.size - 7; result.length < numAlign; pos -= step)
                    result.splice(1, 0, pos);
                return result;
            }
        };
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        QrCode.getNumRawDataModules = function (ver) {
            if (ver < QrCode.MIN_VERSION || ver > QrCode.MAX_VERSION)
                throw new RangeError("Version number out of range");
            var result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                var numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7)
                    result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        };
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        QrCode.getNumDataCodewords = function (ver, ecl) {
            return Math.floor(QrCode.getNumRawDataModules(ver) / 8) -
                QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] *
                    QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        };
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        QrCode.reedSolomonComputeDivisor = function (degree) {
            if (degree < 1 || degree > 255)
                throw new RangeError("Degree out of range");
            // Polynomial coefficients are stored from highest to lowest power, excluding the leading term which is always 1.
            // For example the polynomial x^3 + 255x^2 + 8x + 93 is stored as the uint8 array [255, 8, 93].
            var result = [];
            for (var i = 0; i < degree - 1; i++)
                result.push(0);
            result.push(1); // Start off with the monomial x^0
            // Compute the product polynomial (x - r^0) * (x - r^1) * (x - r^2) * ... * (x - r^{degree-1}),
            // and drop the highest monomial term which is always 1x^degree.
            // Note that r = 0x02, which is a generator element of this field GF(2^8/0x11D).
            var root = 1;
            for (var i = 0; i < degree; i++) {
                // Multiply the current product by (x - r^i)
                for (var j = 0; j < result.length; j++) {
                    result[j] = QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length)
                        result[j] ^= result[j + 1];
                }
                root = QrCode.reedSolomonMultiply(root, 0x02);
            }
            return result;
        };
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        QrCode.reedSolomonComputeRemainder = function (data, divisor) {
            var result = divisor.map(function (_) { return 0; });
            var _loop_2 = function (b) {
                var factor = b ^ result.shift();
                result.push(0);
                divisor.forEach(function (coef, i) {
                    return result[i] ^= QrCode.reedSolomonMultiply(coef, factor);
                });
            };
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var b = data_1[_i];
                _loop_2(b);
            }
            return result;
        };
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        QrCode.reedSolomonMultiply = function (x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0)
                throw new RangeError("Byte out of range");
            // Russian peasant multiplication
            var z = 0;
            for (var i = 7; i >= 0; i--) {
                z = (z << 1) ^ ((z >>> 7) * 0x11D);
                z ^= ((y >>> i) & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        };
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        QrCode.prototype.finderPenaltyCountPatterns = function (runHistory) {
            var n = runHistory[1];
            assert(n <= this.size * 3);
            var core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0)
                + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        };
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        QrCode.prototype.finderPenaltyTerminateAndCount = function (currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) { // Terminate dark run
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size; // Add light border to final run
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        };
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        QrCode.prototype.finderPenaltyAddHistory = function (currentRunLength, runHistory) {
            if (runHistory[0] == 0)
                currentRunLength += this.size; // Add light border to initial run
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        };
        /*-- Constants and tables --*/
        // The minimum version number supported in the QR Code Model 2 standard.
        QrCode.MIN_VERSION = 1;
        // The maximum version number supported in the QR Code Model 2 standard.
        QrCode.MAX_VERSION = 40;
        // For use in getPenaltyScore(), when evaluating which mask is best.
        QrCode.PENALTY_N1 = 3;
        QrCode.PENALTY_N2 = 3;
        QrCode.PENALTY_N3 = 40;
        QrCode.PENALTY_N4 = 10;
        QrCode.ECC_CODEWORDS_PER_BLOCK = [
            // Version: (note that index 0 is for padding, and is set to an illegal value)
            //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
            [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], // Low
            [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28], // Medium
            [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], // Quartile
            [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30], // High
        ];
        QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
            // Version: (note that index 0 is for padding, and is set to an illegal value)
            //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
            [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25], // Low
            [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49], // Medium
            [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68], // Quartile
            [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81], // High
        ];
        return QrCode;
    }());
    qrcodegen.QrCode = QrCode;
    // Appends the given number of low-order bits of the given value
    // to the given buffer. Requires 0 <= len <= 31 and 0 <= val < 2^len.
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0)
            throw new RangeError("Value out of range");
        for (var i = len - 1; i >= 0; i--) // Append bit by bit
            bb.push((val >>> i) & 1);
    }
    // Returns true iff the i'th bit of x is set to 1.
    function getBit(x, i) {
        return ((x >>> i) & 1) != 0;
    }
    // Throws an exception if the given condition is false.
    function assert(cond) {
        if (!cond)
            throw new Error("Assertion error");
    }
    /*---- Data segment class ----*/
    /*
     * A segment of character/binary/control data in a QR Code symbol.
     * Instances of this class are immutable.
     * The mid-level way to create a segment is to take the payload data
     * and call a static factory function such as QrSegment.makeNumeric().
     * The low-level way to create a segment is to custom-make the bit buffer
     * and call the QrSegment() constructor with appropriate values.
     * This segment class imposes no length restrictions, but QR Codes have restrictions.
     * Even in the most favorable conditions, a QR Code can only hold 7089 characters of data.
     * Any segment longer than this is meaningless for the purpose of generating QR Codes.
     */
    var QrSegment = /** @class */ (function () {
        /*-- Constructor (low level) and fields --*/
        // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        function QrSegment(
        // The mode indicator of this segment.
        mode, 
        // The length of this segment's unencoded data. Measured in characters for
        // numeric/alphanumeric/kanji mode, bytes for byte mode, and 0 for ECI mode.
        // Always zero or positive. Not the same as the data's bit length.
        numChars, 
        // The data bits of this segment. Accessed through getData().
        bitData) {
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0)
                throw new RangeError("Invalid argument");
            this.bitData = bitData.slice(); // Make defensive copy
        }
        /*-- Static factory functions (mid level) --*/
        // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        QrSegment.makeBytes = function (data) {
            var bb = [];
            for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                var b = data_2[_i];
                appendBits(b, 8, bb);
            }
            return new QrSegment(QrSegment.Mode.BYTE, data.length, bb);
        };
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        QrSegment.makeNumeric = function (digits) {
            if (!QrSegment.isNumeric(digits))
                throw new RangeError("String contains non-numeric characters");
            var bb = [];
            for (var i = 0; i < digits.length;) { // Consume up to 3 digits per iteration
                var n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new QrSegment(QrSegment.Mode.NUMERIC, digits.length, bb);
        };
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        QrSegment.makeAlphanumeric = function (text) {
            if (!QrSegment.isAlphanumeric(text))
                throw new RangeError("String contains unencodable characters in alphanumeric mode");
            var bb = [];
            var i;
            for (i = 0; i + 2 <= text.length; i += 2) { // Process groups of 2
                var temp = QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) // 1 character remaining
                appendBits(QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new QrSegment(QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        };
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        QrSegment.makeSegments = function (text) {
            // Select the most efficient segment encoding automatically
            if (text == "")
                return [];
            else if (QrSegment.isNumeric(text))
                return [QrSegment.makeNumeric(text)];
            else if (QrSegment.isAlphanumeric(text))
                return [QrSegment.makeAlphanumeric(text)];
            else
                return [QrSegment.makeBytes(QrSegment.toUtf8ByteArray(text))];
        };
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        QrSegment.makeEci = function (assignVal) {
            var bb = [];
            if (assignVal < 0)
                throw new RangeError("ECI assignment value out of range");
            else if (assignVal < (1 << 7))
                appendBits(assignVal, 8, bb);
            else if (assignVal < (1 << 14)) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            }
            else if (assignVal < 1000000) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            }
            else
                throw new RangeError("ECI assignment value out of range");
            return new QrSegment(QrSegment.Mode.ECI, 0, bb);
        };
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        QrSegment.isNumeric = function (text) {
            return QrSegment.NUMERIC_REGEX.test(text);
        };
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        QrSegment.isAlphanumeric = function (text) {
            return QrSegment.ALPHANUMERIC_REGEX.test(text);
        };
        /*-- Methods --*/
        // Returns a new copy of the data bits of this segment.
        QrSegment.prototype.getData = function () {
            return this.bitData.slice(); // Make defensive copy
        };
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        QrSegment.getTotalBits = function (segs, version) {
            var result = 0;
            for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
                var seg = segs_2[_i];
                var ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= (1 << ccbits))
                    return Infinity; // The segment's length doesn't fit the field's bit width
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        };
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        QrSegment.toUtf8ByteArray = function (str) {
            str = encodeURI(str);
            var result = [];
            for (var i = 0; i < str.length; i++) {
                if (str.charAt(i) != "%")
                    result.push(str.charCodeAt(i));
                else {
                    result.push(parseInt(str.substring(i + 1, i + 3), 16));
                    i += 2;
                }
            }
            return result;
        };
        /*-- Constants --*/
        // Describes precisely all strings that are encodable in numeric mode.
        QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
        // Describes precisely all strings that are encodable in alphanumeric mode.
        QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
        // The set of all legal characters in alphanumeric mode,
        // where each character value maps to the index in the string.
        QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
        return QrSegment;
    }());
    qrcodegen.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));
/*---- Public helper enumeration ----*/
(function (qrcodegen) {
    (function (QrCode) {
        /*
         * The error correction level in a QR Code symbol. Immutable.
         */
        var Ecc = /** @class */ (function () {
            /*-- Constructor and fields --*/
            function Ecc(
            // In the range 0 to 3 (unsigned 2-bit integer).
            ordinal, 
            // (Package-private) In the range 0 to 3 (unsigned 2-bit integer).
            formatBits) {
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
            /*-- Constants --*/
            Ecc.LOW = new Ecc(0, 1); // The QR Code can tolerate about  7% erroneous codewords
            Ecc.MEDIUM = new Ecc(1, 0); // The QR Code can tolerate about 15% erroneous codewords
            Ecc.QUARTILE = new Ecc(2, 3); // The QR Code can tolerate about 25% erroneous codewords
            Ecc.HIGH = new Ecc(3, 2); // The QR Code can tolerate about 30% erroneous codewords
            return Ecc;
        }());
        QrCode.Ecc = Ecc;
    })(qrcodegen.QrCode || (qrcodegen.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
/*---- Public helper enumeration ----*/
(function (qrcodegen) {
    (function (QrSegment) {
        /*
         * Describes how a segment's data bits are interpreted. Immutable.
         */
        var Mode = /** @class */ (function () {
            /*-- Constructor and fields --*/
            function Mode(
            // The mode indicator bits, which is a uint4 value (range 0 to 15).
            modeBits, 
            // Number of character count bits for three different version ranges.
            numBitsCharCount) {
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/
            // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            Mode.prototype.numCharCountBits = function (ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            };
            /*-- Constants --*/
            Mode.NUMERIC = new Mode(0x1, [10, 12, 14]);
            Mode.ALPHANUMERIC = new Mode(0x2, [9, 11, 13]);
            Mode.BYTE = new Mode(0x4, [8, 16, 16]);
            Mode.KANJI = new Mode(0x8, [8, 10, 12]);
            Mode.ECI = new Mode(0x7, [0, 0, 0]);
            return Mode;
        }());
        QrSegment.Mode = Mode;
    })(qrcodegen.QrSegment || (qrcodegen.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var QR = qrcodegen;

var defaultErrorCorrectLevel = 'L';
var ErrorCorrectLevelMap = {
    L: QR.QrCode.Ecc.LOW,
    M: QR.QrCode.Ecc.MEDIUM,
    Q: QR.QrCode.Ecc.QUARTILE,
    H: QR.QrCode.Ecc.HIGH,
};
// Thanks the `qrcode.react`
var SUPPORTS_PATH2D = (function () {
    try {
        new Path2D().addPath(new Path2D());
    }
    catch (e) {
        return false;
    }
    return true;
})();
function validErrorCorrectLevel(level) {
    return level in ErrorCorrectLevelMap;
}
function generatePath(modules, margin) {
    if (margin === void 0) { margin = 0; }
    var ops = [];
    modules.forEach(function (row, y) {
        var start = null;
        row.forEach(function (cell, x) {
            if (!cell && start !== null) {
                // M0 0h7v1H0z injects the space with the move and drops the comma,
                // saving a char per operation
                ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
                start = null;
                return;
            }
            // end of row, clean up or skip
            if (x === row.length - 1) {
                if (!cell) {
                    // We would have closed the op above already so this can only mean
                    // 2+ light modules in a row.
                    return;
                }
                if (start === null) {
                    // Just a single dark module.
                    ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
                }
                else {
                    // Otherwise finish the current line.
                    ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
                }
                return;
            }
            if (cell && start === null) {
                start = x;
            }
        });
    });
    return ops.join('');
}
function getImageSettings(cells, size, margin, imageSettings) {
    var width = imageSettings.width, height = imageSettings.height, imageX = imageSettings.x, imageY = imageSettings.y;
    var numCells = cells.length + margin * 2;
    var defaultSize = Math.floor(size * 0.1);
    var scale = numCells / size;
    var w = (width || defaultSize) * scale;
    var h = (height || defaultSize) * scale;
    var x = imageX == null ? cells.length / 2 - w / 2 : imageX * scale;
    var y = imageY == null ? cells.length / 2 - h / 2 : imageY * scale;
    var excavation = null;
    if (imageSettings.excavate) {
        var floorX = Math.floor(x);
        var floorY = Math.floor(y);
        var ceilW = Math.ceil(w + x - floorX);
        var ceilH = Math.ceil(h + y - floorY);
        excavation = { x: floorX, y: floorY, w: ceilW, h: ceilH };
    }
    return { x: x, y: y, h: h, w: w, excavation: excavation };
}
function excavateModules(modules, excavation) {
    return modules.slice().map(function (row, y) {
        if (y < excavation.y || y >= excavation.y + excavation.h) {
            return row;
        }
        return row.map(function (cell, x) {
            if (x < excavation.x || x >= excavation.x + excavation.w) {
                return cell;
            }
            return false;
        });
    });
}
var QRCodeProps = {
    value: {
        type: String,
        required: true,
        default: '',
    },
    size: {
        type: Number,
        default: 100,
    },
    level: {
        type: String,
        default: defaultErrorCorrectLevel,
        validator: function (l) { return validErrorCorrectLevel(l); },
    },
    background: {
        type: String,
        default: '#fff',
    },
    foreground: {
        type: String,
        default: '#000',
    },
    margin: {
        type: Number,
        required: false,
        default: 0,
    },
    imageSettings: {
        type: Object,
        required: false,
        default: function () { return ({}); },
    },
    gradient: {
        type: Boolean,
        required: false,
        default: false,
    },
    gradientType: {
        type: String,
        required: false,
        default: 'linear',
        validator: function (t) { return ['linear', 'radial'].indexOf(t) > -1; },
    },
    gradientStartColor: {
        type: String,
        required: false,
        default: '#000',
    },
    gradientEndColor: {
        type: String,
        required: false,
        default: '#fff',
    },
};
var QRCodeVueProps = __assign(__assign({}, QRCodeProps), { renderAs: {
        type: String,
        required: false,
        default: 'canvas',
        validator: function (as) { return ['canvas', 'svg'].indexOf(as) > -1; },
    } });
var QrcodeSvg = defineComponent({
    name: 'QRCodeSvg',
    props: QRCodeProps,
    setup: function (props) {
        var numCells = ref(0);
        var fgPath = ref('');
        var imageProps;
        var generate = function () {
            var value = props.value, _level = props.level, _margin = props.margin;
            var margin = _margin >>> 0;
            var level = validErrorCorrectLevel(_level) ? _level : defaultErrorCorrectLevel;
            var cells = QR.QrCode.encodeText(value, ErrorCorrectLevelMap[level]).getModules();
            numCells.value = cells.length + margin * 2;
            if (props.imageSettings.src) {
                var imageSettings = getImageSettings(cells, props.size, margin, props.imageSettings);
                imageProps = {
                    x: imageSettings.x + margin,
                    y: imageSettings.y + margin,
                    width: imageSettings.w,
                    height: imageSettings.h,
                };
                if (imageSettings.excavation) {
                    cells = excavateModules(cells, imageSettings.excavation);
                }
            }
            // Drawing strategy: instead of a rect per module, we're going to create a
            // single path for the dark modules and layer that on top of a light rect,
            // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
            // way faster than DOM ops.
            // For level 1, 441 nodes -> 2
            // For level 40, 31329 -> 2
            fgPath.value = generatePath(cells, margin);
        };
        var renderGradient = function () {
            if (!props.gradient)
                return null;
            var gradientProps = props.gradientType === 'linear'
                ? {
                    x1: '0%',
                    y1: '0%',
                    x2: '100%',
                    y2: '100%',
                }
                : {
                    cx: '50%',
                    cy: '50%',
                    r: '50%',
                    fx: '50%',
                    fy: '50%',
                };
            return h(props.gradientType === 'linear' ? 'linearGradient' : 'radialGradient', __assign({ id: 'qr-gradient' }, gradientProps), [
                h('stop', {
                    offset: '0%',
                    style: { stopColor: props.gradientStartColor },
                }),
                h('stop', {
                    offset: '100%',
                    style: { stopColor: props.gradientEndColor },
                }),
            ]);
        };
        generate();
        onUpdated(generate);
        return function () { return h('svg', {
            width: props.size,
            height: props.size,
            'shape-rendering': "crispEdges",
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: "0 0 ".concat(numCells.value, " ").concat(numCells.value),
        }, [
            h('defs', {}, [renderGradient()]),
            h('rect', {
                width: '100%',
                height: '100%',
                fill: props.background,
            }),
            h('path', {
                fill: props.gradient ? 'url(#qr-gradient)' : props.foreground,
                d: fgPath.value,
            }),
            props.imageSettings.src && h('image', __assign({ href: props.imageSettings.src }, imageProps)),
        ]); };
    },
});
var QrcodeCanvas = defineComponent({
    name: 'QRCodeCanvas',
    props: QRCodeProps,
    setup: function (props, ctx) {
        var canvasEl = ref(null);
        var imageRef = ref(null);
        var generate = function () {
            var value = props.value, _level = props.level, size = props.size, _margin = props.margin, background = props.background, foreground = props.foreground, gradient = props.gradient, gradientType = props.gradientType, gradientStartColor = props.gradientStartColor, gradientEndColor = props.gradientEndColor;
            var margin = _margin >>> 0;
            var level = validErrorCorrectLevel(_level) ? _level : defaultErrorCorrectLevel;
            var canvas = canvasEl.value;
            if (!canvas) {
                return;
            }
            var ctx = canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            var cells = QR.QrCode.encodeText(value, ErrorCorrectLevelMap[level]).getModules();
            var numCells = cells.length + margin * 2;
            var image = imageRef.value;
            var imageProps = { x: 0, y: 0, width: 0, height: 0 };
            var showImage = props.imageSettings.src && image != null && image.naturalWidth !== 0 && image.naturalHeight !== 0;
            if (showImage) {
                var imageSettings = getImageSettings(cells, props.size, margin, props.imageSettings);
                imageProps = {
                    x: imageSettings.x + margin,
                    y: imageSettings.y + margin,
                    width: imageSettings.w,
                    height: imageSettings.h,
                };
                if (imageSettings.excavation) {
                    cells = excavateModules(cells, imageSettings.excavation);
                }
            }
            var devicePixelRatio = window.devicePixelRatio || 1;
            var scale = (size / numCells) * devicePixelRatio;
            canvas.height = canvas.width = size * devicePixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = background;
            ctx.fillRect(0, 0, numCells, numCells);
            if (gradient) {
                var grad = void 0;
                if (gradientType === 'linear') {
                    grad = ctx.createLinearGradient(0, 0, numCells, numCells);
                }
                else {
                    grad = ctx.createRadialGradient(numCells / 2, numCells / 2, 0, numCells / 2, numCells / 2, numCells / 2);
                }
                grad.addColorStop(0, gradientStartColor);
                grad.addColorStop(1, gradientEndColor);
                ctx.fillStyle = grad;
            }
            else {
                ctx.fillStyle = foreground;
            }
            if (SUPPORTS_PATH2D) {
                ctx.fill(new Path2D(generatePath(cells, margin)));
            }
            else {
                cells.forEach(function (row, rdx) {
                    row.forEach(function (cell, cdx) {
                        if (cell) {
                            ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                        }
                    });
                });
            }
            if (showImage) {
                ctx.drawImage(image, imageProps.x, imageProps.y, imageProps.width, imageProps.height);
            }
        };
        onMounted(generate);
        onUpdated(generate);
        var style = ctx.attrs.style;
        return function () { return h(Fragment, [
            h('canvas', __assign(__assign({}, ctx.attrs), { ref: canvasEl, style: __assign(__assign({}, style), { width: "".concat(props.size, "px"), height: "".concat(props.size, "px") }) })),
            props.imageSettings.src && h('img', {
                ref: imageRef,
                src: props.imageSettings.src,
                style: { display: 'none' },
                onLoad: generate,
            })
        ]); };
    },
});
var QrcodeVue = defineComponent({
    name: 'Qrcode',
    render: function () {
        var _a = this.$props, renderAs = _a.renderAs, value = _a.value, size = _a.size, margin = _a.margin, level = _a.level, background = _a.background, foreground = _a.foreground, imageSettings = _a.imageSettings, gradient = _a.gradient, gradientType = _a.gradientType, gradientStartColor = _a.gradientStartColor, gradientEndColor = _a.gradientEndColor;
        return h(renderAs === 'svg' ? QrcodeSvg : QrcodeCanvas, {
            value: value,
            size: size,
            margin: margin,
            level: level,
            background: background,
            foreground: foreground,
            imageSettings: imageSettings,
            gradient: gradient,
            gradientType: gradientType,
            gradientStartColor: gradientStartColor,
            gradientEndColor: gradientEndColor,
        });
    },
    props: QRCodeVueProps,
});

const _hoisted_1$v = ["id"];
const _hoisted_2$q = ["accept"];
const _hoisted_3$n = ["disabled"];
const _hoisted_4$l = { class: "upload-progress-label" };
const _hoisted_5$j = {
  key: 0,
  class: "upload-progress-track"
};
const _hoisted_6$g = {
  key: 1,
  class: "upload-progress-only",
  "aria-live": "polite"
};
const _hoisted_7$f = { class: "upload-progress-track" };
const _hoisted_8$d = ["id"];
const _hoisted_9$d = ["accept"];
const _hoisted_10$d = ["id"];
const _hoisted_11$d = { class: "uppy-DashboardTab-name" };
const _hoisted_12$d = { class: "mobile-connect" };
const _hoisted_13$c = {
  key: 0,
  class: "mobile-receive-state"
};
const _hoisted_14$a = { key: 1 };
const _hoisted_15$a = { class: "qr-code" };
const _hoisted_16$9 = { key: 2 };

const CONNECT_UPLOAD_ACTION = 'inline-upload-connect';


var script$y = /*@__PURE__*/Object.assign({
    name: 'PpUpload',
}, {
  __name: 'Upload',
  props: {
    variant: {
        type: String,
        default: 'dashboard',
    },
    buttonLabel: {
        type: String,
        default: '',
    },
    uploadSuccessAction: {
        type: Object,
        default: null,
    },
    uploadMeta: {
        type: Object,
        default: null,
    },
    extraMenuItems: {
        type: Array,
        default: () => [],
    },
},
  emits: ["on-upload", "on-upload-complete", "on-upload-start", "close-upload", "menu-action"],
  setup(__props, { expose: __expose, emit: __emit }) {



let xdebug = "";
if (window.xdebug) xdebug = "?XDEBUG_SESSION=" + window.xdebug;

const props = __props;

const configStore = useConfigStore();
const authStore = useAuthStore();
const alertStore = useAlertStore();
const { locale, t } = useI18n({ useScope: 'global' });

const supportsWebcam = typeof window !== 'undefined'
    && window.isSecureContext
    && !!window.navigator?.mediaDevices?.getUserMedia;

const isMobileClient = detectMobileContext();

const dashboardProps = {
    showNativePhotoCameraButton: false,
    disableLocalFiles: false,
    nativeCameraFacingMode: 'environment',
};
const mobileGalleryInput = ref(null);
let mobileUploadObserver = null;
let interceptedMyDeviceButton = null;
let syncingExtraMenu = false;

const uid = uniqueId();

const uppyLocaleMap = {
    'de-DE': German,
    'en-US': English,
};

const uppyLocaleStringOverrides = {
    'de-DE': {
        // Keep heading compact: no additional "import from" sentence.
        dropPasteImportFiles: 'Dateien hier ablegen/einfügen oder %{browseFiles}',
        dropPasteImportFolders: 'Dateien hier ablegen/einfügen oder %{browseFolders}',
        dropPasteImportBoth: 'Dateien hier ablegen/einfügen, %{browseFiles} oder %{browseFolders}',
        importFiles: 'Dateien auswählen',
    },
    'en-US': {
        dropPasteImportFiles: 'Drop files here or %{browseFiles}',
        dropPasteImportFolders: 'Drop files here or %{browseFolders}',
        dropPasteImportBoth: 'Drop files here, %{browseFiles} or %{browseFolders}',
        importFiles: 'Choose files',
    },
};

function getUppyLocale(localeKey) {
    const normalizedLocale = uppyLocaleMap[localeKey] ? localeKey : 'en-US';
    const baseLocale = uppyLocaleMap[normalizedLocale] ?? English;
    const stringOverrides = uppyLocaleStringOverrides[normalizedLocale] || {};

    return {
        ...baseLocale,
        strings: {
            ...(baseLocale?.strings || {}),
            ...stringOverrides,
        },
    }
}

const headers = {
    'X-API-TOKEN': configStore.xApiToken,
};

function resolveAllowedMimeTypesForCurrentFolder() {
    const folder = glob('folder');
    const currentFolderOid = folder?.value?.currentFolder?.oid;
    const restrictions = configStore.uploadMimeRestrictions || {};

    if (!currentFolderOid) return null

    const oidKey = String(currentFolderOid);
    const allowedTypes = restrictions[oidKey] ?? restrictions[currentFolderOid];
    return Array.isArray(allowedTypes) ? allowedTypes.filter(Boolean) : null
}

// Native mobile Gallery-Input hat kein eigenes Uppy-Restrictions-System, daher separat gepflegt.
const mobileGalleryAccept = ref(resolveAllowedMimeTypesForCurrentFolder()?.join(',') || 'image/*');
const buttonUploadAccept = ref(resolveAllowedMimeTypesForCurrentFolder()?.join(',') || '');
const buttonUploadInput = ref(null);
const buttonUploadActive = ref(false);
const buttonUploadProgress = ref(0);
let buttonUploadResetTimer = null;

const uppy = new Uppy({
    locale: getUppyLocale(locale.value),
    proudlyDisplayPoweredByUppy:false,
    autoProceed: true,
    restrictions: {
        allowedFileTypes: resolveAllowedMimeTypesForCurrentFolder() || undefined,
    },
});

watch(locale, (newLocale) => {
    uppy.setOptions({
        locale: getUppyLocale(newLocale),
    });
});

watch(() => glob('folder')?.value?.currentFolder?.oid, () => {
    const allowedTypes = resolveAllowedMimeTypesForCurrentFolder();
    uppy.setOptions({
        restrictions: {
            allowedFileTypes: allowedTypes || undefined,
        },
    });
    mobileGalleryAccept.value = allowedTypes?.join(',') || 'image/*';
    buttonUploadAccept.value = allowedTypes?.join(',') || '';
});

const emit = __emit;

function resolveConnectUploadAction() {
    const connectParam = new URLSearchParams(window.location.search).get('connect');
    if (!connectParam) return null
    return CONNECT_UPLOAD_ACTION
}

function resolveUploadSuccessActionMeta() {
    const connectUploadAction = resolveConnectUploadAction();
    const baseAction = props.uploadSuccessAction && typeof props.uploadSuccessAction == 'object'
        ? { ...props.uploadSuccessAction }
        : null;

    if (!connectUploadAction) return baseAction

    return {
        ...(baseAction || {}),
        uploadAction: connectUploadAction,
    }
}

if (supportsWebcam) {
    uppy.use(Webcam);
}
uppy.use(XHR, {
    endpoint: configStore.apiUrl + configStore.apiPath + "/images" + xdebug,
    headers: headers,
    withCredentials: true,
    formData: true,
    
});


// Zusätzliche Daten mit Bild senden
uppy.on('file-added', (file) => {
    let folder = glob("folder");
    const currentClientId = authStore.getClientId();
    const uploadSuccessActionMeta = resolveUploadSuccessActionMeta();
    let meta = {
        clientId: currentClientId,
    };
    if (uploadSuccessActionMeta) {
        meta.uploadSuccessAction = JSON.stringify(uploadSuccessActionMeta);
    }
    if (typeof folder?.value?.currentFolder !== 'undefined') {
        meta.oid = folder.value.currentFolder.oid;
    }
    if (props.uploadMeta && typeof props.uploadMeta == 'object') {
        meta = {
            ...meta,
            ...props.uploadMeta,
        };
    }
    meta.session = authStore.getSessionId();

    uppy.setFileMeta(file.id, meta);

    if (file.name.endsWith(".pdf") || file.meta.type == "application/pdf") {
        uppy.setFileState(file.id, {
            xhrUpload: {
                ...file.xhrUpload,
                endpoint: configStore.apiUrl + configStore.apiPath + "/media"+ xdebug,
            }
        });
        uppy.setFileMeta(file.id, genPdfMeta(file));
    }
});

function genPdfMeta(file) {
    const uploadSuccessActionMeta = resolveUploadSuccessActionMeta();
    const folder = glob("folder");
    const currentClientId = authStore.getClientId();
    let meta = {
        clientId: currentClientId,
        module: "file",
        name: file.name,
    };

    if (typeof folder?.value?.currentFolder !== 'undefined') {
        meta.oid = folder.value.currentFolder.oid;
    }
    if (uploadSuccessActionMeta) {
        meta.uploadSuccessAction = JSON.stringify(uploadSuccessActionMeta);
    }
    if (props.uploadMeta && typeof props.uploadMeta == 'object') {
        meta = {
            ...meta,
            ...props.uploadMeta,
        };
    }
    meta.session = authStore.getSessionId();
    meta.components = JSON.stringify([{
        type: "pdf",
        role: "file"
    }]);

    return meta
}


const mercure = glob("mercure");

function resolveUploadOrigin() {
    return resolveConnectUploadAction() || 'default'
}

function publishUploadState(state) {
    const payload = {
        upload: {
            state,
            origin: resolveUploadOrigin(),
        }
    };

    mercure.publish("state", "state", JSON.stringify(payload));
}

function normalizeUploadStateMessage(mess) {
    if (!mess || typeof mess != 'object') return null

    if (mess.upload && typeof mess.upload == 'object') {
        return {
            state: mess.upload.state || '',
            origin: mess.upload.origin || '',
        }
    }

    if (typeof mess.upload == 'string') {
        return {
            state: mess.upload,
            origin: '',
        }
    }

    return null
}

function extractUploadErrorMessage(error, response) {
    const payload = response?.body ?? response?.xhr?.response ?? error?.response?.body ?? error?.body ?? null;
    const parseJson = (value) => {
        if (!value || typeof value !== 'string') return value
        try {
            return JSON.parse(value)
        } catch (e) {
            return value
        }
    };

    const parsedPayload = parseJson(payload);
    const candidates = [
        parsedPayload,
        response,
        error,
    ].filter(Boolean);

    for (const candidate of candidates) {
        const hydraDescription = candidate?.['hydra:description'];
        if (typeof hydraDescription === 'string' && hydraDescription.trim()) {
            return hydraDescription.trim()
        }

        const message = candidate?.message;
        if (typeof message === 'string' && message.trim()) {
            return message.trim()
        }
    }

    return null
}

function updateButtonUploadProgress() {
    const files = uppy.getFiles();
    const totals = files.reduce((result, file) => {
        result.bytesUploaded += file.progress?.bytesUploaded || 0;
        result.bytesTotal += file.progress?.bytesTotal || file.size || 0;
        return result
    }, { bytesUploaded: 0, bytesTotal: 0 });

    buttonUploadProgress.value = totals.bytesTotal > 0
        ? Math.min(100, Math.round((totals.bytesUploaded / totals.bytesTotal) * 100))
        : 0;
}

function openButtonUpload() {
    if (buttonUploadActive.value) return
    buttonUploadInput.value?.click();
}

function addFiles(files, source = 'Dropzone') {
    const uploadFiles = Array.from(files ?? []).map((file) => ({
        name: file.name,
        type: file.type,
        data: file,
        source,
    }));

    if (uploadFiles.length > 0) uppy.addFiles(uploadFiles);
}

__expose({
    openButtonUpload,
    addFiles,
});

function resetButtonUploadProgressSoon() {
    if (buttonUploadResetTimer) window.clearTimeout(buttonUploadResetTimer);
    buttonUploadResetTimer = window.setTimeout(() => {
        buttonUploadProgress.value = 0;
        buttonUploadResetTimer = null;
    }, 700);
}

function onButtonUploadChange(event) {
    const files = Array.from(event.target?.files ?? []);

    files.forEach((file) => {
        try {
            uppy.addFile({
                name: file.name,
                type: file.type,
                data: file,
                source: 'Button',
            });
        } catch (err) {
            if (!err?.isRestriction) {
                uppy.log(err, 'error');
            }
        }
    });

    if (event.target) {
        event.target.value = null;
    }
}

// upload start event
uppy.on('upload', (file) => {
	publishUploadState('started');
    if (buttonUploadResetTimer) window.clearTimeout(buttonUploadResetTimer);
    buttonUploadResetTimer = null;
    buttonUploadActive.value = true;
    buttonUploadProgress.value = 0;
    emit('on-upload-start', file);
});

uppy.on('upload-progress', () => {
    updateButtonUploadProgress();
});

uppy.on('upload-error', (file, error, response) => {
    const message = extractUploadErrorMessage(error, response) || error?.message || t('upload.uploadFailed');
    let messageTranslated = t(message);
    alertStore.error(t('upload.uploadError', { message: messageTranslated }));
    buttonUploadActive.value = false;
    buttonUploadProgress.value = 0;
    publishUploadState('failed');
});

// single file uploaded
uppy.on("upload-success", (status, event) => {
    emit('on-upload', event.body);
});

// all files uploaded
uppy.on("complete", (event) => {
    publishUploadState('finished');
    buttonUploadProgress.value = 100;
    buttonUploadActive.value = false;
    resetButtonUploadProgressSoon();
    emit('on-upload-complete', event);
    if (event?.failed?.length === 0) {
        uppy.clearUploadedFiles();
        emit('close-upload');
    }
});

function mountMobileUploadTab() {
    const main = document.querySelector("#upload-" + uid);
    if (!main) return

    const mobileTabSource = main.querySelector('#mobile-upload-' + uid);
    const target = main.querySelector('.uppy-Dashboard-AddFiles-list');
    const existingProxy = target?.querySelector('[data-mobile-upload-proxy="true"]');

    if (!mobileTabSource || !target || existingProxy) return

    const mobileTabProxy = mobileTabSource.cloneNode(true);
    mobileTabProxy.id = 'mobile-upload-proxy-' + uid;
    mobileTabProxy.dataset.mobileUploadProxy = 'true';
    mobileTabProxy.classList.remove('mobile-upload-source');

    const proxyButton = mobileTabProxy.querySelector('.uppy-DashboardTab-btn');
    if (proxyButton) {
        proxyButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
            qrCodeToggle();
        });
    }

    target.appendChild(mobileTabProxy);
}

function attachMyDeviceInterceptor() {
    if (!isMobileClient) return

    const main = document.querySelector("#upload-" + uid);
    const nextButton = main?.querySelector('[data-uppy-acquirer-id="MyDevice"] .uppy-DashboardTab-btn');

    if (!nextButton || nextButton === interceptedMyDeviceButton) return

    if (interceptedMyDeviceButton) {
        interceptedMyDeviceButton.removeEventListener('click', onMyDeviceClick, true);
    }

    interceptedMyDeviceButton = nextButton;
    interceptedMyDeviceButton.addEventListener('click', onMyDeviceClick, true);
}

function onMyDeviceClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
    }
    openMobileGallery();
}

function normalizeExtraMenuItems(items) {
    if (!Array.isArray(items)) return []

    return items
        .filter((item) => !!item?.label)
        .map((item, index) => ({
            id: item.id || `extra-${index}`,
            label: item.label,
            payload: item,
        }))
}

function resolveExtraMenuIconBackground(item) {
    if (!item || typeof item != 'object') return ''

    // Folder-Icon über folderIcons laden, damit Theme-Farben übernommen werden.
    if (item.id == 'open-gallery' || item.payload?.action == 'open-gallery') {
        return `url("${getFolderSvgFallback('default')}")`
    }

    return ''
}

function readCurrentExtraMenuSignature(target) {
    return Array.from(target.querySelectorAll('[data-upload-extra-menu="true"]'))
        .map((tab) => {
            const id = tab.dataset.uploadExtraMenuId || '';
            const label = tab.querySelector('.uppy-DashboardTab-name')?.textContent || '';
            return `${id}|${label}`
        })
        .join('||')
}

function mountExtraMenuItems() {
    if (syncingExtraMenu) return

    const main = document.querySelector("#upload-" + uid);
    const target = main?.querySelector('.uppy-Dashboard-AddFiles-list');
    if (!target) return

    const normalizedItems = normalizeExtraMenuItems(props.extraMenuItems);
    const expectedSignature = normalizedItems
        .map((item) => `${item.id}|${item.label}`)
        .join('||');
    const currentSignature = readCurrentExtraMenuSignature(target);

    if (currentSignature == expectedSignature) return

    syncingExtraMenu = true;
    target.querySelectorAll('[data-upload-extra-menu="true"]').forEach((el) => el.remove());

    normalizedItems.forEach((item) => {

        const tab = document.createElement('div');
        tab.className = 'uppy-DashboardTab upload-extra-menu';
        tab.dataset.uploadExtraMenu = 'true';
        tab.dataset.uploadExtraMenuId = item.id;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'uppy-u-reset uppy-c-btn uppy-DashboardTab-btn';
        button.setAttribute('role', 'tab');

        const inner = document.createElement('div');
        inner.className = `uppy-DashboardTab-inner ${item.id}`;
        const iconBackground = resolveExtraMenuIconBackground(item);
        if (iconBackground) {
            inner.style.backgroundImage = iconBackground;
        }

        const name = document.createElement('div');
        name.className = 'uppy-DashboardTab-name';
        name.textContent = item.label;

        button.appendChild(inner);
        button.appendChild(name);
        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }
            emit('menu-action', item.payload);
        }, true);

        tab.appendChild(button);
        target.appendChild(tab);
    });

    syncingExtraMenu = false;
}


onMounted(() => {
    const main = document.querySelector("#upload-" + uid);
    if (!main) return

    mountMobileUploadTab();
    attachMyDeviceInterceptor();
    mountExtraMenuItems();

    mobileUploadObserver = new MutationObserver(() => {
        mountMobileUploadTab();
        attachMyDeviceInterceptor();
        mountExtraMenuItems();
    });
    mobileUploadObserver.observe(main, { childList: true, subtree: true });

    releaseMercureStateListener = registerMercureEvent("state", onMercureState);

});

onBeforeUnmount(() => {
    if (buttonUploadResetTimer) {
        window.clearTimeout(buttonUploadResetTimer);
        buttonUploadResetTimer = null;
    }
    mobileUploadObserver?.disconnect();
    mobileUploadObserver = null;
    if (typeof releaseMercureStateListener === 'function') {
        releaseMercureStateListener();
        releaseMercureStateListener = null;
    }
    if (interceptedMyDeviceButton) {
        interceptedMyDeviceButton.removeEventListener('click', onMyDeviceClick, true);
    }
    interceptedMyDeviceButton = null;
    uppy.close({ reason: 'unmount' });
});

watch(() => props.extraMenuItems, () => {
    mountExtraMenuItems();
}, { deep: true });

const connection = ref({active:false});
const receivingUpload = ref(false);
let releaseMercureStateListener = null;

function onMercureState(mess) {
    if (mess["connected"]) {
        connection.value.active = true;
        return
    }

    const uploadState = normalizeUploadStateMessage(mess);
    if (!uploadState) return

    const isInlineConnectOrigin = uploadState.origin == CONNECT_UPLOAD_ACTION;

    if (uploadState.state == 'started') {
        if (isInlineConnectOrigin) receivingUpload.value = true;
        emit('on-upload-start', uploadState);
    } else if (uploadState.state == 'finished') {
        if (isInlineConnectOrigin) receivingUpload.value = false;
        emit('on-upload-complete', uploadState);
    }
}

const mobileConnect = ref(false);

function qrCodeToggle() {
    mobileConnect.value = !mobileConnect.value;
    if (!mobileConnect.value) receivingUpload.value = false;
}

function showQrCodeAgain() {
    connection.value.active = false;
    receivingUpload.value = false;
}

function openMobileGallery() {
    mobileGalleryInput.value?.click();
}

function onMobileGalleryChange(event) {
    const files = Array.from(event.target?.files ?? []);

    files.forEach((file) => {
        try {
            uppy.addFile({
                name: file.name,
                type: file.type,
                data: file,
                source: 'MyDevice',
            });
        } catch (err) {
            if (!err?.isRestriction) {
                uppy.log(err, 'error');
            }
        }
    });

    if (event.target) {
        event.target.value = null;
    }
}

const qrcodeText = document.location.origin + configStore.baseDir + "/account/usermedia?connect=" + authStore.getSessionId() + "&upload=1";


return (_ctx, _cache) => {
  return (props.variant == 'button' || props.variant == 'progress')
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        id: 'upload-' + unref(uid),
        class: normalizeClass(["upload-button-wrapper", { 'upload-progress-only-wrapper': props.variant == 'progress' }])
      }, [
        createElementVNode("input", {
          ref_key: "buttonUploadInput",
          ref: buttonUploadInput,
          hidden: "",
          "aria-hidden": "true",
          tabindex: "-1",
          type: "file",
          name: "upload-button-files[]",
          multiple: "",
          accept: buttonUploadAccept.value,
          onChange: onButtonUploadChange
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2$q),
        (props.variant == 'button')
          ? (openBlock(), createElementBlock("button", {
              key: 0,
              type: "button",
              class: normalizeClass(["uk-button uk-button-primary upload-progress-button", { 'is-uploading': buttonUploadActive.value }]),
              disabled: buttonUploadActive.value,
              onClick: openButtonUpload
            }, [
              createElementVNode("span", {
                class: "upload-progress-fill",
                style: normalizeStyle({ width: `${buttonUploadProgress.value}%` })
              }, null, 4 /* STYLE */),
              createElementVNode("span", _hoisted_4$l, [
                createElementVNode("span", null, toDisplayString$1(buttonUploadActive.value ? `${buttonUploadProgress.value}%` : (props.buttonLabel || 'Dateien hochladen')), 1 /* TEXT */),
                (buttonUploadActive.value)
                  ? (openBlock(), createElementBlock("span", _hoisted_5$j, [
                      createElementVNode("span", {
                        class: "upload-progress-track-fill",
                        style: normalizeStyle({ width: `${buttonUploadProgress.value}%` })
                      }, null, 4 /* STYLE */)
                    ]))
                  : createCommentVNode("v-if", true)
              ])
            ], 10 /* CLASS, PROPS */, _hoisted_3$n))
          : (buttonUploadActive.value)
            ? (openBlock(), createElementBlock("span", _hoisted_6$g, [
                createElementVNode("span", _hoisted_7$f, [
                  createElementVNode("span", {
                    class: "upload-progress-track-fill",
                    style: normalizeStyle({ width: `${buttonUploadProgress.value}%` })
                  }, null, 4 /* STYLE */)
                ])
              ]))
            : createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_1$v))
    : (openBlock(), createElementBlock("div", {
        key: 1,
        id: 'upload-' + unref(uid)
      }, [
        createElementVNode("input", {
          ref_key: "mobileGalleryInput",
          ref: mobileGalleryInput,
          class: "uppy-Dashboard-input",
          hidden: "",
          "aria-hidden": "true",
          tabindex: "-1",
          type: "file",
          name: "mobile-gallery-files[]",
          multiple: "",
          accept: mobileGalleryAccept.value,
          onChange: onMobileGalleryChange
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9$d),
        createElementVNode("div", {
          id: 'mobile-upload-' + unref(uid),
          class: "uppy-DashboardTab mobile-upload-source",
          role: "presentation"
        }, [
          createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => (qrCodeToggle())),
            type: "button",
            class: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
            role: "tab"
          }, [
            _cache[3] || (_cache[3] = createElementVNode("div", { class: "uppy-DashboardTab-inner phone" }, null, -1 /* HOISTED */)),
            createElementVNode("div", _hoisted_11$d, toDisplayString$1(_ctx.$t('upload.mobileDevice')), 1 /* TEXT */)
          ])
        ], 8 /* PROPS */, _hoisted_10$d),
        withDirectives(createElementVNode("div", _hoisted_12$d, [
          (receivingUpload.value)
            ? (openBlock(), createElementBlock("div", _hoisted_13$c, [
                createElementVNode("div", null, toDisplayString$1(_ctx.$t('upload.receivingFile') != 'upload.receivingFile' ? _ctx.$t('upload.receivingFile') : 'Empfange Datei'), 1 /* TEXT */),
                createVNode(unref(script$I), { width: 220 })
              ]))
            : (!connection.value.active)
              ? (openBlock(), createElementBlock("div", _hoisted_14$a, [
                  createElementVNode("div", _hoisted_15$a, [
                    createVNode(QrcodeVue, {
                      size: 160,
                      value: qrcodeText
                    })
                  ]),
                  createElementVNode("div", null, toDisplayString$1(_ctx.$t('upload.scanQr')), 1 /* TEXT */),
                  createElementVNode("div", null, [
                    createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = $event => (qrCodeToggle())),
                      class: "uk-button uk-button-default"
                    }, toDisplayString$1(_ctx.$t('upload.close')), 1 /* TEXT */)
                  ])
                ]))
              : (openBlock(), createElementBlock("div", _hoisted_16$9, [
                  createElementVNode("div", null, [
                    createTextVNode(toDisplayString$1(_ctx.$t('upload.connected')) + " ", 1 /* TEXT */),
                    createElementVNode("p", null, toDisplayString$1(_ctx.$t('upload.chooseFilesOnDevice')), 1 /* TEXT */)
                  ]),
                  createElementVNode("div", null, [
                    createElementVNode("button", {
                      onClick: showQrCodeAgain,
                      class: "uk-button uk-button-default"
                    }, "QR Code erneut anzeigen"),
                    createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = $event => {qrCodeToggle();emit('close-upload');}),
                      class: "uk-button uk-button-default"
                    }, toDisplayString$1(_ctx.$t('upload.ok')), 1 /* TEXT */)
                  ])
                ]))
        ], 512 /* NEED_PATCH */), [
          [vShow, mobileConnect.value]
        ]),
        withDirectives(createElementVNode("div", null, [
          createVNode(unref(Dashboard), {
            uppy: unref(uppy),
            props: dashboardProps
          }, null, 8 /* PROPS */, ["uppy"])
        ], 512 /* NEED_PATCH */), [
          [vShow, !mobileConnect.value]
        ])
      ], 8 /* PROPS */, _hoisted_8$d))
}
}

});

script$y.__file = "src/components/Upload.vue";

const _hoisted_1$u = { key: 0 };
const _hoisted_2$p = { key: 1 };
const _hoisted_3$m = { class: "gallery" };
const _hoisted_4$k = ["onClick"];
const _hoisted_5$i = {
  key: 0,
  class: "img-checked"
};
const _hoisted_6$f = ["src"];
const _hoisted_7$e = { class: "uk-thumbnail-caption" };


var script$x = {
  __name: 'Images',
  emits: ['selectedMedia'],
  setup(__props, { emit: __emit }) {

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);
const selectedItems = ref([]);

var images = ref(new apiResponse([]));

var error = ref();
const showUpload = ref(false);

const emit = __emit;

onBeforeMount(async () => {
    try {
        getImages();
    } catch (e) {
        error.value = e;
    }

});

let releaseMercureImageListener = null;

onUnmounted(() => {
    if (typeof releaseMercureImageListener === 'function') {
        releaseMercureImageListener();
        releaseMercureImageListener = null;
    }
});

// Register Mercure Event listener

releaseMercureImageListener = registerMercureEvent("image", (el) => updateImageList(el));

function updateImageList(elList) {
    if (!Array.isArray(elList)) elList = [elList];
   logger.debug(elList);
   elList.forEach((el) => {
      updateOrAppendImage(el);
   });
   
}

function updateOrAppendImage(el) {

    let updated = false;
    for(let i in images.value) {
       if (images.value[i].id == el.id) {
        images.value[i] = el;
        updated = true;
        return
       }
    }
    if (!updated) images.value.unshift(el);
}

async function getImages() {
    let img_raw_data = await ppapiClient.get("users/" + user.value.kid + "/images");
    if (!img_raw_data) return false
    images.value = img_raw_data.data().sort(sortFunction);
}

function onUpload() {
    getImages();
}

function selectItem(item) {
    item.selected = !item.selected;

    selectedItems.value = _.filter(images.value, (item) => { return item.selected });
    emit("selected-media", selectedItems.value);
}

function sortFunction(a, b) {
    if (a.date > b.date) return -1
    else return 1
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = $event => (showUpload.value = !showUpload.value)),
      class: "toggle-upload uk-button uk-button-default uk-button-primary"
    }, [
      (showUpload.value)
        ? (openBlock(), createElementBlock("span", _hoisted_1$u, "-"))
        : (openBlock(), createElementBlock("span", _hoisted_2$p, "+"))
    ]),
    createVNode(unref(Collapse), {
      when: showUpload.value,
      class: "expand"
    }, {
      default: withCtx(() => [
        createVNode(script$y, { onOnUpload: onUpload })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["when"]),
    createElementVNode("div", _hoisted_3$m, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(images), (item, index) => {
        return (openBlock(), createElementBlock("div", {
          key: index,
          class: normalizeClass(["uk-thumbnail image", { selected: item.selected }]),
          onClick: $event => (selectItem(item))
        }, [
          (item.selected)
            ? (openBlock(), createElementBlock("div", _hoisted_5$i, [...(_cache[1] || (_cache[1] = [
                createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
              ]))]))
            : createCommentVNode("v-if", true),
          createElementVNode("img", {
            src: unref(imgsource)(item, 'th'),
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_6$f),
          createElementVNode("div", _hoisted_7$e, [
            createElementVNode("div", null, toDisplayString$1(item.name), 1 /* TEXT */),
            createElementVNode("div", null, toDisplayString$1(item.bid), 1 /* TEXT */)
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_4$k))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$x.__file = "src/components/Images.vue";

const _hoisted_1$t = {
  key: 0,
  class: "uk-card uk-padding-small"
};
const _hoisted_2$o = { class: "select-mod" };
const _hoisted_3$l = {
  class: "pp-info-bubble",
  style: {"top":"12px","left":"50px"}
};
const _hoisted_4$j = { class: "select-tools" };
const _hoisted_5$h = ["aria-label", "uk-tooltip", "disabled"];
const _hoisted_6$e = { class: "select-tool-label" };
const _hoisted_7$d = { key: 0 };
const _hoisted_8$c = ["aria-label", "disabled"];
const _hoisted_9$c = { class: "select-tool-label" };
const _hoisted_10$c = { key: 1 };
const _hoisted_11$c = ["aria-label", "disabled"];
const _hoisted_12$c = { class: "select-tool-label" };
const _hoisted_13$b = ["aria-label", "disabled"];
const _hoisted_14$9 = { class: "select-tool-label" };
const _hoisted_15$9 = ["aria-label", "disabled"];
const _hoisted_16$8 = { class: "select-tool-label" };
const _hoisted_17$7 = {
  key: 1,
  class: "uk-card uk-padding-small"
};
const _hoisted_18$7 = { class: "select-tools" };
const _hoisted_19$7 = ["aria-label"];
const _hoisted_20$6 = { class: "select-tool-label" };
const _hoisted_21$6 = ["uk-icon"];
const _hoisted_22$5 = ["uk-icon"];
const _hoisted_23$5 = ["onClick"];
const _hoisted_24$5 = ["uk-icon"];
const _hoisted_25$5 = { key: 1 };
const _hoisted_26$4 = { class: "uk-card uk-card-body" };
const _hoisted_27$4 = ["placeholder"];
const _hoisted_28$4 = { class: "gallery" };
const _hoisted_29$3 = {
  key: 0,
  class: "folder-list-container"
};
const _hoisted_30$3 = ["data-oid", "onClick", "onDblclick"];
const _hoisted_31$3 = {
  key: 0,
  class: "img-checked"
};
const _hoisted_32$2 = { class: "folder-caption" };
const _hoisted_33$2 = ["onClick"];
const _hoisted_34$1 = ["data-jid"];
const _hoisted_35$1 = { class: "gallery-item-frame" };
const _hoisted_36$1 = {
  key: 0,
  class: "img-checked"
};
const _hoisted_37$1 = ["onClick"];
const _hoisted_38$1 = { class: "gallery-item-label" };
const _hoisted_39$1 = { class: "gallery-card-actions" };
const _hoisted_40$1 = { class: "gallery-media-icons" };
const _hoisted_41$1 = ["data-type", "data-module", "uk-tooltip"];
const _hoisted_42$1 = ["uk-tooltip"];
const _hoisted_43$1 = ["onClick", "aria-label"];
const _hoisted_44$1 = { class: "gallery-item-frame" };
const _hoisted_45$1 = {
  key: 0,
  class: "img-checked"
};
const _hoisted_46$1 = ["onClick"];
const _hoisted_47$1 = { class: "gallery-item-label" };
const _hoisted_48$1 = { class: "gallery-card-actions" };
const _hoisted_49$1 = ["data-type", "uk-tooltip"];
const _hoisted_50$1 = ["onClick", "aria-label"];
const _hoisted_51$1 = { class: "uk-text-right uk-margin-top" };


var script$w = /*@__PURE__*/Object.assign({ name: 'GalleryView' }, {
  __name: 'Gallery',
  props: {
    setup: Object,
    useRouting: {type: Boolean, default: true}
},
  emits: ['selected-media','folders-changed'],
  setup(__props, { emit: __emit }) {

/** 
 * @module components/Gallery
 * @name GalleryView
 * @description This is a Vue component that displays a gallery of images and folders.
 * 
 * @vue-prop {Object} setup - Configuration Object
 * 
 * @vue-event {Object} selected-media - Emit selected media object
 * @vue-event {Object} folders-changed - Emit folders changed 
 * 
 * @example 
 * <Gallery :setup="{ showUpload: true }" />
 * 
 */


const props = __props;

/** view/hide Upload box */
const showUpload = ref(false);

/** view/hide folder creation box */
const showCreateFolder = ref(false);

/** foldername reactive var */
const foldername = ref();

/** view/hide directory breadcrumbs selector */
const showDirSelect = ref(false);

const emit = __emit;

// CDN-Config initialisieren aus props.setup.cdn
let cdnConfig = null;
if (props.setup?.cdn) {
    cdnConfig = createCdnConfig(props.setup.cdn);
}

const mm = new MediaManager({useRouting:props.useRouting, basePath: props.setup?.basePath || "/", excludeDirs: ["D"]});

// Aus nicht bekanntem Grund können die refs aus der Klasse nicht direkt im Template verwendet werden,
// da die reaktivität sonst nicht geht. Deshalb so:

const folderList = mm.folderList;
const mediaList = mm.mediaList;
const imageList = mm.imageList;
const selectedItems = mm.selectedItems;
const folder = mm.folder;
const copyMove = mm.copyMove;
const canPaste = computed(() => {
    return copyMove.value.items?.length > 0
        && copyMove.value.sourceOid !== folder.value?.currentFolder?.oid
});

const authStore = useAuthStore();
const configStore = useConfigStore();
const { user } = storeToRefs(authStore);
const { t } = useI18n();

function mediaErrorTooltip(media) {
    const errors = getMediaDocumentErrors(media);
    if (!errors.length) return null;
    return `title: ${errors.map((error) => t(`mediaErrors.${error.key}`, { value: error.value })).join('<br>')}; pos: bottom`;
}

const previewModal = ref(false);
const previewList = ref([]);
const previewIndex = ref(0);
const keepSelectionMenuOpen = ref(false);
const imageSelectionModalOpen = ref(false);

const currentFolderActions = computed(() => {
    const oid = folder.value?.currentFolder?.oid;
    const actions = galleryFolderActions?.[oid];
    return Array.isArray(actions) ? actions : []
});

function runFolderAction(action) {
    if (action?.action === 'location' && action.target) {
        window.location.href = action.target;
    }
}

// ==================== Folder Icon URL Management ====================

/**
 * Berechnet die Background-Image-URL für einen Folder
 * Nutzt CDN wenn konfiguriert, sonst Fallback-SVG
 * @param {number} oid - Folder OID
 * @returns {string} background-image CSS-Wert (url(...))
 */
function getFolderImageUrl(oid) {
  if (cdnConfig && cdnConfig.isConfigured()) {
    // CDN-basierte URL synchron (ohne Health-Check)
    const cdnUrl = cdnConfig.getUrlSync(`folder-${oid}.svg`, () => getFolderSvgFallback(oid));
    return `url("${cdnUrl}")`
  }
  // Fallback wenn keine CDN konfiguriert
  const fallbackUrl = getFolderSvgFallback(oid);
  return `url("${fallbackUrl}")`
}

/**
 * Map der Folder OIDs zu ihren Background-Image-URLs
 * Wird aktualisiert, wenn folderList sich ändert
 */
const folderImageMap = computed(() => {
  const map = {};
    const folders = Array.isArray(folderList.value) ? folderList.value : [];

    folders.forEach(folder => {
    map[folder.oid] = getFolderImageUrl(folder.oid);
  });

  // Default-Folder (ohne spezifische OID) 
  map.default = getFolderImageUrl('default');
  return map
});

if (props.setup?.showUpload) showUpload.value = true;

onBeforeMount(async () => {
   
    mm.loadAll();

    watch (mm.folder,() => {
        emit("folders-changed");
    },{deep:true});

    watch (mm.selectedItems,(si) => {
       if (si.length == 0) showDirSelect.value = false;
       
       emit("selected-media", mm.selectedItems.value);
    });
});

onUnmounted(() => {
    mm.close();
});

const uploadProgress = ref(false);

/** 
 * Eventhandler for upload start
 * @returns {void} 
 */
function onUploadStart() {
    uploadProgress.value = true;
}

function onUploadComplete() {
    uploadProgress.value = false;
   // getImages()
}

function onUpload(uploadPayload) {
    mm.updateUploadedList(uploadPayload);
}

async function createFolder (name) {

    mm.createFolder(name);
    showCreateFolder.value = false;
    foldername.value = "";
}

let time = null;

function singleClickSelect(item, index) {
     // first clear  time
      clearTimeout(time);
      time = setTimeout(() => {
        mm.selectItem(item, index);
      }, 300); 
    }

function doubleClick(item, index) {
      clearTimeout(time);  
      mm.enterDir(item, index);
}

const checkSelection = computed(() => {

    if (selectedItems.value.length > 1) {
       return `title: ${t('gallery.selectOneToEdit')}`
    }

    return undefined
});

function isFolderSelectionItem(item) {
    if (!item || typeof item !== 'object') return false
    return typeof item?.path === 'string' || typeof item?.currentPath === 'string'
}

function isImageSelectionItem(item) {
    const type = String(item?.type || item?.['@type'] || '').toLowerCase();
    const module = String(item?.module || '').toLowerCase();
    const bintyp = String(item?.bintyp || '').toLowerCase();

    return type.includes('image') || module.includes('image') || bintyp.includes('image')
}

function hasOrderableSelection() {
    const selected = Array.isArray(selectedItems.value) ? selectedItems.value : [];
    return selected.length > 0 && !selected.some(isFolderSelectionItem)
}

function openCalendarEditor() {
    const editorPath = configStore.calendarEditPath || '/editor.js';
    const href = `${window.location.origin}${editorPath}`;
    window.location.href = href;
}

function toProductSelector() {
    const selected = Array.isArray(selectedItems.value) ? selectedItems.value : [];
    if (selected.some(isFolderSelectionItem)) return

    const hasImageSelection = selected.some(isImageSelectionItem);

    if (hasImageSelection) {
        imageSelectionModalOpen.value = true;
        return
    }

    const mediaSelection = selected.filter((item) => !isImageSelectionItem(item));
    if (mediaSelection.length === 0) return

    psModal({ 
        usePgrId: 4,
        useMedia: mediaSelection,
        bcView:0,
        layout: 'compact'
    });
    mm.selectNone();
}

function selectionMenuOpenByAction() {
    keepSelectionMenuOpen.value = true;
}

function closeSelectionMenuByAction() {
    keepSelectionMenuOpen.value = false;
}

function onSelectAllClick() {
    selectionMenuOpenByAction();
    mm.selectAll();
}

function onSelectNoneClick() {
    selectionMenuOpenByAction();
    mm.selectNone();
}

function onMainAction(actionFn) {
    actionFn();
    closeSelectionMenuByAction();
}

function preview(list,index){
    previewModal.value = true;
    previewList.value = list;
    previewIndex.value = index;
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createVNode(unref(Collapse), {
      when: keepSelectionMenuOpen.value || unref(selectedItems).length > 0 || canPaste.value,
      id: "gallery-selection-menue",
      class: "expand"
    }, {
      default: withCtx(() => [
        (keepSelectionMenuOpen.value || unref(selectedItems).length > 0)
          ? (openBlock(), createElementBlock("div", _hoisted_1$t, [
              createElementVNode("div", _hoisted_2$o, [
                createTextVNode(toDisplayString$1(_ctx.$t('gallery.selection')) + " ", 1 /* TEXT */),
                createElementVNode("div", _hoisted_3$l, toDisplayString$1(unref(selectedItems).length), 1 /* TEXT */),
                _cache[14] || (_cache[14] = createTextVNode("  ")),
                createElementVNode("span", {
                  onClick: onSelectAllClick,
                  class: "uk-badge"
                }, toDisplayString$1(_ctx.$t('gallery.all')), 1 /* TEXT */),
                _cache[15] || (_cache[15] = createTextVNode("  ")),
                createElementVNode("span", {
                  onClick: onSelectNoneClick,
                  class: "uk-badge"
                }, toDisplayString$1(_ctx.$t('gallery.none')), 1 /* TEXT */)
              ]),
              createElementVNode("div", _hoisted_4$j, [
                createElementVNode("button", {
                  class: "uk-button uk-button-small",
                  "aria-label": _ctx.$t('gallery.edit'),
                  "uk-tooltip": checkSelection.value,
                  disabled: unref(selectedItems).length != 1,
                  onClick: _cache[0] || (_cache[0] = $event => (onMainAction(() => unref(mm).editItem())))
                }, [
                  _cache[16] || (_cache[16] = createElementVNode("i", { "uk-icon": "icon: pencil" }, null, -1 /* HOISTED */)),
                  createElementVNode("span", _hoisted_6$e, toDisplayString$1(_ctx.$t('gallery.edit')), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_5$h),
                _cache[24] || (_cache[24] = createTextVNode("  ")),
                createCommentVNode(" <SelectDir v-if=\"folder.currentFolder \" :dirs=\"[folder.object()]\"></SelectDir> "),
                (unref(folder).currentFolder.oid == 1)
                  ? (openBlock(), createElementBlock("span", _hoisted_7$d, [
                      createElementVNode("button", {
                        class: "uk-button uk-button-small",
                        "aria-label": _ctx.$t('gallery.restore'),
                        disabled: unref(selectedItems).length === 0,
                        onClick: _cache[1] || (_cache[1] = $event => (onMainAction(() => unref(mm).moveItems(0))))
                      }, [
                        _cache[17] || (_cache[17] = createElementVNode("i", { "uk-icon": "icon: refresh" }, null, -1 /* HOISTED */)),
                        createElementVNode("span", _hoisted_9$c, toDisplayString$1(_ctx.$t('gallery.restore')), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_8$c),
                      _cache[18] || (_cache[18] = createTextVNode("  "))
                    ]))
                  : (openBlock(), createElementBlock("span", _hoisted_10$c, [
                      createElementVNode("button", {
                        class: "uk-button uk-button-small",
                        "aria-label": _ctx.$t('gallery.cut'),
                        disabled: unref(selectedItems).length === 0,
                        onClick: _cache[2] || (_cache[2] = $event => (onMainAction(() => unref(mm).copyMovePaste('move'))))
                      }, [
                        _cache[19] || (_cache[19] = createElementVNode("i", { "uk-icon": "icon: move" }, null, -1 /* HOISTED */)),
                        createElementVNode("span", _hoisted_12$c, toDisplayString$1(_ctx.$t('gallery.cut')), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_11$c),
                      _cache[22] || (_cache[22] = createTextVNode("  ")),
                      createCommentVNode("    <button class=\"uk-button uk-button-small\" :aria-label=\"$t('gallery.copy')\" :disabled=\"selectedItems.length === 0\" @click=\"onMainAction(() => mm.copyMovePaste('copy'))\"><i uk-icon=\"icon: copy\"></i><span class=\"select-tool-label\">{{ $t('gallery.copy') }}</span></button>&nbsp; "),
                      createElementVNode("button", {
                        class: "uk-button uk-button-small",
                        "aria-label": _ctx.$t('gallery.order'),
                        disabled: !hasOrderableSelection(),
                        onClick: _cache[3] || (_cache[3] = $event => (onMainAction(() => toProductSelector())))
                      }, [
                        _cache[20] || (_cache[20] = createElementVNode("i", { "uk-icon": "icon: cart" }, null, -1 /* HOISTED */)),
                        createElementVNode("span", _hoisted_14$9, toDisplayString$1(_ctx.$t('gallery.order')), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_13$b),
                      _cache[23] || (_cache[23] = createTextVNode("  ")),
                      createElementVNode("button", {
                        class: "uk-button uk-button-small",
                        "aria-label": _ctx.$t('gallery.delete'),
                        disabled: unref(selectedItems).length === 0,
                        onClick: _cache[4] || (_cache[4] = $event => (onMainAction(() => unref(mm).moveItems(1))))
                      }, [
                        _cache[21] || (_cache[21] = createElementVNode("i", { "uk-icon": "icon: trash" }, null, -1 /* HOISTED */)),
                        createElementVNode("span", _hoisted_16$8, toDisplayString$1(_ctx.$t('gallery.delete')), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_15$9)
                    ]))
              ])
            ]))
          : createCommentVNode("v-if", true),
        (canPaste.value)
          ? (openBlock(), createElementBlock("div", _hoisted_17$7, [
              createElementVNode("div", _hoisted_18$7, [
                createElementVNode("button", {
                  class: "uk-button uk-button-small",
                  "aria-label": _ctx.$t('gallery.paste'),
                  onClick: _cache[5] || (_cache[5] = $event => (onMainAction(() => unref(mm).copyMovePaste('paste'))))
                }, [
                  _cache[25] || (_cache[25] = createElementVNode("i", { "uk-icon": "icon: download" }, null, -1 /* HOISTED */)),
                  createElementVNode("span", _hoisted_20$6, toDisplayString$1(_ctx.$t('gallery.paste')), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_19$7),
                _cache[26] || (_cache[26] = createTextVNode("  "))
              ])
            ]))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["when"]),
    createElementVNode("button", {
      onClick: _cache[6] || (_cache[6] = $event => (showUpload.value = !showUpload.value)),
      class: "toggle-upload uk-button uk-button-default uk-button-primary"
    }, [
      createElementVNode("i", {
        "uk-icon": `icon: ${(showUpload.value)?'minus':'plus'}`
      }, null, 8 /* PROPS */, _hoisted_21$6),
      _cache[27] || (_cache[27] = createElementVNode("i", { "uk-icon": "icon: image" }, null, -1 /* HOISTED */))
    ]),
    (unref(user))
      ? (openBlock(), createElementBlock("button", {
          key: 0,
          onClick: _cache[7] || (_cache[7] = $event => (showCreateFolder.value = !showCreateFolder.value)),
          class: "toggle-upload uk-button uk-button-default"
        }, [
          createElementVNode("i", {
            "uk-icon": `icon: ${(showCreateFolder.value)?'minus':'plus'}`
          }, null, 8 /* PROPS */, _hoisted_22$5),
          _cache[28] || (_cache[28] = createElementVNode("i", { "uk-icon": "icon: folder" }, null, -1 /* HOISTED */))
        ]))
      : createCommentVNode("v-if", true),
    (openBlock(true), createElementBlock(Fragment, null, renderList(currentFolderActions.value, (action) => {
      return (openBlock(), createElementBlock("button", {
        key: action.id,
        type: "button",
        class: "folder-extra-action uk-button uk-button-default",
        onClick: $event => (runFolderAction(action))
      }, [
        (action.icon)
          ? (openBlock(), createElementBlock("i", {
              key: 0,
              "uk-icon": `icon: ${action.icon}`
            }, null, 8 /* PROPS */, _hoisted_24$5))
          : createCommentVNode("v-if", true),
        createElementVNode("span", null, toDisplayString$1(action.label), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_23$5))
    }), 128 /* KEYED_FRAGMENT */)),
    (uploadProgress.value && !showUpload.value)
      ? (openBlock(), createElementBlock("div", _hoisted_25$5, [
          createVNode(unref(script$I), { width: 200 })
        ]))
      : createCommentVNode("v-if", true),
    (unref(user))
      ? (openBlock(), createBlock(unref(Collapse), {
          key: 2,
          when: showCreateFolder.value,
          class: "expand create-folder-container"
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_26$4, [
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('gallery.createFolderTitle')) + " " + toDisplayString$1(foldername.value), 1 /* TEXT */),
              withDirectives(createElementVNode("input", {
                class: "uk-input new-folder-name",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((foldername).value = $event)),
                placeholder: _ctx.$t('gallery.folderName')
              }, null, 8 /* PROPS */, _hoisted_27$4), [
                [vModelText, foldername.value]
              ]),
              createElementVNode("button", {
                class: "uk-button uk-button-default uk-button-primary",
                onClick: _cache[9] || (_cache[9] = $event => (createFolder(foldername.value)))
              }, toDisplayString$1(_ctx.$t('gallery.create')), 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["when"]))
      : createCommentVNode("v-if", true),
    createVNode(unref(Collapse), {
      when: showUpload.value,
      class: "expand upload-container"
    }, {
      default: withCtx(() => [
        createVNode(script$y, {
          onCloseUpload: _cache[10] || (_cache[10] = $event => (showUpload.value=false)),
          onOnUpload: onUpload,
          onOnUploadComplete: onUploadComplete,
          onOnUploadStart: onUploadStart
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["when"]),
    createElementVNode("div", _hoisted_28$4, [
      (unref(folderList).length > 0 || (unref(folderList).length == 0 && unref(mediaList).length == 0 && unref(imageList).length == 0))
        ? (openBlock(), createElementBlock("div", _hoisted_29$3, [
            (unref(folderList).length == 0 && unref(mediaList).length == 0 && unref(imageList).length == 0)
              ? (openBlock(), createBlock(unref(script$H), {
                  key: 0,
                  delay: "1000",
                  content: _ctx.$t('gallery.addFile'),
                  arrow: "arrow-top-left"
                }, null, 8 /* PROPS */, ["content"]))
              : createCommentVNode("v-if", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(folderList), (item, index) => {
              return (openBlock(), createElementBlock("div", {
                key: index,
                class: normalizeClass(["folder", { selected: item.selected }]),
                "data-oid": item.oid,
                style: normalizeStyle({ backgroundImage: folderImageMap.value[item.oid] || folderImageMap.value.default }),
                onClick: $event => (singleClickSelect(item,index)),
                onDblclick: $event => (doubleClick(item, index))
              }, [
                (item.selected)
                  ? (openBlock(), createElementBlock("div", _hoisted_31$3, [...(_cache[29] || (_cache[29] = [
                      createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
                    ]))]))
                  : createCommentVNode("v-if", true),
                createElementVNode("div", _hoisted_32$2, [
                  createElementVNode("div", null, [
                    createElementVNode("a", {
                      href: "#",
                      onClick: withModifiers($event => (unref(mm).enterDir(item, index)), ["stop"])
                    }, toDisplayString$1(item.translatedName), 9 /* TEXT, PROPS */, _hoisted_33$2)
                  ])
                ])
              ], 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */, _hoisted_30$3))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : createCommentVNode("v-if", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(mediaList), (item, index) => {
        return (openBlock(), createElementBlock("div", {
          key: index,
          class: normalizeClass(["uk-thumbnail gallery-card", { selected: item.selected }]),
          "data-jid": item.jid
        }, [
          createElementVNode("div", _hoisted_35$1, [
            (item.selected)
              ? (openBlock(), createElementBlock("div", _hoisted_36$1, [...(_cache[30] || (_cache[30] = [
                  createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
                ]))]))
              : createCommentVNode("v-if", true),
            createElementVNode("div", {
              class: normalizeClass(["gallery-item media", (unref(copyMove).idList?.indexOf(item['@type'] + ':' +  item.id)>-1)?'cut':'']),
              onClick: $event => (unref(mm).selectItem(item, index)),
              style: normalizeStyle(`background-image:url(${unref(imgsource)(item, 'th')})`)
            }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_37$1),
            createElementVNode("div", _hoisted_38$1, toDisplayString$1(item.name), 1 /* TEXT */)
          ]),
          createElementVNode("div", _hoisted_39$1, [
            createElementVNode("div", _hoisted_40$1, [
              createElementVNode("div", {
                class: "icon",
                "data-type": item.type,
                "data-module": item.module,
                "uk-tooltip": _ctx.$t('module:' + item.module)
              }, null, 8 /* PROPS */, _hoisted_41$1),
              (unref(getMediaDocumentErrors)(item).length)
                ? (openBlock(), createElementBlock("i", {
                    key: 0,
                    class: "media-error-icon",
                    "uk-icon": "icon: warning",
                    "uk-tooltip": mediaErrorTooltip(item)
                  }, null, 8 /* PROPS */, _hoisted_42$1))
                : createCommentVNode("v-if", true)
            ]),
            createElementVNode("button", {
              type: "button",
              class: "gallery-preview-button",
              onClick: withModifiers($event => (preview(unref(mediaList), index)), ["stop"]),
              "aria-label": _ctx.$t('gallery.preview')
            }, [...(_cache[31] || (_cache[31] = [
              createElementVNode("i", { "uk-icon": "icon: search" }, null, -1 /* HOISTED */)
            ]))], 8 /* PROPS */, _hoisted_43$1)
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_34$1))
      }), 128 /* KEYED_FRAGMENT */)),
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(imageList), (item, index) => {
        return (openBlock(), createElementBlock("div", {
          key: index,
          class: normalizeClass(["uk-thumbnail gallery-card", { selected: item.selected }])
        }, [
          createElementVNode("div", _hoisted_44$1, [
            (item.selected)
              ? (openBlock(), createElementBlock("div", _hoisted_45$1, [...(_cache[32] || (_cache[32] = [
                  createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
                ]))]))
              : createCommentVNode("v-if", true),
            createElementVNode("div", {
              class: normalizeClass(["gallery-item image", (unref(copyMove).idList?.indexOf(item['@type'] + ':' +  item.id)>-1)?'cut':'']),
              onClick: $event => (unref(mm).selectItem(item, index)),
              style: normalizeStyle(`background-image:url(${unref(imgsource)(item, 'th')})`)
            }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_46$1),
            createElementVNode("div", _hoisted_47$1, toDisplayString$1(item.name), 1 /* TEXT */)
          ]),
          createElementVNode("div", _hoisted_48$1, [
            createElementVNode("div", {
              class: "icon",
              "data-type": item['@type'],
              "uk-tooltip": item.bintyp
            }, null, 8 /* PROPS */, _hoisted_49$1),
            createElementVNode("button", {
              type: "button",
              class: "gallery-preview-button",
              onClick: withModifiers($event => (preview(unref(imageList), index)), ["stop"]),
              "aria-label": _ctx.$t('gallery.preview')
            }, [...(_cache[33] || (_cache[33] = [
              createElementVNode("i", { "uk-icon": "icon: search" }, null, -1 /* HOISTED */)
            ]))], 8 /* PROPS */, _hoisted_50$1)
          ])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    createVNode(unref(script$g), {
      open: previewModal.value,
      onClose: _cache[11] || (_cache[11] = $event => (previewModal.value = false)),
      class: "preview-modal"
    }, {
      body: withCtx(() => [
        createVNode(unref(script$G), {
          infoComponent: "FileInfo",
          images: previewList.value,
          index: previewIndex.value
        }, null, 8 /* PROPS */, ["images", "index"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    createVNode(unref(script$g), {
      open: imageSelectionModalOpen.value,
      onClose: _cache[13] || (_cache[13] = $event => (imageSelectionModalOpen.value = false)),
      class: "calendar-create-modal"
    }, {
      title: withCtx(() => [
        createTextVNode(toDisplayString$1(_ctx.$t('gallery.calendarCreationRequiredTitle')), 1 /* TEXT */)
      ]),
      body: withCtx(() => [
        createElementVNode("p", null, toDisplayString$1(_ctx.$t('gallery.calendarCreationRequiredText')), 1 /* TEXT */),
        createElementVNode("div", _hoisted_51$1, [
          createElementVNode("button", {
            class: "uk-button uk-button-primary",
            type: "button",
            onClick: _cache[12] || (_cache[12] = $event => (openCalendarEditor()))
          }, toDisplayString$1(_ctx.$t('gallery.calendarDesignButton')), 1 /* TEXT */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

});

script$w.__file = "src/components/Gallery.vue";

const _hoisted_1$s = { key: 0 };
const _hoisted_2$n = { class: "bc-dir" };
const _hoisted_3$k = { class: "uk-breadcrumb" };
const _hoisted_4$i = ["onClick"];
const _hoisted_5$g = {
  key: 1,
  class: "add-button-container"
};
const _hoisted_6$d = ["uk-icon"];
const _hoisted_7$c = ["uk-icon"];
const _hoisted_8$b = { class: "uk-card uk-card-body" };
const _hoisted_9$b = ["placeholder"];
const _hoisted_10$b = { class: "gallery" };
const _hoisted_11$b = { class: "folders-container" };
const _hoisted_12$b = ["data-oid", "onClick", "onDblclick"];
const _hoisted_13$a = {
  key: 0,
  class: "img-checked"
};
const _hoisted_14$8 = { class: "folder-caption" };
const _hoisted_15$8 = ["onClick"];
const _hoisted_16$7 = ["data-jid", "onClick"];
const _hoisted_17$6 = {
  key: 0,
  class: "img-checked"
};
const _hoisted_18$6 = { class: "uk-thumbnail-caption" };
const _hoisted_19$6 = ["onClick"];
const _hoisted_20$5 = {
  key: 0,
  class: "img-checked"
};
const _hoisted_21$5 = { class: "uk-thumbnail-caption" };


var script$v = {
  __name: 'MediaFiles',
  props: {
    condition: Object,
    mediaManagerSetup: Object,
    addFiles: {
        type: Boolean,
        default: true,
    },
    openUploadTrigger: {
        type: Number,
        default: 0,
    },
    extraUploadMenuItems: {
        type: Array,
        default: () => [],
    },
},
  emits: ['selected-media','folders-changed','upload-menu-action'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const showUpload = ref(false);
const showCreateFolder = ref(false);
const foldername = ref();
const showDirSelect = ref(false);

const props = __props;


const emit = __emit;

const mm = new MediaManager(props.mediaManagerSetup);

// Anzeigefilter für Dateiauswahl
if (props.condition) {
    if (props.condition.accept?.contentType) {
        mm.setResources(acceptArray(props.condition.accept.contentType));
    }
    if (props.condition.accept?.modules) {
        mm.setMediaFilter(acceptArray(props.condition.accept.modules));
    }
    if (props.condition.browse) {
        mm.setBrowse(props.condition.browse);
    }
}

mm.onImagesReceived = (images) => {
    images.forEach((el) => {
            if (el.action) execImageAction(el.action, el);
        });
};

// Aus nicht bekanntem Grund können die refs aus der Klasse nicht direkt im Template verwendet werden,
// da die reaktivität sonst nicht geht. Deshalb so:

const folderList = mm.folderList;
const mediaList = mm.mediaList;
const imageList = mm.imageList;
mm.selectedItems;
mm.folder;
const copyMove = mm.copyMove;

const currentDirs = computed (() => {
    let cp = mm.folder.value.currentPath?.split("/"); 
        cp[0] = t('mediaFiles.inbox');
    return cp
  }
);

//window.mm = mm

onBeforeMount(async () => {
   
    mm.loadAll();

    watch (mm.folder,() => {
        emit("folders-changed");
    },{deep:true});

    watch (mm.selectedItems,(si) => {
       if (si.length == 0) showDirSelect.value = false;
       emit("selected-media", mm.selectedItems.value);
    });

    watch(() => props.openUploadTrigger, () => {
        showUpload.value = true;
    });
});

onUnmounted(() => {
    mm.close();
});

function execImageAction(action, el) {

    const act =  Object.keys(action);

    act.forEach((a) => {
        logger.info(`execute action ${a} for image ${el.name}`);
         switch (a) {
            case "setSelectedState":
                mm.selectItem(el);
                break;
        }
    });  

}

function onUpload() {
   // getImages()
}

function onUploadMenuAction(menuItem) {
    if (menuItem?.action == 'open-gallery') {
        showUpload.value = false;
    }
    emit('upload-menu-action', menuItem);
}

function createFolder (name) {

    mm.createFolder(name);
    showCreateFolder.value = false;
    foldername.value = "";
}

function goTo(depth) {
  
    let newPath = currentDirs.value.slice(0,depth + 1);
    newPath[0] = "";

    let pathString = newPath.join("/");
    if (pathString[0] != "/") pathString = "/" + pathString;

    logger.info(`set path ${pathString}`);
    mm.setPath(pathString);

}

let time = null;

function singleClickSelect(item, index) {
     // first clear  time
      clearTimeout(time);
      time = setTimeout(() => {
        mm.selectItem(item, index);
      }, 300); 
    }

function doubleClick(item, index) {
      clearTimeout(time);  
      mm.enterDir(item, index);
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    (props.condition?.browse!='none')
      ? (openBlock(), createElementBlock("div", _hoisted_1$s, [
          createElementVNode("span", _hoisted_2$n, [
            createElementVNode("ul", _hoisted_3$k, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(currentDirs.value, (dir, depth) => {
                return (openBlock(), createElementBlock("li", null, [
                  createElementVNode("a", {
                    href: "#",
                    style: {"font-size":"1.5em"},
                    onClick: $event => (goTo(depth))
                  }, toDisplayString$1(dir), 9 /* TEXT, PROPS */, _hoisted_4$i)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ]))
      : createCommentVNode("v-if", true),
    (props.addFiles!==false)
      ? (openBlock(), createElementBlock("div", _hoisted_5$g, [
          createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => (showUpload.value = !showUpload.value)),
            class: "toggle-upload uk-button uk-button-default uk-button-primary"
          }, [
            createElementVNode("i", {
              "uk-icon": `icon: ${(showUpload.value)?'minus':'plus'}`
            }, null, 8 /* PROPS */, _hoisted_6$d),
            _cache[4] || (_cache[4] = createTextVNode(" ")),
            _cache[5] || (_cache[5] = createElementVNode("i", { "uk-icon": "icon: image" }, null, -1 /* HOISTED */))
          ]),
          createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = $event => (showCreateFolder.value = !showCreateFolder.value)),
            class: "toggle-upload uk-button uk-button-default"
          }, [
            createElementVNode("i", {
              "uk-icon": `icon: ${(showCreateFolder.value)?'minus':'plus'}`
            }, null, 8 /* PROPS */, _hoisted_7$c),
            _cache[6] || (_cache[6] = createTextVNode(" ")),
            _cache[7] || (_cache[7] = createElementVNode("i", { "uk-icon": "icon: folder" }, null, -1 /* HOISTED */))
          ])
        ]))
      : createCommentVNode("v-if", true),
    createVNode(unref(Collapse), {
      when: showCreateFolder.value,
      class: "expand"
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_8$b, [
          createElementVNode("div", null, toDisplayString$1(_ctx.$t('gallery.createFolderTitle')) + " " + toDisplayString$1(foldername.value), 1 /* TEXT */),
          withDirectives(createElementVNode("input", {
            class: "uk-input new-folder-name",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((foldername).value = $event)),
            placeholder: _ctx.$t('gallery.folderName')
          }, null, 8 /* PROPS */, _hoisted_9$b), [
            [vModelText, foldername.value]
          ]),
          createElementVNode("button", {
            class: "uk-button uk-button-default uk-button-primary",
            onClick: _cache[3] || (_cache[3] = $event => (createFolder(foldername.value)))
          }, toDisplayString$1(_ctx.$t('gallery.create')), 1 /* TEXT */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["when"]),
    createVNode(unref(Collapse), {
      when: showUpload.value,
      class: "expand upload-container"
    }, {
      default: withCtx(() => [
        createVNode(script$y, {
          uploadSuccessAction: {setSelectedState:1},
          extraMenuItems: props.extraUploadMenuItems,
          onMenuAction: onUploadMenuAction,
          onOnUpload: onUpload
        }, null, 8 /* PROPS */, ["extraMenuItems"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["when"]),
    createElementVNode("div", _hoisted_10$b, [
      createElementVNode("div", _hoisted_11$b, [
        (unref(mediaList).length == 0 && unref(imageList).length == 0)
          ? (openBlock(), createBlock(unref(script$H), {
              key: 0,
              delay: "1000",
              content: _ctx.$t('gallery.addFile'),
              arrow: "arrow-top-left"
            }, null, 8 /* PROPS */, ["content"]))
          : createCommentVNode("v-if", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(folderList), (item, index) => {
          return (openBlock(), createElementBlock("div", {
            key: index,
            class: normalizeClass(["folder", { selected: item.selected }]),
            "data-oid": item.oid,
            onClick: $event => (singleClickSelect(item,index)),
            onDblclick: $event => (doubleClick(item, index))
          }, [
            (item.selected)
              ? (openBlock(), createElementBlock("div", _hoisted_13$a, [...(_cache[8] || (_cache[8] = [
                  createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
                ]))]))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_14$8, [
              createElementVNode("div", null, [
                createElementVNode("a", {
                  href: "#",
                  onClick: withModifiers($event => (unref(mm).enterDir(item, index)), ["stop"])
                }, toDisplayString$1(item.translatedName), 9 /* TEXT, PROPS */, _hoisted_15$8)
              ])
            ])
          ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_12$b))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(mediaList), (item, index) => {
        return (openBlock(), createElementBlock("div", {
          key: index,
          class: normalizeClass(["uk-thumbnail image", { selected: item.selected }]),
          "data-jid": item.jid,
          onClick: $event => (unref(mm).selectItem(item, index))
        }, [
          (item.selected)
            ? (openBlock(), createElementBlock("div", _hoisted_17$6, [...(_cache[9] || (_cache[9] = [
                createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
              ]))]))
            : createCommentVNode("v-if", true),
          createElementVNode("div", {
            class: normalizeClass(["gallery-item media", (unref(copyMove).idList?.indexOf(item['@type'] + ':' +  item.id)>-1)?'cut':'']),
            style: normalizeStyle(`background-image:url(${unref(imgsource)(item, 'th')})`)
          }, null, 6 /* CLASS, STYLE */),
          createElementVNode("div", _hoisted_18$6, [
            createElementVNode("div", null, toDisplayString$1(item.name), 1 /* TEXT */),
            createElementVNode("div", null, toDisplayString$1(item.jid), 1 /* TEXT */)
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_16$7))
      }), 128 /* KEYED_FRAGMENT */)),
      (openBlock(true), createElementBlock(Fragment, null, renderList(unref(imageList), (item, index) => {
        return (openBlock(), createElementBlock("div", {
          key: index,
          class: normalizeClass(["uk-thumbnail image", { selected: item.selected }]),
          onClick: $event => (unref(mm).selectItem(item, index))
        }, [
          (item.selected)
            ? (openBlock(), createElementBlock("div", _hoisted_20$5, [...(_cache[10] || (_cache[10] = [
                createElementVNode("i", { "uk-icon": "icon: check" }, null, -1 /* HOISTED */)
              ]))]))
            : createCommentVNode("v-if", true),
          createElementVNode("div", {
            class: normalizeClass(["gallery-item image", (unref(copyMove).idList?.indexOf(item['@type'] + ':' +  item.id)>-1)?'cut':'']),
            style: normalizeStyle(`background-image:url(${unref(imgsource)(item, 'th')})`)
          }, null, 6 /* CLASS, STYLE */),
          createElementVNode("div", _hoisted_21$5, [
            createElementVNode("div", null, toDisplayString$1(item.name), 1 /* TEXT */),
            createElementVNode("div", null, toDisplayString$1(item.bid), 1 /* TEXT */)
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_19$6))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$v.__scopeId = "data-v-714bdcba";
script$v.__file = "src/components/MediaFiles.vue";

var script$u = {
  __name: 'InfoBubble',
  props: {
    info: String,
    style: String
},
  setup(__props) {


const props = __props;

const sessionStore = useSessionStore();
const authStore = useAuthStore();
const { cart } = storeToRefs(sessionStore);
const { user } = storeToRefs(authStore);

sessionStore.normalizeCart();

const cartItems = computed(() => Array.isArray(cart.value) ? cart.value : (cart.value?.items || []));

const isLoggedIn = computed(() => Boolean(user.value?.token || user.value?.kid));

function getInitialFromValue(value) {
    const normalized = String(value || '').trim();
    if (!normalized) return '';
    return normalized.charAt(0).toUpperCase();
}

const accountInitials = computed(() => {
    if (!isLoggedIn.value) return '';

    const firstName = String(user.value?.firstname || user.value?.firstName || '').trim();
    const lastName = String(user.value?.lastname || user.value?.lastName || '').trim();
    const fromNames = `${getInitialFromValue(firstName)}${getInitialFromValue(lastName)}`.trim();
    if (fromNames) return fromNames;

    const username = String(user.value?.username || '').trim();
    if (username) {
        const parts = username.split(/\s+/).filter(Boolean);
        if (parts.length >= 2) {
            return `${getInitialFromValue(parts[0])}${getInitialFromValue(parts[1])}`;
        }
        return username.slice(0, 2).toUpperCase();
    }

    const email = String(user.value?.email || '').trim();
    if (email) {
        return email.slice(0, 2).toUpperCase();
    }

    return '';
});



return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    (props.info == 'cart' && cartItems.value.length > 0)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          style: normalizeStyle(props.style),
          class: normalizeClass(["pp-info-bubble", props.info])
        }, toDisplayString$1(cartItems.value.length), 7 /* TEXT, CLASS, STYLE */))
      : createCommentVNode("v-if", true),
    (props.info == 'account' && accountInitials.value)
      ? (openBlock(), createElementBlock("div", {
          key: 1,
          style: normalizeStyle(props.style),
          class: normalizeClass(["pp-info-bubble", props.info])
        }, toDisplayString$1(accountInitials.value), 7 /* TEXT, CLASS, STYLE */))
      : createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$u.__file = "src/components/InfoBubble.vue";

var script$t = {
  __name: 'CartInfo',
  props: {
    style: String
},
  setup(__props) {


const props = __props;

const sessionStore = useSessionStore();
const { cart } = storeToRefs(sessionStore);
const { t, locale } = useI18n();

sessionStore.normalizeCart();

const cartItems = computed(() => Array.isArray(cart.value) ? cart.value : (cart.value?.items || []));

const cartTotal = computed(() => cartItems.value.reduce((sum, element) => sum + element.priceCalc.current, 0));

const formattedCartTotal = computed(() => {
    const formatter = new Intl.NumberFormat(locale.value, { style: 'currency', currency: 'EUR' });
    return formatter.format(cartTotal.value);
});


return (_ctx, _cache) => {
  return (cartItems.value.length > 0)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        style: normalizeStyle(props.style),
        class: "pp-cart-infobox"
      }, toDisplayString$1(unref(t)('cartInfo.summary', { count: cartItems.value.length, value: formattedCartTotal.value })), 5 /* TEXT, STYLE */))
    : createCommentVNode("v-if", true)
}
}

};

script$t.__file = "src/components/CartInfo.vue";

/*
*  VICI (Vector Image Composer Interface)
*
*  Erstellen und Editieren von Vectorgrafiken die mittels svg.js erzeugt werden
*  Mithilfe der Printopt Class können alle verfügbaren Druck-/Randoptionen von
*  photodruck erzeugt werden
*/


class Vici {

    constructor(setup, media) {

        // Unique Id für DOM Referezen bei mehreren Instanzen
        this.id = 'vici' + uniqueId();

        // Größe der Ansicht. Größe des ganzen SVGs wird dem gleichgesetzt, kann aber
        // mittels doc.size auch größer gewählt werden. Die Ansicht wird dann zentriert
        // zu doc.size gesetzt
        this.size = [260, 260];

        // Anzahl Seiten
        this.pages = 1;
        this.pagelabel = {};
        this.currentPage = 1;

        // Edit Mode
        this.interactive = 1;
        if (setup?.interactive === false) this.interactive = 0;

        // id des ausgewählten mediums (aus der Liste "media")
        this.mediaId = 0;

        // InnerSize ist die größe des eigentlichen Print SVGs (ohne äußeres Doco SVG)
        // Diese Größe kann unabhängig gesetzt werden.Sie wird durch skalierung an das
        // äußere SVG angepasst. Wichtig ist eine außreichende Größe, da beim import
        // in threejs diese größe die Auflösung bestimmt        
        this.innerSize = [500, 500];

        // Skalierungsfaktor vom inneren SVG zu Orginalgröße. Wird automatisch gesetzt.
        // mit disem Faktor können alle Werte des SVGs in Orginal-Formatgröße umgerechnet werden
        this.originalScale = [1, 1];

        // die größe soll auf das seitenverhältnis des Formats angepasst werden
        this.crop = true;

        // Die Dokumentengröße soll auf inhalt beschnitten werden
        this.cropToFormat = false;

        // Animation true/false
        this.animate = true;

        // Vorschafläche auf die die Voransicht gemapped wird
        // wird im Äußeren SVG angelegt (this.svg)
        this.previewMap = {};

        // Exportfilter ignoriert angegebene Elemente beim Export mit Attribut "display" = "<filter>[-..]"
        // Der String vor dem ersten "-" ist auschlaggebend. z.B. der Trim-Rahmen, der nur bei der Vorschau
        // angezeigt werden soll, hat das Attribut display="preview-trim" und wird somit mit dem exportFilter 
        // "preview" nicht exportiert 
        this.exportFilter = ["preview"];

        // Text als foreignObject (XHTML) rendern 
        this.renderTextAsHTML = true;

        //Id's editierbarer Texte
        this.editableTexts = ref({});

        // Status der Textelemente (static,edit)
        this.textStates = reactive({});


        if (typeof setup.crop != "undefined") this.crop = setup.crop;
        this.doc = {
            origin: [0, 0],
            size: [...this.size]
        };

        this.svg = false;
        this.elements = [];
        this.selectedElement = false;


        if (!Array.isArray(media)) media = [media];
        this.media = media;
        this.setup = setup;
        if (!this.setup.imgResource) this.setup.imgResource = "th";
        this.printOpt = new Printopt();

        if (setup.size) this.size = setup.size;
        else if (setup.doc?.size) {
            this.size = [...setup.doc.size];
        }

        if (setup.doc && setup.doc.size) {
            this.doc.size = [...setup.doc.size];
        } else if (setup.size) {
            this.doc.size = [...setup.size];
        }

        if (!setup.doc || !setup.doc.origin) {
            this.doc.origin = this.calcOrigin(this.size, this.doc.size);
        }

        if (this.setup.pages) this.pages = this.setup.pages;
        if (this.setup.pagelabel) this.pagelabel = this.setup.pagelabel;

        this.initialSetup = {
            size: this.size,
            innerSize: this.innerSize
        };


        this.innerScale = Math.max(...this.innerSize) / Math.max(...this.size);

        this.tool = new ViciTools(this);

    }

    setMedia(media,animate) {

        if (!Array.isArray(media)) media = [media];

        let changed = false;
        this.media.forEach((m,i) => {
            if (m["@id"] != media[i]["@id"]) {
                changed = true;
                return
            }
        });

        this.media = media;

        // Nur bei geänderten Medien neu rendern

        if (changed) {
            let that = this;
            // Alle elemente mit Nutzerbildern rendern
            this.elements.filter((el) => el.userimage).forEach((el) => {
                that.renderElement(el,animate);            
            }); 
        }
    }

    mediaurl(id, resource) {


        const mediaObject = this.getMediaObject(id);
        useConfigStore();

        if (!mediaObject?.resourceUrl) return "";
        // TODO Svg Anzeige immer norm? 
        if (!resource || mediaObject.bintyp == "SVG") resource = "orig";

        return mediasource(mediaObject,resource)
    }

    getMediaObject(id) {

        if (typeof id == "undefined") id = 0;

        let mediaObject = {};

        if (typeof id === 'object') ; else {
            mediaObject = this.media[id];
        }
        return mediaObject
    }
    render(config) {

        logger.debug("vici: render start");

        var promiseResolve;

        this.loaded = new Promise(function (resolve, reject) {
            promiseResolve = resolve;
        });
        this.promiseResolve = promiseResolve;

        if (config) this.config = config;

        if (this.setup.preset == "printopt") {
            this.readSetup();
            if (this.config.method == "vic") {
                if (!this.loadVic()) return false
            } else {
                if (!this.loadPrintopt()) return false
            }
        }
        this.createDocument();
        this.addBorderLayout();
        this.renderElements();
        this.selectedElement = this.selectElementByName("userimage-1");

        logger.debug("vici: render finished");
        return true
    }

    update(config) {

        logger.debug("vici: render update");

        // reset to initial setup before applying printopt
        this.size = this.initialSetup.size;
        this.innerSize = this.initialSetup.innerSize;
        this.innerScale = Math.max(...this.innerSize) / Math.max(...this.size);

        if (config) this.config = config;

        if (this.setup.preset == "printopt") {
            this.readSetup();
            this.updatePrintopt();
            this.addBorderLayout();

        }

        // Elemente werden einzeln über sette Function gerendert
        //this.renderElements()

    }

    updatePrintopt() {
        if (typeof (this.setup.domNode) == "string") {
            var dn = document.querySelector(this.setup.domNode);
        } else {
            dn = this.setup.domNode;
        }

        if (dn) this.svg.addTo(this.setup.domNode);
        if (!this.selectedElement) this.selectedElement = this.selectElementByName("userimage-1");

        if (!this.calcPrintopt()) return false

        const pm = this.config.previewMap;
        if (pm) {
            if (this.previewMap?.id != pm.id) this.setPreviewMap(pm);
        } else {
            this.resetInnerViewbox();
        }

        return true
    }


    setDocumentSize() {
        const config = this.config;
        if (config.previewMap?.size) {
            this.doc.size = this.fitin(config.previewMap.size, this.doc.size);
        } else if (config.format) {
            // Unterscheidung zwischen printopt-calculation oder VIC-Dokument
            if (this.po) this.doc.size = this.fitin(this.po.coordTargetPrint(), this.doc.size);
            else if (this.vic.header.size) this.doc.size = this.fitin(this.vic.header.size, this.doc.size);
        }
    }

    selectElementByName(name) {

        if (!this.elements.find) return
        return this.elements.find((e) => e.name == name)

    }

    loadVic() {
        let mediaObj = this.media[this.mediaId].obj;
        if (!mediaObj?.type == "vic") {
            logger.warn("Object not in VIC Format");
            return false
        }
        if (typeof mediaObj.vic == "string") {
            try {
                this.vic = JSON.parse(mediaObj.vic);
            } catch (error) {
                logger.error("Error during parse of VIC Object");
            }
        } else {
            this.vic = mediaObj.vic;
        }

        // Dokumentenheader einlesen
        // TODO check size against selected format

        let vicDocSize = this.vic.header.size;
        this.innerSize = this.fitin(vicDocSize, this.innerSize);
        this.format = [
            vicDocSize[0] - this.vic.header.trim[0] * 2,
            vicDocSize[1] - this.vic.header.trim[1] * 2
        ];
        this.formatTrim = this.vic.header.trim;

        // Elemente einlesen
        this.elements = [];
        this.vic.elements.forEach((elem) => {
            let scaledElem = {};
            for (var p in elem) {
                scaledElem[p] = this.toInnerSize(elem, p);
            }
            this.elements.push(this.createElement(scaledElem));
        });

        let overlay = { type: "path", name: "trim-overlay", fillColor: { rgb: [228, 228, 228, 128] }, display: "preview-trim" };
        this.elements.push(this.createElement(overlay));
        let scaledVicDocSize = this.toInnerSize(vicDocSize, null, 2);
        this.setTrimOverlay({ w: scaledVicDocSize[0], h: scaledVicDocSize[1] }, this.toInnerSize(this.vic.header.trim, null, 2));

        this.originalScale = [
            scaledVicDocSize[0] / vicDocSize[0],
            scaledVicDocSize[1] / vicDocSize[1]
        ];

        if (this.crop) {
            this.size = this.fitin(this.innerSize, this.size);
        }

        if (this.cropToFormat) {
            this.setDocumentSize();
        }
        return true
    }

    loadPrintopt(config) {

        // Allgemeine Elementdefinition für printopt Dokument

        this.elements = [
            this.createElement({ type: "rect", name: "background", fillColor: { rgb: [255, 255, 255] } }),
            this.createElement({ type: "rect", name: "userimage-1" }),
            this.createElement({ type: "path", name: "border", fillColor: { rgb: [255, 255, 255] } }),
            this.createElement({ type: "path", name: "trim-overlay", fillColor: { rgb: [228, 228, 228, 128] }, display: "preview-trim" })
        ];

        if (config) this.config = config;
        if (!this.selectedElement) this.selectedElement = this.selectElementByName("userimage-1");

        if (!this.calcPrintopt()) return false

        if (this.cropToFormat) {
            this.setDocumentSize();
        }

        return true
    }

    createElement(parameter) {
        let param = { _parent: this, ...parameter };
        return new ViciElement(param)
    }

    hasUserimage() {
        if (!this.elements) return false
        if (this.selectElementByName("userimage-1")) return true
        return false
    }
    /** Alle Elemente neu rendern und watcher anlegen*/
    renderElements() {

        let result = false;

        this.elements.forEach((elem) => {
            result = this.renderElement(elem);
            if (result) watch(elem, (elem) => {
                this.renderElement(elem);
            });
        });
    }

    renderElement(elem,animate) {

        if (!this.draw) return

        logger.debug("vici: render Element " + elem.name + " " + this.animate);

        var response = false;

        switch (elem.type) {
            case "rect": return this.rect(elem,animate)
            case "path": return this.path(elem,animate)
            case "text": return this.text(elem,animate)
            case "g": return this.group(elem,animate)
        }

        return response
    }

    rect(elem,animate) {

        if (typeof(animate) == "undefined") animate = this.animate;

        let svg_el = elem._svgjs;
        let elemSize = elem.getSize();
        if (!elem._svgjs) {
            elem._svgjs = this.draw.rect(...elemSize);
        } else {
            svg_el = elem._svgjs;
            if (animate) svg_el = elem._svgjs.animate();
            svg_el.size(...elemSize);
        }
        elem._svgjs.fill(elem.getFillColorHex()).move(...elem.getPos());

        if (elem.transform) {
            //const tr = elem.transform

            // const svgtr = {}
            // if (isObject(tr)) {
            //     for (const [key, value] of Object.entries(tr)) {
            //         svgtr[key]
            //       }
            // }
            elem._svgjs.transform(elem.transform);
        }

        // Bei Bedarf Bild anlegen
        if (elem.userimage) {
            const eu = elem.userimage;
            let imgurl = this.mediaurl(this.mediaId, this.setup.imgResource);
            if (elemSize[0] == 0 || elemSize[1] == 0) imgurl = "";

            // Clippath erstellen falls Clip definiert
            let ecs = elem.getImageClipSize();
            let ecp = elem.getImageClipPos();

            if (ecs !== null) {
                if (!elem.userimage._clippath) eu._clippath = {};
                if (!eu._clippath._svgjs) {
                    eu._clippath._svgjs = this.draw.rect(...ecs);
                } else {
                    let svg_el = eu._clippath._svgjs;
                    if (animate) svg_el = eu._clippath._svgjs.animate();
                    svg_el.size(...ecs);
                }
                eu._clippath._svgjs.move(...ecp);
            } else {
                eu._clippath = null;
            }
            eu._clippath = null;
            if (!eu._svgjs) {
                eu._svgjs = this.draw.image(imgurl, () => { this.promiseResolve(); });
                if (eu._clippath?._svgjs) eu._svgjs.clipWith(eu._clippath._svgjs);
                eu._svgjs.size(...elem.getSize()).move(...elem.getPos());
                if (this.interactive) eu._svgjs.draggable();

                eu._svgjs.on('dragmove.namespace', (evt) => this.onMove(evt, elem));
                eu._svgjs.on('dragend.namespace', (evt) => {
                    if (typeof this.onChangeEnd == "function") this.onChangeEnd();
                });
                //eu._svgjs.on('dragmove.namespace', (evt) => this.watchConstraints(evt))
            } else {
                eu._svgjs.load(imgurl, () => { this.promiseResolve(); });
                svg_el = eu._svgjs;
                if (animate) svg_el = eu._svgjs.animate();
                svg_el.size(...elem.getSize()).move(...elem.getPos());
            }
            if (elem.transform) {
                eu._svgjs.transform(elem.transform);
            }


        }

        return elem._svgjs

    }

    text(elem,animate) {

        if (typeof(animate) == "undefined") animate = this.animate;

        const editId = elem.getEditId();
        if (!elem._state) {
            // Zustand auf editor setzen
            this.editableTexts.value = this.replace(this.editableTexts.value, editId, "empty");
            return this.htmlText(elem)
        } else if (elem._state == "editor") {
            this.editableTexts.value = this.replace(this.editableTexts.value, editId, "editor");
            return this.htmlText(elem)
        }

        // Wenn Text ein Objekt von Quill-Editor, dann zu TextGroup()
        if (elem.contents?.ops) return this.textGroup(elem)

        let svg_el = elem._svgjs;
        let elemSize = elem.getSize();
        if (!elem._svgjs) {
            elem._svgjs = this.draw.rect(...elemSize);
        } else {
            svg_el = elem._svgjs;
            if (animate) svg_el = elem._svgjs.animate();
            svg_el.size(...elemSize);
        }
        elem._svgjs.fill(elem.getFillColorHex()).move(...elem.getPos());

        if (elem.transform) {
            elem._svgjs.transform(elem.transform);
        }

        return elem._svgjs
    }


    textGroup(elem) {

        if (elem._svgjs && elem._svgjs.type != "g") {
            elem._svgjs.clear();
            elem._svgjs = false;
        }
        if (!elem._svgjs) {
            elem._svgjs = this.draw.group();
        }

        const editId = elem.getEditId();

        // editableTexts wird von vidge überwacht (watcher)
        // so kann auf den den jeweiligen Zustand reagiert werden
        // inhalt ist der text "static" oder das conent Objekt des Editors 

        this.editableTexts.value = this.replace(this.editableTexts.value, editId, "static");

        elem._svgjs.node.id = editId + "_static";

        elem._svgjs.move(...elem.getPos());

        if (elem.transform) {
            elem._svgjs.transform(elem.transform);
        }

        if (!Array.isArray(elem.textElements)) return false

        let gb = elem.geometricBounds;

        // Check overflow lowest element
        let bottom = -100;
        let fontsize = 0;
        elem.textElements.forEach((tel) => {
            let bounds = tel.geometricBounds;
            if (bounds[3] > bottom) {
                bottom = bounds[3];
                fontsize = tel.fontsize;
                if (typeof fontsize == "string") fontsize = parseInt(tel.fontsize.replace("px", ""));
            }
        });
        let moveToAlignBottom = 0;
        let baslineshift = 0.36;   // TODO Baselineverschiebung für Font konfigurieren
        if (elem.verticalAlign == "bottom") {
            moveToAlignBottom = gb[3] - gb[1] - bottom + 1 - (fontsize * baslineshift);
        }

        elem.textElements.forEach((tel) => {
            let t = elem._svgjs.text().plain(tel.contents);

            //  geometricBounds der textElements sind relativ zu elem.geometricBounds
            let bounds = tel.geometricBounds;
            let textFormat = tel.getTextFormat(tel);

            t.font({ family: "Helvetica", size: 13 })
                .attr({ x: (gb[0] + bounds[0]), y: (gb[1] + bounds[3] + moveToAlignBottom) });  // y Koordinate von Text ist bottom der Boundingbox

            if (textFormat.fill) {
                t.fill(textFormat.fill);
                delete textFormat.fill;
            }

            t.font(textFormat);

            const decoration = textFormat.decoration || tel.textdecoration;
            if (decoration) {
                t.attr({ "text-decoration": String(decoration).trim() });
            }

        });

    }

    htmlText(elem) {


        let elemSize = elem.getSize();
        const editId = elem.getEditId();

        // Statische Texte löschen
        if (elem._svgjs) {
            elem._svgjs.clear();
        }

        if (!elem._svgjs_html) {
            elem._svgjs_html = this.draw.foreignObject(...elemSize).attr({ id: elem.name });
            const textdiv = document.createElement("div");
            textdiv.setAttribute("id", editId);
            textdiv.style.width = "100%";
            textdiv.style.height = "100%";
            textdiv.style.overflow = "hidden";
            //SVG(`<body xmlns="http://www.w3.org/1999/xhtml" style="font-family: Amadeus; font-size: 20px">${elem.contents}</body>`)
            elem._svgjs_html.add(textdiv);
        }


        elem._svgjs_html.fill(elem.getFillColorHex()).move(...elem.getPos());
        return elem._svgjs_html
    }



    onMove(evt, elem) {

        let pos = [evt.target.x.baseVal.value, evt.target.y.baseVal.value];

        elem.setPos(pos, { animate: false, skipRender: true });
        if (typeof this.onChange == "function") this.onChange();
    }

    group(elem) {

    }

    path(elem,animate) {

        if (typeof(animate) == "undefined") animate = this.animate;

        if (!elem._svgjs) {
            elem._svgjs = this.draw.path(elem.path);
        }
        elem._svgjs.attr({ fill: elem.getFillColorHex() });
        if (animate) elem._svgjs.animate().plot(elem.path).move(...elem.getPos());
        else elem._svgjs.plot(elem.path).move(...elem.getPos());
        return elem._svgjs
    }

    createDocument() {

        if (typeof (this.setup.domNode) == "string") {
            var dn = document.querySelector(this.setup.domNode);
        } else {
            dn = this.setup.domNode;
        }
        if (dn) dn.innerHTML = '';


        this.svg = SVG().size(this.doc.size[0], this.doc.size[1]).viewbox(0, 0, this.doc.size[0], this.doc.size[1]);
        if (dn) this.svg.addTo(this.setup.domNode);

        // Es wird ein geschachteltes SVG angelegt
        // Im Outer SVG können Zusätzliche Hintergründe etc angelegt werden
        // das eigentliche Bild ist das nested svg "draw"

        this.previewMap._svgjs = this.svg.group({ id: 'previewMap' });

        this.draw = this.svg.nested().attr({ preserveAspectRatio: "xMinYMin meet", id: `${this.id}_main-print`, width: this.size[0], height: this.size[1] });


        // Vorschauoption, wenn Bild auf Objekt gemapped werden soll
        const pm = this.config.previewMap;
        if (pm) {
            // Mit Vorschauoption wird die PreviewMap ins äußere SVG
            this.setPreviewMap(pm);
        } else {
            // Falls keine Vorschauoption, wird das innere SVG zentriert
            const viewBoxSize = this.fitin(this.size, [this.doc.size[0] * this.innerScale, this.doc.size[1] * this.innerScale]);
            this.draw.viewbox(0, 0, viewBoxSize[0], viewBoxSize[1]);
            this.draw.move(...this.calcOrigin(this.size, this.doc.size));
        }

        // idx.img.node.on('dragmove.namespace', (evt) => this.watchConstraints(evt))
        // idx.img.node.on('dragend.namespace', (evt) => {
        //     if (typeof this.onChange == "function") this.onChange() 
        // })

    }


    watchConstraints(event) {

        const { handler, box } = event.detail;
        event.preventDefault();

        const constraints = this.constraints;

        let { x, y } = box;

        // objekt kleiner als constraints => objekt innerhalb grenzen bewegen
        // wenn objekt größer als constraint => außerhalb grenzen bewegen
        let xsmall = (box.w < constraints[2] - constraints[0]);
        let ysmall = (box.h < constraints[3] - constraints[1]);

        if (xsmall && x < constraints[0] || !xsmall && x > constraints[0]) {
            x = constraints[0];
        }

        if (ysmall && y < constraints[1] || !ysmall && y > constraints[1]) {
            y = constraints[1];
        }

        if (xsmall && box.x2 > constraints[2] || !xsmall && box.x2 < constraints[2]) {
            x = constraints[2] - box.w;
        }

        if (ysmall && box.y2 > constraints[3] || !ysmall && box.y2 < constraints[3]) {
            y = constraints[3] - box.h;
        }

        handler.move(x, y);

    }


    setPreviewMap(previewMap) {

        this.elements;

        if (this.previewMap._svgjs) {
            this.clearPreviewMap();
        }

        this.previewMap.id = previewMap.id;

        let ds = this.doc.size;

        if (previewMap.background) {
            this.previewMap._svgjs.image(this.getImgUrl(previewMap.background)).size(...ds);
        }

        let fittedSize = this.fitin(previewMap.size, ds);
        let scale = fittedSize[0] / previewMap.size[0];
        let pm = previewMap.map;

        let vbScale = this.innerSize[0] / previewMap.map[2];

        let viewBox = [0, 0, previewMap.map[2] * vbScale, previewMap.map[3] * vbScale];
        let pos = [(ds[0] - fittedSize[0]) / 2 + pm[0] * scale, (ds[1] - fittedSize[1]) / 2 + pm[1] * scale];

        this.draw.viewbox(viewBox).attr({ width: previewMap.map[2] * scale, height: previewMap.map[3] * scale }).move(...pos);

        return


    }

    getImgUrl(src) {
        // in production den relativen Pfad nehmen (modul liegt dann in assets, sodass ../ ins app-root führt)
        let rel = "";
        if (process.env.NODE_ENV == 'production') rel = '..';
        return new URL(rel + src, import.meta.url).href
    }

    clearPreviewMap() {

        this.previewMap._svgjs.lastElementChild;
        if (this.previewMap._svgjs) {
            this.previewMap._svgjs.children().forEach(child => {
                child.remove();
            });
        }
        delete this.previewMap.id;

    }

    resetInnerViewbox() {

        if (!this.draw) return

        if (this.previewMap._svgjs) this.clearPreviewMap();
        const viewBoxSize = this.fitin(this.size, [this.doc.size[0] * this.innerScale, this.doc.size[1] * this.innerScale]);
        if (this.animate) {
            this.draw.animate()
                .viewbox(0, 0, viewBoxSize[0], viewBoxSize[1])
                .attr({ width: this.size[0], height: this.size[1] })
                .move(...this.calcOrigin(this.size, this.doc.size));
        } else {
            this.draw.viewbox(0, 0, viewBoxSize[0], viewBoxSize[1])
                .attr({ width: this.size[0], height: this.size[1] })
                .move(...this.calcOrigin(this.size, this.doc.size));
        }
    }


    updateImage(resource,animate) {

        if (typeof(animate) == "undefined") animate = this.animate;

        let set = this.elements.img.set;
        let imgurl = this.mediaurl(0, resource);
        if (animate) this.elements.img.node.load(imgurl).animate().size(...set.size).move(...set.pos);
        else this.elements.img.node.load(imgurl).animate().size(...set.size).move(...set.pos);
    }

    readSetup() {

        const po = this.printOpt;

        po.reset_opt();

        const setupRoot = this.config.product?.setup;
        const setup = setupRoot?.data || setupRoot;
        if (!setup || typeof setup != "object") return

        if (setup.orientation == "fixed") po.autoOrientation = false;
        else po.autoOrientation = true;

        if (typeof setup.printopt != "object") return

        for (var m in setup.printopt) {
            const methodDef = setup.printopt[m];

            // Array-Definitionen ersetzen die komplette Methode in der Printopt-Klasse.
            if (Array.isArray(methodDef)) {
                po.setOptDefinition(m, toRaw(methodDef));
                continue
            }

            po.opt(m, methodDef);
        }

    }

    calcPrintopt() {

        const po = this.printOpt;
        const mo = this.getMediaObject();

        if (this.config.format) var format = this.config.format;
        if (this.config.method) var method = this.config.method;

        if (!Array.isArray(format) || format.length < 2) {
            if (mo.width && mo.height) {
                format = [mo.width, mo.height];
            } else {
                format = this.innerSize;
            }
        }
        this.format = format;

        if (method) po.method = method;
        po.resize = Math.max(...this.innerSize);
        po.setTrimmm(format[0], format[1]);
        if (Array.isArray(this.config.imgSize)) po.setImgpx(this.config.imgSize[0], this.config.imgSize[1]);
        else if (mo.width && mo.height) po.setImgpx(mo.width, mo.height);
        else po.setImgpx(format[0], format[1]);


        let fit = po.calc();
        if (fit === false) {
            logger.warn("stopping because of previous error");
            return false
        }

        let cTFormat = po.coordTargetFormat();
        po.coordTargetFit(false);
        let cTFit = po.coordTargetFit("overflow");
        let cTPrint = po.coordTargetPrint();

        this.bleedBox = [cTPrint.x, cTPrint.y, cTPrint.w, cTPrint.h];
        this.trimBox = [cTFormat.x, cTFormat.y, cTFormat.w, cTFormat.h];

        // "formatDisplay" ist das Druckformat (nach Beschnitt) gedreht in
        // der Ausrichtung in der das Dokument gerade angezeigt wird
        if (po.orientation == "L") {
            this.formatDisplay = [Math.max(...format), Math.min(...format)];
        } else {
            this.formatDisplay = format;
        }

        // Anschnitt in Einheiten der Formatangabe direkt aus Definition
        this.formatTrim = [
            po.appliedOpt[2][0] + po.appliedOpt[2][1] * this.formatDisplay[0],
            po.appliedOpt[2][0] + po.appliedOpt[2][1] * this.formatDisplay[1],
        ];
        // Skalierungsfaktor zum Orginaldokument
        this.originalScale = [
            cTFit.w / (this.formatDisplay[0] + this.formatTrim[0] * 2),
            cTFit.h / (this.formatDisplay[1] + this.formatTrim[1] * 2)
        ];

        this.coordTargetFormat = cTFormat;
        this.coordTargetPrint = cTPrint;
        this.trim = fit.trimborder;

        this.po = po;

        if (this.crop) {
            this.innerSize = [cTPrint.w, cTPrint.h];
            this.size = this.fitin(this.innerSize, this.size);
        }

        const origin = this.calcOrigin([cTPrint.w, cTPrint.h], this.innerSize);


        // Hintergrund -----------------------------------

        const bg = this.selectElementByName("background");
        bg.set({
            geometricBounds: [
                origin[0],
                origin[1],
                origin[0] + cTPrint.w,
                origin[1] + cTPrint.h
            ]
        });

        // -----------------------------------------------

        // var pattern = group.pattern(20, 20, function(add) {
        //   add.rect(20, 20).fill('#fff')
        //   add.rect(10, 10)
        //   add.rect(10, 10).move(10, 10)
        // })

        // Aktives Element (Bild) ---------------

        let selElementPar = {
            geometricBounds: [
                origin[0] + cTFit.x,
                origin[1] + cTFit.y,
                origin[0] + cTFit.x + cTFit.w,
                origin[1] + cTFit.y + cTFit.h,
            ]
        };

        if (!this.selectedElement.userimage) this.selectedElement.userimage = {};
        this.selectedElement.userimage;

        // selElementPar.userimage = {
        //         x: cTFitClipped.x - cTFit.x,
        //         y: cTFitClipped.y - cTFit.y,
        //         fitwidth: cTFitClipped.w,
        //         fitheight: cTFitClipped.h
        //         }

        selElementPar.userimage = {};

        this.selectedElement.set(selElementPar);

        // Border -----------------------------

        let pb = po.printborder;

        let borderX = cTPrint.w - pb[0] * 2;
        let borderY = cTPrint.h - pb[1] * 2;

        const outerBorder = `M0 0 h${cTPrint.w} v${cTPrint.h} h-${cTPrint.w}z`;
        const innerBorder = `M${pb[0]} ${pb[1]} v${borderY} h${borderX} v-${borderY}z`;

        const border = this.selectElementByName("border");
        border.set({
            path: `${outerBorder} ${innerBorder}`,
            position: [...origin]
        });


        // Beschnittanzeige -------------------

        this.setTrimOverlay(cTPrint, fit.trimborder);

        // --------------------------------

        this.constraints = this.selectedElement.geometricBounds;

        return true

    }

    addBorderLayout() {

        const appliedOpt = this.po?.appliedOpt;

        this.svg.find('#document-border').forEach((el) => { el.remove(); });
        if (!appliedOpt || appliedOpt[3] < 2) {
            return 0
        }

        // appliedOpt[3] > 1 bedeutet Spezielle Randoption wie mirror (2) oder stretch (3)
        const group = this.svg.group({ id: 'document-border' });

        let trimXScaled = this.trim[0] / this.innerScale;
        let trimYScaled = this.trim[1] / this.innerScale * 1.025; // small factor fix gegen Blitzer TODO: bessere Lösung ???
        let offsetX = (this.doc.size[0] - this.size[0]) / 2;
        let offsetY = (this.doc.size[1] - this.size[1]) / 2;
        let borderX = trimXScaled;
        let borderY = trimYScaled;
        let scaleX = 1;
        let scaleY = 1;
        let translateXL = 0;
        let translateYT = 0;
        let translateXR = 0;
        let translateYB = 0;


        if (appliedOpt[3] == 2) {
            // mirror
            borderX = trimXScaled;  //* 1.025 // small factor fix gegen Blitzer TODO: bessere Lösung ???
            borderY = trimYScaled; //* 1.025 // small factor fix gegen Blitzer TODO: bessere Lösung ???
            scaleX = -1;
            scaleY = -1;

            translateXL = 2 * borderX + offsetX;
            translateXR = this.doc.size[0] - trimXScaled - offsetX;
            translateYT = 2 * borderY + offsetY;
            translateYB = this.doc.size[1] - trimYScaled - offsetY;

        } else if (appliedOpt[3] == 3) {
            // stretch
            borderX = trimXScaled; //* 1.025 // small factor fix gegen Blitzer TODO: bessere Lösung ???
            borderY = trimYScaled; //* 1.025 // small factor fix gegen Blitzer TODO: bessere Lösung ???
            scaleX = 100;
            scaleY = 100;

            translateXL = -scaleX * (borderX + offsetX);
            translateXR = -scaleX * (this.doc.size[0] - trimXScaled - offsetX) * .999;

            translateYT = -scaleY * (borderY + offsetY);
            translateYB = -scaleX * (this.doc.size[1] - trimYScaled - offsetY) * .999;

        }

        let trans_string = "";

        // Linker Rand -----------------------------------------
        let borderLeftAttr = {
            preserveAspectRatio: "xMinYMin slice",
            id: "svg-left",
            width: borderX,
            height: this.doc.size[1] + "px",
            x: offsetX
        };

        trans_string = `translate(${translateXL},0) scale(${scaleX},1)`;

        const borderLeft = group.nested().attr(borderLeftAttr);
        borderLeft.use({ href: `#${this.id}_main-print`, transform: trans_string });

        // Rechter Rand -----------------------------------------

        let borderRightAttr = {
            preserveAspectRatio: "xMinYMin slice",
            id: "svg-right",
            width: borderX,
            height: this.doc.size[1] + "px",
            x: this.doc.size[0] - trimXScaled - offsetX
        };

        trans_string = `translate(${translateXR},0) scale(${scaleX},1)`;

        const borderRight = group.nested().attr(borderRightAttr);
        borderRight.use({ href: `#${this.id}_main-print`, transform: trans_string });

        // Oberer Rand -----------------------------------------
        let borderTopAttr = {
            preserveAspectRatio: "xMinYMin slice",
            id: "svg-top",
            width: this.doc.size[0] + "px",
            height: borderY,
            y: offsetY
        };

        trans_string = `translate(0,${translateYT}) scale(1,${scaleY})`;

        const borderTop = group.nested().attr(borderTopAttr);
        borderTop.use({ href: `#${this.id}_main-print`, transform: trans_string });

        // Unterer Rand -----------------------------------------
        let borderBottomAttr = {
            preserveAspectRatio: "xMinYMin slice",
            id: "svg-bottom",
            width: this.doc.size[0] + "px",
            height: borderY,
            y: this.doc.size[1] - trimYScaled - offsetY
        };

        trans_string = `translate(0,${translateYB}) scale(1,${scaleY})`;

        const borderBottom = group.nested().attr(borderBottomAttr);
        borderBottom.use({ href: `#${this.id}_main-print`, transform: trans_string });

    }

    setTrimOverlay(cTPrint, trimborder) {

        let trimx = cTPrint.w - trimborder[0] * 2;
        let trimy = cTPrint.h - trimborder[1] * 2;

        this.doc.trimx = trimx;
        this.doc.trimy = trimy;

        const outer = `M0 0 h${cTPrint.w} v${cTPrint.h} h-${cTPrint.w}z`;
        const inner = `M${trimborder[0]} ${trimborder[1]} v${trimy} h${trimx} v-${trimy}z`;

        const overlay = this.selectElementByName("trim-overlay");
        overlay.set({
            path: `${outer} ${inner}`,
            position: [...origin]
        });

    }

    mask() {


        // Testexample SVG.js
        // see: https://jsfiddle.net/qstarx/vz6jw8p2/
        //
        // var draw = SVG().addTo('body').size(400, 300)
        // var rect = draw.rect(390, 290).fill('#fff').move(5, 5)
        // const outer = "M0 0 h400 v300 h-400z"
        // const inner = "M5 5 v290 h390 v-290z"

        // var image = draw.image('https://static.wixstatic.com/media/bb1bd6_f221ad0f4d6f4103bf1d37b68b04492e~mv2.png')
        // image.size(400, 300).move(0, 0)
        // var mask = draw.path(`${inner} ${outer}`).attr({ fill: '#fff',opacity:0.5 })
    }

    calcOrigin(sourceSize, targetSize) {

        this.origin = [
            (targetSize[0] - sourceSize[0]) / 2,
            (targetSize[1] - sourceSize[1]) / 2
        ];

        return this.origin
    }

    fitin(sourceSize, targetSize, opt) {

        const fittedSize = [];

        let sSize = [];

        if (Array.isArray(sourceSize)) sSize = sourceSize;
        else {
            if (sourceSize["width"] && sourceSize["height"]) sSize = [sourceSize["width"], sourceSize["height"]];
            if (sourceSize["w"] && sourceSize["h"]) sSize = [sourceSize["w"], sourceSize["h"]];
            else return []
        }

        if (!sSize[0] || !sSize[1] || !targetSize[0] || !targetSize[1]) return fittedSize

        if (sSize[0] / sSize[1] > targetSize[0] / targetSize[1]) {
            fittedSize[0] = targetSize[0];
            fittedSize[1] = sSize[1] / sSize[0] * fittedSize[0];
        } else {
            fittedSize[1] = targetSize[1];
            fittedSize[0] = sSize[0] / sSize[1] * fittedSize[1];
        }

        if (opt?.output == "scale") return fittedSize[0] / sourceSize[0]

        return fittedSize
    }

    setGrid(elem, grid) {

        if (!this.gridcount) this.gridcount = 0;
        this.gridcount++;

        if (!elem._bindings) elem._bindings = [];

        const size = elem.getSize();
        const pos = elem.getPos();
        const gridId = '_grid-' + this.gridcount;
        const groupElem = this.draw.group({ id: gridId, name: 'grid' });

        elem._bindings.push(groupElem);

        const dy = size[1] / grid[0];
        const dx = size[0] / grid[1];

        for (let i = 1; i < grid[0]; i++) {
            groupElem.line(pos[0], pos[1] + i * dy, pos[0] + size[0], pos[1] + i * dy).stroke({ width: 1, color: '#eee' });
        }
        for (let i = 1; i < grid[1]; i++) {
            groupElem.line(pos[0] + i * dx, pos[1], pos[0] + i * dx, pos[1] + size[1]).stroke({ width: 1, color: '#eee' });
        }

        return elem

    }

    unsetGrid(elem) {

        if (!elem._bindings) return

        let i = 0;
        elem._bindings.forEach((bel) => {
            if (bel.id().split("-")[0] == "_grid") {
                bel.remove();
                elem._bindings.splice(i, 1);
            }
            i++;
        });

        return elem
    }

    exportDocument(options) {

        const doc = { header: {}, elements: [] };
        this.export = {
            size: "print"
        };
        if (this.export.size == "print") {
            doc.header["size"] = this.toPrintSize(this.innerSize, null, 2);
            doc.header["trim"] = this.formatTrim;
        } else {
            doc.header["size"] = this.innerSize;
            doc.header["trim"] = this.trim;
        }
        doc.elements = this.exportElements();

        return doc
    }

    exportElements() {

        const elementsExport = [];

        this.elements.forEach((elem) => {
            let display = elem.display;
            if (display && this.exportFilter.includes(display.split("-")[0])) {
                return
            }
            elementsExport.push(this.exportElement(elem));
        });

        return elementsExport
    }

    exportElement(elem) {

        const elemExport = {};

        for (var p in elem) {
            if (p.substring(0, 1) != "_") {
                if (typeof elem[p] == "object" && !Array.isArray(elem[p])) {
                    elemExport[p] = this.exportElement(elem[p]);
                } else {
                    elemExport[p] = elem[p];
                    if (this.export.size == "print") {
                        elemExport[p] = this.toPrintSize(elem, p);
                    }
                }
            }
        }
        return elemExport
    }

    toPrintSize(elem, name, type) {

        if (!this.formatDisplay) this.formatDisplay = [...this.format];

        let scaleX = (this.formatDisplay[0] + this.formatTrim[0] * 2) / this.innerSize[0];
        let scaleY = (this.formatDisplay[1] + this.formatTrim[1] * 2) / this.innerSize[1];

        return this.scaleParameter(elem, name, type, scaleX, scaleY)
    }

    toInnerSize(elem, name, type) {
        if (!this.formatDisplay) this.formatDisplay = [...this.format];

        let scaleX = this.innerSize[0] / this.vic.header.size[0];
        let scaleY = this.innerSize[1] / this.vic.header.size[1];

        return this.scaleParameter(elem, name, type, scaleX, scaleY)
    }

    scaleParameter(elem, name, type, scaleX, scaleY) {

        let data = null;
        let tempPath = "";
        let pathData = "";
        let scaledPathObject = "";

        if (name) data = elem[name];
        else data = elem;

        if (name) type = this.getTypeByName(name);
        if (!type) return data


        switch (type) {
            case 2:
                return [
                    data[0] * scaleX,
                    data[1] * scaleY
                ]
            case 3:
            case 4:
                return [
                    data[0] * scaleX,
                    data[1] * scaleY,
                    data[2] * scaleX,
                    data[3] * scaleY,
                ]
            case 10:
                // getPathData() ist ein polyfill mit dem ein SVG Pfad geparsed werden kann
                // Damit kann der Pfad skaliert werden und über einen temporären path-node
                // wieder in einen Pfad String umgewandelt werden 
                tempPath = document.createElementNS(
                    'http://www.w3.org/2000/svg',
                    'path'
                );
                pathData = "";
                if (elem._svgjs?.node) {
                    pathData = elem._svgjs.node.getPathData();
                } else {
                    tempPath.setAttribute("d", data);
                    pathData = tempPath.getPathData();
                }

                scaledPathObject = this.scalePathData(pathData, scaleX, scaleY);

                tempPath.setPathData(scaledPathObject);
                return tempPath.getAttribute("d")


        }

    }

    getTypeByName(name) {

        /* Types: 1: Einzelner wert gilt für x und y
                  2: Ortsvektor (x,y)
                  3: Ortsvektor mit Größe (x,y,width,height)
                  4: Doppelvektor (x1,y1,x2,y2)
                  10: Pfad
        */
        const typeDef = {
            geometricBounds: 4,
            geometricBoundsBase: 4,
            position: 2,
            path: 10
        };

        if (!typeDef[name]) return false

        return typeDef[name]

    }

    scalePathData(pathData, scaleX, scaleY) {
        let pathDataScaled = [];
        pathData.forEach((com) => {
            let [type, values] = [com.type, com.values];
            let typeL = type.toLowerCase();
            let valuesL = values.length;
            let valsScaled = [];

            switch (typeL) {
                case "a":
                    pathDataScaled.push({
                        type: type,
                        values: [
                            values[0] * scaleX,
                            values[1] * scaleY,
                            values[2],
                            values[3],
                            values[4],
                            values[5] * scaleX,
                            values[6] * scaleY
                        ]
                    });
                    break;

                case "h":
                    pathDataScaled.push({
                        type: type,
                        values: [values[0] * scaleX]
                    });
                    break;

                case "v":
                    pathDataScaled.push({
                        type: type,
                        values: [values[0] * scaleY]
                    });
                    break;
                case "z":
                    pathDataScaled.push(com);
                    break;

                default:
                    if (valuesL) {
                        valsScaled = [];
                        for (let i = 0; i < values.length; i += 2) {
                            let x = values[i] * scaleX;
                            let y = values[i + 1] * scaleY;
                            valsScaled.push(x, y);
                        }
                        pathDataScaled.push({
                            type: type,
                            values: valsScaled
                        });
                    }
            }
        });
        return pathDataScaled;
    }

    setTextState(textId, state) {

        let elem = this.elements.find(e => e._editId === textId);
        if (!elem) return false

        elem.setState(state);

    }

    processText(textId, contents, textElements) {

        let elem = this.elements.find(e => e._editId === textId);
        if (!elem) return false
        if (!Array.isArray(textElements)) return false

        elem.contents = contents;
        elem.textElements = [];
        textElements.forEach((tel) => {
            elem.textElements.push(new ViciElement(tel));
        });



    }

    replace(obj, key, value) {

        // ändert einen Wert eine Objekts, taucht aber dabei das ganze Objekt
        // Mit dieser Vorgehensweise kann ein Watcher oldval und newval erfassen

        let newval = { ...obj };
        newval[key] = value;

        return newval
    }

}

const _hoisted_1$r = { class: "size-tool" };


var script$s = {
  __name: 'Resize',
  props: {
    vici: Object
},
  emits: ["tool-event"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const size = ref(props.vici.selectedElement.getOriginalSize());
const ratio = size.value[0] / size.value[1];

function sizeChanged(s) {
    emit("tool-event", "Resize", "setOriginalSize", s);
}

function xSizeChanged(xs) {
    size.value = [xs, xs / ratio];
    sizeChanged(size.value);
}

function ySizeChanged(ys) {
    size.value = [ys * ratio, ys];
    sizeChanged(size.value);
}

function sizeChangeEnd() {
    emit("tool-event", "Resize", "changeEnd");
}



return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$r, [
    _cache[0] || (_cache[0] = createElementVNode("div", { class: "tool-title" }, "Motivgröße:", -1 /* HOISTED */)),
    _cache[1] || (_cache[1] = createTextVNode(" Breite ")),
    createVNode(unref(script$p), {
      name: "size",
      min: "0",
      max: "1000",
      "step-size": "10",
      setup: { rulerHeight: 400 },
      value: size.value[0],
      onOnchange: xSizeChanged,
      onSlideEnd: sizeChangeEnd
    }, null, 8 /* PROPS */, ["value"]),
    _cache[2] || (_cache[2] = createTextVNode(" Höhe ")),
    createVNode(unref(script$p), {
      name: "size",
      min: "0",
      max: "1000",
      "step-size": "10",
      setup: { fade: true, show: { tics: 0, triangle: 1 }, rulerHeight: 400 },
      value: size.value[1],
      onOnchange: ySizeChanged,
      onSlideEnd: sizeChangeEnd
    }, null, 8 /* PROPS */, ["value"])
  ]))
}
}

};

script$s.__file = "src/bundles/vidge/components/Resize.vue";

const _hoisted_1$q = { class: "vector-tool" };


var script$r = {
  __name: 'Vectorize',
  props: {
    step: Number,
    threshhold: Number,
    blur: Number
},
  emits: ["tool-event"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const threshhold = ref(props.threshhold);
const blur = ref(props.blur);


emit("tool-event", "Vectorize", "setImgFilter", { threshhold: threshhold.value, blur: blur.value });
watch([threshhold, blur], ([th, bl]) => {
    emit("tool-event", "Vectorize", "setImgFilter", { threshhold: threshhold.value, blur: blur.value });
});

onUnmounted(() => {
    emit("tool-event", "Vectorize", "unsetImgFilter");
});

function vectFinish() {
    emit("tool-event", "Vectorize", "vectFinish", {}, { loader: true });
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$q, [
    _cache[2] || (_cache[2] = createElementVNode("div", { class: "tool-title" }, "Vektorisieren", -1 /* HOISTED */)),
    _cache[3] || (_cache[3] = createElementVNode("label", { for: "threshhold" }, "Schwellwert:", -1 /* HOISTED */)),
    _cache[4] || (_cache[4] = createTextVNode("  ")),
    withDirectives(createElementVNode("input", {
      style: {"width":"180px"},
      min: "0",
      max: "100",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((threshhold).value = $event)),
      class: "uk-range",
      type: "range"
    }, null, 512 /* NEED_PATCH */), [
      [vModelText, threshhold.value]
    ]),
    _cache[5] || (_cache[5] = createElementVNode("br", null, null, -1 /* HOISTED */)),
    _cache[6] || (_cache[6] = createElementVNode("label", { for: "blur" }, "Unschärfe:", -1 /* HOISTED */)),
    _cache[7] || (_cache[7] = createTextVNode("  ")),
    withDirectives(createElementVNode("input", {
      style: {"width":"180px"},
      min: "0",
      max: "20",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((blur).value = $event)),
      class: "uk-range",
      type: "range"
    }, null, 512 /* NEED_PATCH */), [
      [vModelText, blur.value]
    ]),
    _cache[8] || (_cache[8] = createElementVNode("br", null, null, -1 /* HOISTED */)),
    createElementVNode("div", { style: {"margin-top":"10px"} }, [
      createElementVNode("button", {
        onClick: vectFinish,
        class: "uk-button uk-button-default uk-button-small uk-button-primary"
      }, " fertigstellen ")
    ])
  ]))
}
}

};

script$r.__file = "src/bundles/vidge/components/Vectorize.vue";

const _hoisted_1$p = { class: "angle-tool" };


var script$q = {
  __name: 'AdjustAngle',
  props: {
    vici: Object
},
  emits: ["tool-event"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const angle = ref(props.vici.selectedElement.getRotation());

function angleChanged(angle) {
    emit("tool-event", "AdjustAngle", "setAngle", angle);
}

function slideStart(e) {
    emit("tool-event", "AdjustAngle", "setGrid");
}
function slideEnd(e) {
    emit("tool-event", "AdjustAngle", "unsetGrid");
    emit("tool-event", "AdjustAngle", "changeEnd");
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$p, [
    _cache[0] || (_cache[0] = createElementVNode("div", { class: "tool-title" }, "Motivausrichtung:", -1 /* HOISTED */)),
    _cache[1] || (_cache[1] = createTextVNode(" Winkel ")),
    createVNode(unref(script$p), {
      name: "size",
      min: "-90",
      max: "90",
      "step-size": "1",
      setup: { rulerHeight: 600, precision: 1 },
      value: angle.value,
      onOnchange: angleChanged,
      onSlide: slideStart,
      onSlideEnd: slideEnd
    }, null, 8 /* PROPS */, ["value"])
  ]))
}
}

};

script$q.__file = "src/bundles/vidge/components/AdjustAngle.vue";

const _hoisted_1$o = { class: "input-ruler" };
const _hoisted_2$m = ["value"];
const _hoisted_3$j = { class: "ruler-pointer" };
const _hoisted_4$h = ["width", "height"];
const _hoisted_5$f = { key: 0 };
const _hoisted_6$c = ["points"];
const _hoisted_7$b = ["y1", "x2", "y2"];
const _hoisted_8$a = ["points"];
const _hoisted_9$a = ["y1", "x2", "y2"];
const _hoisted_10$a = { class: "ruler" };
const _hoisted_11$a = ["width", "height"];
const _hoisted_12$a = ["x1", "y1", "x2", "y2"];
const _hoisted_13$9 = ["points"];

const rulerWinExpandedHeight = 96;
const rulerWinCollapsedHeight = 27;
// Länge der kurzen/langen Tickmarks
const yPadding = 2;

const rulerStrokeWidth = 0.5;

// eslint-disable-next-line no-unused-vars

var script$p = {
  __name: 'SelectRuler',
  props: {
    min: [Number, String],
    max: [Number, String],
    stepSize: [Number, String],
    value: [Number, String],
    setup: Object
},
  emits: ["onchange", "slide", "slide-end"],
  setup(__props, { emit: __emit }) {

const ticLength = [5, 10];
// Abstand des ersten Tickmarks zum rand
let precision = 0;

const { x, y } = useMouse();
const { pressed } = useMousePressed();
const mode = ref("collapsed");
const tics = ref({});
const rulerHeight = ref(210);
const rulerWidth = ref(20);
const rulerSVG = ref(null);
const rulerWinHeight = ref(rulerWinCollapsedHeight);
const rulerWinWidth = ref(20);
const rulerWinMargin = ref(0);

let ruler = ref({ input: 0 });

let rulerScale = 1;
let rulerMin = 0;
let rulerMax = 100;
let step = 1;
const show = {
    tics: true,
    triangle: false
};

const props = __props;

// Auswertung props

if (props.min != null) rulerMin = parseFloat(props.min);
if (props.max != null) rulerMax = parseFloat(props.max);
if (props.stepSize != null) step = parseFloat(props.stepSize);
if (props.value != null) ruler.value = { input: parseFloat(props.value), event: false };
if (props.setup?.rulerHeight) rulerHeight.value = props.setup?.rulerHeight;
if (typeof props.setup?.show?.tics != "undefined") show.tics = props.setup.show.tics;
if (typeof props.setup?.show?.triangle != "undefined") show.triangle = props.setup.show.triangle;
if (typeof props.setup?.precision != "undefined") precision = props.setup.precision;

watch(() => props.value, () => {
    // Um event loops zu vermeiden wird die Herkunft des Events mitgesendet
    // das Objekt "ruler" hat dazuz den key "input" für den Wert des input Feldes und 
    // den key "event" für zusätzliche Informationen zum Event.
    // Hier kommt der wert aus den props, also vom parent
    ruler.value = { input: parseFloat(props.value), event: { from: "parent" } };
});

const emit = __emit;

function createTics(min, max, step, len) {

    rulerMin = min;
    rulerMax = max;

    const width = rulerWidth.value;
    const height = rulerHeight.value;
    const xoff = [];

    // Zehnerpotenz der Schrittweite ermitteln
    let stepTenth = 10 ** (step.toString().length);

    let y = yPadding;
    let dist = (height - 2 * yPadding) / (max - min) * step;
    xoff[1] = (width - len[1]) / 2;
    len[2] = (len[0] + len[1]) / 2;
    xoff[0] = xoff[1] + len[1] - len[0];
    xoff[2] = xoff[1] + len[1] - len[2];
    let ticmarks = [];
    let v = 0;

    rulerScale = (max - min) / (rulerHeight.value - 2 * yPadding);

    for (let i = min; i <= max; i = i + step) {
        if (i % stepTenth == 0) v = 1;
        else if (i % (stepTenth / 2) == 0) v = 2;
        else v = 0;

        ticmarks.push({
            x1: xoff[v],
            y1: y,
            x2: xoff[v] + len[v],
            y2: y,
            value: i
        });

        y = y + dist;
    }

    return ticmarks

}

tics.value = createTics(rulerMin, rulerMax, step, ticLength);

let unwatch = false;

let ryoff = 0;
let y0 = false;

function slide(e) {
    if (mode.value == "expanded") {
        // slide mode  already startet
        return
    }
    emit("slide", e);
    e.preventDefault();
    rulerWinHeight.value = rulerWinExpandedHeight;
    rulerWinMargin.value = -(rulerWinExpandedHeight - rulerWinCollapsedHeight) / 2;
    mode.value = "expanded";
    setRuler();
    y0 = false;
    let is_touch = false;
    unwatch = watch([y, pressed], ([my, mp]) => {
        // Bei touch events macht das erste Drag event einen großen positions-sprung
        // Daher folgende Vorgehensweise:
        // 1. am Anfang von slide wird y0 mit false initialisiert -> watch macht nichts außer y0 auf true setzen
        // 2. Durchgang: jetzt wurde drag gestartet. y0 mimmt die aktuelle Position an

        if (y0 === false) {
            y0 = true;
            // Wenn Mousebutton nicht gedrückt => touchevent
            if (!mp) is_touch = true;
            return
        }
        // Mousbutton an jeder Stelle des Fensters beobachten (nur wenn nicht touchevent)
        if (!mp && !is_touch) slideEnd();
        if (y0 === true) y0 = my;
        changeBy((y0 - my) * rulerScale);
        y0 = y.value;
    });
}

function slideEnd() {
    rulerWinMargin.value = 0;
    rulerWinHeight.value = rulerWinCollapsedHeight;
    mode.value = "collapsed";
    if (unwatch) {
        unwatch();
    }
    setRuler();
    emit("slide-end");
}

function changeBy(changeVal) {
    let correctedVal = Math.max(rulerMin, parseFloat(ruler.value.input) + changeVal);
    correctedVal = Math.min(rulerMax, correctedVal);
    // Hier kommt der Wert aus dem drag event
    ruler.value = { input: correctedVal, event: { from: 'ruler' } };
}

function setRuler() {

    ryoff = -(ruler.value.input - rulerMin) / rulerScale + (rulerWinHeight.value / 2 - yPadding);
    let ryoffString = ryoff + "px";
    rulerSVG.value.style.transform = `translate(0,${ryoffString})`;
}

function setInput(event) {
    // Hier kommt der Wert aus dem Eingabefeld
    ruler.value = { input: event.target.value, event: { from: 'input' } };
}

function precisionRound(num) {

    const factor = 10 ** precision;

    return Math.round(num * factor) / factor

}

onMounted(() => {
    setRuler();
    watch(() => ruler.value.input, (v) => {
        // emit an parent nur dann auslösen, wenn event nicht von parent
        if (ruler.value.event == false || ruler.value.event?.from != "parent") {
            emit("onchange", parseFloat(v));
        }
        setRuler();
    });
});


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$o, [
    createElementVNode("input", {
      value: precisionRound(unref(ruler).input),
      onChange: _cache[0] || (_cache[0] = $event => (setInput($event))),
      type: "text"
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2$m),
    createElementVNode("div", {
      class: normalizeClass(["ruler-container", mode.value]),
      style: normalizeStyle('width:' + rulerWinWidth.value + 'px;height:' + rulerWinHeight.value + 'px;margin-top:' + rulerWinMargin.value + 'px'),
      onMouseup: slideEnd,
      onTouchend: slideEnd,
      onMousedown: _cache[1] || (_cache[1] = $event => (slide($event))),
      onTouchstart: _cache[2] || (_cache[2] = $event => (slide($event)))
    }, [
      createElementVNode("div", _hoisted_3$j, [
        (openBlock(), createElementBlock("svg", {
          width: rulerWinWidth.value,
          height: rulerWinHeight.value,
          style: normalizeStyle('stroke-width:' + rulerStrokeWidth + ';')
        }, [
          (mode.value == 'collapsed')
            ? (openBlock(), createElementBlock("g", _hoisted_5$f, [
                createElementVNode("polygon", {
                  points: `6,${rulerWinHeight.value / 2 - 4} ${rulerWinWidth.value / 2},${rulerWinHeight.value / 2 - 10} ${rulerWinWidth.value - 6},${rulerWinHeight.value / 2 - 4}`,
                  stroke: "black",
                  "fill-opacity": "0"
                }, null, 8 /* PROPS */, _hoisted_6$c),
                createElementVNode("line", {
                  x1: 6,
                  y1: rulerWinHeight.value / 2,
                  x2: rulerWinWidth.value - 6,
                  y2: rulerWinHeight.value / 2,
                  stroke: "black"
                }, null, 8 /* PROPS */, _hoisted_7$b),
                createElementVNode("polygon", {
                  points: `6,${rulerWinHeight.value / 2 + 4} ${rulerWinWidth.value / 2},${rulerWinHeight.value / 2 + 10} ${rulerWinWidth.value - 6},${rulerWinHeight.value / 2 + 4}`,
                  stroke: "black",
                  "fill-opacity": "0"
                }, null, 8 /* PROPS */, _hoisted_8$a)
              ]))
            : createCommentVNode("v-if", true),
          (mode.value == 'expanded')
            ? (openBlock(), createElementBlock("line", {
                key: 1,
                x1: 2,
                y1: rulerWinHeight.value / 2,
                x2: rulerWinWidth.value - 2,
                y2: rulerWinHeight.value / 2,
                stroke: "blue"
              }, null, 8 /* PROPS */, _hoisted_9$a))
            : createCommentVNode("v-if", true)
        ], 12 /* STYLE, PROPS */, _hoisted_4$h))
      ]),
      (mode.value == 'expanded' && props.setup.fade)
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "overlay",
            style: normalizeStyle('width:' + rulerWinWidth.value + 'px;height:' + rulerWinHeight.value + 'px;')
          }, null, 4 /* STYLE */))
        : createCommentVNode("v-if", true),
      withDirectives(createElementVNode("div", _hoisted_10$a, [
        (openBlock(), createElementBlock("svg", {
          ref_key: "rulerSVG",
          ref: rulerSVG,
          width: rulerWidth.value,
          height: rulerHeight.value,
          style: normalizeStyle('stroke-width:' + rulerStrokeWidth + ';')
        }, [
          (show.tics)
            ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(tics.value, (tic, i) => {
                return (openBlock(), createElementBlock("line", {
                  x1: tic.x1,
                  y1: tic.y1,
                  x2: tic.x2,
                  y2: tic.y2,
                  key: i,
                  stroke: "black"
                }, null, 8 /* PROPS */, _hoisted_12$a))
              }), 128 /* KEYED_FRAGMENT */))
            : createCommentVNode("v-if", true),
          (show.triangle)
            ? (openBlock(), createElementBlock("polygon", {
                key: 1,
                points: `${rulerWidth.value},0 ${rulerHeight.value},${rulerHeight.value} 0,${rulerHeight.value}`,
                stroke: "black",
                fill: "black",
                "fill-opacity": "0.5"
              }, null, 8 /* PROPS */, _hoisted_13$9))
            : createCommentVNode("v-if", true)
        ], 12 /* STYLE, PROPS */, _hoisted_11$a))
      ], 512 /* NEED_PATCH */), [
        [vShow, mode.value == 'expanded']
      ])
    ], 38 /* CLASS, STYLE, NEED_HYDRATION */)
  ]))
}
}

};

script$p.__file = "src/bundles/vidge/components/SelectRuler.vue";

const STATIC_VIDGE_FONTS = [
    
];

function normalizeFontConfigCandidate(candidate) {
    if (!candidate || typeof candidate !== 'object') return null

    const key = String(candidate.key || '').trim();
    const family = String(candidate.family || '').trim();
    if (!key || !family) return null

    return {
        key,
        label: candidate.label || family,
        optionLabel: candidate.optionLabel || candidate.label || family,
        dropdownLabel: candidate.dropdownLabel || candidate.optionLabel || candidate.label || family,
        family,
        includeInToolbar: candidate.includeInToolbar !== false,
        includeInWhitelist: candidate.includeInWhitelist !== false,
        headingSizeFactor: candidate.headingSizeFactor,
        headingBaselineShiftFactor: candidate.headingBaselineShiftFactor
    }
}

function resolveRuntimeFonts() {
    const runtimeConfig = typeof window !== 'undefined' ? window.__PP_SHOP_FONT_CONFIG__ : null;
    const runtimeFonts = Array.isArray(runtimeConfig?.fonts)
        ? runtimeConfig.fonts.map(normalizeFontConfigCandidate).filter(Boolean)
        : [];

    if (runtimeFonts.length > 0) {
        return runtimeFonts
    }

    return STATIC_VIDGE_FONTS
}

const VIDGE_FONTS = resolveRuntimeFonts();

const DEFAULT_HEADING_SIZE_FACTOR = { 1: 0.96, 2: 0.97, 3: 0.98 };
const DEFAULT_HEADING_BASELINE_SHIFT_FACTOR = { 1: 0.14, 2: 0.12, 3: 0.10 };

Object.fromEntries(VIDGE_FONTS.map((font) => [font.key, font]));
const fontByFamily = Object.fromEntries(VIDGE_FONTS.map((font) => [font.family, font]));

const VIDGE_FONT_KEYS = VIDGE_FONTS
    .filter((font) => font.includeInWhitelist !== false)
    .map((font) => font.key);

const VIDGE_FONT_MAP = Object.fromEntries(
    VIDGE_FONTS.map((font) => [font.key, font.family])
);

const VIDGE_TOOLBAR_FONTS = VIDGE_FONTS.filter((font) => font.includeInToolbar !== false);

function getHeadingSizeFactor(fontFamily, level) {
    const normalizedLevel = parseInt(level, 10);
    if (![1, 2, 3].includes(normalizedLevel)) return 1
    const font = fontByFamily[fontFamily];
    return font?.headingSizeFactor?.[normalizedLevel] || DEFAULT_HEADING_SIZE_FACTOR[normalizedLevel] || 1
}

function getHeadingBaselineShiftFactor(fontFamily, level) {
    const normalizedLevel = parseInt(level, 10);
    if (![1, 2, 3].includes(normalizedLevel)) return 0
    const font = fontByFamily[fontFamily];
    return font?.headingBaselineShiftFactor?.[normalizedLevel] || DEFAULT_HEADING_BASELINE_SHIFT_FACTOR[normalizedLevel] || 0
}

function getQuillFontCss(fonts = VIDGE_FONTS) {
    const lines = [];

    fonts.forEach((font) => {
        lines.push(`#toolbar-container .ql-font span[data-label="${font.dropdownLabel}"]::before { font-family: "${font.family}"; }`);
        lines.push(`.ql-font-${font.key}, .ql-font [data-value="${font.key}"] { font-family: "${font.family}"; }`);
    });

    return lines.join('\n')
}

const _hoisted_1$n = { className: "" };
const _hoisted_2$l = {
  class: "ql-formats",
  defaultValue: "opensans"
};
const _hoisted_3$i = { class: "ql-font wide" };
const _hoisted_4$g = ["value", "selected"];


var script$o = {
  __name: 'Qtoolbar',
  setup(__props) {

const toolbarFonts = VIDGE_TOOLBAR_FONTS;
const defaultFont = toolbarFonts.find((font) => font.key === 'opensans') || toolbarFonts[0];
const dynamicFontCss = computed(() => getQuillFontCss(toolbarFonts));


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$n, [
    _cache[0] || (_cache[0] = createElementVNode("div", { className: "ql-formats" }, [
      createElementVNode("select", {
        className: "ql-header",
        defaultValue: "0"
      }, [
        createElementVNode("option", { value: "0" }),
        createElementVNode("option", { value: "1" }),
        createElementVNode("option", { value: "2" }),
        createElementVNode("option", { value: "3" })
      ])
    ], -1 /* HOISTED */)),
    createElementVNode("div", _hoisted_2$l, [
      createElementVNode("select", _hoisted_3$i, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(toolbarFonts), (font) => {
          return (openBlock(), createElementBlock("option", {
            key: font.key,
            value: font.key,
            selected: font.key === unref(defaultFont)?.key
          }, toDisplayString$1(font.optionLabel), 9 /* TEXT, PROPS */, _hoisted_4$g))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _cache[1] || (_cache[1] = createElementVNode("div", { className: "ql-formats" }, [
      createElementVNode("select", { className: "ql-size" }, [
        createElementVNode("option", { value: "9px" }, "9px"),
        createElementVNode("option", { value: "10px" }, "10px"),
        createElementVNode("option", { value: "11px" }, "11px"),
        createElementVNode("option", { value: "12px" }, "12px"),
        createElementVNode("option", {
          selected: "",
          value: "13px"
        }, "13px"),
        createElementVNode("option", { value: "14px" }, "14px"),
        createElementVNode("option", { value: "16px" }, "16px"),
        createElementVNode("option", { value: "18px" }, "18px"),
        createElementVNode("option", { value: "20px" }, "20px"),
        createElementVNode("option", { value: "22px" }, "22px")
      ])
    ], -1 /* HOISTED */)),
    _cache[2] || (_cache[2] = createElementVNode("span", { className: "ql-formats" }, [
      createElementVNode("button", { className: "ql-bold" }),
      createElementVNode("button", { className: "ql-italic" }),
      createElementVNode("button", { className: "ql-underline" }),
      createElementVNode("button", { className: "ql-strike" })
    ], -1 /* HOISTED */)),
    _cache[3] || (_cache[3] = createElementVNode("span", { className: "ql-formats" }, [
      createElementVNode("select", { className: "ql-color" })
    ], -1 /* HOISTED */)),
    createCommentVNode(" <span className=\"ql-formats\">\n            <button className=\"ql-script\" value=\"sub\"></button>\n            <button className=\"ql-script\" value=\"super\"></button>\n        </span> "),
    _cache[4] || (_cache[4] = createElementVNode("span", { className: "ql-formats" }, [
      createElementVNode("button", {
        className: "ql-indent",
        value: "-1"
      }),
      createElementVNode("button", {
        className: "ql-indent",
        value: "+1"
      })
    ], -1 /* HOISTED */)),
    createCommentVNode(" <span className=\"ql-formats\">\n            <button className=\"ql-image\"></button>\n        </span> "),
    (openBlock(), createBlock(resolveDynamicComponent('style'), null, {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1(dynamicFontCss.value), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }))
  ]))
}
}

};

script$o.__file = "src/bundles/vidge/components/Qtoolbar.vue";

const _hoisted_1$m = { class: "qedit-shell" };
const _hoisted_2$k = ["viewBox"];
const _hoisted_3$h = ["x", "y", "width", "height"];
const _hoisted_4$f = ["x", "y"];
const _hoisted_5$e = { class: "qedit-debug-toolbar" };
const _hoisted_6$b = { class: "qedit-debug-summary" };


var script$n = {
  __name: 'Qedit',
  props: {
    toolbar: String,           // toolbar DOM Referenz
    content: [Boolean, Object], // Daten asu quill.getContents()
    state: String,
    placeholder: String,              // blur|focus|close Bei Änderung auf close wird Speichervorgang ausgelöst
    debugOverlay: Boolean,
    targetSize: Array
},
  emits: ["save", "renderSvg"],
  setup(__props, { emit: __emit }) {


const editorRef = ref();
const debugSegments = ref([]);
const debugOverlayActive = ref(false);
const isEditorFocused = ref(false);
const editorViewport = ref({
    left: 0,
    top: 0,
    width: 0,
    height: 0
});
const editorScale = ref({
    x: 1,
    y: 1,
    renderX: 1,
    renderY: 1,
    offsetX: 0,
    offsetY: -4,
    editorWidth: 0,
    editorHeight: 0
});

// Add fonts to whitelist
let Font = Quill.import('formats/font');
Font.whitelist = VIDGE_FONT_KEYS;
Quill.register(Font, true);

// Size List
var Size = Quill.import("attributors/style/size");
Size.whitelist = [
    "9px",
    "10px",
    "11px",
    "12px",
    "13px",
    "14px",
    "16px",
    "18px",
    "20px",
    "22px",
    "24px",
    "26px",
    "28px",
];
Quill.register(Size, true);

let qedit = false;

const props = __props;

let placeholderText = "Ihr Text";
if (props.placeholder) placeholderText = props.placeholder;

const emit = __emit;

watch(props.state, (state) => {
    if (state == "close") save();
    if (state == "focus" && qedit) {
        isEditorFocused.value = true;
        clearDebugOverlay();
        qedit.focus();
    }
    if (state == "blur" && qedit) {
        isEditorFocused.value = false;
        qedit.blur();
        if (props.debugOverlay) previewDebugOverlay();
    }
});

function createEditor() {

    var options = {
        modules: {
            toolbar: props.toolbar
        },
        placeholder: placeholderText,

        readOnly: false,
        theme: 'snow'
    };


    const quill = new Quill(editorRef.value, options);

    if (props.content) {
        quill.setContents(props.content);
    }

    updateEditorScale();

    quill.on("text-change", () => {
        clearDebugOverlay();
    });

    return quill
}

function save() {

    if (!qedit) return false
    const { contents, textDeltaCoords, vicElements } = collectTextGeometry();
    logger.debug(vicElements);

    if (props.debugOverlay) showDebugOverlay(textDeltaCoords);

    emit("save", contents, vicElements);

}

function renderSvg() {

    if (!qedit) return false
    const { contents, textDeltaCoords, vicElements } = collectTextGeometry();
    logger.debug(vicElements);

    showDebugOverlay(textDeltaCoords);

    emit("renderSvg", contents, vicElements);

}

function collectTextGeometry() {
    updateEditorScale();
    let contents = qedit.getContents();
    let textDeltaCoords = quillGetTextCoordinates();
    let vicElements = deltaCoordsToVic(textDeltaCoords);
    return { contents, textDeltaCoords, vicElements }
}

function previewDebugOverlay() {
    if (!qedit) return false
    updateEditorScale();
    const textDeltaCoords = quillGetTextCoordinates();
    showDebugOverlay(textDeltaCoords);
}

function clearDebugOverlay() {
    debugSegments.value = [];
    debugOverlayActive.value = false;
}

function updateEditorScale() {

    const shellRect = editorRef.value?.parentElement?.getBoundingClientRect?.();
    const editorNode = editorRef.value?.querySelector(".ql-editor");
    const rect = editorNode?.getBoundingClientRect?.();
    const layoutWidth = editorNode?.clientWidth || editorNode?.offsetWidth || rect?.width || 0;
    const layoutHeight = editorNode?.clientHeight || editorNode?.offsetHeight || rect?.height || 0;
    const targetWidth = Array.isArray(props.targetSize) ? props.targetSize[0] : 0;
    const targetHeight = Array.isArray(props.targetSize) ? props.targetSize[1] : 0;

    if (!layoutWidth || !layoutHeight || !targetWidth || !targetHeight) {
        editorViewport.value = {
            left: rect && shellRect ? rect.left - shellRect.left : 0,
            top: rect && shellRect ? rect.top - shellRect.top : 0,
            width: layoutWidth,
            height: layoutHeight
        };
        editorScale.value = {
            x: 1,
            y: 1,
            renderX: rect?.width && layoutWidth ? rect.width / layoutWidth : 1,
            renderY: rect?.height && layoutHeight ? rect.height / layoutHeight : 1,
            offsetX: 0,
            offsetY: -4,
            editorWidth: layoutWidth,
            editorHeight: layoutHeight
        };
        return editorScale.value
    }

    const scaleX = targetWidth / layoutWidth;

    // Fuer Text-Geometrie nur eine isotrope Skalierung verwenden.
    // Die Zielhoehe repraesentiert oft den gesamten Textrahmen, nicht die
    // reale Quill-Contenthoehe. Eine separate Y-Skalierung vergroessert sonst
    // die Zeilenabstaende im Export.
    const scaleY = scaleX;

    editorViewport.value = {
        left: rect && shellRect ? rect.left - shellRect.left : 0,
        top: rect && shellRect ? rect.top - shellRect.top : 0,
        width: layoutWidth,
        height: layoutHeight
    };

    editorScale.value = {
        x: scaleX,
        y: scaleY,
        renderX: rect?.width && layoutWidth ? rect.width / layoutWidth : 1,
        renderY: rect?.height && layoutHeight ? rect.height / layoutHeight : 1,
        offsetX: 0,
        offsetY: -4,
        editorWidth: layoutWidth,
        editorHeight: layoutHeight
    };

    return editorScale.value
}

function debugOverlayStyle() {
    return {
        left: `${editorViewport.value.left}px`,
        top: `${editorViewport.value.top}px`,
        width: `${editorViewport.value.width}px`,
        height: `${editorViewport.value.height}px`
    }
}

const debugSvgFrame = computed(() => {

    const targetWidth = Array.isArray(props.targetSize) ? props.targetSize[0] : 0;
    const fallbackWidth = Math.max(1, (editorScale.value.editorWidth || 1) * (editorScale.value.x || 1));
    const fallbackHeight = Math.max(1, (editorScale.value.editorHeight || 1) * (editorScale.value.y || 1));

    let minX = 0;
    let minY = Infinity;
    let maxX = targetWidth || fallbackWidth;
    let maxY = -Infinity;

    debugSegments.value.forEach((segment) => {
        const gb = segment.geometricBounds;
        if (!Array.isArray(gb) || gb.length < 4) return
        minY = Math.min(minY, gb[1]);
        maxY = Math.max(maxY, gb[3]);
    });

    if (!Number.isFinite(minY) || !Number.isFinite(maxY)) {
        minX = 0;
        minY = 0;
        maxX = fallbackWidth;
        maxY = fallbackHeight;
    }

    const yPadding = 2;
    minY -= yPadding;
    maxY += yPadding;

    return {
        minX,
        minY,
        width: Math.max(1, maxX - minX),
        height: Math.max(1, maxY - minY)
    }
});

function showDebugOverlay(deltaCoords) {

    const scale = updateEditorScale();

    debugSegments.value = deltaCoords.map((content, index) => {
        const bounds = normalizeBounds(content.bounds);

        return {
            id: `${index}-${content.text}`,
            text: content.text,
            bounds,
            geometricBounds: boundsToGeometricBounds(bounds),
            scale
        }
    }).filter((content) => {
        return content.bounds.width > 0 && content.bounds.height > 0
    });

    debugOverlayActive.value = debugSegments.value.length > 0;
}

function normalizeBounds(bounds) {

    if (!bounds || typeof bounds.left != "number" || typeof bounds.top != "number") {
        return {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            width: 0,
            height: 0
        }
    }

    const right = typeof bounds.right == "number" ? bounds.right : bounds.left + (bounds.width || 0);
    const bottom = typeof bounds.bottom == "number" ? bounds.bottom : bounds.top + (bounds.height || 0);

    return {
        left: bounds.left,
        top: bounds.top,
        right,
        bottom,
        width: typeof bounds.width == "number" ? bounds.width : right - bounds.left,
        height: typeof bounds.height == "number" ? bounds.height : bottom - bounds.top
    }
}

function quillGetTextCoordinates() {

    let spaces = splitQuillString();
    logger.debug(spaces);
    let lastpos = 0;
    let coords = [];
    spaces.forEach((pos) => {
        let length = pos - lastpos;
        let str = qedit.getText(lastpos, length);
        let textStart = lastpos;
        let textLength = length;

        // Fuehrende/trailing Whitespaces duerfen nicht in Bounds eingehen
        const leadingWhitespace = str.match(/^\s+/)?.[0].length || 0;
        const trailingChunk = str.match(/\s+$/)?.[0] || "";
        const trailingWhitespace = trailingChunk.length;
        textStart += leadingWhitespace;
        textLength -= leadingWhitespace + trailingWhitespace;

        // Zeilenumbrüche für die Inhaltsspeicherung entfernen
        let str_clean = qedit.getText(textStart, textLength).replace(/\r?\n|\r/g, "");
        if (textLength > 0 && str_clean != "") {
            const format = qedit.getFormat(textStart, textLength);

            // Fuer Unterstreichung/Strike den Zwischenraum als NBSP erhalten,
            // damit die Linie ueber Wortgrenzen visuell durchlaeuft.
            // Wichtig: splitQuillString trennt am ersten Whitespace, daher liegen
            // Zwischenraeume meist im naechsten Segment und nicht in trailingChunk.
            const hasTextDecoration = Boolean(format?.underline || format?.strike);
            if (hasTextDecoration) {
                let spacesToKeep = (trailingChunk.match(/[ \t]/g) || []).length;

                // Zusaetzlich Inline-Spaces direkt NACH dem Segment einsammeln
                // (typischer Fall bei Wort-Segmentierung).
                // Aber nur, wenn danach noch nicht-Whitespace Text mit gleicher
                // Formatierung kommt.
                let lookahead = pos;
                let lookaheadSpaces = 0;
                while (lookahead < qedit.getLength()) {
                    const ch = qedit.getText(lookahead, 1);
                    if (ch == " " || ch == "\t") {
                        lookaheadSpaces += 1;
                        lookahead += 1;
                        continue
                    }
                    break
                }
                
                // Nur die lookahead Spaces beibehalten, wenn danach noch Text 
                // mit gleicher Formatierung kommt
                if (lookaheadSpaces > 0 && lookahead < qedit.getLength()) {
                    const nextFormat = qedit.getFormat(lookahead, 1);
                    const nextHasUnderline = Boolean(nextFormat?.underline);
                    const nextHasStrike = Boolean(nextFormat?.strike);
                    
                    if ((format.underline && nextHasUnderline) || (format.strike && nextHasStrike)) {
                        spacesToKeep += lookaheadSpaces;
                    }
                }

                if (spacesToKeep > 0) {
                    str_clean += "\u00A0".repeat(spacesToKeep);
                }
            }

            coords.push({
                text: str_clean,
                bounds: qedit.getBounds(textStart, textLength),
                format
            });
        }
        lastpos = pos;
    });
    logger.debug(coords);

    return coords

}


function splitQuillString() {

    let splitIndex = [0];

    let str = qedit.getText();
    let bounds = qedit.getBounds(0, 1);
    let format = qedit.getFormat(0, 1);
    let y_last = Math.round(bounds.bottom * 10);
    let format_str_last = JSON.stringify(format);

    for (var i = 1; i < str.length; i++) {

        bounds = qedit.getBounds(i, 1);
        format = qedit.getFormat(i, 1);

        let y = Math.round(bounds.bottom * 10);
        let format_str = JSON.stringify(format);

        // Split bei whitespace
        if (str[i].match(/\s/)) {
            splitIndex.push(i);
            //  Split bei Zeilensprung
        } else if (y != y_last && splitIndex.at(-1) != i) {
            splitIndex.push(i);
            // Split bei Formatierungswechsel
        } else if (format_str_last != format_str && splitIndex.at(-1) != i) {
            splitIndex.push(i);
        }

        format_str_last = format_str;
        y_last = y;

    }

    if (splitIndex.at(-1) != str.length) splitIndex.push(str.length);

    return splitIndex

}

function deltaCoordsToVic(deltaCoords) {

    const elements = [];

    deltaCoords.forEach((content) => {

        if (typeof content.bounds?.left != "number") return false

        const textAttr = quillFormatToAttr(content.format);
        const baselineShiftY = getHeadingBaselineShift(content.format, textAttr);

        elements.push({
            type: "text",
            // Dieser fix war für Leerzeichenproblematiken in Quill-Texten nötig, da Quill getBounds für reine Leerzeichen nicht korrekt liefert.
            // Inzwischen werden Leerzeichen aber in quillGetTextCoordinates bereits getrimmt, so dass dieser Fix hier eigentlich nicht mehr nötig sein sollte. Sollte es aber doch nochmal Probleme mit Leerzeichen
            //contents: content.text.replace(" ", "\u00A0"),  // Leerzeichen durch fixed space Unicode Zeichen ersetzen
            contents: content.text,
            geometricBounds: boundsToGeometricBounds(content.bounds, baselineShiftY),
            ...textAttr
        });
    });

    return elements
}

function boundsToGeometricBounds(bounds, baselineShiftY = 0) {

    const scale = updateEditorScale();
    const renderX = scale.renderX || 1;
    const renderY = scale.renderY || 1;

    // Quill getBounds kann bei SVG/foreignObject-Skalierung Screen-Pixel liefern.
    // Mit renderX/renderY auf lokale Editor-Koordinaten zurückrechnen.
    const left = bounds.left / renderX;
    const top = bounds.top / renderY;
    const right = bounds.right / renderX;
    const bottom = bounds.bottom / renderY;

    return [
        left * scale.x + scale.offsetX,
        top * scale.y + scale.offsetY - baselineShiftY,
        right * scale.x + scale.offsetX,
        bottom * scale.y + scale.offsetY - baselineShiftY
    ]
}

function getHeadingBaselineShift(format, textAttr) {

    const headerLevel = parseInt(format?.header, 10);
    if (![1, 2, 3].includes(headerLevel)) return 0

    const fontSize = parseFloat(textAttr?.fontsize);
    if (!fontSize || Number.isNaN(fontSize)) return 0

    const fontName = String(textAttr?.font || "");
    const factor = getHeadingBaselineShiftFactor(fontName, headerLevel);

    return fontSize * factor
}

function quillFormatToAttr(format) {

    let text_deco = [];
    let fs = 13;

    // Defaults
    let attr = {
        fillColor: { web: "#333" },
        fontsize: fs,
        font: "Open Sans"
    };

    let header_size = false;
    let header_level = false;
    let script_scale = false;
    let text_size = false;
    Object.keys(format).forEach((key) => {
        if (format[key]) {
            if (key == "font") {
                if (VIDGE_FONT_MAP[format[key]]) attr["font"] = VIDGE_FONT_MAP[format[key]];
                else attr["font"] = format[key];
            }
            if (key == "underline") text_deco.push("underline");
            if (key == "strike") text_deco.push("line-through");
            if (key == "bold") attr["fontweight"] = "bold";
            if (key == "italic") attr["fontstyle"] = "italic";
            if (key == "header") {
                header_level = parseInt(format[key], 10);
                if (header_level == 1) header_size = (fs * 2);
                else if (header_level == 2) header_size = (fs * 1.5);
                else if (header_level == 3) header_size = (fs * 1.17);
            }
            if (key == "size") text_size = parseInt(format[key], 10);
            if (key == "script") script_scale = 0.75;
            if (key == "color") attr["fillColor"] = { web: format[key] };
        }
    });


    // fontsize in definierter Reihenfolge anwenden
    if (header_size) fs = header_size;

    if (header_size && header_level) {
        const fontName = String(attr["font"] || "");
        const factor = getHeadingSizeFactor(fontName, header_level);
        fs = fs * factor;
    }

    if (text_size) fs = text_size;
    if (script_scale) fs = fs * script_scale;

    if (header_size || text_size || script_scale) attr["fontsize"] = fs;
    if (text_deco.length > 0) attr["textdecoration"] = text_deco.join(" ");

    return attr

}

onMounted(() => {
    qedit = createEditor();
});


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$m, [
    (props.debugOverlay && !isEditorFocused.value && debugOverlayActive.value)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "qedit-debug-controls",
          onMousedown: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop","prevent"])),
          onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["stop","prevent"]))
        }, [
          createElementVNode("button", {
            class: "qedit-debug-render-btn",
            onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop","prevent"])),
            onClick: _cache[1] || (_cache[1] = withModifiers($event => (renderSvg()), ["stop","prevent"]))
          }, " render SVG ", 32 /* NEED_HYDRATION */)
        ], 32 /* NEED_HYDRATION */))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      ref_key: "editorRef",
      ref: editorRef
    }, null, 512 /* NEED_PATCH */),
    (debugOverlayActive.value)
      ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "qedit-debug-overlay",
          style: normalizeStyle(debugOverlayStyle()),
          "aria-hidden": "true"
        }, [
          (openBlock(), createElementBlock("svg", {
            class: "qedit-debug-svg",
            viewBox: `${debugSvgFrame.value.minX} ${debugSvgFrame.value.minY} ${debugSvgFrame.value.width} ${debugSvgFrame.value.height}`,
            preserveAspectRatio: "none"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(debugSegments.value, (segment, index) => {
              return (openBlock(), createElementBlock("g", {
                key: segment.id,
                class: "qedit-debug-segment"
              }, [
                createElementVNode("rect", {
                  x: segment.geometricBounds[0],
                  y: segment.geometricBounds[1],
                  width: Math.max(0, segment.geometricBounds[2] - segment.geometricBounds[0]),
                  height: Math.max(0, segment.geometricBounds[3] - segment.geometricBounds[1]),
                  class: "qedit-debug-box"
                }, null, 8 /* PROPS */, _hoisted_3$h),
                createElementVNode("text", {
                  x: segment.geometricBounds[0],
                  y: segment.geometricBounds[1] - 1,
                  class: "qedit-debug-label"
                }, toDisplayString$1(index + 1), 9 /* TEXT, PROPS */, _hoisted_4$f)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_2$k))
        ], 4 /* STYLE */))
      : createCommentVNode("v-if", true),
    (debugOverlayActive.value)
      ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: "qedit-debug-panel",
          onClick: _cache[4] || (_cache[4] = withModifiers(() => {}, ["stop"]))
        }, [
          createElementVNode("div", _hoisted_5$e, [
            createElementVNode("div", _hoisted_6$b, " scaleX: " + toDisplayString$1(editorScale.value.x.toFixed(3)) + " | scaleY: " + toDisplayString$1(editorScale.value.y.toFixed(3)) + " | editor: " + toDisplayString$1(Math.round(editorScale.value.editorWidth)) + " x " + toDisplayString$1(Math.round(editorScale.value.editorHeight)) + " | target: " + toDisplayString$1(Math.round(props.targetSize?.[0] || 0)) + " x " + toDisplayString$1(Math.round(props.targetSize?.[1] || 0)) + " | render: " + toDisplayString$1(editorScale.value.renderX.toFixed(3)) + " / " + toDisplayString$1(editorScale.value.renderY.toFixed(3)), 1 /* TEXT */)
          ]),
          (openBlock(true), createElementBlock(Fragment, null, renderList(debugSegments.value, (segment, index) => {
            return (openBlock(), createElementBlock("div", {
              key: `debug-${segment.id}`,
              class: "qedit-debug-row"
            }, toDisplayString$1(index + 1) + ". \"" + toDisplayString$1(segment.text) + "\" | editor: " + toDisplayString$1(Math.round(segment.bounds.left)) + ", " + toDisplayString$1(Math.round(segment.bounds.top)) + ", " + toDisplayString$1(Math.round(segment.bounds.right)) + ", " + toDisplayString$1(Math.round(segment.bounds.bottom)) + " | export: " + toDisplayString$1(Math.round(segment.geometricBounds[0])) + ", " + toDisplayString$1(Math.round(segment.geometricBounds[1])) + ", " + toDisplayString$1(Math.round(segment.geometricBounds[2])) + ", " + toDisplayString$1(Math.round(segment.geometricBounds[3])), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : createCommentVNode("v-if", true)
  ]))
}
}

};

script$n.__scopeId = "data-v-a139a68e";
script$n.__file = "src/bundles/vidge/components/Qedit.vue";

const _hoisted_1$l = { class: "vidge-shell" };
const _hoisted_2$j = { class: "vidge-titlebar" };
const _hoisted_3$g = { class: "vidge-titletext" };
const _hoisted_4$e = {
  key: 0,
  class: "pages-strip"
};
const _hoisted_5$d = ["onClick"];
const _hoisted_6$a = { key: 0 };
const _hoisted_7$a = { key: 1 };
const _hoisted_8$9 = { class: "preview3D-canvas-stack" };
const _hoisted_9$9 = ["onKeydown"];
const _hoisted_10$9 = {
  key: 0,
  class: "vidge-actionbar"
};
const _hoisted_11$9 = { class: "vidge-actionbar-buttons" };
const _hoisted_12$9 = {
  class: "uk-button uk-button-default uk-button-small uk-background-default tool-button",
  title: "Text hinzufügen",
  disabled: ""
};
const _hoisted_13$8 = {
  class: "uk-button uk-button-default uk-button-small uk-background-default tool-button",
  title: "Bild hinzufügen",
  disabled: ""
};
const _hoisted_14$7 = { id: "qtoolbar" };
const _hoisted_15$7 = { class: "edit-img-shell" };
const _hoisted_16$6 = ["onKeydown"];
const _hoisted_17$5 = {
  key: 0,
  class: "palette-img"
};
const _hoisted_18$5 = { style: {"margin-top":"7px"} };
const _hoisted_19$5 = {
  name: "method",
  style: {"width":"170px","margin-top":"10px"},
  class: "methodButton uk-button-small uk-button-default uk-background-default",
  type: "button"
};
const _hoisted_20$4 = { "uk-icon": "chevron-down" };
const _hoisted_21$4 = {
  "uk-dropdown": "mode: click",
  "uk-toggle": ""
};
const _hoisted_22$4 = { class: "uk-nav uk-dropdown-nav" };
const _hoisted_23$4 = ["value"];
const _hoisted_24$4 = ["onClick"];
const _hoisted_25$4 = { class: "tool-suite" };
const _hoisted_26$3 = { class: "toolbox" };
const _hoisted_27$3 = { class: "tab-body" };
const _hoisted_28$3 = { class: "tool" };


var script$m = {
  __name: 'Vidge',
  props: {
    status: Object,
    listId: Number,
    items: Array,
    itemNumber: Number,
},
  emits: ["onload", "save-vic"],
  setup(__props, { emit: __emit }) {

/*
*  VIDGE (Vector Image Designer and Graphic Editor)
*/

const props = __props;

const emit = __emit;
const configStore = useConfigStore();

const productTitle = computed(() => {
    const product = props.status?.product || {};
    return product.name
        || product.title
        || product.productName
        || product.pname
        || product.label
        || props.status?.productName
        || props.status?.title
        || ""
});

const productNumber = computed(() => {
    const product = props.status?.product || {};
    return product.pid || product.id || ""
});

const editImg = ref();
// voreingestellte Vergrößerung in Prozent
const zoom = ref(100);
// voreingestellter Wert für Schwellwert für vektorisieren
const threshhold = ref(50);
// voreingestellter Wert für Blurradius für vektorisieren
const blur = ref(0);
// Die beiden 3D preview nodes. Eine zum anzeigen, die jeweils andere zum prerendern
const preview3D1 = ref();
const preview3D2 = ref();
const previewCardRef = ref();
const editorCardRef = ref();
// aktuell aktive 3D preview canvas 1|2
const preview3DShow = ref(1);
// Klassenname für die editier-Ansicht. Startet mit small für eine transition nach dem öffnen
const editPreviewClass = ref("small");
// Seitenverhältnis der Ansicht
const ratio = ref(1);
// Bild Selektion
const imageSel = ref(0);
// aktive Werkzeugkomponente
const tool = ref('');
// Quill Toolbar
const qToolbarRef = ref();
// Referenz auf den aktiven  Text Editor 
const qeditActive = ref(false);
// Key für Texteditor. Wird immer um 1 hochgezählt um rerender zu erzwingen
const qeditKey = ref(0);
const qeditDebugOverlay = computed(() => configStore.vidgeDebugOverlay === true);

// Loader
const $loading = useLoading({
    isFullPage: false,
    loader: 'dots'
});

var pages = ref(1);
const pagelabel = ref({});
const pageActive = ref(1);
const pageState = ref(false);

var vici = {};

// Dynamische Komponenten
const morphs = {
    Resize: script$s, Vectorize: script$r, AdjustAngle: script$q
};

// Props der Dynamischen Komponenten
const toolProp = {
    Resize: {
        vici: vici,
        zoom: zoom.value
    },
    Vectorize: {
        step: ref(0),
        threshhold: threshhold.value,
        blur: blur.value
    },
    AdjustAngle: {
        vici: vici
    }
};

// laden der Tools
function loadTool(name) {
    tool.value = name;
    if (name == "Vectorize") toolProp.Vectorize.step.value = 0;
}

// Standardfunktion zum Empfang aller Events für die ViciTools 
//  als Teil einer dynamischen Komponente
function toolReceive(toolName, action, data, options) {

    if (toolName == "Vidge") {

        if (typeof VidgeAction[action] == "function") VidgeAction[action](data);

    } else if (vici.tool[toolName] && vici.tool[toolName][action]) {

        // Loader Starten falls angegeben
        if (options && options["loader"]) {
            var imgProcessing = $loading.show({ container: editImg.value });
        }
        let result = vici.tool[toolName][action](data);


        // Falls Promise zurückgegeben wird auf Promise.resolve warten
        if (result && typeof result.then == "function") {
            result.then((r) => {
                if (imgProcessing) imgProcessing.hide();
                toolFinished(r);
            });
        } else {
            if (imgProcessing) imgProcessing.hide();
            toolFinished(result);
        }

    }
}

function toolFinished(result) {

    logger.info(result);

}

let threePreview = false;
const threePreviewDisabled = ref(false);
const textEdit = {};
let debugRenderOverlayGroup = null;
let textureUpdateRequested = false;
let textureUpdateInFlight = false;
const svgImageDataUrlCache = new Map();

const livePreview3D = computed(() => {
    if (typeof configStore.vidge3DLivePreview === 'boolean') {
        return configStore.vidge3DLivePreview
    }

    if (typeof configStore.vidge3DUpdateMode === 'string') {
        return configStore.vidge3DUpdateMode.toLowerCase() === 'live'
    }

    return false
});
//window.textEdit = textEdit

async function loadEditor(itemNumber, mediaId) {

    pageState.value = "loading";

    if (!itemNumber) itemNumber = 0;
    if (!mediaId) mediaId = 0;

    let setup = structuredClone(toRaw(props.items[itemNumber]?.vici?.setup));
    if (!setup) setup = {};
    setup.domNode = editImg.value;
    setup.imgResource = "orig";
    setup.interactive = true;
    const product = props.status.product;
    // Druckmethoden-Einstellung der Liste "psList"
    let method = props.status.mediaSettings.printMethod;
    // TODO klick durch alle Medien von "items"

    let media = props.items[itemNumber]?.media;

    if (!Array.isArray(media)) media = [media];
    const isFirstPage = mediaId === 0;

    updateMethodOptions();

    if (!media[mediaId] && setup.templates?.defaults && setup.templates.defaults[mediaId + 1]) {
        media[mediaId] = await fetchTemplate(setup.templates?.defaults[mediaId + 1], "vicobject");
        if (!media.settings) media.settings = {};
        media.settings.printMethod = "vic";
    }

    // Druckmethode des gewählten Bildes
    if (media[mediaId]?.settings?.printMethod) {
        method = media[mediaId].settings.printMethod;
        logger.debug("Method set to " + method);
    }

    // Bei mehrseitigen Dokumenten gilt Printopt nur auf Seite 1.
    // Für weitere Seiten immer Benutzerdefiniert (vic) verwenden.
    // TODO: printopt Logik für komplexere produkte (z.B.: mehrere Bilder pro Seite) prüfen
    // TODO: Diese Logik ist nur für Produkte mit einem Bild pro Seite gedacht. Bei mehreren Bildern pro Seite muss die Logik überarbeitet werden.
    if (!isFirstPage) {
        if (!media[mediaId]) media[mediaId] = {};
        if (!media[mediaId].settings) media[mediaId].settings = {};
        media[mediaId].settings.printMethod = "vic";
        method = "vic";
    }

    if (!method) {
        const firstMethod = Object.keys(methods.value)[0];
        if (firstMethod) {
            method = firstMethod;
            if (!media[mediaId]) media[mediaId] = {};
            if (!media[mediaId].settings) media[mediaId].settings = {};
            media[mediaId].settings.printMethod = method;
        }
    }

    // Nur Methoden aus printopt im Auswahlbutton anzeigen.
    // Bei benutzerdefinierten Zuständen (z.B. vic) auf "Benutzerdefiniert" gehen.
    selectedMethod.value = methods.value[method] ? method : "";

    vici = new Vici(setup, media);
    vici.mediaId = mediaId;
    toolProp.Resize.vici = vici;
    toolProp.AdjustAngle.vici = vici;
    vici.cropToFormat = true;

    // Editierbare Texte
    watch(vici.editableTexts, (currentValue, oldValue) => {
        {
            Object.keys(currentValue).forEach((textId) => {

                if (currentValue[textId] == oldValue[textId]) return

                let editorNode = document.querySelector("#" + textId);
                if (currentValue[textId] == "empty") {

                    let placeholderText = "Ihr Text";
                    let textEl = vici.elements.find((el) => { return el._editId == textId });
                    if (textEl && textEl.placeholder) placeholderText = textEl.placeholder;

                    let placeholder = qeditPlaceholder(editorNode);
                    placeholder.setAttribute("placeholder", placeholderText);

                    placeholder.onclick = function () {
                        vici.setTextState(textId, "editor");
                    };
                } else if (currentValue[textId] == "static") {

                    let staticNode = document.querySelector("#" + textId + "_static");
                    editorNode.style.display = 'none';
                    // Sowohl auf den Editor, der den gesamten Textbereich überspannt
                    // als auch auf den statischen Text (der darüber liegt), dasselbe Event legen
                    // deas den editor wieder aktiviert
                    editorNode.parentNode.onclick = function () {
                        vici.setTextState(textId, "editor");
                    };
                    staticNode.onclick = function () {
                        vici.setTextState(textId, "editor");
                    };
                } else {
                    activateTextEditor(textId);
                }
            }, { deep: true });
        }
    });

    vici.render({ product: product, format: [product.widthMM, product.heightMM], method: method, previewMap: previewMaps[product.pid] });

    pages.value = vici.pages;
    pagelabel.value = vici.pagelabel;
    ratio.value = vici.doc.size[0] / vici.doc.size[1];
    vici.loaded.then(() => {
        emit("onload");
        setTimeout(() => {
            if (ratio.value <= 2) editPreviewClass.value = "large";
            else editPreviewClass.value = "wide";
        }, 20);
        loadTool('Resize');

        pageState.value = "loaded";
    });

    if (previewMaps[product.pid]?.three) {

        load3DView();

        sync3DPreviewMode();

    }
}

// Find Existing or create placeholder
function qeditPlaceholder(parentNode) {

    let ph = parentNode.querySelector(".qedit-placeholder");

    if (ph) return ph

    let placeholder = document.createElement('div');
    placeholder.setAttribute("contenteditable", true);
    placeholder.className = "qedit-placeholder";

    parentNode.appendChild(placeholder);

    return placeholder

}

let qed = false;

async function activateTextEditor(textId) {

    const editorContainer = document.querySelector("#" + textId);

    if (qed) qed.unmount();
    qeditKey.value += 1;
    await nextTick();

    let phNode = document.querySelector("#" + textId + " .qedit-placeholder");
    if (phNode) editorContainer.removeChild(phNode);

    // Erstellen, falls nicht vorhanden
    if (!document.querySelector("#" + textId + " .ql-editor")) {

        if (!textEdit[textId]) textEdit[textId] = { state: ref("blur") };

        // check for placeholder
        let placeholder = null;
        let textContents = null;
        let textSize = null;
        let textEl = vici.elements.find((el) => { return el._editId == textId });
        if (textEl) {
            if (textEl.placeholder) placeholder = textEl.placeholder;
            if (textEl.contents) textContents = textEl.contents;
            textSize = textEl.getSize();
            if (textEl.verticalAlign == "bottom") editorContainer.className = "qedit-bottom";
        }


        qed = createApp({
            setup() {
                return () => h(script$n, {
                    toolbar: "#qtoolbar",
                    content: textContents,
                    state: textEdit[textId].state,
                    placeholder: placeholder,
                    targetSize: textSize,
                    debugOverlay: qeditDebugOverlay.value,
                    onSave(content, textDeltaCoords) { qsave(content, textDeltaCoords); },
                    onRenderSvg(content, textDeltaCoords) { qrenderSvg(content, textDeltaCoords); }
                })
            }
        });

        const wrapper = document.createElement("div");
        wrapper.className = "qedit";
        editorContainer.appendChild(wrapper);

        qed.mount(wrapper);

        // Events für focus und blur

        wrapper.onclick = () => {
            textEditorFocus(textId);
        };
        onClickOutside(wrapper, () => {
            if (qeditDebugOverlay.value) {
                textEdit[textId].state.value = "blur";
                return
            }
            textEdit[textId].state.value = "close";
        }, { ignore: [qToolbarRef, editorContainer] });

    }

    editorContainer.style.display = 'block';
    textEditorFocus(textId);
}

function textEditorFocus(textId) {
    clearRenderDebugOverlay();
    if (!textEdit[textId]) return false
    textEdit[textId].state.value = "focus";
    qeditActive.value = textId;
}

function clearRenderDebugOverlay() {
    if (debugRenderOverlayGroup && typeof debugRenderOverlayGroup.remove == "function") {
        debugRenderOverlayGroup.remove();
    }
    debugRenderOverlayGroup = null;
}

function drawRenderDebugOverlay(textId, textElements) {
    clearRenderDebugOverlay();
    if (!qeditDebugOverlay.value) return false
    if (!vici?.draw || !Array.isArray(textElements) || textElements.length == 0) return false

    let textEl = vici.elements.find((el) => el._editId == textId);
    if (!textEl || !Array.isArray(textEl.geometricBounds) || textEl.geometricBounds.length < 4) return false

    const hostGb = textEl.geometricBounds;
    const group = vici.draw.group();
    group.attr({ "pointer-events": "none" });
    group.addClass("vidge-debug-render-overlay");

    textElements.forEach((tel, index) => {
        const gb = tel?.geometricBounds;
        if (!Array.isArray(gb) || gb.length < 4) return

        const x = hostGb[0] + gb[0];
        const y = hostGb[1] + gb[1];
        const w = Math.max(0.5, gb[2] - gb[0]);
        const h = Math.max(0.5, gb[3] - gb[1]);

        group
            .rect(w, h)
            .move(x, y)
            .fill({ color: "#cf274d", opacity: 0.08 })
            .stroke({ color: "#cf274d", width: 0.6, dasharray: "1.5 1.2" });

        group
            .text(String(index + 1))
            .move(x, y - 7)
            .font({ family: "Open Sans", size: 6, weight: "700" })
            .fill("#cf274d");
    });

    debugRenderOverlayGroup = group;
    return true
}

// Text Editor Content speichern (getriggert durch Qedit Component onSave)

function qrenderSvg(content, textElements) {
    logger.info("renderSvg " + qeditActive.value);
    const textId = qeditActive.value;
    let activeEditor = textEdit[textId];
    if (!activeEditor) return false
    activeEditor.content = content;
    vici.processText(textId, content, textElements);
    vici.setTextState(textId, "static");

    drawRenderDebugOverlay(textId, textElements);

    let qeditContainer = document.querySelector("#" + textId);
    let wrapper = document.querySelector("#" + textId + " .qedit");
    if (qeditContainer && wrapper && qeditContainer.contains(wrapper)) {
        qeditContainer.removeChild(wrapper);
    }

    qeditActive.value = false;
    activeEditor.state.value = "blur";
}

function qsave(content, textElements) {

    logger.info("save " + qeditActive.value);

    clearRenderDebugOverlay();

    let activeEditor = textEdit[qeditActive.value];
    if (!activeEditor) return false

    activeEditor.content = content;
    vici.processText(qeditActive.value, content, textElements);

    if (qeditDebugOverlay.value) {
        activeEditor.state.value = "blur";
        return true
    }

    vici.setTextState(qeditActive.value, "static");

    let qeditContainer = document.querySelector("#" + qeditActive.value);
    let wrapper = document.querySelector("#" + qeditActive.value + " .qedit");
    qeditContainer.removeChild(wrapper);

    qeditActive.value = false;

}

onMounted(() => {
    loadEditor(props.itemNumber);
});

onBeforeUnmount(() => {
    clearRenderDebugOverlay();
    // Finaler Cleanup beim Verlassen der Komponente:
    // Hier ist forceContextLoss explizit erlaubt, um GPU-Ressourcen sauber freizugeben.
    if (threePreview && typeof threePreview.destroy === 'function') {
        threePreview.destroy({ forceContextLoss: true, reason: 'unmount' });
    }

    [preview3D1.value, preview3D2.value].forEach((canvas) => {
        if (canvas?.__ppThreePreview && typeof canvas.__ppThreePreview.destroy === 'function') {
            canvas.__ppThreePreview.destroy({ forceContextLoss: true, reason: 'unmount' });
        }
    });

    threePreview = false;
});


async function perform3DTextureUpdate() {
    if (!threePreview || threePreviewDisabled.value || !threePreview.printMaterial) return

    const product = props.status.product;
    if (!previewMaps[product.pid]?.three) return

    let mainPrint = vici.svg.find(`#${vici.id}_main-print`)[0].clone();
    mainPrint.attr({
        xmlns: "http://www.w3.org/2000/svg",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: vici.innerSize[0],
        height: vici.innerSize[1],
        viewBox: null,
        x: null,
        y: null
    });

    const svgDataUrl = await svgNodeToBase64(mainPrint.node);
    await threePreview.updateTexture(svgDataUrl);
}

async function update3DTexture() {
    textureUpdateRequested = true;

    if (textureUpdateInFlight) return

    textureUpdateInFlight = true;

    try {
        while (textureUpdateRequested) {
            textureUpdateRequested = false;
            await perform3DTextureUpdate();
        }
    } finally {
        textureUpdateInFlight = false;
    }
}

async function viciChangedHandler() {
    if (livePreview3D.value) {
        update3DTexture();
    }
}

function flush3DUpdate() {
    update3DTexture();
}

function sync3DPreviewMode() {
    if (!vici) return
    vici.onChange = livePreview3D.value ? viciChangedHandler : undefined;
    vici.onChangeEnd = flush3DUpdate;
}

watch(livePreview3D, () => {
    sync3DPreviewMode();
    flush3DUpdate();
});

async function load3DView() {

    const product = props.status.product;

    if (!previewMaps[product.pid]?.three || threePreviewDisabled.value) return false

    logger.debug("3DView: load 3D view for " + product.pid);

    let mainPrint = vici.svg.find(`#${vici.id}_main-print`)[0].clone();
    mainPrint.attr({
        xmlns: "http://www.w3.org/2000/svg",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: vici.innerSize[0],
        height: vici.innerSize[1],
        viewBox: null,
        x: null,
        y: null
    });

    let modelUrl = getModelUrl(previewMaps[product.pid].three.model);

    try {
        threePreview = new ThreePreview(cachePreview3D.value, { size: stateSize[state3DView.value] });
    } catch (error) {
        threePreviewDisabled.value = true;
        logger.error('3DView: WebGL context konnte nicht erstellt werden', error);
        return Promise.resolve(false)
    }

    threePreview.setBackgroundColor(0xffffff);

    svgNodeToBase64(mainPrint.node).then(svgDataUrl => {
        threePreview.setImage(svgDataUrl).then(() => {
            threePreview.loadScene(modelUrl, { ...previewMaps[product.pid].three });
            threePreview.animate();
        }).catch(err => {
            logger.error('Fehler beim Laden der Textur:', err);
        });
        threePreview.loaded.then(() => {
            currentPreview3D.value = "toggle";
        });
    });

    return threePreview.loaded
}

function getModelUrl(src) {
    // in production den relativen Pfad nehmen (modul liegt dann in assets, sodass ../ ins app-root führt)
    let rel = "";
    if (process.env.NODE_ENV == 'production') rel = '..';
    return new URL(rel + src, import.meta.url).href
}

/****  System zum tauschen zweier canvas nodes für prerendering ****/

// Liefert den aktuell augeblendeten canvas-node
const cachePreview3D = computed(() => {
    if (preview3DShow.value == 1) return preview3D2.value
    else return preview3D1.value
});

// Liefert den aktuell angezeigten canvas-node
// tauscht aktuellen node mit cache mit currentPreview3D.value = "toggle"
const currentPreview3D = computed({
    get() {
        if (preview3DShow.value == 1) return preview3D1.value
        else return preview3D2.value
    },
    set(task) {
        if (task == "toggle") {
            if (preview3DShow.value == 1) {
                preview3DShow.value = 2;
            } else {
                preview3DShow.value = 1;
            }
        } else if (task == 1) {
            preview3DShow.value = 1;
        } else if (task == 2) {
            preview3DShow.value = 2;
        }
    }
});

/*******************************************************************/

/****   SVG Bild in bas64 URL umwandeln   ****/

function svgNodeToBase64(domNode) {

    let s = new XMLSerializer();

    const getImageHref = (imgNode) => {
        return imgNode.getAttribute('href')
            || imgNode.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
            || imgNode?.href?.animVal
            || imgNode?.href?.baseVal
            || ""
    };

    const setImageHref = (imgNode, href) => {
        imgNode.setAttribute('href', href);
        imgNode.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
        if (imgNode?.href && typeof imgNode.href.baseVal !== 'undefined') {
            imgNode.href.baseVal = href;
        }
    };

    return new Promise((resolve) => {

        const promiseList = [];
        // Alle eingebettetten Bildquellen holen, in dataUrl wandeln und schließlich
        // im SVG Baum ersetzen
        domNode.querySelectorAll('image').forEach(imgNode => {
            const sourceUrl = getImageHref(imgNode);
            if (!sourceUrl || sourceUrl.startsWith('data:')) return

            if (svgImageDataUrlCache.has(sourceUrl)) {
                setImageHref(imgNode, svgImageDataUrlCache.get(sourceUrl));
                return
            }

            promiseList.push(
                getBase64FromUrl(sourceUrl)
                    .then(dataUrl => {
                        svgImageDataUrlCache.set(sourceUrl, dataUrl);
                        setImageHref(imgNode, dataUrl);
                    })
                    .catch(() => {
                        // Fallback: bestehende URL belassen, damit kein falscher Placeholder erzwungen wird.
                        setImageHref(imgNode, sourceUrl);
                    })
            );

        });
        // Wenn alle Bildquellen geladen wurden, SVG Node serialisieren
        Promise.all(promiseList).then(() => {
            let str = s.serializeToString(domNode);
            resolve(svgToDataUrl(str));
        });

    })

}





const stateSize = {
    minified: [100, 100],
    enlarged: [500, 350]
};

const state3DView = ref("minified");
const stateEditView = ref("enlarged");
const previewInMain = ref(false);

async function animateCardSwap(swapStateFn) {
    const previewCard = previewCardRef.value;
    const editorCard = editorCardRef.value;

    if (!previewCard || !editorCard) {
        swapStateFn();
        await nextTick();
        return
    }

    const firstPreview = previewCard.getBoundingClientRect();
    const firstEditor = editorCard.getBoundingClientRect();

    swapStateFn();
    await nextTick();

    const lastPreview = previewCard.getBoundingClientRect();
    const lastEditor = editorCard.getBoundingClientRect();

    const previewDx = firstPreview.left - lastPreview.left;
    const previewDy = firstPreview.top - lastPreview.top;
    const previewSx = firstPreview.width / Math.max(lastPreview.width, 1);
    const previewSy = firstPreview.height / Math.max(lastPreview.height, 1);

    const editorDx = firstEditor.left - lastEditor.left;
    const editorDy = firstEditor.top - lastEditor.top;
    const editorSx = firstEditor.width / Math.max(lastEditor.width, 1);
    const editorSy = firstEditor.height / Math.max(lastEditor.height, 1);

    const animationOptions = {
        duration: 460,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'both'
    };

    const animateEl = (el, dx, dy, sx, sy) => {
        if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5 && Math.abs(sx - 1) < 0.01 && Math.abs(sy - 1) < 0.01) {
            return null
        }

        if (typeof el.getAnimations === 'function') {
            el.getAnimations().forEach((anim) => anim.cancel());
        }

        if (typeof el.animate === 'function') {
            return el.animate([
                {
                    transformOrigin: 'top left',
                    transform: `translate(${dx}px, ${dy}px) scale(${sx}, ${sy})`
                },
                {
                    transformOrigin: 'top left',
                    transform: 'translate(0px, 0px) scale(1, 1)'
                }
            ], animationOptions)
        }

        return null
    };

    const previewAnim = animateEl(previewCard, previewDx, previewDy, previewSx, previewSy);
    const editorAnim = animateEl(editorCard, editorDx, editorDy, editorSx, editorSy);

    const finished = [];
    if (previewAnim?.finished) finished.push(previewAnim.finished.catch(() => {}));
    if (editorAnim?.finished) finished.push(editorAnim.finished.catch(() => {}));
    if (finished.length) await Promise.all(finished);
}

async function toggle3DView() {
    await animateCardSwap(() => {
        previewInMain.value = !previewInMain.value;
        state3DView.value = previewInMain.value ? "enlarged" : "minified";
        stateEditView.value = previewInMain.value ? "minified" : "enlarged";

        // Resize direkt beim State-Wechsel ausführen, damit der Canvas-Inhalt
        // innerhalb der FLIP-Animation mit skaliert und nicht erst am Ende springt.
        if (threePreview && !threePreviewDisabled.value) {
            threePreview.resize(stateSize[state3DView.value]);
        }
    });
}

const VidgeAction = {
    formChange: function () {
        load3DView();
    }

};

const methodLabels = {
    fillin: "formatfüllend",
    fitin: "eingepasst",
    border: "mit weißem Rand",
    fillborder: "gleichmäßiger Rand",
    canvas: "Leinwand",
    canvasborder: "Leinwand mit Rand",
    canvaswhiteborder: "Leinwand weißer Rand",
    canvasmirror: "Leinwand gespiegelt",
    canvasstretch: "Leinwand gestreckt"
};

const defaultMethodNames = ["fillin", "fitin", "border", "fillborder"];

function createMethodMap(names) {
    const result = {};
    names.forEach((name) => {
        result[name] = { label: methodLabels[name] || name };
    });
    return result
}

const methods = ref(createMethodMap(defaultMethodNames));
const selectedMethod = ref("");

const selectedMethodLabel = computed(() => {
    if (!selectedMethod.value) return "Benutzerdefiniert"
    return methods.value[selectedMethod.value]?.label || selectedMethod.value
});

function getCurrentMediaObject() {
    const itemNumber = Number.isInteger(props.itemNumber) ? props.itemNumber : 0;
    const mediaId = Math.max(0, pageActive.value - 1);
    let media = props.items?.[itemNumber]?.media;
    if (!Array.isArray(media)) media = [media];
    return media?.[mediaId]
}

function updateMethodOptions() {
    const setupRoot = toRaw(props.status?.product?.setup) || {};
    const setupData = setupRoot?.data && typeof setupRoot.data == 'object' ? setupRoot.data : setupRoot;
    const printopt = setupData?.printopt;

    if (printopt && typeof printopt == 'object') {
        const nextMethods = createMethodMap(Object.keys(printopt));
        if (Object.keys(nextMethods).length) {
            methods.value = nextMethods;
            return
        }
    }

    methods.value = createMethodMap(defaultMethodNames);
}

function selMethod(name) {
    if (!name || !methods.value[name]) return

    // Ab Seite 2 bleibt die Methode benutzerdefiniert.
    if (pageActive.value > 1) return

    selectedMethod.value = name;

    const mediaObj = getCurrentMediaObject();
    if (mediaObj) {
        if (!mediaObj.settings) mediaObj.settings = {};
        mediaObj.settings.printMethod = name;
    }
    if (vici?.update && vici?.config) {
        const product = props.status.product;
        const format = [product.widthMM, product.heightMM];
        vici.update({ ...vici.config, product, format, method: name, previewMap: previewMaps[product.pid] });
    }

    flush3DUpdate();
}

function save() {

    // TODO set correct mediaId
    let mediaId = 0;
    let vicJSON = JSON.stringify(vici.exportDocument());

    emit("save-vic", props.listId, mediaId, vicJSON);
}

async function selectPage(n) {
    pageState.value = false;
    // rendering abwarten ist notwendig, damit die qToolbar Koponente gelöscht wird.
    // Sie muß beim Erstellen des Editors neu initialisiert werden sonst behält sie alte bindings
    await nextTick();
    pageActive.value = n;

    // TODO: Beim Seitenwechsel muss das Dokument gespeichert werden, sonst gehen Daten verloren

    loadEditor(props.itemNumber, n - 1);
}






return (_ctx, _cache) => {
  const _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["vidge", editPreviewClass.value])
  }, [
    createElementVNode("div", _hoisted_1$l, [
      createElementVNode("div", _hoisted_2$j, [
        createElementVNode("div", _hoisted_3$g, toDisplayString$1([productTitle.value, productNumber.value].filter(Boolean).join(' ')), 1 /* TEXT */)
      ]),
      createElementVNode("div", {
        class: normalizeClass(["swap-layout", stateEditView.value])
      }, [
        (unref(pages) > 1)
          ? (openBlock(), createElementBlock("div", _hoisted_4$e, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(pages), (n, i) => {
                return (openBlock(), createElementBlock("button", {
                  key: i,
                  class: normalizeClass(["page-chip", (pageActive.value == n) ? 'active' : '']),
                  onClick: $event => (selectPage(n))
                }, [
                  (pagelabel.value[n])
                    ? (openBlock(), createElementBlock("span", _hoisted_6$a, toDisplayString$1(pagelabel.value[n]), 1 /* TEXT */))
                    : (openBlock(), createElementBlock("span", _hoisted_7$a, "Seite " + toDisplayString$1(n), 1 /* TEXT */))
                ], 10 /* CLASS, PROPS */, _hoisted_5$d))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : createCommentVNode("v-if", true),
        withDirectives(createElementVNode("div", {
          ref_key: "previewCardRef",
          ref: previewCardRef,
          class: normalizeClass(["preview3D-card", [state3DView.value, previewInMain.value ? 'card-main' : 'card-top']])
        }, [
          createElementVNode("div", _hoisted_8$9, [
            withDirectives(createElementVNode("canvas", {
              ref_key: "preview3D1",
              ref: preview3D1,
              class: "preview3D-canvas"
            }, null, 512 /* NEED_PATCH */), [
              [vShow, preview3DShow.value == 1]
            ]),
            withDirectives(createElementVNode("canvas", {
              ref_key: "preview3D2",
              ref: preview3D2,
              class: "preview3D-canvas"
            }, null, 512 /* NEED_PATCH */), [
              [vShow, preview3DShow.value == 2]
            ])
          ]),
          (state3DView.value == 'minified')
            ? (openBlock(), createElementBlock("span", {
                key: 0,
                class: "toggle-view-icon",
                "uk-icon": "expand",
                role: "button",
                tabindex: "0",
                onClick: toggle3DView,
                onKeydown: [
                  withKeys(withModifiers(toggle3DView, ["prevent"]), ["enter"]),
                  withKeys(withModifiers(toggle3DView, ["prevent"]), ["space"])
                ]
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_9$9))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */), [
          [vShow, unref(previewMaps)[props.status.product.pid]?.three && !threePreviewDisabled.value]
        ]),
        (unref(previewMaps)[props.status.product.pid]?.three && threePreviewDisabled.value)
          ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(["preview3D-card is-disabled", [state3DView.value, previewInMain.value ? 'card-main' : 'card-top']])
            }, _cache[3] || (_cache[3] = [
              createElementVNode("div", { class: "center preview-fallback" }, " 3D-Vorschau im Browser derzeit nicht verfügbar (WebGL konnte nicht initialisiert werden). ", -1 /* HOISTED */)
            ]), 2 /* CLASS */))
          : createCommentVNode("v-if", true),
        createElementVNode("div", {
          ref_key: "editorCardRef",
          ref: editorCardRef,
          class: normalizeClass(["editor-stage", [stateEditView.value, previewInMain.value ? 'card-top' : 'card-main']])
        }, [
          (pageState.value)
            ? (openBlock(), createElementBlock("div", _hoisted_10$9, [
                withDirectives(createElementVNode("div", _hoisted_11$9, [
                  createCommentVNode(" Platzhalter: Buttons für neue Text- oder Bildelemente "),
                  createElementVNode("button", _hoisted_12$9, [
                    createVNode(_component_font_awesome_icon, { icon: ['fas', 'font'] })
                  ]),
                  createElementVNode("button", _hoisted_13$8, [
                    createVNode(_component_font_awesome_icon, { icon: ['fas', 'image'] })
                  ])
                ], 512 /* NEED_PATCH */), [
                  [vShow, !qeditActive.value]
                ]),
                withDirectives(createElementVNode("div", _hoisted_14$7, [
                  (openBlock(), createBlock(unref(script$o), {
                    key: qeditKey.value,
                    ref_key: "qToolbarRef",
                    ref: qToolbarRef
                  }))
                ], 512 /* NEED_PATCH */), [
                  [vShow, qeditActive.value]
                ])
              ]))
            : createCommentVNode("v-if", true),
          createElementVNode("div", _hoisted_15$7, [
            createElementVNode("div", {
              class: normalizeClass(["center edit-img-container", editPreviewClass.value]),
              ref_key: "editImg",
              ref: editImg
            }, null, 2 /* CLASS */)
          ]),
          (stateEditView.value == 'minified')
            ? (openBlock(), createElementBlock("span", {
                key: 1,
                class: "toggle-view-icon",
                "uk-icon": "expand",
                role: "button",
                tabindex: "0",
                onClick: toggle3DView,
                onKeydown: [
                  withKeys(withModifiers(toggle3DView, ["prevent"]), ["enter"]),
                  withKeys(withModifiers(toggle3DView, ["prevent"]), ["space"])
                ]
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16$6))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        createElementVNode("div", {
          class: normalizeClass(["edit-controls", editPreviewClass.value])
        }, [
          (imageSel.value !== false)
            ? (openBlock(), createElementBlock("div", _hoisted_17$5, [
                createElementVNode("div", _hoisted_18$5, [
                  createElementVNode("button", _hoisted_19$5, [
                    createElementVNode("span", _hoisted_20$4, toDisplayString$1(selectedMethodLabel.value), 1 /* TEXT */)
                  ]),
                  createElementVNode("div", _hoisted_21$4, [
                    createElementVNode("ul", _hoisted_22$4, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(methods.value, (method, name) => {
                        return (openBlock(), createElementBlock("li", {
                          key: name,
                          value: name
                        }, [
                          createElementVNode("a", {
                            class: "uk-dropdown-close",
                            onClick: $event => (selMethod(name))
                          }, toDisplayString$1(method.label), 9 /* TEXT, PROPS */, _hoisted_24$4)
                        ], 8 /* PROPS */, _hoisted_23$4))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                createElementVNode("div", _hoisted_25$4, [
                  createElementVNode("div", _hoisted_26$3, [
                    _cache[4] || (_cache[4] = createElementVNode("div", { class: "tab-header" }, "Werkzeuge", -1 /* HOISTED */)),
                    createElementVNode("div", _hoisted_27$3, [
                      createElementVNode("button", {
                        title: "Bildgröße",
                        onClick: _cache[0] || (_cache[0] = $event => (loadTool('Resize'))),
                        class: normalizeClass([(tool.value == 'Resize') ? 'active' : '', "uk-button uk-button-default uk-button-small uk-background-default tool-button"])
                      }, [
                        createVNode(_component_font_awesome_icon, { icon: ['fas', 'up-right-and-down-left-from-center'] })
                      ], 2 /* CLASS */),
                      createElementVNode("button", {
                        title: "Ausrichten",
                        onClick: _cache[1] || (_cache[1] = $event => (loadTool('AdjustAngle'))),
                        class: normalizeClass([(tool.value == 'AdjustAngle') ? 'active' : '', "uk-button uk-button-default uk-button-small uk-background-default tool-button"])
                      }, [
                        createVNode(_component_font_awesome_icon, { icon: ['fas', 'rotate'] })
                      ], 2 /* CLASS */),
                      createElementVNode("button", {
                        title: "Vektorisieren",
                        onClick: _cache[2] || (_cache[2] = $event => (loadTool('Vectorize'))),
                        class: normalizeClass([(tool.value == 'Vectorize') ? 'active' : '', "uk-button uk-button-default uk-button-small uk-background-default tool-button"])
                      }, [
                        createVNode(_component_font_awesome_icon, { icon: ['fas', 'bezier-curve'] })
                      ], 2 /* CLASS */)
                    ])
                  ]),
                  createElementVNode("div", _hoisted_28$3, [
                    (openBlock(), createBlock(resolveDynamicComponent(morphs[tool.value]), mergeProps(toolProp[tool.value], { onToolEvent: toolReceive }), null, 16 /* FULL_PROPS */))
                  ])
                ]),
                createElementVNode("div", { class: "last-box" }, [
                  createElementVNode("button", {
                    class: "uk-button uk-button-default uk-button-small uk-button-primary save-button",
                    onClick: save
                  }, "speichern")
                ])
              ]))
            : createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ])
  ], 2 /* CLASS */))
}
}

};

script$m.__file = "src/bundles/vidge/Vidge.vue";

class ViciTools {

    constructor(vici) {

        this.vici = vici;
        this.Resize = new Resize(vici);
        this.Vectorize = new Vectorize(vici);
        this.AdjustAngle = new AdjustAngle(vici);

    }

}

class Resize {

    constructor(vici) {
        this.vici = vici;
    }
    /** Bildskalierung vom Mittelpunkt mittels Motivgröße im Endformat*/

    // setzen der Elementgröße unter Angabe der Orginalgröße
    setSize(newSize) {
        const im = this.vici.selectedElement;
        if (!im) return

        const gb = im.geometricBounds;

        let oldSize = im.getSize();

        let growX = (newSize[0] - oldSize[0]);
        let growY = (newSize[1] - oldSize[1]);

        let gbNew = {
            geometricBounds: [
                gb[0] - growX / 2,
                gb[1] - growY / 2,
                gb[0] - growX / 2 + newSize[0],
                gb[1] - growY / 2 + newSize[1]
            ]
        };

        im.set(gbNew, { animate: false });

    }

    setOriginalSize(newSize) {

        newSize = [
            newSize[0] * this.vici.originalScale[0],
            newSize[1] * this.vici.originalScale[1],
        ];

        this.setSize(newSize);
        this.vici.onChange?.();
    }

    /** Bildskalierung vom Mittelpunkt mittels Zoom-Faktor*/

    setImgZoom(zoom, animate) {

        const im = this.vici.selectedElement;
        if (!im) return

        let oldZoom = im.zoom;
        im.zoom = zoom;

        const gb = im.geometricBounds;

        let oldSize = [im._initialSize[0] * oldZoom / 100, im._initialSize[1] * oldZoom / 100];
        //let oldSize =  im.getSize()
        let newSize = [im._initialSize[0] * zoom / 100, im._initialSize[1] * zoom / 100];

        let growX = (newSize[0] - oldSize[0]);
        let growY = (newSize[1] - oldSize[1]);

        let gbNew = {
            geometricBounds: [
                gb[0] - growX / 2,
                gb[1] - growY / 2,
                gb[0] - growX / 2 + newSize[0],
                gb[1] - growY / 2 + newSize[1]
            ]
        };



        im.set(gbNew, { animate: false });


        // TODO set clipping
    }

    getImgZoom() {
        const im = this.vici.selectedElement;
        if (!im) return

        if (!im.zoom) im.zoom = 100;
        return im.zoom
    }

        changeEnd() {
            this.vici.onChangeEnd?.();
        }

}

class AdjustAngle {
    constructor(vici) {
        this.vici = vici;
    }
    /** Bildskalierung vom Mittelpunkt mittels Motivgröße im Endformat*/

    // setzen der Elementgröße unter Angabe der Orginalgröße
    setAngle(newAngle) {
        const im = this.vici.selectedElement;
        if (!im) return

        let trNew = {
            transform: {
                rotate: newAngle,
                scale: this.scaleToFill(newAngle)
            }

        };

        im.set(trNew, { animate: false });
        this.vici.onChange?.();

    }

    setGrid() {
        const im = this.vici.selectedElement;
        this.vici.setGrid(im, [3, 3]);
    }
    unsetGrid() {
        const im = this.vici.selectedElement;
        this.vici.unsetGrid(im);
    }

    // Berechne Skalierungsfaktor um rechteckigen Hintergrund vollständig zu füllen
    scaleToFill(angle) {

        const im = this.vici.selectedElement;

        let size = im.getSize();

        // Berechnung scale in x-Richtung
        let omega = Math.atan(size[1] / size[0]) * 180 / Math.PI;
        let beta = omega - Math.abs(angle);
        let scaleX = Math.sqrt(size[0] ** 2 + size[1] ** 2) * Math.cos(beta * Math.PI / 180) / size[0];

        // Berechnung scale in y-Richtung
        let omega2 = Math.atan(size[0] / size[1]) * 180 / Math.PI;
        let gamma = omega2 - Math.abs(angle);
        let scaleY = Math.sqrt(size[0] ** 2 + size[1] ** 2) * Math.cos(gamma * Math.PI / 180) / size[1];

        // Bild soll nicht verzerrt werden, daher wird der größere Wert genommen
        let scale = Math.max(scaleX, scaleY);

        return [scale, scale]

    }

        changeEnd() {
            this.vici.onChangeEnd?.();
        }

    s
}

class Vectorize {

    constructor(vici) {
        this.vici = vici;
    }

    /** Image Filter */

    setImgFilter(filter) {
        const im = this.vici.selectedElement;
        if (!im) return
        this.vectFilter = { ...this.filter, ...filter };
        im.userimage._svgjs.node.style.filter = this.getCSSFilter(im);
        return {}
    }

    unsetImgFilter() {
        this.filterString = "";
        const im = this.vici.selectedElement;
        if (!im) return
        im.userimage._svgjs.node.style.filter = "";
        return {}
    }

    /** Berechne CSS Filter string abhängig von Bildgröße (Blur kann nicht als Prozentwert angegeben werden) */
    getCSSFilter(im, size) {

        let imgsize = im.getSize();
        if (size) imgsize = size;
        let blurpx = this.vectFilter.blur / 1000 * Math.max(...imgsize);

        // In CSS existiert kein threshhold Filter. Die Kombination aus brightness, gayscale und contrast 
        // kann das verhalten simulieren, liefert aber kein absolutes s/w Bild (es bleiben Grauwerte)  
        let thval = 3 * parseInt(this.vectFilter.threshhold);
        return "blur(" + blurpx + "px) brightness(" + thval + "%) grayscale(100%) contrast(1000%)"
    }

    vectFinish() {

        var isFinished;
        let promise = new Promise(function (resolve) {
            isFinished = resolve;
        });

        const im = this.vici.selectedElement;
        if (!im) return
        let imgNode = im.userimage._svgjs.node;
        let downloadedImg = new Image();
        downloadedImg.crossOrigin = "use-credentials";
        downloadedImg.src = imgNode.href.baseVal;

        let canvas = document.createElement("canvas");

        let that = this;

        downloadedImg.onload = function () {
            let scaledSize = fitin(downloadedImg, [2000, 2000]);
            downloadedImg.style.filter = "contrast(1000%)";
            let ctx = canvas.getContext('2d');
            ctx.canvas.width = scaledSize[0];
            ctx.canvas.height = scaledSize[1];
            // document.querySelector("body").appendChild(canvas)
            // document.querySelector("body").appendChild(downloadedImg)

            ctx.filter = that.getCSSFilter(im, scaledSize);
            ctx.drawImage(downloadedImg, 0, 0, scaledSize[0], scaledSize[1]);
            let imgd = ImageTracer.getImgdata(canvas);
            let svgstr = ImageTracer.imagedataToSVG(imgd, 'posterized1');

            imgNode.href.baseVal = "";
            imgNode.onload = function () {
                isFinished();
            };
            that.unsetImgFilter();
            imgNode.href.baseVal = svgToDataUrl(svgstr);

        };

        return promise
    }



}

class ViciElement {

    constructor(setup) {

        for (var par in setup) {
            this[par] = setup[par];
        }
        this.init();
    }

    /* testen auf geometricBounds 
    *  Werden geometricBounds erstmalig gesetzt wird der zoom Wert auf 100 festgelegt
    */
    init() {
        const gb = this.geometricBounds;
        if (gb && this.zoom && !this._initialSize) {
            this._initialSize = [
                (gb[2] - gb[0]) / (this.zoom / 100),
                (gb[3] - gb[1]) / (this.zoom / 100),
            ];
        }
        if (gb && !this.zoom && (gb[2] - gb[0]) > 0 && (gb[3] - gb[1]) > 0) {
            this.zoom = 100;
            this._initialSize = [
                (gb[2] - gb[0]) * this.zoom / 100,
                (gb[3] - gb[1]) * this.zoom / 100,
            ];
        }
    }

    getSize() {

        if (!this.geometricBounds) return [0, 0]

        const gb = this.geometricBounds;

        return [gb[2] - gb[0], gb[3] - gb[1]]

    }

    getOriginalSize() {

        let size = this.getSize();
        return [
            size[0] / this._parent.originalScale[0],
            size[1] / this._parent.originalScale[1]
        ]
    }

    setSize(size, options) {

        if (!Array.isArray(size) || size.length != 2) {
            logger.warn("wrong argument for size");
            return false
        }
        if (!this.geometricBounds) this.geometricBounds = [0, 0];

        let gb = this.geometricBounds;
        let gbNew = {
            geometricBounds: [
                gb[0],
                gb[1],
                gb[0] + size[0],
                gb[3] + size[1]
            ]
        };

        this.set(gbNew, options);

        return this

    }

    setOriginalSize(size, options) {

        size = [
            size[0] * this._parent.originalScale[0],
            size[1] * this._parent.originalScale[1]
        ];

        return this.setSize(size, options)
    }

    getPos() {

        if (!this.geometricBounds) return [0, 0]

        const gb = this.geometricBounds;

        return [gb[0], gb[1]]
    }

    setPos(pos, options) {

        const size = this.getSize();

        let gbNew = {
            geometricBounds: [
                pos[0],
                pos[1],
                pos[0] + size[0],
                pos[1] + size[1]
            ]
        };
        logger.debug(JSON.stringify(this.geometricBounds));
        this.set(gbNew, options);

        return this
    }

    getRotation() {

        if (!this.transform) this.transform = {};

        const tr = this.transform;

        return tr.rotate

    }

    setRotation(rot, options) {

        let trNew = {
            transform: {
                rotate: rot
            }
        };

        this.set(trNew, options);

        return this

    }

    getFillColorHex() {

        if (this.fillColor?.web) return this.fillColor.web

        if (!this.fillColor?.rgb) return "#00000000"

        return color2hex(this.fillColor.rgb)

    }

    getImageClipSize() {

        if (!this.userimage) return false

        const ui = this.userimage;
        if (!ui.x && !ui.y && !ui.fitwidth && !ui.fitwidth) return null

        const gb = this.geometricBounds;

        let fitwidth = gb[2] - gb[0];
        let fitheight = gb[3] - gb[1];

        if (ui.fitwidth) fitwidth = ui.fitwidth;
        if (ui.fitheight) fitheight = ui.fitheight;

        return [fitwidth, fitheight]
    }

    getImageClipPos() {

        if (!this.userimage) return false

        const ui = this.userimage;
        if (!ui.x && !ui.y && !ui.fitwidth && !ui.fitwidth) return null

        const gb = this.geometricBounds;

        let x = 0;
        let y = 0;
        if (ui.x) x = ui.x;
        if (ui.y) y = ui.y;

        return [
            gb[0] + x,
            gb[1] + y
        ]
    }

    /*
    * Setter function. Triggert rendering on change 
    */

    set(param, options) {

        let that = this;
        let hasChanged = false;
        if (!options) options = {};

        if (options.scope) {
            that = options.scope;
        }

        if (typeof param == "object") {
            for (var i in param) {
                // Objekte rekursiv setzen (Ausnahme Arrays!)
                if (typeof param[i] == "object" && !Array.isArray(param[i])) {
                    // Rendern in Rekursion überspringen
                    if (this.set(param[i], { scope: that[i], skipRender: true })) hasChanged = true;
                } else {
                    if (that[i] && that[i].toString() != param[i].toString()) hasChanged = true;
                    that[i] = param[i];
                }
            }
        }

        this.init();

        // Element nur rendern wenn Werte geändert
        if (!options.skipRender) {
            if (hasChanged) {
                const viciAnimSetting = this._parent.animate;
                if (typeof options.animate == "boolean") this._parent.animate = options.animate;
                this._parent.renderElement(this);
                this._parent.animate = viciAnimSetting;
            } else {
                logger.debug(this.name + " unchanged => skip render");
            }

        }
        return hasChanged

    }

    setState(state) {

        if (this._state != state) {
            this._state = state;
            this._parent.renderElement(this);
        }
    }

    getEditId() {

        if (!this._editId) {
            this._editId = "vic_" + uniqueId() + "_" + this.name;
        }
        return this._editId
    }

    getTextFormat() {

        // liefert textformatierung im SVG format (font-Attribute)

        let attr = {};

        if (this.font) attr["family"] = this.font;
        if (this.fontsize) attr["size"] = this.fontsize;
        if (this.textdecoration) attr["decoration"] = this.textdecoration;
        if (this.fontweight) attr["weight"] = this.fontweight;
        if (this.fontstyle) attr["style"] = this.fontstyle;
        if (this.fillColor) attr["fill"] = this.getFillColorHex();


        return attr
    }


}

class Printopt {
    constructor() {
        this.img = false;        // GD Image resource
        this.imgpx = [];         // Pixelmasse des Bildes in voller Auflösung
        this.targetdpi = 300;    // Druckaufloesung
        this.PID = false;
        this.method = "fillin";
        this.dest_file = "";
        this.src_file = "";
        this.th_file = "";
        this.gal_file = "";
        this.resize = false;
        this.fit = [];
        this.crop = [];
        this.trim = [];
        this.trimmark = false;
        this.totpx = [];         // Zielgröße in Pixeln
        this.totmm = [];         // Zielgröße im mm
        this.outfile = false;
        this.format = "JPEG";
        this.surface = false;    // Transparentes Overlay-Bild zur Simulation der Oberflächenstruktur
        this.bgc = false;        // custom Background color
        this.debug = false;
        this.oversizemm = [0, 0];
        this.fitOffsetX = 50;    // Verschiebung des Ausschnitts nach fit in Prozent der möglichen Verschiebung
        this.fitOffsetY = 50;    // 50 entspricht mittig
        this.min_px_size = false;
        this.printborder = [];

        this.imgloadpx = [];     // Pixelmasse des geladenen Bildes
        this.imgloadscale = [1, 1]; // Skalierung des geladenen Bildes gegenüber Orginalbild
        this.orientation = "";
        this.autoOrientation = true; // Dreht Bild Automatisch in passende Ausrichtung des Formats
        this.trimpx = [];        // Trimmgröße in Pixeln (= Formatgröße)
        this.trimmm = [];        // Trimmgröße im mm (= Formatgröße)
        this.fitpx = [];         // Fitgröße in Pixeln (= Formatgröße)
        this.fitmm = [];         // Fitgröße im mm (= Formatgröße)
        this.scale = 1;
        this.task = "calc";
        this.tempfiles = [];
        this.gd_source = false;

        /***************************************************************************************
           Die Fitmethode wird wird über vier Indices Parametrisiert  
           
          [0] Beschnitt 0=cut 1=fit 2=noresize, 3=noresize Anpassung Ausgabe-DPI 
          [1] Rand (Rand innerhalb des Formats) [mm absolut, mm relativ]
          [2] Trimmbereich (Beschnittzugabe. Rand außerhalb des Formats) [mm absolut,mm relativ]
          [3] Randoption    
                             0=kein Rand, 
                             1=weißer Rand, 
                             #<Farbe> = Randfarbe, 
                             2=gespiegelter Rand, 
                             3=Pixelwiederholung
          [4] Fitoption
                             0=fit Außenkante
                             1=fit innerer Rand
                             2=fit Trimmbereich
          
          [5] Bleed (Zusatzlicher Produktionsrand
                             [<mm>,[<marker>,..]]
                                    marker: 0=ohne
                                            1=trim
                                            2=middle
                                            3=corner
                                            4=ANR
                                            5=Thumbnail 
        
        ******************************************************************************************/

        this.initOPT = {
            "original": [0, [0, 0], [0, 0], 0, 0],
            "fillin": [0, [0, 0], [0, 0.015], 0, 0],
            "fitin": [1, [0, 0], [0, 0.015], 0, 0],
            "border": [1, [4, 0.015], [0, 0.015], 1, 1],
            "fitborder": [1, [4, 0.015], [0, 0.015], 1, 1],
            "fillborder": [0, [4, 0.015], [0, 0.015], 1, 1],
            "fillBorder": [0, [4, 0.015], [0, 0.015], 1, 1],
            "noresize": [2, [0, 0], [0, 0], 0, 0],
            "constborder": [0, [4, 0.015], [0, 0.015], 1, 1],
            "stretch": [0, [0, 0.015], [0, 0.015], 3, 2],
            "canvas": [0, [0, 0], [25, 0], 0, 0, [25, [2, 3, 4, 5]]], // DANIEL: für Icongenerierung den Wert 25 auf 75 ändern (4x)
            "canvasmirror": [0, [0, 0], [25, 0], 2, 2, [25, [2, 3, 4, 5]]],
            "canvasborder": [0, [0, 0], [25, 0], 1, 2, [25, [2, 3, 4, 5]]],
            "canvaswhiteborder": [0, [20, 0], [25, 0], 1, 1, [25, [2, 3, 4, 5]]],
            "canvasstretch": [0, [0, 0], [25, 0], 3, 2, [25, [2, 3, 4, 5]]]
        };

        this.OPT = structuredClone(this.initOPT);

        this.TMfile = {
            "default": "preview/schraffur1_400.png",
            "schraffur1": "preview/schraffur1_400.png",
            "30p_schwarz": "preview/30p_schwarz_400.png",
            "50p_schwarz": "preview/50p_schwarz_400.png",
            "50p_weiss": "preview/50p_weiss_400.png",
            "75p_weiss": "preview/75p_weiss_400.png"
        };

        this.view = {
            "print": {
                "trimmark": false,
                "render": "print"
            },
            "print_trimmark": {
                "trimmark": "schraffur1",
                "render": "print"
            },
            "povray_canvas": {
                "trimmark": false,
                "render": "povray",
                "display": "canvas"
            },
            "povray_canvas2": {
                "trimmark": false,
                "render": "povray",
                "display": "canvas2"
            },
            "original": {
                "trimmark": false,
                "render": "original"
            },
            "original_trimmark": {
                "trimmark": true,
                "render": "original"
            }
        };

        this.overlay = {
            "canvas1": {
                "file": "preview/canvas_150mm_transparent.png",
                "size_mm": [150, 150]
            }
        };
    }

    reset_opt() {
        this.autoOrientation = true;
        this.OPT = structuredClone(this.initOPT);
    }

    set_view(viewname) {
        if (this.view[viewname]) {
            const view = this.view[viewname];
            for (const param in view) {
                this[param] = view[param];
            }
        }
    }

    set_orientation(size) {
        const [width, height] = size;
        const o = width >= height ? "L" : "P";
        this.orientation = o;
        this.target_to_orientation();
    }

    target_to_orientation() {
        const o = this.orientation;

        if (this.trimmm.length > 0) {
            let [width, height] = this.trimmm;
            if ((width > height && o === "P") || (height > width && o === "L")) {
                [width, height] = [height, width];
                this.trimmm = [width, height];
            }
        }

        if (this.trimpx.length > 0) {
            let [width, height] = this.trimpx;
            if ((width > height && o === "P") || (height > width && o === "L")) {
                [width, height] = [height, width];
                this.trimpx = [width, height];
            }
        }
    }

    swap(size) {
        const [width, height] = size;
        return [height, width];
    }

    vop(v1, v2, op) {
        let v = [];

        if (!Array.isArray(v1) && !Array.isArray(v2)) {
            v1 = [v1];
            v2 = [v2];
        } else if (!Array.isArray(v1)) {
            const v1_val = v1;
            v1 = [];
            v2.forEach((val) => v1.push(v1_val));
        } else if (!Array.isArray(v2)) {
            const v2_val = v2;
            v2 = [];
            v1.forEach((val) => v2.push(v2_val));
        }

        for (let i = 0; i < v1.length; i++) {
            if (op === "+") v[i] = v1[i] + v2[i];
            else if (op === "-") v[i] = v1[i] - v2[i];
            else if (op === "*") v[i] = v1[i] * v2[i];
            else if (op === "/") v[i] = v1[i] / v2[i];
        }

        return v;
    }

    setImgpx(x, y) {
        if (arguments.length === 0) return this.imgpx;

        this.imgpx[0] = x;
        this.imgpx[1] = y;

        if (this.autoOrientation) this.set_orientation(this.imgpx);
    }

    setTrimpx(x, y) {
        if (arguments.length === 0) return this.trimpx;

        this.trimpx[0] = x;
        this.trimpx[1] = y;
        if (this.targetdpi > 0) {
            this.trimmm[0] = (this.trimpx[0] / this.targetdpi) * 25.4;
            this.trimmm[1] = (this.trimpx[1] / this.targetdpi) * 25.4;
        }
        this.target_to_orientation();
    }

    setTrimmm(x, y) {
        if (arguments.length === 0) return this.trimmm;

        this.trimmm[0] = x + this.oversizemm[0];
        this.trimmm[1] = y + this.oversizemm[1];
        if (this.targetdpi > 0) {
            this.trimpx[0] = (this.trimmm[0] / 25.4) * this.targetdpi;
            this.trimpx[1] = (this.trimmm[1] / 25.4) * this.targetdpi;
        }
        this.target_to_orientation();
    }

    opt(method, par) {

        if (!par) par = [];
        if (arguments.length === 1) return this.OPT[method];

        if (par[0] !== undefined) this.OPT[method][0] = par[0];
        if (par[1] !== undefined) this.OPT[method][1] = par[1];
        if (par[2] !== undefined) this.OPT[method][2] = par[2];
        if (par[3] !== undefined) this.OPT[method][3] = par[3];
        if (par[4] !== undefined) this.OPT[method][4] = par[4];
        if (par[5] !== undefined) this.OPT[method][5] = par[5];
    }

    setOptDefinition(method, definition) {
        if (!method || !Array.isArray(definition)) return false

        try {
            this.OPT[method] = structuredClone(definition);
        } catch (err) {
            // Fallback für reaktive Proxy-Objekte (z.B. aus Vue), die structuredClone nicht direkt klonen kann.
            this.OPT[method] = JSON.parse(JSON.stringify(definition));
        }

        return true
    }

    calc() {
        this.method = this.method.replace("-", "").toLowerCase();

        if (this.trimmark === "false") this.trimmark = 0;

        const par = this.OPT[this.method];

        if (!par) {
            logger.warn("No definition for print method " + this.method);
            return false
        }

        this.appliedOpt = par;

        let tmm = this.trimmm;
        let tpx = this.trimpx;

        this.fitmm = [...tmm];
        this.totmm = [...tmm];
        this.rtrim = [1, 1];
        this.rfit = [1, 1];
        this.rtot = [1, 1];

        if (this.bgc && !Array.isArray(this.bgc)) {
            this.bgc = this.hex2rgb(this.bgc);
        }

        if (tpx.length === 0 && tmm.length === 0) return -1;

        if (par[0] < 2) {
            if (Math.max(...par[1]) === 0 && Math.max(...par[2]) === 0) {
                this.calcFit(tmm, par[0]);
                this.trimpx = this.vop(this.fitpx, this.rframe, "/");
                this.totpx = this.trimpx;
            } else {
                const bmm = par[1][0];
                this.fitmm[0] = tmm[0] - 2 * bmm;
                this.fitmm[1] = tmm[1] - 2 * bmm;

                const tbmm = par[2][0];
                const tbrel = par[2][1];
                this.totmm[0] = tmm[0] + 2 * (tbmm + tbrel * this.totmm[0]);
                this.totmm[1] = tmm[1] + 2 * (tbmm + tbrel * this.totmm[1]);
                this.rtrim = this.vop(this.totmm, tmm, "/");
            }

            if (par[4] === 0) this.fitmm = [...this.totmm];
            if (par[4] === 2) this.fitmm = [...tmm];

            this.rfit = this.vop(this.fitmm, tmm, "/");
            this.rtot = this.vop(this.fitmm, this.totmm, "/");

            this.calcFit(this.fitmm, par[0]);

            this.printborder[0] =
                (this.fitpx[0] / this.rtot[0] - this.fitpx[0]) / 2;
            this.printborder[1] =
                (this.fitpx[1] / this.rtot[1] - this.fitpx[1]) / 2;

            this.imgpxresized = this.vop(this.imgpx, this.scale, "*");

            this.trimpx = this.vop(this.fitpx, this.rfit, "/");
            this.totpx = this.vop(this.fitpx, this.rtot, "/");
        } else {
            if (this.resize > 0) {
                const scale = this.resize / Math.max(...this.trimpx);
                this.trimpx = this.vop(this.trimpx, scale, "*");
                this.imgpxresized = this.vop(this.imgpx, scale, "*");
                this.scale = scale;
            }

            this.crop = this.vop(
                this.vop(this.trimpx, this.imgpxresized, "-"),
                2,
                "/"
            );

            this.fitpx = [...this.trimpx];
            this.totpx = [...this.trimpx];
        }

        this.trimborder = this.vop(
            this.vop(this.totpx, this.trimpx, "-"),
            2,
            "/"
        );

        return {
            imgpx: this.imgpx,
            imgpxresized: this.imgpxresized,
            trimpx: this.trimpx,
            crop: this.crop,
            fit: this.fitpx,
            totpx: this.totpx,
            scale: this.scale,
            trimborder: this.trimborder
        };
    }

    calcFit(frame, fitmode) {
        let scale = 1;

        if (fitmode > 1) return 0;

        const rx = this.imgpx[0] / frame[0];
        const ry = this.imgpx[1] / frame[1];

        let i1, i2;

        if ((rx < ry && fitmode === 0) || (rx > ry && fitmode === 1)) {
            i1 = 0;
            i2 = 1;
        } else {
            i1 = 1;
            i2 = 0;
        }

        const fit = [];
        fit[i1] = this.imgpx[i1];
        fit[i2] = (this.imgpx[i1] * frame[i2]) / frame[i1];

        const crop = [];
        crop[i1] = 0;
        crop[i2] = (fit[i2] - this.imgpx[i2]) / 2;

        const fit_to = this.OPT[this.method][4];

        if (fit_to === 0) {
            this.totpx = fit;
        } else {
            this.totpx = this.vop(fit, this.rtot, "/");
        }

        if (this.resize === "targetdpi" && this.targetdpi > 0) {
            scale = (this.totmm[0] / 25.4) * (this.targetdpi / this.totpx[0]);
        } else if (this.resize > 0) {
            scale = this.resize / Math.max(...this.totpx);
        }

        this.fitpx = this.vop(fit, scale, "*");
        this.crop = this.vop(crop, scale, "*");
        this.scale = scale;
    }

    coordSrcPrint() {
        const ps = this.vop(this.totpx, this.scale, "/");
        const is = this.imgpx;

        const r = this.vop(is, ps, "-");

        return {
            x: (r[0] * (100 - this.fitOffsetX)) / 100,
            y: (r[1] * (100 - this.fitOffsetY)) / 100,
            w: ps[0],
            h: ps[1]
        };
    }

    coordSrcFormat() {
        const ts = this.vop(this.trimpx, this.scale, "/");
        const is = this.imgpx;

        const r = this.vop(is, ts, "-");

        return {
            x: (r[0] * (100 - this.fitOffsetX)) / 100,
            y: (r[1] * (100 - this.fitOffsetY)) / 100,
            w: ts[0],
            h: ts[1]
        };
    }

    coordSrcFit(crop) {

        // Bei crop = "overflow" darf r negativ werden, 
        // d.h das Motiv darf über das Zielformat herausragen

        if (typeof crop == "undefined") crop = true;
        const fs = this.vop(this.fitpx, this.scale, "/");
        const is = this.imgpx;

        let r = this.vop(this.vop(is, fs, "-"), 2, "/");

        if (crop || crop == "overflow") {
            this.vop(this.vop(this.imgpxresized, fs, "-"), 2, "/");
            r = r.map((rv, i) => {
                if (rv < 0) {
                    fs[i] += 2 * r[i];
                    return 0;
                } else {
                    return rv;
                }
            });
        }

        return {
            x: (r[0] * (100 - this.fitOffsetX)) / 50,
            y: (r[1] * (100 - this.fitOffsetY)) / 50,
            w: fs[0],
            h: fs[1]
        };
    }

    coordTargetFit(crop) {

        // Bei crop = "overflow" darf r negativ werden, 
        // d.h das Motiv darf über das Zielformat herausragen

        if (typeof crop == "undefined") crop = true;
        const ft = this.fitpx;
        const pt = this.totpx;
        const it = this.imgpxresized;

        const r = this.vop(this.vop(pt, ft, "-"), 2, "/");

        if (crop) {
            const r2 = this.vop(this.vop(it, ft, "-"), 2, "/");
            r2.forEach((r2v, i) => {
                if (r2v < 0 || crop == "overflow") {
                    r[i] -= r2[i];
                    ft[i] = it[i];
                }
            });
        }

        return { x: r[0], y: r[1], w: ft[0], h: ft[1] };
    }

    coordTargetPrint() {
        const ps = this.totpx;
        const pb = [0, 0];
        if (this.printborder[0] > 0) pb[0] = this.printborder[0];
        if (this.printborder[1] > 0) pb[1] = this.printborder[1];

        return { x: pb[0], y: pb[1], w: ps[0], h: ps[1] };
    }

    coordTargetFormat() {
        const ts = this.trimpx;
        const ps = this.totpx;

        const r = this.vop(ps, ts, "-");

        const x1 = r[0] / 2;
        const y1 = r[1] / 2;

        return { x: x1, y: y1, w: ts[0], h: ts[1] };
    }

    coordCubeTiles() { }

    hex2rgb(hex) {
        const color = hex.replace("#", "");
        return [
            parseInt(color.substr(0, 2), 16),
            parseInt(color.substr(2, 2), 16),
            parseInt(color.substr(4, 2), 16)
        ];
    }
}

/**
 * @description Loop Subdivision Surface
 * @about       Smooth subdivision surface modifier for use with three.js BufferGeometry.
 * @author      Stephens Nunnally <@stevinz>
 * @license     MIT - Copyright (c) 2022 Stephens Nunnally
 * @source      https://github.com/stevinz/three-subdivide
 */
/////////////////////////////////////////////////////////////////////////////////////
//
//  Functions
//      modify              Applies Loop subdivision to BufferGeometry, returns new BufferGeometry
//      edgeSplit           Splits all triangles at edges shared by coplanar triangles
//      flat                One iteration of Loop subdivision, without point averaging
//      smooth              One iteration of Loop subdivision, with point averaging
//
//  Info
//      This modifier uses the Loop (Charles Loop, 1987) subdivision surface algorithm to smooth
//      modern three.js BufferGeometry.
//
//      At one point, three.js included a subdivision surface modifier in the extended examples (see bottom
//      of file for links), it was removed in r125. The modifier was originally based on the Catmull-Clark
//      algorithm, which works best for geometry with convex coplanar n-gon faces. In three.js r60 the modifier
//      was changed to utilize the Loop algorithm. The Loop algorithm was designed to work better with triangle
//      based meshes.
//
//      The Loop algorithm, however, doesn't always provide uniform results as the vertices are
//      skewed toward the most used vertex positions. A triangle based box (e.g. BoxGeometry for example) will
//      tend to favor the corners. To alleviate this issue, this implementation includes an initial pass to split
//      coplanar faces at their shared edges. It starts by splitting along the longest shared edge first, and then
//      from that midpoint it splits to any remaining coplanar shared edges.
//
//      Also by default, this implementation inserts new uv coordinates, but does not average them using the Loop
//      algorithm. In some cases (often in flat geometries) this will produce undesired results, a
//      noticeable tearing will occur. In such cases, try passing 'uvSmooth' as true to enable uv averaging.
//
//  Note(s)
//      - This modifier returns a new BufferGeometry instance, it does not dispose() of the old geometry.
//
//      - This modifier returns a NonIndexed geometry. An Indexed geometry can be created by using the
//        BufferGeometryUtils.mergeVertices() function, see:
//        https://threejs.org/docs/?q=buffer#examples/en/utils/BufferGeometryUtils.mergeVertices
//
//      - This modifier works best with geometry whose triangles share edges AND edge vertices. See diagram below.
//
//          OKAY          NOT OKAY
//            O              O
//           /|\            / \
//          / | \          /   \
//         /  |  \        /     \
//        O---O---O      O---O---O
//         \  |  /        \  |  /
//          \ | /          \ | /
//           \|/            \|/
//            O              O
//
//  Reference(s)
//      - Subdivision Surfaces
//          https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/thesis-10.pdf
//          https://en.wikipedia.org/wiki/Loop_subdivision_surface
//          https://cseweb.ucsd.edu/~alchern/teaching/cse167_fa21/6-3Surfaces.pdf
//
//      - Original three.js SubdivisionModifier, r124 (Loop)
//          https://github.com/mrdoob/three.js/blob/r124/examples/jsm/modifiers/SubdivisionModifier.js
//
//      - Original three.js SubdivisionModifier, r59 (Catmull-Clark)
//          https://github.com/mrdoob/three.js/blob/r59/examples/js/modifiers/SubdivisionModifier.js
//
/////////////////////////////////////////////////////////////////////////////////////


///// Constants

const POSITION_DECIMALS = 2;

///// Local Variables

const _average = new THREE.Vector3();
const _center = new THREE.Vector3();
const _midpoint = new THREE.Vector3();
const _normal = new THREE.Vector3();
const _temp = new THREE.Vector3();

const _vector0 = new THREE.Vector3(); // .Vector4();
const _vector1 = new THREE.Vector3(); // .Vector4();
const _vector2 = new THREE.Vector3(); // .Vector4();
const _vec0to1 = new THREE.Vector3();
const _vec1to2 = new THREE.Vector3();
const _vec2to0 = new THREE.Vector3();

const _position = [
    new THREE.Vector3(),
    new THREE.Vector3(),
    new THREE.Vector3(),
];

const _vertex = [
    new THREE.Vector3(),
    new THREE.Vector3(),
    new THREE.Vector3(),
];

const _triangle = new THREE.Triangle();

/////////////////////////////////////////////////////////////////////////////////////
/////   Loop Subdivision Surface
/////////////////////////////////////////////////////////////////////////////////////

/** Loop subdivision surface modifier for use with modern three.js BufferGeometry */
class LoopSubdivision {

    /////////////////////////////////////////////////////////////////////////////////////
    /////   Modify
    ////////////////////

    /**
     * Applies Loop subdivision modifier to geometry
     *
     * @param {Object} bufferGeometry - Three.js geometry to be subdivided
     * @param {Number} iterations - How many times to run subdividion
     * @param {Object} params - Optional parameters object, see below
     * @returns {Object} Returns new, subdivided, three.js BufferGeometry object
     *
     * Optional Parameters Object
     * @param {Boolean} split - Should coplanar faces be divided along shared edges before running Loop subdivision?
     * @param {Boolean} uvSmooth - Should UV values be averaged during subdivision?
     * @param {Boolean} preserveEdges - Should edges / breaks in geometry be ignored during subdivision?
     * @param {Boolean} flatOnly - If true, subdivision generates triangles, but does not modify positions
     * @param {Number} maxTriangles - If geometry contains more than this many triangles, subdivision will not continue
     * @param {Number} weight - How much to weigh favoring heavy corners vs favoring Loop's formula
     */
    static modify(bufferGeometry, iterations = 1, params = {}) {
        if (arguments.length > 3) console.warn(`LoopSubdivision.modify() now uses a parameter object. See readme for more info!`);

        if (typeof params !== 'object') params = {};

        ///// Parameters
        if (params.split === undefined) params.split = true;
        if (params.uvSmooth === undefined) params.uvSmooth = false;
        if (params.preserveEdges === undefined) params.preserveEdges = false;
        if (params.flatOnly === undefined) params.flatOnly = false;
        if (params.maxTriangles === undefined) params.maxTriangles = Infinity;
        if (params.weight === undefined) params.weight = 1;
        if (isNaN(params.weight) || !isFinite(params.weight)) params.weight = 1;
        params.weight = Math.max(0, (Math.min(1, params.weight)));

        ///// Geometries
        if (! verifyGeometry(bufferGeometry)) return bufferGeometry;
        let modifiedGeometry = bufferGeometry.clone();

        ///// Presplit
        if (params.split) {
            const splitGeometry = LoopSubdivision.edgeSplit(modifiedGeometry);
            modifiedGeometry.dispose();
            modifiedGeometry = splitGeometry;
        }

        ///// Apply Subdivision
        for (let i = 0; i < iterations; i++) {
            let currentTriangles = modifiedGeometry.attributes.position.count / 3;
            if (currentTriangles < params.maxTriangles) {
                let subdividedGeometry;

                // Subdivide
                if (params.flatOnly) {
                    subdividedGeometry = LoopSubdivision.flat(modifiedGeometry, params);
                } else {
                    subdividedGeometry = LoopSubdivision.smooth(modifiedGeometry, params);
                }

                // Copy and Resize Groups
                modifiedGeometry.groups.forEach((group) => {
                    subdividedGeometry.addGroup(group.start * 4, group.count * 4, group.materialIndex);
                });

                // Clean Up
                modifiedGeometry.dispose();
                modifiedGeometry = subdividedGeometry;
            }
        }

        ///// Return New Geometry
        return modifiedGeometry;
    }

    /////////////////////////////////////////////////////////////////////////////////////
    /////   Split Hypotenuse
    ////////////////////

    /**
     * Applies one iteration of split subdivision. Splits all triangles at edges shared by coplanar triangles.
     * Starts by splitting at longest shared edge, followed by splitting from that new center edge point to the
     * center of any other shared edges.
     */
    static edgeSplit(geometry) {

        ///// Geometries
        if (! verifyGeometry(geometry)) return geometry;
        const existing = (geometry.index !== null) ? geometry.toNonIndexed() : geometry.clone();
        const split = new THREE.BufferGeometry();

        ///// Attributes
        const attributeList = gatherAttributes(existing);
        const vertexCount = existing.attributes.position.count;
        const posAttribute = existing.getAttribute('position');
        const norAttribute = existing.getAttribute('normal');
        const edgeHashToTriangle = {};
        const triangleEdgeHashes = [];
        const edgeLength = {};
        const triangleExist = [];

        ///// Edges
        for (let i = 0; i < vertexCount; i += 3) {

            // Positions
            _vector0.fromBufferAttribute(posAttribute, i + 0);
            _vector1.fromBufferAttribute(posAttribute, i + 1);
            _vector2.fromBufferAttribute(posAttribute, i + 2);
            _normal.fromBufferAttribute(norAttribute, i);
            const vecHash0 = hashFromVector(_vector0);
            const vecHash1 = hashFromVector(_vector1);
            const vecHash2 = hashFromVector(_vector2);

            // Verify Area
            const triangleSize = _triangle.set(_vector0, _vector1, _vector2).getArea();
            triangleExist.push(! fuzzy(triangleSize, 0));
            if (! triangleExist[i / 3]) {
                triangleEdgeHashes.push([]);
                continue;
            }

            // Calculate Normals
            calcNormal(_normal, _vector0, _vector1, _vector2);
            const normalHash = hashFromVector(_normal);

            // Vertex Hashes
            const hashes = [
                `${vecHash0}_${vecHash1}_${normalHash}`, // [0]: 0to1
                `${vecHash1}_${vecHash0}_${normalHash}`, // [1]: 1to0
                `${vecHash1}_${vecHash2}_${normalHash}`, // [2]: 1to2
                `${vecHash2}_${vecHash1}_${normalHash}`, // [3]: 2to1
                `${vecHash2}_${vecHash0}_${normalHash}`, // [4]: 2to0
                `${vecHash0}_${vecHash2}_${normalHash}`, // [5]: 0to2
            ];

            // Store Edge Hashes
            const index = i / 3;
            for (let j = 0; j < hashes.length; j++) {
                // Attach Triangle Index to Edge Hash
                if (! edgeHashToTriangle[hashes[j]]) edgeHashToTriangle[hashes[j]] = [];
                edgeHashToTriangle[hashes[j]].push(index);

                // Edge Length
                if (! edgeLength[hashes[j]]) {
                    if (j === 0 || j === 1) edgeLength[hashes[j]] = _vector0.distanceTo(_vector1);
                    if (j === 2 || j === 3) edgeLength[hashes[j]] = _vector1.distanceTo(_vector2);
                    if (j === 4 || j === 5) edgeLength[hashes[j]] = _vector2.distanceTo(_vector0);
                }
            }

            // Triangle Edge Reference
            triangleEdgeHashes.push([ hashes[0], hashes[2], hashes[4] ]);
        }

        ///// Build Geometry, Set Attributes
        attributeList.forEach((attributeName) => {
            const attribute = existing.getAttribute(attributeName);
            if (! attribute) return;
            const floatArray = splitAttribute(attribute, attributeName);
            split.setAttribute(attributeName, new THREE.BufferAttribute(floatArray, attribute.itemSize));
        });

        ///// Morph Attributes
        const morphAttributes = existing.morphAttributes;
        for (const attributeName in morphAttributes) {
            const array = [];
            const morphAttribute = morphAttributes[attributeName];

            // Process Array of Float32BufferAttributes
            for (let i = 0, l = morphAttribute.length; i < l; i++) {
                if (morphAttribute[i].count !== vertexCount) continue;
                const floatArray = splitAttribute(morphAttribute[i], attributeName, true);
                array.push(new THREE.BufferAttribute(floatArray, morphAttribute[i].itemSize));
            }
            split.morphAttributes[attributeName] = array;
        }
        split.morphTargetsRelative = existing.morphTargetsRelative;

        // Clean Up, Return New Geometry
        existing.dispose();
        return split;

        // Loop Subdivide Function
        function splitAttribute(attribute, attributeName, morph = false) {
            const newTriangles = 4; /* maximum number of new triangles */
            const arrayLength = (vertexCount * attribute.itemSize) * newTriangles;
            const floatArray = new attribute.array.constructor(arrayLength);

            const processGroups = (attributeName === 'position' && ! morph && existing.groups.length > 0);
            let groupStart = undefined, groupMaterial = undefined;

            let index = 0;
            let skipped = 0;
            let step = attribute.itemSize;
            for (let i = 0; i < vertexCount; i += 3) {

                // Verify Triangle is Valid
                if (! triangleExist[i / 3]) {
                    skipped += 3;
                    continue;
                }

                // Get Triangle Points
                _vector0.fromBufferAttribute(attribute, i + 0);
                _vector1.fromBufferAttribute(attribute, i + 1);
                _vector2.fromBufferAttribute(attribute, i + 2);

                // Check for Shared Edges
                const existingIndex = i / 3;
                const edgeHash0to1 = triangleEdgeHashes[existingIndex][0];
                const edgeHash1to2 = triangleEdgeHashes[existingIndex][1];
                const edgeHash2to0 = triangleEdgeHashes[existingIndex][2];

                const edgeCount0to1 = edgeHashToTriangle[edgeHash0to1].length;
                const edgeCount1to2 = edgeHashToTriangle[edgeHash1to2].length;
                const edgeCount2to0 = edgeHashToTriangle[edgeHash2to0].length;
                const sharedCount = (edgeCount0to1 + edgeCount1to2 + edgeCount2to0) - 3;

                // New Index (Before New Triangles, used for Groups)
                const loopStartIndex = ((index * 3) / step) / 3;

                // No Shared Edges
                if (sharedCount === 0) {
                    setTriangle(floatArray, index, step, _vector0, _vector1, _vector2); index += (step * 3);

                // Shared Edges
                } else {
                    const length0to1 = edgeLength[edgeHash0to1];
                    const length1to2 = edgeLength[edgeHash1to2];
                    const length2to0 = edgeLength[edgeHash2to0];

                    // Add New Triangle Positions
                    if ((length0to1 > length1to2 || edgeCount1to2 <= 1) &&
                        (length0to1 > length2to0 || edgeCount2to0 <= 1) && edgeCount0to1 > 1) {
                        _center.copy(_vector0).add(_vector1).divideScalar(2.0);
                        if (edgeCount2to0 > 1) {
                            _midpoint.copy(_vector2).add(_vector0).divideScalar(2.0);
                            setTriangle(floatArray, index, step, _vector0, _center, _midpoint); index += (step * 3);
                            setTriangle(floatArray, index, step, _center, _vector2, _midpoint); index += (step * 3);
                        } else {
                            setTriangle(floatArray, index, step, _vector0, _center, _vector2); index += (step * 3);
                        }
                        if (edgeCount1to2 > 1) {
                            _midpoint.copy(_vector1).add(_vector2).divideScalar(2.0);
                            setTriangle(floatArray, index, step, _center, _vector1, _midpoint); index += (step * 3);
                            setTriangle(floatArray, index, step, _midpoint, _vector2, _center); index += (step * 3);
                        } else {
                            setTriangle(floatArray, index, step, _vector1, _vector2, _center); index += (step * 3);
                        }

                    } else if ((length1to2 > length2to0 || edgeCount2to0 <= 1) && edgeCount1to2 > 1) {
                        _center.copy(_vector1).add(_vector2).divideScalar(2.0);
                        if (edgeCount0to1 > 1) {
                            _midpoint.copy(_vector0).add(_vector1).divideScalar(2.0);
                            setTriangle(floatArray, index, step, _center, _midpoint, _vector1); index += (step * 3);
                            setTriangle(floatArray, index, step, _midpoint, _center, _vector0); index += (step * 3);
                        } else {
                            setTriangle(floatArray, index, step, _vector1, _center, _vector0); index += (step * 3);
                        }
                        if (edgeCount2to0 > 1) {
                            _midpoint.copy(_vector2).add(_vector0).divideScalar(2.0);
                            setTriangle(floatArray, index, step, _center, _vector2, _midpoint); index += (step * 3);
                            setTriangle(floatArray, index, step, _midpoint, _vector0, _center); index += (step * 3);
                        } else {
                            setTriangle(floatArray, index, step, _vector2, _vector0, _center); index += (step * 3);
                        }

                    } else if (edgeCount2to0 > 1) {
                        _center.copy(_vector2).add(_vector0).divideScalar(2.0);
                        if (edgeCount1to2 > 1) {
                            _midpoint.copy(_vector1).add(_vector2).divideScalar(2.0);
                            setTriangle(floatArray, index, step, _vector2, _center, _midpoint); index += (step * 3);
                            setTriangle(floatArray, index, step, _center, _vector1, _midpoint); index += (step * 3);
                        } else {
                            setTriangle(floatArray, index, step, _vector2, _center, _vector1); index += (step * 3);
                        }
                        if (edgeCount0to1 > 1) {
                            _midpoint.copy(_vector0).add(_vector1).divideScalar(2.0);
                            setTriangle(floatArray, index, step, _vector0, _midpoint, _center); index += (step * 3);
                            setTriangle(floatArray, index, step, _midpoint, _vector1, _center); index += (step * 3);
                        } else {
                            setTriangle(floatArray, index, step, _vector0, _vector1, _center); index += (step * 3);
                        }

                    } else {
                        setTriangle(floatArray, index, step, _vector0, _vector1, _vector2); index += (step * 3);
                    }
                }

                // Process Groups
                if (processGroups) {
                    existing.groups.forEach((group) => {
                        if (group.start === (i - skipped)) {
                            if (groupStart !== undefined && groupMaterial !== undefined) {
                                split.addGroup(groupStart, loopStartIndex - groupStart, groupMaterial);
                            }
                            groupStart = loopStartIndex;
                            groupMaterial = group.materialIndex;
                        }
                    });
                }

                // Reset Skipped Triangle Counter
                skipped = 0;
            }

            // Resize Array
            const reducedCount = (index * 3) / step;
            const reducedArray = new attribute.array.constructor(reducedCount);
            for (let i = 0; i < reducedCount; i++) {
                reducedArray[i] = floatArray[i];
            }

            // Final Group
            if (processGroups && groupStart !== undefined && groupMaterial !== undefined) {
                split.addGroup(groupStart, (((index * 3) / step) / 3) - groupStart, groupMaterial);
            }

            return reducedArray;
        }
    }

    /////////////////////////////////////////////////////////////////////////////////////
    /////   Flat
    ////////////////////

    /** Applies one iteration of Loop (flat) subdivision (1 triangle split into 4 triangles) */
    static flat(geometry, params = {}) {

        ///// Geometries
        if (! verifyGeometry(geometry)) return geometry;
        const existing = (geometry.index !== null) ? geometry.toNonIndexed() : geometry.clone();
        const loop = new THREE.BufferGeometry();

        ///// Attributes
        const attributeList = gatherAttributes(existing);
        const vertexCount = existing.attributes.position.count;

        ///// Build Geometry
        attributeList.forEach((attributeName) => {
            const attribute = existing.getAttribute(attributeName);
            if (! attribute) return;

            loop.setAttribute(attributeName, LoopSubdivision.flatAttribute(attribute, vertexCount, params));
        });

        ///// Morph Attributes
        const morphAttributes = existing.morphAttributes;
        for (const attributeName in morphAttributes) {
            const array = [];
            const morphAttribute = morphAttributes[attributeName];

            // Process Array of Float32BufferAttributes
			for (let i = 0, l = morphAttribute.length; i < l; i++) {
                if (morphAttribute[i].count !== vertexCount) continue;
                array.push(LoopSubdivision.flatAttribute(morphAttribute[i], vertexCount, params));
            }
            loop.morphAttributes[attributeName] = array;
        }
        loop.morphTargetsRelative = existing.morphTargetsRelative;

        ///// Clean Up
        existing.dispose();
        return loop;
    }

    static flatAttribute(attribute, vertexCount, params = {}) {
        const newTriangles = 4;
        const arrayLength = (vertexCount * attribute.itemSize) * newTriangles;
        const floatArray = new attribute.array.constructor(arrayLength);

        let index = 0;
        let step = attribute.itemSize;
        for (let i = 0; i < vertexCount; i += 3) {

            // Original Vertices
            _vector0.fromBufferAttribute(attribute, i + 0);
            _vector1.fromBufferAttribute(attribute, i + 1);
            _vector2.fromBufferAttribute(attribute, i + 2);

            // Midpoints
            _vec0to1.copy(_vector0).add(_vector1).divideScalar(2.0);
            _vec1to2.copy(_vector1).add(_vector2).divideScalar(2.0);
            _vec2to0.copy(_vector2).add(_vector0).divideScalar(2.0);

            // Add New Triangle Positions
            setTriangle(floatArray, index, step, _vector0, _vec0to1, _vec2to0); index += (step * 3);
            setTriangle(floatArray, index, step, _vector1, _vec1to2, _vec0to1); index += (step * 3);
            setTriangle(floatArray, index, step, _vector2, _vec2to0, _vec1to2); index += (step * 3);
            setTriangle(floatArray, index, step, _vec0to1, _vec1to2, _vec2to0); index += (step * 3);
        }

        return new THREE.BufferAttribute(floatArray, attribute.itemSize);
    }

    /////////////////////////////////////////////////////////////////////////////////////
    /////   Smooth
    ////////////////////

    /** Applies one iteration of Loop (smooth) subdivision (1 triangle split into 4 triangles) */
    static smooth(geometry, params = {}) {

        if (typeof params !== 'object') params = {};

        ///// Parameters
        if (params.uvSmooth === undefined) params.uvSmooth = false;
        if (params.preserveEdges === undefined) params.preserveEdges = false;

        ///// Geometries
        if (! verifyGeometry(geometry)) return geometry;
        const existing = (geometry.index !== null) ? geometry.toNonIndexed() : geometry.clone();
        const flat = LoopSubdivision.flat(existing, params);
        const loop = new THREE.BufferGeometry();

        ///// Attributes
        const attributeList = gatherAttributes(existing);
        const vertexCount = existing.attributes.position.count;
        const posAttribute = existing.getAttribute('position');
        const flatPosition = flat.getAttribute('position');
        const hashToIndex = {};             // Position hash mapped to index values of same position
        const existingNeighbors = {};       // Position hash mapped to existing vertex neighbors
        const flatOpposites = {};           // Position hash mapped to new edge point opposites
        const existingEdges = {};

        function addNeighbor(posHash, neighborHash, index) {
            if (! existingNeighbors[posHash]) existingNeighbors[posHash] = {};
            if (! existingNeighbors[posHash][neighborHash]) existingNeighbors[posHash][neighborHash] = [];
            existingNeighbors[posHash][neighborHash].push(index);
        }

        function addOpposite(posHash, index) {
            if (! flatOpposites[posHash]) flatOpposites[posHash] = [];
            flatOpposites[posHash].push(index);
        }

        function addEdgePoint(posHash, edgeHash) {
            if (! existingEdges[posHash]) existingEdges[posHash] = new Set();
            existingEdges[posHash].add(edgeHash);
        }

        ///// Existing Vertex Hashes
        for (let i = 0; i < vertexCount; i += 3) {
            const posHash0 = hashFromVector(_vertex[0].fromBufferAttribute(posAttribute, i + 0));
            const posHash1 = hashFromVector(_vertex[1].fromBufferAttribute(posAttribute, i + 1));
            const posHash2 = hashFromVector(_vertex[2].fromBufferAttribute(posAttribute, i + 2));

            // Neighbors (of Existing Geometry)
            addNeighbor(posHash0, posHash1, i + 1);
            addNeighbor(posHash0, posHash2, i + 2);
            addNeighbor(posHash1, posHash0, i + 0);
            addNeighbor(posHash1, posHash2, i + 2);
            addNeighbor(posHash2, posHash0, i + 0);
            addNeighbor(posHash2, posHash1, i + 1);

            // Opposites (of new FlatSubdivided vertices)
            _vec0to1.copy(_vertex[0]).add(_vertex[1]).divideScalar(2.0);
            _vec1to2.copy(_vertex[1]).add(_vertex[2]).divideScalar(2.0);
            _vec2to0.copy(_vertex[2]).add(_vertex[0]).divideScalar(2.0);
            const hash0to1 = hashFromVector(_vec0to1);
            const hash1to2 = hashFromVector(_vec1to2);
            const hash2to0 = hashFromVector(_vec2to0);
            addOpposite(hash0to1, i + 2);
            addOpposite(hash1to2, i + 0);
            addOpposite(hash2to0, i + 1);

            // Track Edges for 'edgePreserve'
            addEdgePoint(posHash0, hash0to1);
            addEdgePoint(posHash0, hash2to0);
            addEdgePoint(posHash1, hash0to1);
            addEdgePoint(posHash1, hash1to2);
            addEdgePoint(posHash2, hash1to2);
            addEdgePoint(posHash2, hash2to0);
        }

        ///// Flat Position to Index Map
        for (let i = 0; i < flat.attributes.position.count; i++) {
            const posHash = hashFromVector(_temp.fromBufferAttribute(flatPosition, i));
            if (! hashToIndex[posHash]) hashToIndex[posHash] = [];
            hashToIndex[posHash].push(i);
        }

        ///// Build Geometry, Set Attributes
        attributeList.forEach((attributeName) => {
            const existingAttribute = existing.getAttribute(attributeName);
            const flattenedAttribute = flat.getAttribute(attributeName);
            if (existingAttribute === undefined || flattenedAttribute === undefined) return;

            const floatArray = subdivideAttribute(attributeName, existingAttribute, flattenedAttribute);
            loop.setAttribute(attributeName, new THREE.BufferAttribute(floatArray, flattenedAttribute.itemSize));
        });

        ///// Morph Attributes
        const morphAttributes = existing.morphAttributes;
        for (const attributeName in morphAttributes) {
            const array = [];
            const morphAttribute = morphAttributes[attributeName];

            // Process Array of Float32BufferAttributes
            for (let i = 0, l = morphAttribute.length; i < l; i++) {
                if (morphAttribute[i].count !== vertexCount) continue;
                const existingAttribute = morphAttribute[i];
                const flattenedAttribute = LoopSubdivision.flatAttribute(morphAttribute[i], morphAttribute[i].count, params);

                const floatArray = subdivideAttribute(attributeName, existingAttribute, flattenedAttribute);
                array.push(new THREE.BufferAttribute(floatArray, flattenedAttribute.itemSize));
            }
            loop.morphAttributes[attributeName] = array;
        }
        loop.morphTargetsRelative = existing.morphTargetsRelative;

        ///// Clean Up
        flat.dispose();
        existing.dispose();
        return loop;

        //////////

        // Loop Subdivide Function
        function subdivideAttribute(attributeName, existingAttribute, flattenedAttribute) {
            const arrayLength = (flat.attributes.position.count * flattenedAttribute.itemSize);
            const floatArray = new existingAttribute.array.constructor(arrayLength);

            // Process Triangles
            let index = 0;
            for (let i = 0; i < flat.attributes.position.count; i += 3) {

                // Process Triangle Points
                for (let v = 0; v < 3; v++) {

                    if (attributeName === 'uv' && ! params.uvSmooth) {

                        _vertex[v].fromBufferAttribute(flattenedAttribute, i + v);

                    } else if (attributeName === 'normal') { // && params.normalSmooth) {

                        _position[v].fromBufferAttribute(flatPosition, i + v);
                        const positionHash = hashFromVector(_position[v]);
                        const positions = hashToIndex[positionHash];

                        const k = Object.keys(positions).length;
                        const beta = 0.75 / k;
                        const startWeight = 1.0 - (beta * k);

                        _vertex[v].fromBufferAttribute(flattenedAttribute, i + v);
                        _vertex[v].multiplyScalar(startWeight);

                        positions.forEach(positionIndex => {
                            _average.fromBufferAttribute(flattenedAttribute, positionIndex);
                            _average.multiplyScalar(beta);
                            _vertex[v].add(_average);
                        });


                    } else { // 'position', 'color', etc...

                        _vertex[v].fromBufferAttribute(flattenedAttribute, i + v);
                        _position[v].fromBufferAttribute(flatPosition, i + v);

                        const positionHash = hashFromVector(_position[v]);
                        const neighbors = existingNeighbors[positionHash];
                        const opposites = flatOpposites[positionHash];

                        ///// Adjust Source Vertex
                        if (neighbors) {

                            // Check Edges have even Opposite Points
                            if (params.preserveEdges) {
                                const edgeSet = existingEdges[positionHash];
                                let hasPair = true;
                                for (const edgeHash of edgeSet) {
                                    if (flatOpposites[edgeHash].length % 2 !== 0) hasPair = false;
                                }
                                if (! hasPair) continue;
                            }

                            // Number of Neighbors
                            const k = Object.keys(neighbors).length;

                            ///// Loop's Formula
                            const beta = 1 / k * ((5/8) - Math.pow((3/8) + (1/4) * Math.cos(2 * Math.PI / k), 2));

                            ///// Warren's Formula
                            // const beta = (k > 3) ? 3 / (8 * k) : ((k === 3) ? 3 / 16 : 0);

                            ///// Stevinz' Formula
                            // const beta = 0.5 / k;

                            ///// Corners
                            const heavy = (1 / k) / k;

                            ///// Interpolate Beta -> Heavy
                            const weight = lerp(heavy, beta, params.weight);

                            ///// Average with Neighbors
                            const startWeight = 1.0 - (weight * k);
                            _vertex[v].multiplyScalar(startWeight);

                            for (let neighborHash in neighbors) {
                                const neighborIndices = neighbors[neighborHash];

                                _average.set(0, 0, 0);
                                for (let j = 0; j < neighborIndices.length; j++) {
                                    _average.add(_temp.fromBufferAttribute(existingAttribute, neighborIndices[j]));
                                }
                                _average.divideScalar(neighborIndices.length);

                                _average.multiplyScalar(weight);
                                _vertex[v].add(_average);
                            }

                        ///// Newly Added Edge Vertex
                        } else if (opposites && opposites.length === 2) {
                            const k = opposites.length;
                            const beta = 0.125; /* 1/8 */
                            const startWeight = 1.0 - (beta * k);
                            _vertex[v].multiplyScalar(startWeight);

                            opposites.forEach(oppositeIndex => {
                                _average.fromBufferAttribute(existingAttribute, oppositeIndex);
                                _average.multiplyScalar(beta);
                                _vertex[v].add(_average);
                            });
                        }
                    }
                }

                // Add New Triangle Position
                setTriangle(floatArray, index, flattenedAttribute.itemSize, _vertex[0], _vertex[1], _vertex[2]);
                index += (flattenedAttribute.itemSize * 3);
            }

            return floatArray;
        }

    }

}

/////////////////////////////////////////////////////////////////////////////////////
/////   Local Functions, Hash
/////////////////////////////////////////////////////////////////////////////////////

const _positionShift = Math.pow(10, POSITION_DECIMALS);

/** Compares two numbers to see if they're almost the same */
function fuzzy(a, b, tolerance = 0.00001) {
    return ((a < (b + tolerance)) && (a > (b - tolerance)));
}

/** Generates hash strong from Number */
function hashFromNumber(num, shift = _positionShift) {
    let roundedNumber = round(num * shift);
    if (roundedNumber == 0) roundedNumber = 0; /* prevent -0 (signed 0 can effect Math.atan2(), etc.) */
    return `${roundedNumber}`;
}

/** Generates hash strong from Vector3 */
function hashFromVector(vector, shift = _positionShift) {
    return `${hashFromNumber(vector.x, shift)},${hashFromNumber(vector.y, shift)},${hashFromNumber(vector.z, shift)}`;
}

function lerp(x, y, t) {
    return (1 - t) * x + t * y;
}

function round(x) {
    return (x + ((x > 0) ? 0.5 : -0.5)) << 0;
}

/////////////////////////////////////////////////////////////////////////////////////
/////   Local Functions, Geometry
/////////////////////////////////////////////////////////////////////////////////////

function calcNormal(target, vec1, vec2, vec3) {
    _temp.subVectors(vec1, vec2);
    target.subVectors(vec2, vec3);
    target.cross(_temp).normalize();
}

function gatherAttributes(geometry) {
    const desired = [ 'position', 'normal', 'uv' ];
    const contains = Object.keys(geometry.attributes);
    const attributeList = Array.from(new Set(desired.concat(contains)));
    return attributeList;
}

function setTriangle(positions, index, step, vec0, vec1, vec2) {
    if (step >= 1) {
        positions[index + 0 + (step * 0)] = vec0.x;
        positions[index + 0 + (step * 1)] = vec1.x;
        positions[index + 0 + (step * 2)] = vec2.x;
    }
    if (step >= 2) {
        positions[index + 1 + (step * 0)] = vec0.y;
        positions[index + 1 + (step * 1)] = vec1.y;
        positions[index + 1 + (step * 2)] = vec2.y;
    }
    if (step >= 3) {
        positions[index + 2 + (step * 0)] = vec0.z;
        positions[index + 2 + (step * 1)] = vec1.z;
        positions[index + 2 + (step * 2)] = vec2.z;
    }
    if (step >= 4) {
        positions[index + 3 + (step * 0)] = vec0.w;
        positions[index + 3 + (step * 1)] = vec1.w;
        positions[index + 3 + (step * 2)] = vec2.w;
    }
}

function verifyGeometry(geometry) {
    if (geometry === undefined) {
        console.warn(`LoopSubdivision: Geometry provided is undefined`);
        return false;
    }

    if (! geometry.isBufferGeometry) {
        console.warn(`LoopSubdivision: Geometry provided is not 'BufferGeometry' type`);
        return false;
    }

    if (geometry.attributes.position === undefined) {
        console.warn(`LoopSubdivision: Geometry provided missing required 'position' attribute`);
        return false;
    }

    if (geometry.attributes.normal === undefined) {
        geometry.computeVertexNormals();
    }
    return true;
}

class ThreePreview {

    constructor(domNode, setup) {

        var isLoaded, isRejected;
        this.loaded = new Promise(function (resolve, reject) {
            isLoaded = resolve;
            isRejected = reject;
        });
        this.isLoaded = isLoaded;
        this.isRejected = isRejected;

        let size = [300, 300];
        if (setup.size) size = setup.size;

        const scene = new THREE.Scene(domNode);

        const camera = new THREE.PerspectiveCamera(
            42,
            size[0] / size[1],
            0.1,
            1000
        );
        camera.position.z = 2;
        camera.position.x = 6.5;
        camera.position.y = 2;

        this.camera = camera;

        let drawingSurface = domNode;
        this._rafId = null;

        // Falls auf diesem Canvas bereits eine Preview lief, zuerst sauber freigeben.
        // Wichtig: Beim normalen Canvas-Swap KEIN forceContextLoss verwenden,
        // sonst kann der nächste WebGL-Init auf demselben Canvas fehlschlagen.
        if (drawingSurface.__ppThreePreview && typeof drawingSurface.__ppThreePreview.destroy === 'function') {
            drawingSurface.__ppThreePreview.destroy({ reason: 'rerender' });
        }

        const preserveDrawingBuffer = Boolean(setup?.preserveDrawingBuffer);

        const contextAttributes = {
            antialias: true,
            alpha: true,
            preserveDrawingBuffer,
            powerPreference: 'high-performance',
            failIfMajorPerformanceCaveat: false
        };

        const webglContext =
            drawingSurface.getContext('webgl2', contextAttributes) ||
            drawingSurface.getContext('webgl', contextAttributes) ||
            drawingSurface.getContext('experimental-webgl', contextAttributes);

        if (!webglContext) {
            throw new Error('WebGL context konnte nicht erstellt werden')
        }

        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            canvas: drawingSurface,
            context: webglContext
        });
        drawingSurface.__ppThreePreview = this;
        // Since Three r150, and Blender 3.6, lighting has changed significantly.
        //
        // this.renderer.physicallyCorrectLights = true // is now deprecated since Three r150. Use renderer.useLegacyLights = false instead.
        //
        // If exporting lights from Blender, they are very bright.
        // lights exported from blender are 10000 times brighter when used in Threejs
        // so, you can counter this by setting renderer.useLegacyLights = false
        this.renderer.useLegacyLights = false; // WebGLRenderer.physicallyCorrectLights = true is now WebGLRenderer.useLegacyLights = false
        // however, they are now still 100 times brighter in Threejs than in Blender,
        // so to try and match the threejs scene shown in video, reduce Spotlight watts in Blender to 10w.
        // The scene in blender will be lit very dull. 
        // Blender and Threejs use different renderers, they will never match. Just try your best.
        //
        this.renderer.shadowMap.enabled = true;
        this.renderer.setSize(...size);


        this.controls = new OrbitControls(camera, this.renderer.domElement);
        this.controls.enableDamping = true;

        // Add lights to the scene
        const ambientLight = new THREE.AmbientLight(0xffffff);
        scene.add(ambientLight);

        const directionalLight = new THREE.DirectionalLight(0xffffff);
        directionalLight.position.set(10, 10, 10).normalize();
        scene.add(directionalLight);

        const directionalLight2 = new THREE.DirectionalLight(0xffffff);
        directionalLight2.position.set(-10, -10, 10).normalize();
        scene.add(directionalLight2);

        const pointLight = new THREE.PointLight(0xffffff, 5, 1);
        pointLight.position.set(10, 10, 20); // Set the position of the light
        scene.add(pointLight);

        this.scene = scene;
        this.camera = camera;
        this.overlayWhiteAsTransparent = true;
        this.overlayWhiteThreshold = 0.98;
        this.useSubdivisionModifier = setup?.useSubdivisionModifier || false;
        this.subdivisionLevels = setup?.subdivisionLevels || 2;
        this.subdivisionPreserveEdges = setup?.subdivisionPreserveEdges ?? true;
        this.subdivisionMaxTriangles = setup?.subdivisionMaxTriangles ?? 120000;
        this.subdivisionExcludeMaterialNames = setup?.subdivisionExcludeMaterialNames || [];
        this.subdivisionOnlyOnMaterialNames = setup?.subdivisionOnlyOnMaterialNames || [];
    }

    setImage(path) {
        return new Promise((resolve, reject) => {
            new THREE.TextureLoader().load(
                path,
                (texture) => {
                    texture.flipY = false;
                    texture.encoding = THREE.sRGBEncoding;
                    this.imgTexture = texture;
                    if (this.printMaterial?.userData?.ppOverlayShader?.uniforms?.ppOverlayMap) {
                        this.printMaterial.userData.ppOverlayShader.uniforms.ppOverlayMap.value = texture;
                    }
                    resolve(texture);
                },
                undefined,
                (error) => {
                    logger.error('Texture konnte nicht geladen werden:', error);
                    reject(error);
                }
            );
        })
    }

    updateTexture(url) {
        return new Promise((resolve, reject) => {
            new THREE.TextureLoader().load(
                url,
                (texture) => {
                    texture.flipY = false;
                    texture.encoding = THREE.sRGBEncoding;
                    const oldTexture = this.imgTexture;
                    this.imgTexture = texture;
                    if (this.printMaterial) {
                        if (this.printMaterial?.userData?.ppOverlayShader?.uniforms?.ppOverlayMap) {
                            this.printMaterial.userData.ppOverlayShader.uniforms.ppOverlayMap.value = texture;
                        }
                        this.printMaterial.needsUpdate = true;
                    }
                    if (oldTexture && typeof oldTexture.dispose === 'function') {
                        oldTexture.dispose();
                    }
                    resolve(texture);
                },
                undefined,
                reject
            );
        })
    }

    setOverlayWhiteAsTransparent(enabled, threshold = this.overlayWhiteThreshold) {
        this.overlayWhiteAsTransparent = Boolean(enabled);
        this.overlayWhiteThreshold = Math.min(1, Math.max(0, Number(threshold) || 0.98));

        const uniforms = this.printMaterial?.userData?.ppOverlayShader?.uniforms;
        if (uniforms?.ppOverlayWhiteAsTransparent) {
            uniforms.ppOverlayWhiteAsTransparent.value = this.overlayWhiteAsTransparent ? 1 : 0;
        }
        if (uniforms?.ppOverlayWhiteThreshold) {
            uniforms.ppOverlayWhiteThreshold.value = this.overlayWhiteThreshold;
        }
        if (this.printMaterial) {
            this.printMaterial.needsUpdate = true;
        }
    }

    applyPrintOverlayMaterial(material, mesh, overlayOptions = {}) {
        if (!material || material.userData?.ppOverlayEnabled) return

        if (!mesh?.geometry?.attributes?.uv) {
            logger.warn('Overlay-Mapping nicht moeglich: Mesh hat keine UV-Koordinaten', { materialName: material.name });
            return
        }

        material.defines = material.defines || {};
        material.defines.USE_UV = '';

        const prevCacheKey = typeof material.customProgramCacheKey === 'function'
            ? material.customProgramCacheKey.bind(material)
            : null;

        const prevOnBeforeCompile = material.onBeforeCompile;

        const whiteAsTransparent = overlayOptions.whiteAsTransparent ?? this.overlayWhiteAsTransparent;
        const whiteThreshold = overlayOptions.whiteThreshold ?? this.overlayWhiteThreshold;

        material.onBeforeCompile = (shader) => {
            if (typeof prevOnBeforeCompile === 'function') {
                prevOnBeforeCompile(shader);
            }

            shader.uniforms.ppOverlayMap = { value: this.imgTexture || null };
            shader.uniforms.ppOverlayWhiteAsTransparent = { value: whiteAsTransparent ? 1 : 0 };
            shader.uniforms.ppOverlayWhiteThreshold = { value: whiteThreshold };

            shader.fragmentShader = shader.fragmentShader
                .replace(
                    '#include <common>',
                    '#include <common>\nuniform sampler2D ppOverlayMap;\nuniform float ppOverlayWhiteAsTransparent;\nuniform float ppOverlayWhiteThreshold;'
                )
                .replace(
                    '#include <map_fragment>',
                    '#include <map_fragment>\n#ifdef USE_UV\n    vec4 ppOverlayColor = texture2D(ppOverlayMap, vUv);\n    float ppOverlayAlpha = ppOverlayColor.a;\n    if (ppOverlayWhiteAsTransparent > 0.5) {\n        float ppMinChannel = min(min(ppOverlayColor.r, ppOverlayColor.g), ppOverlayColor.b);\n        float ppWhiteMask = smoothstep(ppOverlayWhiteThreshold, 1.0, ppMinChannel);\n        ppOverlayAlpha *= (1.0 - ppWhiteMask);\n    }\n    diffuseColor.rgb = mix(diffuseColor.rgb, ppOverlayColor.rgb, ppOverlayAlpha);\n#endif'
                );

            material.userData.ppOverlayShader = shader;
        };

        material.customProgramCacheKey = () => {
            const base = prevCacheKey ? prevCacheKey() : 'default';
            return `${base}|pp-overlay-v1`
        };

        material.userData.ppOverlayEnabled = true;
        material.needsUpdate = true;
    }

    makeTextureFromSVGNode = (svg) => {

        let img = new Image();

        const cnv = document.createElement("canvas");
        const ctx = cnv.getContext('2d');
        const svgData = (new XMLSerializer()).serializeToString(svg);
        const base64 = window.btoa(unescape(encodeURIComponent(svgData)));
        const src = "data:image/svg+xml;base64," + base64;

        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            texture.needsUpdate = true;
        };

        const texture = new THREE.Texture(cnv);
        img.src = src;

        this.imgTexture = texture;

        cnv.remove();
    }

    loadScene(file, options = {}) {

        const materialName = options.materialName || "Material.001";
        const replaceOtherMaterials = options.replaceOtherMaterials || false;
        const overlayWhiteAsTransparent = options.overlayWhiteAsTransparent ?? this.overlayWhiteAsTransparent;
        const overlayWhiteThreshold = options.overlayWhiteThreshold ?? this.overlayWhiteThreshold;
        const useSubdivisionModifier = options.useSubdivisionModifier ?? this.useSubdivisionModifier;
        const subdivisionLevels = options.subdivisionLevels ?? this.subdivisionLevels;
        const subdivisionPreserveEdges = options.subdivisionPreserveEdges ?? this.subdivisionPreserveEdges;
        const subdivisionMaxTriangles = options.subdivisionMaxTriangles ?? this.subdivisionMaxTriangles;
        const subdivisionExcludeMaterialNames = options.subdivisionExcludeMaterialNames ?? this.subdivisionExcludeMaterialNames;
        const subdivisionOnlyOnMaterialNames = options.subdivisionOnlyOnMaterialNames ?? this.subdivisionOnlyOnMaterialNames;

        this.setOverlayWhiteAsTransparent(overlayWhiteAsTransparent, overlayWhiteThreshold);

        var that = this;
        const loader = new GLTFLoader();

        const dracoDecoder = options.draco ?? null;
        if (dracoDecoder !== false && dracoDecoder !== null) {
            const dracoLoader = new DRACOLoader();
            // dracoDecoder kann ein String mit lokalem Pfad oder true (→ Standard /draco/) sein
            const decoderPath = typeof dracoDecoder === 'string' ? dracoDecoder : '/assets/three/draco/';
            dracoLoader.setDecoderPath(decoderPath);
            loader.setDRACOLoader(dracoLoader);
        }

        loader.load(
            file,
            function (gltf) {

                gltf.scene.traverse(function (child) {
                    if (child.isMesh) {
                        const m = child;
                        const materials = Array.isArray(m.material) ? m.material : [m.material];
                        const materialNames = materials.map((mat) => mat?.name).filter(Boolean);
                        const shouldExcludeSubdivision =
                            Array.isArray(subdivisionExcludeMaterialNames) &&
                            subdivisionExcludeMaterialNames.length > 0 &&
                            materialNames.some((name) => subdivisionExcludeMaterialNames.includes(name));
                        const shouldApplySubdivision =
                            !Array.isArray(subdivisionOnlyOnMaterialNames) ||
                            subdivisionOnlyOnMaterialNames.length === 0 ||
                            materialNames.some((name) => subdivisionOnlyOnMaterialNames.includes(name));
                        
                        if (useSubdivisionModifier && subdivisionLevels > 0 && shouldApplySubdivision && !shouldExcludeSubdivision) {
                            try {
                                that.applySubdivision(m, subdivisionLevels, {
                                    preserveEdges: subdivisionPreserveEdges,
                                    maxTriangles: subdivisionMaxTriangles
                                });
                            } catch (err) {
                                logger.warn('Subdivision konnte nicht angewendet werden:', err);
                            }
                        }

                        const updatedMaterials = materials.map((mat) => {
                            if (mat?.name === materialName) {
                                that.applyPrintOverlayMaterial(mat, m, {
                                    whiteAsTransparent: overlayWhiteAsTransparent,
                                    whiteThreshold: overlayWhiteThreshold
                                });
                                that.printMaterial = mat;
                                return mat
                            }

                            if (replaceOtherMaterials) {
                                const replacement = new THREE.MeshPhysicalMaterial({});
                                replacement.reflectivity = 1;
                                replacement.roughness = 0;
                                replacement.metalness = 0.1;
                                replacement.clearcoat = 0.5;
                                replacement.clearcoatRoughness = 0.8;
                                replacement.ior = 1.2;
                                replacement.emissive.set(0x999999);
                                replacement.color.set(0xffffff);
                                return replacement
                            }

                            return mat
                        });

                        if (Array.isArray(m.material)) {
                            m.material = updatedMaterials;
                        } else {
                            m.material = updatedMaterials[0];
                        }
                        m.receiveShadow = true;
                        m.castShadow = true;
                    }
                    if (child.isLight) {
                        const l = child;
                        l.castShadow = true;
                        l.shadow.bias = -0.003;
                        l.shadow.mapSize.width = 2048;
                        l.shadow.mapSize.height = 2048;
                    }
                });

                that.scene.add(gltf.scene);
                that.isLoaded();

            },
            (xhr) => {
                logger.info((xhr.loaded / xhr.total) * 100 + '% loaded');
            },
            (error) => {
                logger.error(error);
                if (typeof this.isRejected === 'function') this.isRejected(error);
            }
        );
    }

    setBackgroundColor(color) {
        this.scene.background = new THREE.Color(color);
    }

    resize(size) {
        this.camera.aspect = size[0] / size[1];
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(...size);
        this.render();
    }
    animate() {

        var that = this;

        const anim = function () {
            that._rafId = requestAnimationFrame(anim);

            that.render();
        };

        anim();
    }

    render() {
        this.renderer.render(this.scene, this.camera);
    }

    toDataUrl(type = 'image/png', quality) {
        this.render();
        return this.renderer?.domElement?.toDataURL(type, quality)
    }

    destroy(options = {}) {
        const { forceContextLoss = false, reason = 'unspecified' } = options;

        // Guard gegen Regressionen:
        // forceContextLoss ist nur fuer finalen Cleanup gedacht (z. B. beim Unmount).
        // Im normalen Rerender-Zyklus darf der Kontext nicht hart verloren gehen,
        // weil danach der WebGL-Init auf dem Canvas instabil werden kann.
        if (forceContextLoss && reason !== 'unmount') {
            logger.warn('3DView: forceContextLoss ausserhalb Unmount angefordert. Aufruf pruefen.', { reason });
        }
        if (this._rafId) {
            cancelAnimationFrame(this._rafId);
            this._rafId = null;
        }

        if (this.controls && typeof this.controls.dispose === 'function') {
            this.controls.dispose();
        }

        if (this.scene) {
            this.scene.traverse((obj) => {
                if (obj.material) {
                    if (Array.isArray(obj.material)) {
                        obj.material.forEach((mat) => {
                            if (mat.map && typeof mat.map.dispose === 'function') mat.map.dispose();
                            if (typeof mat.dispose === 'function') mat.dispose();
                        });
                    } else {
                        if (obj.material.map && typeof obj.material.map.dispose === 'function') obj.material.map.dispose();
                        if (typeof obj.material.dispose === 'function') obj.material.dispose();
                    }
                }
                if (obj.geometry && typeof obj.geometry.dispose === 'function') {
                    obj.geometry.dispose();
                }
            });
        }

        if (this.renderer) {
            if (forceContextLoss && typeof this.renderer.forceContextLoss === 'function') this.renderer.forceContextLoss();
            this.renderer.dispose();
        }

        const canvas = this.renderer?.domElement;
        if (canvas && canvas.__ppThreePreview === this) {
            delete canvas.__ppThreePreview;
        }
    }

    applySubdivision(mesh, subdivisions = 1, options = {}) {
        const levelCount = Math.max(0, Math.min(3, Math.floor(Number(subdivisions) || 0)));
        if (!levelCount || !mesh?.geometry?.attributes?.position) return

        const preserveEdges = options.preserveEdges ?? true;
        const maxTriangles = Number(options.maxTriangles) || 120000;

        const oldGeometry = mesh.geometry;
        const subdivided = LoopSubdivision.modify(oldGeometry, levelCount, {
            split: true,
            uvSmooth: false,
            preserveEdges,
            flatOnly: false,
            maxTriangles
        });

        if (!subdivided) return

        subdivided.computeVertexNormals();
        subdivided.computeBoundingBox();
        subdivided.computeBoundingSphere();

        mesh.geometry = subdivided;

        if (oldGeometry && oldGeometry !== subdivided && typeof oldGeometry.dispose === 'function') {
            oldGeometry.dispose();
        }
    }

}

const _hoisted_1$k = ["id"];
const _hoisted_2$i = {
  key: 0,
  class: "uk-overlay uk-overlay-primary uk-position-bottom media-warning"
};
const _hoisted_3$f = ["aria-label"];
const _hoisted_4$d = {
  key: 1,
  class: "zoom-icon",
  "uk-icon": "icon: search; ratio: 2"
};


var script$l = {
  __name: 'ProductPreview',
  props: {
    psElement: Object,
    listId: Number,
    previewSize: Array,
    id: String,
    missing: Object,
    selectedMethod: String,
    zoomable: Boolean
},
  emits: ["display-media", "change-item", "update-methods", "resolution-warning"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const productMethods = {
    fillin: { labelKey: "fillin" },
    fitin: { labelKey: "fitin" },
    border: { labelKey: "border" },
    fillborder: { labelKey: "fillborder" },
    canvas: { labelKey: "canvas" },
    canvasborder: { labelKey: "canvasborder" },
    canvaswhiteborder: { labelKey: "canvaswhiteborder" },
    canvasmirror: { labelKey: "canvasmirror" },
    canvasstretch: { labelKey: "canvasstretch" }
};

const methods = ref({...productMethods});
const { t, te } = useI18n();

const swiperInstance = ref();
const currentSel = ref();
const resolutionBadgePosition = ref(null);

const ps = props.psElement?.ps;
if (ps?.status) {
    currentSel.value = ps.status;
    if (!currentSel.value.mediaSettings) currentSel.value.mediaSettings = {};
    if (!currentSel.value.mediaSettings.printMethod) {
        currentSel.value.mediaSettings.printMethod = Object.keys(productMethods)[0];
    }
}

function ensureMediaSettings() {
    if (!currentSel.value) currentSel.value = props.psElement?.ps?.status || {};
    if (!currentSel.value.mediaSettings) currentSel.value.mediaSettings = {};
    if (!currentSel.value.mediaSettings.printMethod) {
        currentSel.value.mediaSettings.printMethod = Object.keys(productMethods)[0];
    }
    return currentSel.value
}

function onSwiper(swiper) {
    swiperInstance.value = swiper;
}

const modules = [Pagination, EffectCoverflow, EffectCards];

let previewDims = [260, 260];
if (props.previewSize && props.previewSize.length == 2) previewDims = props.previewSize;

const imgsrc = ref([]);



watch(() => props.psElement?.previewUC, () => {
    if (!props.psElement?.ps?.status) return
    currentSel.value = props.psElement.ps.status;
    ensureMediaSettings();
    update();
});

watch(() => props.selectedMethod, (method) => {
    if (method && currentSel.value?.mediaSettings && currentSel.value.mediaSettings.printMethod !== method) {
        currentSel.value.mediaSettings.printMethod = method;
        update();
    }
});

const update = debounce(() => {
    logger.debug("updating ProductPreview");
    render();
},100);




const displayMedia = [];
const svgImageDataUrlCache = new Map();

window.displayMedia = displayMedia; // Debug

function getSlideNode(index) {
    return document.querySelector(`.preview${props.listId}-${index}.product`)
}

function updateResolutionBadgePosition() {
    const slide = getSlideNode(swiperInstance.value?.activeIndex ?? 0);
    const container = slide?.closest('.preview-image-container');
    const image = slide?.style.backgroundImage
        ? slide.querySelector('svg')
        : slide?.querySelector('svg[id$="_main-print"]') || slide?.querySelector('svg');
    if (!container || !image) {
        resolutionBadgePosition.value = null;
        return
    }

    const imageRect = image.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const scale = containerRect.width / container.offsetWidth || 1;
    resolutionBadgePosition.value = {
        top: `${(imageRect.top - containerRect.top + 8) / scale}px`,
        left: `${(imageRect.right - containerRect.left - 8) / scale - 26}px`
    };
}

onMounted(() => window.addEventListener('resize', updateResolutionBadgePosition));
onUnmounted(() => window.removeEventListener('resize', updateResolutionBadgePosition));

function setSlideImageOverride(index, imageUrl) {
    const slide = getSlideNode(index);
    if (!slide || !imageUrl) return

    slide.style.backgroundImage = `url(${imageUrl})`;
    slide.style.backgroundRepeat = 'no-repeat';
    slide.style.backgroundPosition = 'center';
    slide.style.backgroundSize = 'contain';

    const svg = slide.querySelector('svg');
    if (svg) svg.style.opacity = '0';
}

function clearSlideImageOverride(index) {
    const slide = getSlideNode(index);
    if (!slide) return

    slide.style.backgroundImage = '';
    slide.style.backgroundRepeat = '';
    slide.style.backgroundPosition = '';
    slide.style.backgroundSize = '';

    const svg = slide.querySelector('svg');
    if (svg) svg.style.opacity = '1';
}

function useThreePreviewImage(previewMap) {
    return previewMap?.renderMode === 'three-image' && Boolean(previewMap?.three?.model)
}

function getOriginalPreviewFormat(mediaItem) {
    const width = Number(mediaItem?.width);
    const height = Number(mediaItem?.height);
    if (width > 0 && height > 0) return [width, height]

    const objectType = mediaItem?.objectType || mediaItem?.mediaType || mediaItem?.type;
    const ratio = Number(filterDef?.mediaType?.[objectType]?.ratio);
    if (!ratio || !Number.isFinite(ratio) || ratio <= 0) return false

    const previewWidthMM = 300;
    return [previewWidthMM, previewWidthMM / ratio]
}

function getModelUrl(src) {
    let rel = "";
    if (import.meta.env.PROD) rel = '..';
    return new URL(rel + src, import.meta.url).href
}

function cloneMainPrintNode(vici) {
    const mainPrint = vici?.svg?.find?.(`#${vici.id}_main-print`)?.[0]?.clone?.();
    if (!mainPrint) return false

    mainPrint.attr({
        xmlns: "http://www.w3.org/2000/svg",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        version: "1.1",
        width: vici.innerSize[0],
        height: vici.innerSize[1],
        viewBox: null,
        x: null,
        y: null
    });

    return mainPrint.node
}

function getImageHref(imgNode) {
    return imgNode.getAttribute('href')
        || imgNode.getAttributeNS('http://www.w3.org/1999/xlink', 'href')
        || imgNode?.href?.animVal
        || imgNode?.href?.baseVal
        || ""
}

function setImageHref(imgNode, href) {
    imgNode.setAttribute('href', href);
    imgNode.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
    if (imgNode?.href && typeof imgNode.href.baseVal !== 'undefined') {
        imgNode.href.baseVal = href;
    }
}

async function svgNodeToDataUrl(domNode) {
    const serializer = new XMLSerializer();
    const promiseList = [];

    domNode.querySelectorAll('image').forEach((imgNode) => {
        const sourceUrl = getImageHref(imgNode);
        if (!sourceUrl || sourceUrl.startsWith('data:')) return

        if (svgImageDataUrlCache.has(sourceUrl)) {
            setImageHref(imgNode, svgImageDataUrlCache.get(sourceUrl));
            return
        }

        promiseList.push(
            getBase64FromUrl(sourceUrl)
                .then((dataUrl) => {
                    svgImageDataUrlCache.set(sourceUrl, dataUrl);
                    setImageHref(imgNode, dataUrl);
                })
                .catch(() => {
                    setImageHref(imgNode, sourceUrl);
                })
        );
    });

    await Promise.all(promiseList);
    const str = serializer.serializeToString(domNode);
    return svgToDataUrl(str)
}

async function waitForViciLoaded(vici) {
    if (!vici?.loaded || typeof vici.loaded.then !== 'function') return

    await Promise.race([
        vici.loaded,
        new Promise((resolve) => setTimeout(resolve, 700))
    ]);
}

async function renderThreePreviewImage(vici, previewMap) {
    if (!previewMap?.three?.model) return false

    const domNode = document.createElement('canvas');
    let threePreview = false;

    try {
        threePreview = new ThreePreview(domNode, { size: [...previewDims], preserveDrawingBuffer: true });
    } catch (error) {
        logger.warn('preview: 3D initialisierung fehlgeschlagen, fallback auf 2D', error);
        return false
    }

    try {
        const mainPrint = cloneMainPrintNode(vici);
        if (!mainPrint) return false

        const svgDataUrl = await svgNodeToDataUrl(mainPrint);
        threePreview.setBackgroundColor(0xffffff);
        await threePreview.setImage(svgDataUrl);
        const modelUrl = getModelUrl(previewMap.three.model);
        threePreview.loadScene(modelUrl, { ...previewMap.three });
        await threePreview.loaded;

        // Nach dem Scene-Load kurz warten, bis Materialbindung und erster Render sicher durch sind.
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

        if (!threePreview.printMaterial) {
            logger.warn('preview: 3D material nicht gefunden, fallback auf 2D');
            return false
        }

        return threePreview.toDataUrl('image/png')
    } catch (error) {
        logger.warn('preview: 3D snapshot fehlgeschlagen, fallback auf 2D', error);
        return false
    } finally {
        if (threePreview && typeof threePreview.destroy === 'function') {
            threePreview.destroy({ reason: 'snapshot' });
        }
    }
}



async function render() {
    if (!props.psElement?.ps?.status) return false
    currentSel.value = props.psElement.ps.status;
    ensureMediaSettings();

    let setupData = {};
    let setupPrintopt = null;
    let pages = 1;
    let pagelabel = {};
    let templates = {};

    imgsrc.value = [];
    let selectedMedia = currentSel.value.media;
    if (!selectedMedia) return false

    const setupRoot = toRaw(currentSel.value.product?.setup) || {};
    if (setupRoot && typeof setupRoot === 'object') {
        if (setupRoot.data && typeof setupRoot.data === 'object') {
            setupData = setupRoot.data;
            setupPrintopt = setupData.printopt || setupRoot.printopt || null;
        } else {
            setupData = setupRoot;
            setupPrintopt = setupRoot.printopt || null;
        }
    }

    if (setupData.pages) {
        pages = setupData.pages;
    }
    if (setupData.pagelabel) {
        pagelabel = setupData.pagelabel;
    }
    if (setupData.templates) {
        templates = setupData.templates;
    }

    if (setupPrintopt) {
        let printopt = setupPrintopt;
        methods.value = {};
        Object.keys(printopt).forEach((m) => {
            if (productMethods[m]) {
                methods.value[m] = productMethods[m];
            }
        });
        if (!Object.keys(methods.value).length) {
            methods.value = productMethods;
        }
    } else {
        methods.value = productMethods;
    }

    let methodSel = currentSel.value.mediaSettings.printMethod;
    if (!methods.value[methodSel]) {
        currentSel.value.mediaSettings.printMethod = Object.keys(methods.value)[0];
        methodSel = currentSel.value.mediaSettings.printMethod;
    }
    emit('update-methods', { methods: methods.value, selected: methodSel });
    let i = 0;

    if (!displayMedia[props.listId]) displayMedia[props.listId] = [];
    let DM = displayMedia[props.listId];

    await nextTick();
    selectedMedia.forEach((item) => {

        //  die Werte aus selectedMedia werden in eigenem Objekt "displayMedia" referenziert
        // so kann Vici hinzugefügt werden ohne, dass currentSel.media geändert wird

        // wenn vici Display bereits erstellt wurde, dieses beibehalten
        if (!DM[i]) {

            let displayItem = {};
            displayItem.media = item;

            DM[i] = displayItem;

            displayItem.vici = new Vici(
                {
                    interactive: false,
                    preset: 'printopt',
                    pages: pages,
                    pagelabel: pagelabel,
                    templates: templates,
                    domNode: '.product.preview' + props.listId + '-' + i,
                    doc: { size: [...previewDims] },
                    size: [...previewDims]
                }
                , item);
        } else {
            // neues Medium zuordnen
            DM[i].vici.setup.pages = pages;
            DM[i].vici.setup.pagelabel = pagelabel;
            DM[i].vici.setup.templates = templates;
            DM[i].vici.setMedia(item,false);
            DM[i].media = item;
        }

        i++;

    });

    // Überzählige entfernen
    for (var n in DM) {
        if (n >= i) DM.splice(n, 1);
        let dn = document.querySelector(".preview" + props.listId + '-' + n + ".product");
        if (dn) dn.innerHTML = '';
    }

    // Nun alle rendern bzw updaten
    for (let i = 0; i < DM.length; i++) {

        const item = DM[i];

        // Wenn nur eine Bestimmzte Zahl angezeigt werden soll, hier abbrechen
        // allerdings sollten die dann beim blättern nachgeladen werden. Diese nachladefunktion fehlt noch
        // if (i>2) return
        const product = currentSel.value.product;

        if (!product) {
            logger.debug("preview: vici: render item");
            const originalFormat = getOriginalPreviewFormat(item.media);
            item.vici.setup.imgResource = "th";
            if (!item.vici.hasUserimage()) item.vici.render({ format: originalFormat, method: "original" });
            else item.vici.update({ format: originalFormat, method: "original" });
            clearSlideImageOverride(i);
        } else {
            logger.debug("preview: vici: render product item");
            const previewMap = previewMaps[product.pid];
            const targetFormat = [product.widthMM, product.heightMM];
            // Server rechnet die Voransicht bei abweichendem Seitenverhältnis direkt auf Zielgröße
            const formatAdjusted = needsFormatAdjustment(item.media, product);
            item.vici.setup.imgResource = formatAdjusted ? getFitinResource(product, previewResourceSizes.thumbnail) : "th";
            const renderConfig = { product: product, format: targetFormat, method: methodSel, previewMap: previewMap, imgSize: formatAdjusted ? targetFormat : null };
            if (!item.vici.hasUserimage()) item.vici.render(renderConfig);
            else item.vici.update(renderConfig);

            if (useThreePreviewImage(previewMap)) {
                await waitForViciLoaded(item.vici);
                const threePreviewImageUrl = await renderThreePreviewImage(item.vici, previewMap);
                if (threePreviewImageUrl) setSlideImageOverride(i, threePreviewImageUrl);
                else clearSlideImageOverride(i);
            } else {
                clearSlideImageOverride(i);
            }
        }
    }

    emit("display-media", DM, props.listId);
    emit('resolution-warning', resolutionLevel.value);
    updateResolutionBadgePosition();

}

function slideChange() {
    emit("change-item", swiperInstance.value.activeIndex);
    updateResolutionBadgePosition();
}

function translateMismatchValue(value) {
    if (typeof value !== 'string') return value

    const key = `productPreview.warnings.values.${value}`;
    if (te(key)) return t(key)

    return filterDef.mediaType?.[value]?.label ?? value
}

const warningText = computed(() => {
    const mismatch = props.missing.mismatch;
    let text = "";
    if (mismatch && mismatch.property) {
        let failedProperty = translateMismatchValue(mismatch.property);
        let failedValue = translateMismatchValue(mismatch.value);
        let targetCondition = "";
        if (mismatch.condition == "unsupportedContentType") {
            text = t('productPreview.warnings.unsupportedContentType', { value: failedValue });
        } else if (mismatch.condition == "between") { 
            if (mismatch.required[0] != mismatch.required[1]) targetCondition = t('productPreview.warnings.between', { property: failedProperty, min: mismatch.required[0], max: mismatch.required[1] });
            else targetCondition = t('productPreview.warnings.equalValue', { property: failedProperty, value: mismatch.required[0] });
        } else if (mismatch.condition == "equal") {
            let required = translateMismatchValue(mismatch.required);
            targetCondition = t('productPreview.warnings.equalValue', { property: failedProperty, value: required });
        }

        if (!text) text = t('productPreview.warnings.summary', { property: failedProperty, value: failedValue, condition: targetCondition });
    }
    return text
});

const resolutionLevel = computed(() => getWorstResolutionLevel(currentSel.value?.media));
const resolutionBadge = computed(() => ['notRecommended', 'low'].includes(resolutionLevel.value) ? resolutionLevel.value : '');
const resolutionTooltip = computed(() => getResolutionWarnings(currentSel.value?.media).map(({ level, count, pages }) => {
    const label = t(`productPreview.resolutionDetails.${level}.${count === 1 ? 'one' : 'many'}`, { count });
    if (!pages.length) return label
    const pageLabel = t(`productPreview.resolutionDetails.${pages.length === 1 ? 'page' : 'pages'}`, { pages: pages.join(', ') });
    return `${label} (${pageLabel})`
}).join('\n'));

watch(resolutionLevel, (level) => emit('resolution-warning', level), { immediate: true });

const zoomOpen = ref(false);
const zoomList = ref([]);
const zoomIndex = ref(0);

function openZoom(index = swiperInstance.value?.activeIndex ?? 0) {
    if (!props.zoomable) return
    const product = currentSel.value?.product;
    zoomList.value = (currentSel.value?.media || []).map((media) => ({
        ...media,
        resource: product && needsFormatAdjustment(media, product) ? getFitinResource(product, previewResourceSizes.gallery) : undefined
    }));
    zoomIndex.value = index;
    zoomOpen.value = true;
}

__expose({ openZoom });

update();


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["preview-image-container", { zoomable: props.zoomable }]),
    id: props.id
  }, [
    createVNode(unref(Swiper), {
      onSwiper: onSwiper,
      onSlideChange: _cache[0] || (_cache[0] = $event => (slideChange())),
      onSlideChangeTransitionEnd: updateResolutionBadgePosition,
      onResize: updateResolutionBadgePosition,
      class: "mySwiper",
      modules: modules,
      effect: 'cards',
      centeredSlides: true,
      slidesPerView: 'auto'
    }, {
      default: withCtx(() => [
        createCommentVNode(" Slides "),
        (openBlock(true), createElementBlock(Fragment, null, renderList(currentSel.value.media, (sm, i) => {
          return (openBlock(), createBlock(unref(SwiperSlide), {
            class: normalizeClass(["product", 'preview' + props.listId + '-' + i]),
            key: 'preview-' + props.listId + '-' + i,
            onClick: $event => (openZoom(i))
          }, null, 8 /* PROPS */, ["class", "onClick"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (warningText.value)
          ? (openBlock(), createElementBlock("div", _hoisted_2$i, [
              createElementVNode("p", null, toDisplayString$1(warningText.value), 1 /* TEXT */)
            ]))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    (resolutionBadge.value && resolutionBadgePosition.value)
      ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "resolution-badge",
          style: normalizeStyle(resolutionBadgePosition.value)
        }, [
          withDirectives((openBlock(), createElementBlock("button", {
            type: "button",
            class: normalizeClass(["resolution-info", `resolution-${resolutionBadge.value}`]),
            "aria-label": resolutionTooltip.value
          }, _cache[2] || (_cache[2] = [
            createElementVNode("span", { "uk-icon": "icon: info; ratio: 1.2" }, null, -1 /* HOISTED */)
          ]), 10 /* CLASS, PROPS */, _hoisted_3$f)), [
            [unref(vTooltip), { content: resolutionTooltip.value, triggers: ['hover', 'click'], popperClass: 'resolution-tooltip' }]
          ])
        ], 4 /* STYLE */))
      : createCommentVNode("v-if", true),
    (props.zoomable && currentSel.value?.media?.length)
      ? (openBlock(), createElementBlock("span", _hoisted_4$d))
      : createCommentVNode("v-if", true),
    (openBlock(), createBlock(Teleport, { to: "body" }, [
      createVNode(unref(script$g), {
        open: zoomOpen.value,
        onClose: _cache[1] || (_cache[1] = $event => (zoomOpen.value = false)),
        class: "preview-modal"
      }, {
        body: withCtx(() => [
          createVNode(unref(script$G), {
            infoComponent: "FileInfo",
            images: zoomList.value,
            index: zoomIndex.value
          }, null, 8 /* PROPS */, ["images", "index"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["open"])
    ]))
  ], 10 /* CLASS, PROPS */, _hoisted_1$k))
}
}

};

script$l.__file = "src/components/ProductPreview.vue";

const _hoisted_1$j = ["aria-label"];
const _hoisted_2$h = { class: "product-info-content" };
const _hoisted_3$e = ["src", "alt"];
const _hoisted_4$c = { key: 0 };
const _hoisted_5$c = { key: 1 };


const requests = new Map();

var script$k = {
  __name: 'ProductInfoButton',
  props: { pid: [String, Number] },
  setup(__props) {

const props = __props;
const configStore = useConfigStore();
const info = ref(null);
const details = computed(() => {
    if (!info.value?.details) return [];
    const text = new DOMParser().parseFromString(info.value.details, 'text/html').body.textContent || '';
    return text.split(';').map((value) => value.trim()).filter(Boolean);
});

function imageUrl(image) {
    const url = image?.formats?.medium?.url || image?.url;
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return `${configStore.contentBase.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`;
}

watch([() => props.pid, () => configStore.contentBase], async ([pid, contentBase], _, onCleanup) => {
    info.value = null;
    if (!pid || !contentBase) return;

    let active = true;
    onCleanup(() => { active = false; });
    const base = contentBase.replace(/\/+$/, '');
    const cacheKey = `${base}:${pid}`;
    if (!requests.has(cacheKey)) {
        const query = new URLSearchParams({ 'filters[pid][$eq]': String(pid), populate: 'image' });
        requests.set(cacheKey, fetch(`${base}/api/product-infos?${query}`)
            .then((response) => {
                if (!response.ok) throw new Error(`Product info ${pid}: ${response.status}`);
                return response.json();
            })
            .then((response) => response.data?.[0] || null)
            .catch((error) => {
                requests.delete(cacheKey);
                logger.warn(error);
                return null;
            }));
    }
    const result = await requests.get(cacheKey);
    if (active) info.value = result;
}, { immediate: true });

return (_ctx, _cache) => {
  return (info.value)
    ? (openBlock(), createBlock(unref(Dropdown), {
        key: 0,
        triggers: ['click'],
        distance: 8,
        placement: "bottom",
        "popper-class": "product-info-popper"
      }, {
        popper: withCtx(() => [
          createElementVNode("div", _hoisted_2$h, [
            (imageUrl(info.value.image))
              ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  src: imageUrl(info.value.image),
                  alt: info.value.title || ''
                }, null, 8 /* PROPS */, _hoisted_3$e))
              : createCommentVNode("v-if", true),
            createElementVNode("div", null, [
              createElementVNode("strong", null, toDisplayString$1(info.value.title || info.value.compactTitle), 1 /* TEXT */),
              (info.value.description || info.value.shortDescription)
                ? (openBlock(), createElementBlock("p", _hoisted_4$c, toDisplayString$1(info.value.description || info.value.shortDescription), 1 /* TEXT */))
                : createCommentVNode("v-if", true),
              (details.value.length)
                ? (openBlock(), createElementBlock("ul", _hoisted_5$c, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(details.value, (detail, index) => {
                      return (openBlock(), createElementBlock("li", { key: index }, toDisplayString$1(detail), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : createCommentVNode("v-if", true)
            ])
          ])
        ]),
        default: withCtx(() => [
          createElementVNode("button", {
            type: "button",
            class: "product-info-trigger",
            "aria-label": info.value.title || info.value.pid
          }, _cache[0] || (_cache[0] = [
            createElementVNode("span", { "uk-icon": "icon: info; ratio: 0.85" }, null, -1 /* HOISTED */)
          ]), 8 /* PROPS */, _hoisted_1$j)
        ]),
        _: 1 /* STABLE */
      }))
    : createCommentVNode("v-if", true)
}
}

};

script$k.__file = "src/components/ProductInfoButton.vue";

var script$j = /*@__PURE__*/Object.assign({
    name: 'UploadButton',
}, {
  __name: 'UploadButton',
  props: {

    globalFunction: {
        type: String,
        default: null,
    },
    
    buttonLabel: {
        type: String,
        default: '',
    },
    variant: {
        type: String,
        default: 'button',
    },
    uploadSuccessAction: {
        type: Object,
        default: null,
    },
    uploadMeta: {
        type: Object,
        default: null,
    },
    redirectPath: {
        type: String,
        default: '/shop/account/usermedia',
    },
    redirectMethod: {
        type: String,
        default: 'push',
    },
},
  emits: ["on-upload", "on-upload-complete", "on-upload-start", "close-upload"],
  setup(__props, { emit: __emit }) {



const props = __props;

const emit = __emit;
const router = useRouter();
const uploadedItems = ref([]);
const upload = ref(null);
let registeredGlobalFunction = null;

function triggerUpload() {
    upload.value?.openButtonUpload();
}

function unregisterGlobalFunction(name) {
    if (!name || !window.ppShop) return
    if (window.ppShop[name] === triggerUpload) {
        delete window.ppShop[name];
    }
}

watch(() => props.globalFunction, (globalFunction, oldGlobalFunction) => {
    unregisterGlobalFunction(oldGlobalFunction);
    registeredGlobalFunction = null;

    if (!globalFunction) return

    globalize(globalFunction, triggerUpload);
    registeredGlobalFunction = globalFunction;
}, { immediate: true });

onBeforeUnmount(() => {
    unregisterGlobalFunction(registeredGlobalFunction);
});

function resolveTopsPath(item) {
    if (!item || typeof item !== 'object') return ''

    const type = item['@type'] || item.type;
    const resource = type === 'Image' || item.bid ? 'images' : type === 'Media' || item.jid || item.module ? 'media' : '';
    const id = resource === 'images'
        ? item.bid || item.uid || item.id
        : resource === 'media'
            ? item.jid || item.uid || item.id
            : '';

    if (resource && id) return `${resource}/${id}`

    const jsonLdId = String(item['@id'] || '').split('?')[0].replace(/^\/+|\/+$/g, '');
    const pathMatch = jsonLdId.match(/(?:^|\/)(images|media)\/(.+)$/);
    if (pathMatch) return `${pathMatch[1]}/${pathMatch[2]}`

    return ''
}

function onUpload(uploadPayload) {
    if (Array.isArray(uploadPayload)) {
        uploadedItems.value.push(...uploadPayload);
    } else if (uploadPayload) {
        uploadedItems.value.push(uploadPayload);
    }

    emit('on-upload', uploadPayload);
}

function onUploadStart(payload) {
    uploadedItems.value = [];
    emit('on-upload-start', payload);
}

function onUploadComplete(event) {
    const responseItems = Array.isArray(event?.successful)
        ? event.successful.map((file) => file?.response?.body).filter(Boolean)
        : [];

    const items = responseItems.length > 0 ? responseItems : uploadedItems.value;
    const tops = [...new Set(items.map(resolveTopsPath).filter(Boolean))];

    emit('on-upload-complete', event);

    if (tops.length === 0) return

    if (props.redirectMethod == 'push') {
        router[props.redirectMethod]({
            path: props.redirectPath,
            query: { tops },
        });
    }
    if (props.redirectMethod == 'location') {  
        window.location.href = `${props.redirectPath}?tops=${tops.join(',')}`;
    }
}

return (_ctx, _cache) => {
  return (openBlock(), createBlock(script$y, {
    ref_key: "upload",
    ref: upload,
    variant: props.variant,
    "button-label": props.buttonLabel,
    "upload-success-action": props.uploadSuccessAction,
    "upload-meta": props.uploadMeta,
    onOnUpload: onUpload,
    onOnUploadComplete: onUploadComplete,
    onOnUploadStart: onUploadStart,
    onCloseUpload: _cache[0] || (_cache[0] = $event => (emit('close-upload')))
  }, null, 8 /* PROPS */, ["variant", "button-label", "upload-success-action", "upload-meta"]))
}
}

});

script$j.__file = "src/components/UploadButton.vue";

const _hoisted_1$i = { class: "uk-modal-dialog uk-modal-body" };


var script$i = {
  __name: 'UploadModal',
  setup(__props) {

const upload = ref(null);
const uploadMeta = ref(null);
const uploadQueue = [];
let activeUpload = null;

function normalizeFiles(files) {
    if (typeof File !== 'undefined' && files instanceof File) return [files]
    if (!files || typeof files[Symbol.iterator] !== 'function') return []
    return Array.from(files).filter((file) => typeof File === 'undefined' || file instanceof File)
}

async function processUploadQueue() {
    if (activeUpload || uploadQueue.length === 0) return

    activeUpload = uploadQueue.shift();
    uploadMeta.value = activeUpload.uploadMeta;
    uploadModal.open(activeUpload.setup);
    await nextTick();
    upload.value?.addFiles(activeUpload.files);
}

function onDropzoneUpload(event) {
    const files = normalizeFiles(event.detail?.files);
    if (files.length === 0) return

    uploadQueue.push({
        files,
        setup: event.detail?.setup && typeof event.detail.setup === 'object'
            ? { ...event.detail.setup }
            : undefined,
        uploadMeta: event.detail?.uploadMeta && typeof event.detail.uploadMeta === 'object'
            ? { ...event.detail.uploadMeta }
            : null,
        callback: typeof event.detail?.callback === 'function' ? event.detail.callback : null,
    });
    processUploadQueue();
}

function onUploadComplete(event) {
    if (!Array.isArray(event?.successful) || !Array.isArray(event?.failed)) return

    const closeAutomatically = uploadModal.closeMode.value == 'auto' && event.failed.length === 0;

    if (!activeUpload) {
        if (closeAutomatically) uploadModal.close();
        return
    }

    const responses = event.successful.map((file) => file?.response?.body).filter(Boolean);
    const callbackPayload = responses.length === 1 ? responses[0] : responses;
    const callback = activeUpload.callback;
    activeUpload = null;
    uploadMeta.value = null;

    try {
        if (callback) callback(callbackPayload, event);
    } finally {
        if (closeAutomatically) uploadModal.close();
        queueMicrotask(processUploadQueue);
    }
}

const releaseDropzoneUploadEvent = registerPpShopEvent(DROPZONE_UPLOAD_EVENT, onDropzoneUpload);

onBeforeUnmount(() => releaseDropzoneUploadEvent());

return (_ctx, _cache) => {
  return (openBlock(), createBlock(Transition, { name: "upload-modal-fade" }, {
    default: withCtx(() => [
      (unref(uploadModal).show.value)
        ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "uk-modal uk-open",
            style: {"display":"block"},
            onClick: withModifiers($event => (1), ["stop"])
          }, [
            createElementVNode("div", _hoisted_1$i, [
              withDirectives(createElementVNode("h2", { class: "uk-modal-title" }, toDisplayString$1(unref(uploadModal).title.value.text || _ctx.$t('uploadModal.addImages')), 513 /* TEXT, NEED_PATCH */), [
                [vShow, unref(uploadModal).title.value.display != 'none']
              ]),
              createVNode(unref(script$y), {
                ref_key: "upload",
                ref: upload,
                variant: unref(uploadModal).variant.value,
                "upload-meta": uploadMeta.value,
                onOnUpload: _cache[0] || (_cache[0] = $event => (unref(uploadModal).onUpload($event))),
                onOnUploadComplete: onUploadComplete
              }, null, 8 /* PROPS */, ["variant", "upload-meta"]),
              withDirectives(createElementVNode("button", {
                class: "uk-button uk-button-primary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = withModifiers($event => {unref(uploadModal).close();}, ["stop"]))
              }, toDisplayString$1(unref(uploadModal).closeButton.value.text || _ctx.$t('uploadModal.close')), 513 /* TEXT, NEED_PATCH */), [
                [vShow, unref(uploadModal).closeButton.value.display != 'none']
              ])
            ])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

};

script$i.__file = "src/components/UploadModal.vue";

const _hoisted_1$h = { class: "uk-modal-dialog uk-modal-body" };
const _hoisted_2$g = { class: "uk-modal-title" };


var script$h = {
  __name: 'MediaModal',
  setup(__props) {


function selectMedia(data) {

    mediaModal.selectedMedia = data;
    mediaModal.onSelect(data);
}


return (_ctx, _cache) => {
  return (unref(mediaModal).show.value)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "uk-modal uk-open",
        style: {"display":"block"},
        onClick: withModifiers($event => (1), ["stop"])
      }, [
        createElementVNode("div", _hoisted_1$h, [
          createElementVNode("button", {
            class: "uk-modal-close-default",
            type: "button",
            "uk-close": "",
            onClick: _cache[0] || (_cache[0] = withModifiers($event => {unref(mediaModal).close();}, ["stop"]))
          }),
          createElementVNode("h2", _hoisted_2$g, toDisplayString$1(_ctx.$t('mediaModal.selectDocument')), 1 /* TEXT */),
          createElementVNode("button", {
            class: "uk-button uk-button-primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = withModifiers($event => {unref(mediaModal).onMediaOpen();}, ["stop"]))
          }, toDisplayString$1(_ctx.$t('mediaModal.open')), 1 /* TEXT */),
          createVNode(unref(script$v), {
            mediaManagerSetup: unref(mediaModal).setup.mediaManager,
            addFiles: unref(mediaModal).setup.addFiles,
            condition: unref(mediaModal).setup.condition,
            onSelectedMedia: selectMedia
          }, null, 8 /* PROPS */, ["mediaManagerSetup", "addFiles", "condition"])
        ])
      ]))
    : createCommentVNode("v-if", true)
}
}

};

script$h.__file = "src/components/MediaModal.vue";

const _hoisted_1$g = { class: "uk-modal-dialog uk-width-auto" };
const _hoisted_2$f = {
  key: 0,
  class: "uk-modal-header"
};
const _hoisted_3$d = { class: "uk-modal-title" };
const _hoisted_4$b = { class: "uk-modal-body" };
const _hoisted_5$b = {
  key: 1,
  class: "uk-modal-footer"
};


var script$g = {
  __name: 'StandardModal',
  props: {
    open: Boolean
},
  emits: ["close"],
  setup(__props) {


let openModalCount = 0;
let lockedScrollY = 0;
let previousBodyStyles = null;
let previousHtmlOverflow = '';

function lockPageScroll() {
    if (typeof document === 'undefined' || openModalCount++ > 0) return

    lockedScrollY = window.scrollY;
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousBodyStyles = {
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width
    };

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.width = '100%';
}

function unlockPageScroll() {
    if (typeof document === 'undefined' || openModalCount === 0 || --openModalCount > 0) return

    document.documentElement.style.overflow = previousHtmlOverflow;
    Object.assign(document.body.style, previousBodyStyles);
    window.scrollTo(0, lockedScrollY);
    previousBodyStyles = null;
}

const props = __props;



let ownsScrollLock = false;

watch(() => props.open, (open) => {
    if (open && !ownsScrollLock) {
        lockPageScroll();
        ownsScrollLock = true;
    } else if (!open && ownsScrollLock) {
        unlockPageScroll();
        ownsScrollLock = false;
    }
}, { immediate: true });

onUnmounted(() => {
    if (ownsScrollLock) unlockPageScroll();
});


return (_ctx, _cache) => {
  return (props.open)
    ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: "uk-modal uk-open",
        style: {"display":"block"},
        onClick: withModifiers($event => (1), ["stop"])
      }, [
        createElementVNode("div", _hoisted_1$g, [
          createElementVNode("button", {
            class: "uk-modal-close-default",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close'))),
            type: "button",
            "uk-close": ""
          }),
          (_ctx.$slots['header'])
            ? (openBlock(), createElementBlock("div", _hoisted_2$f, [
                createElementVNode("h2", _hoisted_3$d, [
                  renderSlot(_ctx.$slots, "title")
                ])
              ]))
            : createCommentVNode("v-if", true),
          createElementVNode("div", _hoisted_4$b, [
            renderSlot(_ctx.$slots, "body")
          ]),
          (_ctx.$slots['footer'])
            ? (openBlock(), createElementBlock("div", _hoisted_5$b, [
                renderSlot(_ctx.$slots, "footer")
              ]))
            : createCommentVNode("v-if", true)
        ])
      ]))
    : createCommentVNode("v-if", true)
}
}

};

script$g.__file = "src/components/StandardModal.vue";

const _hoisted_1$f = { class: "product-edit-dialog modal-view" };


var script$f = {
  __name: 'ProductEditModal',
  props: {
    psEl: Object,
    listId: Number,
    itemNumber: Number
},
  emits: ["vidge-loaded", "save-vic"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;


const loaded = ref(false);
const entered = ref(false);
const animated = ref(false);
const dialogStyle = ref({});

// Geändert auf fullscreen Modal, daher keine Koordinaten mehr notwendig
//const coords = ref({ top: 0, left: 0, width: 260, height: 260 })
// onBeforeMount(() => {

//     // Koordinaten für Modal in Bezug zur Bildposition berechnen

//     coords.value = getImageCoords()
//     coords.value.width = "100%";
//     coords.value.minHeight = 560;
//     coords.value.top -= 120;
//     coords.value.left = 0;
//     coords.value.css =
//         'top:' + coords.value.top + 'px;' +
//         'left:' + coords.value.left + 'px;' +
//         'width:100%;' +
//         'min-height:' + coords.value.minHeight + 'px;'
// })

// function getImageCoords() {
//     let previewElem = document.querySelector('#preview-' + props.listId)
//     let icoords = {
//         top: previewElem.offsetTop,
//         left: previewElem.offsetLeft,
//         width: previewElem.clientWidth,
//         height: previewElem.clientHeight
//     }
//     return icoords
// }

function vidgeLoaded() {
    loaded.value = true;
    emit("vidge-loaded");
}

function saveVic(listId, mediaId, vicJSON) {
    emit("save-vic", listId, mediaId, vicJSON);
    emit("close");
}

onMounted(async () => {
    dialogStyle.value = getInitialDialogStyle();
    animated.value = !!dialogStyle.value.transform;

    await nextTick();
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            entered.value = true;
        });
    });
});

function getInitialDialogStyle() {
    const previewElem = document.querySelector('#preview-' + props.listId);
    if (!previewElem) return {}

    const rect = previewElem.getBoundingClientRect();
    const vw = Math.max(window.innerWidth, 1);
    const vh = Math.max(window.innerHeight, 1);

    if (!rect.width || !rect.height) return {}

    // Start immer kleiner als fullscreen, damit der Effekt visuell sicher "klein -> groß" ist.
    const sx = Math.min(Math.max(rect.width / vw, 0.08), 0.95);
    const sy = Math.min(Math.max(rect.height / vh, 0.08), 0.95);

    return {
        transform: `translate(${rect.left}px, ${rect.top}px) scale(${sx}, ${sy})`
    }
}


return (_ctx, _cache) => {
  return (openBlock(), createBlock(Teleport, { to: "body" }, [
    createElementVNode("div", {
      class: normalizeClass(["product-edit-modal uk-modal uk-open uk-modal-full", { 'is-entered': entered.value }]),
      style: {"display":"block"}
    }, [
      createElementVNode("div", {
        class: normalizeClass(["product-edit-zoom-layer", { 'is-animated': animated.value }]),
        style: normalizeStyle(entered.value ? undefined : dialogStyle.value)
      }, [
        createElementVNode("div", _hoisted_1$f, [
          createElementVNode("button", {
            class: "uk-modal-close-default",
            type: "button",
            "uk-close": "",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
          }),
          createVNode(unref(script$m), {
            listId: props.listId,
            status: props.psEl.ps.status,
            items: props.psEl.displayMedia,
            itemNumber: props.itemNumber,
            onOnload: _cache[1] || (_cache[1] = $event => (vidgeLoaded())),
            onSaveVic: saveVic
          }, null, 8 /* PROPS */, ["listId", "status", "items", "itemNumber"])
        ])
      ], 6 /* CLASS, STYLE */)
    ], 2 /* CLASS */)
  ]))
}
}

};

script$f.__file = "src/components/ProductEditModal.vue";

const _hoisted_1$e = {
  class: "uk-modal uk-open",
  style: {"display":"block"}
};
const _hoisted_2$e = ["src"];


var script$e = {
  __name: 'ProductEditExtModal',
  props: {
    psEl: Object,
    listId: Number,
    itemNumber: {
        type: Number,
        default: 0
    }
},
  emits: [],
  setup(__props, { emit: __emit }) {

const authStore = useAuthStore();
const configStore = useConfigStore();

const props = __props;

const coords = ref({ top: 0, left: 0, width: 260, height: 260 });
const loaded = ref(false);
const iframe = ref();

const mediaId = computed(() => {
    try {
        return props.psEl.displayMedia[props.itemNumber].media["@id"]
    } catch (e) {
        console.error('Error accessing media ID:', e);
        return null
    }
});

onBeforeMount(() => {

    // Koordinaten für Modal in Bezug zur Bildposition berechnen

    coords.value = getImageCoords();
    coords.value.width = "100%";
    coords.value.minHeight = 560;
    coords.value.top -= 120;
    coords.value.left = 0;
    coords.value.css =
        'top:' + coords.value.top + 'px;' +
        'left:' + coords.value.left + 'px;' +
        'width:100%;' +
        'min-height:' + coords.value.minHeight + 'px;';
    loaded.value = true;
});

function getImageCoords() {
    let previewElem = document.querySelector('#preview-' + props.listId);
    let icoords = {
        top: previewElem.offsetTop,
        left: previewElem.offsetLeft,
        width: previewElem.clientWidth,
        height: previewElem.clientHeight
    };
    return icoords
}

// TEST: iframe mit postMessage
// Lädt den PDF Editor in ein iframe und kommuniziert via postMessage den JWT Token

const extEditorUrl = computed(() => configStore.extEditorUrl);

useEventListener(window, 'message', (event) => {
    if (event.origin !== extEditorUrl.value) return
    
    if (event.data.type === 'JWT_REQUEST') {
        const user = toRaw(authStore.getUser()); // adjust based on your store
        iframe.value.contentWindow.postMessage(
            { type: 'userAuth', user: user },
            `${extEditorUrl.value}/preview${mediaId.value}`
        );
    }
});



return (_ctx, _cache) => {
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1$e, [
    createElementVNode("div", {
      style: normalizeStyle(coords.value.css),
      class: "product-edit-dialog modal-view uk-modal-dialog"
    }, [
      createElementVNode("button", {
        class: "uk-modal-close-default",
        type: "button",
        "uk-close": "",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
      }),
      (extEditorUrl.value)
        ? (openBlock(), createElementBlock("iframe", {
            key: 0,
            ref_key: "iframe",
            ref: iframe,
            src: `${extEditorUrl.value}/preview${mediaId.value}`,
            style: {"width":"100%","height":"420px","border":"none"}
          }, null, 8 /* PROPS */, _hoisted_2$e))
        : createCommentVNode("v-if", true)
    ], 4 /* STYLE */)
  ], 512 /* NEED_PATCH */)), [
    [vShow, loaded.value]
  ])
}
}

};

script$e.__file = "src/components/ProductEditExtModal.vue";

const _hoisted_1$d = {
  class: "uk-nav-sub",
  "uk-nav": ""
};
const _hoisted_2$d = { href: "#" };
const _hoisted_3$c = {
  key: 0,
  class: "chevron"
};
const _hoisted_4$a = { class: "dir-item" };
const _hoisted_5$a = { class: "dir-action uk-align-right uk-margin-remove" };
const _hoisted_6$9 = ["onClick"];
const _hoisted_7$9 = ["onClick"];


var script$d = {
  __name: 'SelectDirItems',
  props: {
    dirs: {
        type: Object,
    }
},
  setup(__props) {

const props = __props;


return (_ctx, _cache) => {
  const _component_SelectDirItems = resolveComponent("SelectDirItems", true);

  return (openBlock(), createElementBlock("ul", _hoisted_1$d, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(props.dirs, (item) => {
      return (openBlock(), createElementBlock("li", {
        key: item.path || item.name,
        class: normalizeClass(["uk-parent", (item.path=='/')?'uk-open':''])
      }, [
        createElementVNode("a", _hoisted_2$d, [
          (Object.keys(item.children).length>0)
            ? (openBlock(), createElementBlock("div", _hoisted_3$c, [...(_cache[2] || (_cache[2] = [
                createElementVNode("span", { "uk-icon": "chevron-down" }, null, -1 /* HOISTED */),
                createElementVNode("span", { "uk-icon": "chevron-up" }, null, -1 /* HOISTED */)
              ]))]))
            : createCommentVNode("v-if", true),
          createElementVNode("div", _hoisted_4$a, [
            createTextVNode(toDisplayString$1(item.name) + " ", 1 /* TEXT */),
            createElementVNode("div", _hoisted_5$a, [
              withDirectives(createElementVNode("span", {
                onClick: withModifiers($event => (_ctx.$emit('move',item)), ["stop","prevent"]),
                "uk-icon": "move"
              }, null, 8 /* PROPS */, _hoisted_6$9), [
                [unref(vTooltip), { content: _ctx.$t('selectDirItems.moveTo', { name: item.name }) }]
              ]),
              withDirectives(createElementVNode("span", {
                onClick: withModifiers($event => (_ctx.$emit('copy',item)), ["stop","prevent"]),
                "uk-icon": "copy"
              }, null, 8 /* PROPS */, _hoisted_7$9), [
                [unref(vTooltip), { content: _ctx.$t('selectDirItems.copyTo', { name: item.name }) }]
              ])
            ])
          ])
        ]),
        (Object.keys(item.children).length>0)
          ? (openBlock(), createBlock(_component_SelectDirItems, {
              key: 0,
              dirs: item.children,
              onMove: _cache[0] || (_cache[0] = (target) => _ctx.$emit('move',target)),
              onCopy: _cache[1] || (_cache[1] = (target) => _ctx.$emit('copy',target))
            }, null, 8 /* PROPS */, ["dirs"]))
          : createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

};

script$d.__file = "src/components/SelectDirItems.vue";

const _hoisted_1$c = {
  key: 0,
  class: "uk-card uk-card-body uk-align-center uk-margin-top"
};
const _hoisted_2$c = { class: "orders-content uk-align-center" };
const _hoisted_3$b = { class: "uk-card-title" };
const _hoisted_4$9 = {
  key: 0,
  class: "orders-year-group"
};
const _hoisted_5$9 = { class: "uk-form-label" };
const _hoisted_6$8 = ["aria-label"];
const _hoisted_7$8 = ["disabled", "onClick"];
const _hoisted_8$8 = ["disabled"];
const _hoisted_9$8 = {
  key: 1,
  class: "custom-filter-panel"
};
const _hoisted_10$8 = { class: "custom-filter-grid" };
const _hoisted_11$8 = {
  class: "uk-form-label",
  for: "orders-last-days"
};
const _hoisted_12$8 = {
  class: "uk-form-label",
  for: "orders-from-date"
};
const _hoisted_13$7 = {
  class: "uk-form-label",
  for: "orders-to-date"
};
const _hoisted_14$6 = {
  key: 0,
  class: "uk-text-danger uk-text-small uk-margin-small-top"
};
const _hoisted_15$6 = {
  key: 1,
  class: "uk-text-danger uk-text-small uk-margin-small-top"
};
const _hoisted_16$5 = { class: "custom-filter-actions" };
const _hoisted_17$4 = ["disabled"];
const _hoisted_18$4 = ["disabled"];
const _hoisted_19$4 = {
  key: 2,
  class: "uk-text-meta uk-margin-small-bottom"
};
const _hoisted_20$3 = {
  key: 3,
  class: "uk-text-meta"
};
const _hoisted_21$3 = { class: "purchase-row-layout" };
const _hoisted_22$3 = { class: "purchase-thumb-column" };
const _hoisted_23$3 = ["src", "onError"];
const _hoisted_24$3 = {
  key: 1,
  class: "purchase-thumb-empty"
};
const _hoisted_25$3 = { class: "purchase-main-column" };
const _hoisted_26$2 = { class: "purchase-number" };
const _hoisted_27$2 = { class: "purchase-payment uk-text-small" };
const _hoisted_28$2 = {
  key: 0,
  class: "purchase-proof-info uk-text-small"
};
const _hoisted_29$2 = { class: "purchase-proof-status" };
const _hoisted_30$2 = ["onClick"];
const _hoisted_31$2 = { class: "purchase-status" };
const _hoisted_32$1 = { class: "purchase-meta-column uk-text-small" };
const _hoisted_33$1 = { class: "uk-text-bold" };


var script$c = {
  __name: 'UserOrders',
  setup(__props) {

const { t, d } = useI18n();

const om = new OrderManager();

const accounting = ref(om.accounting);
const loadingOrders = ref(false);
const purchaseThumbs = ref({});
const loadingPurchaseThumbs = ref({});
const hiddenPurchaseThumbs = ref({});
const proofApprovalModal = ref({ open: false, purchase: null });
const proofPreviewLoading = ref(false);
const proofPreviewError = ref('');
const previewModal = ref(false);
const previewList = ref([]);
const previewIndex = ref(0);
const orderMediaManager = new MediaManager({
    useRouting: false,
    browse: 'none',
    resources: ['images', 'media']
});

const {
    ensureOrderMediaLoaded,
    rebuildOrderMediaLookup,
    resolveItemImages
} = createOrderMediaPreview(orderMediaManager);

const {
    resolvePurchasePreviewImages,
    resetOrderPurchasePreview
} = createOrderPurchasePreview({
    ppapiClient,
    ensureOrderMediaLoaded,
    rebuildOrderMediaLookup,
    resolveItemImages
});

const currentYear = new Date().getFullYear();
const selectedYear = ref(null);

const showCustomFilter = ref(false);
const customFilter = ref({
    lastDays: '',
    from: '',
    to: ''
});

const allAccountingOrders = computed(() => {

    const list = accounting.value?.list;
    if (!Array.isArray(list)) return []

    return list.filter((item) => item?.type == 'AU')

});

const availableYears = computed(() => {

    const years = new Set();

    allAccountingOrders.value.forEach((item) => {
        const year = getOrderYear(item);
        if (year) years.add(year);
    });

    return Array.from(years).sort((a, b) => b - a)

});

const accountingOrders = computed(() => {

    if (showCustomFilter.value || !selectedYear.value) return allAccountingOrders.value

    return allAccountingOrders.value.filter((item) => getOrderYear(item) == selectedYear.value)

});

const hasInvalidDateRange = computed(() => {

    if (!customFilter.value.from || !customFilter.value.to) return false
    return customFilter.value.from > customFilter.value.to

});

const hasInvalidLastDays = computed(() => {

    const rawLastDays = `${customFilter.value.lastDays || ''}`.trim();
    if (!rawLastDays) return false

    const parsedLastDays = Number(rawLastDays);
    return !Number.isInteger(parsedLastDays) || parsedLastDays <= 0

});

function toLookupKey(value) {
    if (typeof value === 'number') return String(value)
    if (typeof value !== 'string') return ''

    const key = value.trim();
    if (!key) return ''

    return key
}

function normalizeProofStatusKey(value) {
    return toLookupKey(value).toLowerCase()
}

function toErrorText(err) {
    if (!err) return ''
    if (typeof err === 'string') return err
    if (typeof err?.message === 'string') return err.message

    try {
        return JSON.stringify(err)
    } catch {
        return t('userOrderDetails.unknownError')
    }
}

function openPositionImagesOverlay(images, startIndex = 0) {
    if (!images?.length) return
    previewList.value = images;
    previewIndex.value = startIndex;
    previewModal.value = true;
}

function closePreviewModal() {
    previewModal.value = false;
    previewList.value = [];
    previewIndex.value = 0;
}

function hasPurchaseProof(purchase) {
    return !!normalizeProofStatusKey(purchase?.proofstat)
}

function shouldShowProofApprovalButton(purchase) {
    return normalizeProofStatusKey(purchase?.proofstat) === 'bestellt'
}

function formatPurchaseProofDate(value) {
    const rawValue = toLookupKey(value);
    if (!rawValue) return ''

    const parsedDate = new Date(rawValue);
    if (Number.isNaN(parsedDate.getTime())) return rawValue

    try {
        return d(parsedDate, 'short')
    } catch {
        return rawValue
    }
}

function getPurchaseProofMessage(purchase) {
    const normalized = normalizeProofStatusKey(purchase?.proofstat);
    const formattedDate = formatPurchaseProofDate(purchase?.proofCompletionDate);

    if (normalized === 'bestellt') {
        if (formattedDate) {
            return t('userOrderDetails.proofSentOn', { date: formattedDate })
        }

        return t('userOrderDetails.proofStatusOrdered')
    }

    const statusLabels = {
        freigegeben: t('userOrderDetails.proofStatusApproved'),
        storno: t('userOrderDetails.proofStatusCanceled')
    };

    return statusLabels[normalized] || toLookupKey(purchase?.proofstat)
}

function triggerProofApproval(purchase) {
    proofPreviewError.value = '';
    proofPreviewLoading.value = false;
    proofApprovalModal.value = { open: true, purchase };
}

function closeProofApprovalModal() {
    proofApprovalModal.value = { open: false, purchase: null };
    proofPreviewError.value = '';
    proofPreviewLoading.value = false;
}

async function submitProofDecision(purchase, proofStat) {
    if (!purchase?.kid || !purchase?.aid) return

    try {
        await ppapiClient.put(`users/${purchase.kid}/purchases/${purchase.aid}/printapproval`, { proofStat });
        purchase.proofstat = proofStat;
        closeProofApprovalModal();
    } catch (err) {
        const alertStore = useAlertStore();
        alertStore.error(err);
    }
}

function handleProofApproval(purchase) {
    submitProofDecision(purchase, 'freigegeben');
}

function handleProofStop(purchase) {
    submitProofDecision(purchase, 'storno');
}

async function openPurchaseProofPreview(purchase) {
    proofPreviewError.value = '';
    proofPreviewLoading.value = true;

    try {
        const resolvedImages = await resolvePurchasePreviewImages(purchase);
        if (!resolvedImages.length) {
            proofPreviewError.value = t('userOrderDetails.noImagesForItem');
            return
        }

        openPositionImagesOverlay(resolvedImages);
    } catch (err) {
        proofPreviewError.value = toErrorText(err);
    } finally {
        proofPreviewLoading.value = false;
    }
}

function getDefaultDateFilterFrom() {
    return `${currentYear - 2}-01-01`
}

function getRecentYearsDateFilter() {
    return { from: getDefaultDateFilterFrom() }
}

function getOrderYear(item) {

    if (!item?.date) return null

    const date = new Date(item.date);
    if (Number.isNaN(date.getTime())) return null

    return date.getFullYear()

}

function buildCustomDateFilter() {

    const dateFilter = {};
    const rawLastDays = `${customFilter.value.lastDays || ''}`.trim();

    if (rawLastDays) {
        const parsedLastDays = Number(rawLastDays);
        if (Number.isInteger(parsedLastDays) && parsedLastDays > 0) {
            dateFilter.lastDays = parsedLastDays;
            return dateFilter
        }
    }

    if (customFilter.value.from) dateFilter.from = customFilter.value.from;
    if (customFilter.value.to) dateFilter.to = customFilter.value.to;

    return dateFilter

}

async function loadOrders(dateFilter) {

    if (hasInvalidDateRange.value || hasInvalidLastDays.value) return

    loadingOrders.value = true;
    try {
        await om.load(dateFilter);
    } finally {
        loadingOrders.value = false;
    }

}

async function loadRecentYears() {
    await loadOrders(getRecentYearsDateFilter());
}

function selectYear(year) {
    selectedYear.value = year;
}

async function applyCustomFilter() {

    const dateFilter = buildCustomDateFilter();

    if (!Object.keys(dateFilter).length) {
        await loadRecentYears();
        return
    }

    await loadOrders(dateFilter);

}

async function resetCustomFilter() {

    customFilter.value = {
        lastDays: '',
        from: '',
        to: ''
    };
    selectedYear.value = null;
    showCustomFilter.value = false;
    await loadRecentYears();

}

function openCustomFilter() {
    showCustomFilter.value = true;
}

loadRecentYears();

function getPurchaseKey(purchase) {

    if (!purchase?.kid || !purchase?.aid) return ''
    return `${purchase.kid}-${purchase.aid}`

}

function getOrderDetailsRoute(item) {
    return `/shop/account/orders/${item.kid}-${item.reference}`
}

function getThumbEntries(purchase) {

    const key = getPurchaseKey(purchase);
    if (!key) return []

    const thumbs = purchaseThumbs.value[key]?.thumbs;
    if (!Array.isArray(thumbs)) return []

    return thumbs

}

function getFirstThumbUrl(purchase) {

    const thumbs = getThumbEntries(purchase);
    if (!thumbs.length) return ''

    return thumbs[0]?.dataUrl || ''

}

function hasThumbStack(purchase) {
    return getThumbEntries(purchase).length > 1
}

function isPurchaseThumbHidden(purchase) {

    const key = getPurchaseKey(purchase);
    if (!key) return false

    return !!hiddenPurchaseThumbs.value[key]

}

function hidePurchaseThumb(purchase) {

    const key = getPurchaseKey(purchase);
    if (!key) return

    hiddenPurchaseThumbs.value = {
        ...hiddenPurchaseThumbs.value,
        [key]: true
    };

}

async function loadPurchaseThumb(purchase) {

    const key = getPurchaseKey(purchase);
    if (!key) return

    if (Object.prototype.hasOwnProperty.call(purchaseThumbs.value, key)) return
    if (loadingPurchaseThumbs.value[key]) return

    loadingPurchaseThumbs.value = {
        ...loadingPurchaseThumbs.value,
        [key]: true
    };

    try {
        const response = await ppapiClient.get(`storage/media/order/K/0/${purchase.kid}/${purchase.aid}`);
        const thumbs = Array.isArray(response?.thumbs) ? response.thumbs : [];

        purchaseThumbs.value = {
            ...purchaseThumbs.value,
            [key]: { thumbs }
        };
    } catch {
        purchaseThumbs.value = {
            ...purchaseThumbs.value,
            [key]: { thumbs: [] }
        };
    } finally {
        loadingPurchaseThumbs.value = {
            ...loadingPurchaseThumbs.value,
            [key]: false
        };
    }

}

async function loadThumbsForAccounting(accountingList) {

    if (!Array.isArray(accountingList)) return

    const purchases = accountingList
        .filter((item) => item?.type == 'AU')
        .flatMap((item) => Array.isArray(item?.purchases) ? item.purchases : []);

    await Promise.all(purchases.map((purchase) => loadPurchaseThumb(purchase)));

}

watch(
    availableYears,
    (years) => {

        if (!years.length) {
            selectedYear.value = null;
            return
        }

        if (!selectedYear.value || !years.includes(selectedYear.value)) {
            selectedYear.value = years[0];
        }

    },
    { immediate: true }
);

watch(
    () => accounting.value?.list,
    (list) => {
        loadThumbsForAccounting(list);
    },
    { immediate: true }
);

onUnmounted(() => {
    resetOrderPurchasePreview();
    orderMediaManager.close();
});


return (_ctx, _cache) => {
  const _component_router_link = resolveComponent("router-link");

  return (accounting.value.loaded || loadingOrders.value)
    ? (openBlock(), createElementBlock("div", _hoisted_1$c, [
        createElementVNode("div", _hoisted_2$c, [
          createElementVNode("h4", _hoisted_3$b, toDisplayString$1(_ctx.$t('userOrders.title')), 1 /* TEXT */),
          (availableYears.value.length && !showCustomFilter.value)
            ? (openBlock(), createElementBlock("div", _hoisted_4$9, [
                createElementVNode("div", _hoisted_5$9, toDisplayString$1(_ctx.$t('userOrders.yearFilter')), 1 /* TEXT */),
                createElementVNode("div", {
                  class: "orders-year-switch",
                  role: "tablist",
                  "aria-label": _ctx.$t('userOrders.yearFilter')
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(availableYears.value, (year) => {
                    return (openBlock(), createElementBlock("button", {
                      key: `year-${year}`,
                      type: "button",
                      class: normalizeClass(["uk-button", selectedYear.value == year ? 'uk-button-primary' : 'uk-button-default']),
                      disabled: loadingOrders.value,
                      onClick: $event => (selectYear(year))
                    }, toDisplayString$1(year), 11 /* TEXT, CLASS, PROPS */, _hoisted_7$8))
                  }), 128 /* KEYED_FRAGMENT */)),
                  createElementVNode("button", {
                    type: "button",
                    class: "orders-more-link",
                    disabled: loadingOrders.value,
                    onClick: openCustomFilter
                  }, toDisplayString$1(_ctx.$t('userOrders.more')), 9 /* TEXT, PROPS */, _hoisted_8$8)
                ], 8 /* PROPS */, _hoisted_6$8)
              ]))
            : createCommentVNode("v-if", true),
          (showCustomFilter.value)
            ? (openBlock(), createElementBlock("div", _hoisted_9$8, [
                createElementVNode("div", _hoisted_10$8, [
                  createElementVNode("div", null, [
                    createElementVNode("label", _hoisted_11$8, toDisplayString$1(_ctx.$t('userOrders.lastDays')), 1 /* TEXT */),
                    withDirectives(createElementVNode("input", {
                      id: "orders-last-days",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((customFilter.value.lastDays) = $event)),
                      class: "uk-input",
                      type: "number",
                      min: "1",
                      step: "1"
                    }, null, 512 /* NEED_PATCH */), [
                      [vModelText, customFilter.value.lastDays]
                    ])
                  ]),
                  createElementVNode("div", null, [
                    createElementVNode("label", _hoisted_12$8, toDisplayString$1(_ctx.$t('userOrders.fromDate')), 1 /* TEXT */),
                    withDirectives(createElementVNode("input", {
                      id: "orders-from-date",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((customFilter.value.from) = $event)),
                      class: "uk-input",
                      type: "date"
                    }, null, 512 /* NEED_PATCH */), [
                      [vModelText, customFilter.value.from]
                    ])
                  ]),
                  createElementVNode("div", null, [
                    createElementVNode("label", _hoisted_13$7, toDisplayString$1(_ctx.$t('userOrders.toDate')), 1 /* TEXT */),
                    withDirectives(createElementVNode("input", {
                      id: "orders-to-date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((customFilter.value.to) = $event)),
                      class: "uk-input",
                      type: "date"
                    }, null, 512 /* NEED_PATCH */), [
                      [vModelText, customFilter.value.to]
                    ])
                  ])
                ]),
                (hasInvalidLastDays.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_14$6, toDisplayString$1(_ctx.$t('userOrders.invalidLastDays')), 1 /* TEXT */))
                  : createCommentVNode("v-if", true),
                (hasInvalidDateRange.value)
                  ? (openBlock(), createElementBlock("div", _hoisted_15$6, toDisplayString$1(_ctx.$t('userOrders.invalidDateRange')), 1 /* TEXT */))
                  : createCommentVNode("v-if", true),
                createElementVNode("div", _hoisted_16$5, [
                  createElementVNode("button", {
                    type: "button",
                    class: "uk-button uk-button-primary",
                    disabled: loadingOrders.value || hasInvalidLastDays.value || hasInvalidDateRange.value,
                    onClick: applyCustomFilter
                  }, toDisplayString$1(_ctx.$t('userOrders.applyFilter')), 9 /* TEXT, PROPS */, _hoisted_17$4),
                  createElementVNode("button", {
                    type: "button",
                    class: "uk-button uk-button-default",
                    disabled: loadingOrders.value,
                    onClick: resetCustomFilter
                  }, toDisplayString$1(_ctx.$t('userOrders.resetFilter')), 9 /* TEXT, PROPS */, _hoisted_18$4)
                ])
              ]))
            : createCommentVNode("v-if", true),
          (loadingOrders.value)
            ? (openBlock(), createElementBlock("div", _hoisted_19$4, toDisplayString$1(_ctx.$t('userOrders.loading')), 1 /* TEXT */))
            : createCommentVNode("v-if", true),
          (!loadingOrders.value && accountingOrders.value.length === 0)
            ? (openBlock(), createElementBlock("div", _hoisted_20$3, toDisplayString$1(_ctx.$t('userOrders.noOrders')), 1 /* TEXT */))
            : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(Fragment, null, renderList(accountingOrders.value, (item, id) => {
            return (openBlock(), createElementBlock("div", {
              class: "au",
              key: id
            }, [
              createElementVNode("div", _hoisted_21$3, [
                createElementVNode("div", _hoisted_22$3, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(item.purchases, (order, pkey) => {
                    return (openBlock(), createElementBlock("div", {
                      class: "purchase-thumb-stack",
                      key: `thumb-${id}-${pkey}`
                    }, [
                      createVNode(_component_router_link, {
                        to: getOrderDetailsRoute(item),
                        class: "purchase-thumb-link",
                        "aria-label": _ctx.$t('userOrders.openOrderDetails', { orderNumber: `${order.kid}-${order.aid}` })
                      }, {
                        default: withCtx(() => [
                          createElementVNode("div", {
                            class: normalizeClass(["purchase-thumb-wrapper", { 'has-stack': hasThumbStack(order) }])
                          }, [
                            (getFirstThumbUrl(order) && !isPurchaseThumbHidden(order))
                              ? (openBlock(), createElementBlock("img", {
                                  key: 0,
                                  class: "purchase-thumb",
                                  src: getFirstThumbUrl(order),
                                  alt: "",
                                  onError: $event => (hidePurchaseThumb(order))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_23$3))
                              : (openBlock(), createElementBlock("div", _hoisted_24$3, [...(_cache[3] || (_cache[3] = [
                                  createElementVNode("span", { "uk-icon": "icon: album; ratio: 1.5" }, null, -1 /* HOISTED */)
                                ]))]))
                          ], 2 /* CLASS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "aria-label"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                createElementVNode("div", _hoisted_25$3, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(item.purchases, (order, pkey) => {
                    return (openBlock(), createElementBlock("div", {
                      class: "purchase",
                      key: `main-${id}-${pkey}`
                    }, [
                      createElementVNode("div", _hoisted_26$2, [
                        createElementVNode("div", null, [
                          createVNode(_component_router_link, {
                            to: getOrderDetailsRoute(item)
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(order.kid) + "-" + toDisplayString$1(order.aid), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                        ]),
                        createElementVNode("div", _hoisted_27$2, [
                          createVNode(unref(script$8), {
                            type: item.paymentType
                          }, null, 8 /* PROPS */, ["type"])
                        ]),
                        (hasPurchaseProof(order))
                          ? (openBlock(), createElementBlock("div", _hoisted_28$2, [
                              createElementVNode("span", _hoisted_29$2, toDisplayString$1(getPurchaseProofMessage(order)), 1 /* TEXT */),
                              (shouldShowProofApprovalButton(order))
                                ? (openBlock(), createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "uk-button uk-button-primary uk-button-small purchase-proof-button",
                                    onClick: $event => (triggerProofApproval(order))
                                  }, toDisplayString$1(_ctx.$t('userOrderDetails.proofApprovalButton')), 9 /* TEXT, PROPS */, _hoisted_30$2))
                                : createCommentVNode("v-if", true)
                            ]))
                          : createCommentVNode("v-if", true)
                      ]),
                      createElementVNode("div", _hoisted_31$2, [
                        createVNode(unref(script$9), {
                          state: order.state
                        }, null, 8 /* PROPS */, ["state"])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                createElementVNode("div", _hoisted_32$1, [
                  createElementVNode("div", null, toDisplayString$1(_ctx.$d(item.date, "short")), 1 /* TEXT */),
                  createElementVNode("div", null, toDisplayString$1(_ctx.$t("n deliveries", item.purchases.length)), 1 /* TEXT */),
                  createElementVNode("div", _hoisted_33$1, toDisplayString$1(_ctx.$n((item.gross!=0)?-item.gross:0, item.currency)), 1 /* TEXT */)
                ])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        createVNode(unref(script$g), {
          open: proofApprovalModal.value.open,
          onClose: closeProofApprovalModal,
          class: "proof-approval-modal"
        }, {
          body: withCtx(() => [
            (proofApprovalModal.value.purchase)
              ? (openBlock(), createBlock(unref(script$a), {
                  key: 0,
                  purchase: proofApprovalModal.value.purchase,
                  canOpenOnlinePreview: true,
                  previewLoading: proofPreviewLoading.value,
                  previewError: proofPreviewError.value,
                  onRelease: handleProofApproval,
                  onCancel: handleProofStop,
                  onPreviewOnlineDocument: openPurchaseProofPreview,
                  onClose: closeProofApprovalModal
                }, null, 8 /* PROPS */, ["purchase", "previewLoading", "previewError"]))
              : createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["open"]),
        createVNode(unref(script$g), {
          open: previewModal.value,
          onClose: closePreviewModal,
          class: "preview-modal"
        }, {
          body: withCtx(() => [
            createVNode(unref(script$G), {
              infoComponent: "FileInfo",
              images: previewList.value,
              index: previewIndex.value
            }, null, 8 /* PROPS */, ["images", "index"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["open"])
      ]))
    : createCommentVNode("v-if", true)
}
}

};

script$c.__scopeId = "data-v-104548c0";
script$c.__file = "src/components/UserOrders.vue";

const _hoisted_1$b = {
  key: 0,
  class: "uk-card uk-card-body uk-align-center uk-margin-top"
};
const _hoisted_2$b = { class: "orders-content uk-align-center" };
const _hoisted_3$a = { class: "order-header-row" };
const _hoisted_4$8 = {
  key: 0,
  class: "uk-card-title"
};
const _hoisted_5$8 = {
  key: 0,
  class: "au-details"
};
const _hoisted_6$7 = { class: "uk-text-bold" };
const _hoisted_7$7 = {
  key: 1,
  class: "address-grid uk-margin-top"
};
const _hoisted_8$7 = {
  key: 0,
  class: "address-card"
};
const _hoisted_9$7 = { class: "address-title" };
const _hoisted_10$7 = {
  key: 1,
  class: "address-card"
};
const _hoisted_11$7 = { class: "address-title" };
const _hoisted_12$7 = {
  key: 0,
  class: "address-tracking-number uk-text-small"
};
const _hoisted_13$6 = { class: "purchases-header uk-text-small" };
const _hoisted_14$5 = { class: "purchases-title" };
const _hoisted_15$5 = {
  key: 2,
  class: "purchase-list"
};
const _hoisted_16$4 = { class: "purchase-thumbs" };
const _hoisted_17$3 = {
  key: 0,
  class: "purchase-thumb-row"
};
const _hoisted_18$3 = ["aria-label"];
const _hoisted_19$3 = ["src", "onError"];
const _hoisted_20$2 = {
  key: 0,
  class: "uk-badge purchase-thumb-badge"
};
const _hoisted_21$2 = ["aria-label"];
const _hoisted_22$2 = {
  key: 0,
  class: "purchase-thumb-row"
};
const _hoisted_23$2 = { class: "purchase-details" };
const _hoisted_24$2 = { class: "purchase-headline" };
const _hoisted_25$2 = { class: "purchase-id-group" };
const _hoisted_26$1 = { class: "purchase-id" };
const _hoisted_27$1 = {
  key: 0,
  class: "purchase-id-separator",
  "aria-hidden": "true"
};
const _hoisted_28$1 = {
  key: 1,
  class: "purchase-date"
};
const _hoisted_29$1 = { class: "purchase-total uk-text-bold" };
const _hoisted_30$1 = { class: "purchase-products uk-text-small" };
const _hoisted_31$1 = { class: "purchase-product-main" };
const _hoisted_32 = { class: "purchase-product-name" };
const _hoisted_33 = {
  key: 0,
  class: "item-quantity"
};
const _hoisted_34 = {
  key: 1,
  class: "purchase-option-inline"
};
const _hoisted_35 = { class: "product-pid" };
const _hoisted_36 = { class: "item-single-price" };
const _hoisted_37 = {
  key: 0,
  class: "purchase-product-row purchase-credit-row"
};
const _hoisted_38 = { class: "purchase-product-main" };
const _hoisted_39 = { class: "purchase-product-name" };
const _hoisted_40 = { class: "item-single-price" };
const _hoisted_41 = {
  key: 1,
  class: "purchase-product-row"
};
const _hoisted_42 = { class: "purchase-meta uk-text-small" };
const _hoisted_43 = {
  key: 0,
  class: "purchase-proof-info"
};
const _hoisted_44 = { class: "purchase-proof-summary" };
const _hoisted_45 = { class: "purchase-proof-status" };
const _hoisted_46 = ["onClick"];
const _hoisted_47 = {
  key: 1,
  class: "purchase-delivery-info"
};
const _hoisted_48 = ["src", "alt"];
const _hoisted_49 = {
  key: 1,
  "uk-icon": "icon: location",
  class: "uk-margin-small-right"
};
const _hoisted_50 = ["onClick"];
const _hoisted_51 = ["title", "aria-label", "onClick"];
const _hoisted_52 = {
  key: 2,
  class: "purchase-delivery-info"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  key: 3,
  class: "purchase-delivery-info"
};
const _hoisted_55 = ["src", "alt"];
const _hoisted_56 = {
  key: 1,
  "uk-icon": "icon: location",
  class: "uk-margin-small-right"
};
const _hoisted_57 = {
  key: 3,
  class: "all-files-view"
};
const _hoisted_58 = {
  key: 0,
  class: "uk-text-meta"
};
const _hoisted_59 = {
  key: 1,
  class: "uk-text-danger"
};
const _hoisted_60 = {
  key: 2,
  class: "uk-text-meta"
};
const _hoisted_61 = { class: "all-files-delivery-title" };
const _hoisted_62 = {
  key: 0,
  class: "uk-text-meta uk-text-small"
};
const _hoisted_63 = { class: "all-files-position-title uk-text-small" };
const _hoisted_64 = {
  key: 0,
  class: "all-files-position-options uk-text-small"
};
const _hoisted_65 = {
  key: 0,
  class: "all-files-image-group-options uk-text-small"
};
const _hoisted_66 = {
  key: 1,
  class: "all-files-image-group-options uk-text-small"
};
const _hoisted_67 = { class: "all-files-position-option all-files-position-option--neutral" };
const _hoisted_68 = {
  key: 2,
  class: "all-files-images"
};
const _hoisted_69 = ["src", "onClick"];
const _hoisted_70 = { class: "all-files-images" };
const _hoisted_71 = ["src", "onClick"];
const _hoisted_72 = {
  key: 2,
  class: "uk-text-meta uk-text-small"
};
const _hoisted_73 = {
  key: 4,
  class: "uk-text-danger uk-margin-small-top"
};
const _hoisted_74 = ["src"];
const _hoisted_75 = { class: "tracking-numbers-panel" };
const _hoisted_76 = { class: "tracking-numbers-title" };
const _hoisted_77 = { class: "tracking-numbers-table" };
const _hoisted_78 = { class: "tracking-numbers-row tracking-numbers-row-head" };
const _hoisted_79 = { class: "tracking-numbers-carrier" };
const _hoisted_80 = ["src", "alt"];
const _hoisted_81 = { class: "tracking-numbers-carrier-label" };
const _hoisted_82 = { class: "tracking-numbers-number" };


var script$b = {
  __name: 'UserOrderDetails',
  setup(__props) {

const route = useRoute();
const { t, n, d } = useI18n();
const configStore = useConfigStore();
const authStore = useAuthStore();
const order = ref({
    loaded: false,
    purchases: []
});
const error = ref('');
const productsByPid = ref({});
const productOptionsByPo = ref({});
const hiddenThumbnails = ref({});
const orderMediaManager = new MediaManager({
    useRouting: false,
    browse: 'none',
    resources: ['images', 'media']
});
const detailsView = ref('summary');
const allFilesLoading = ref(false);
const allFilesError = ref('');

const previewModal = ref(false);
const previewList = ref([]);
const previewIndex = ref(0);

const trackingModal = ref({ open: false, url: '' });
const trackingNumbersModal = ref({ open: false, entries: [] });
const proofApprovalModal = ref({ open: false, purchase: null });
const proofPreviewLoading = ref(false);
const proofPreviewError = ref('');

const {
    ensureOrderMediaLoaded,
    rebuildOrderMediaLookup,
    resolveItemImages,
    resetOrderMediaPreview
} = createOrderMediaPreview(orderMediaManager);

function openTrackingInBrowser(url) {
    const popup = window.open(url, '_blank');
    if (popup) {
        // Keep the new tab secure without relying on features that can return null in Firefox.
        popup.opener = null;
        return
    }

    // Popup blocker fallback: navigate in same tab.
    window.location.assign(url);
}

function shouldOpenTrackingInBrowser(carrier) {
    const configured = Array.isArray(configStore?.trackingForceBrowserWindowCarriers)
        ? configStore.trackingForceBrowserWindowCarriers
        : ['DHL','HERMES','FEDEX'];

    const forcedCarriers = configured
        .map((entry) => normalizeCarrierKey(entry))
        .filter(Boolean);

    return forcedCarriers.includes(normalizeCarrierKey(carrier))
}

function openTrackingModal(purchase, rows) {
    const url = buildTrackingUrl(rows, purchase);
    if (!url) return
    const carrier = getCarrierFromRows(rows);

    if (shouldOpenTrackingInBrowser(carrier)) {
        openTrackingInBrowser(url);
        return
    }

    trackingModal.value = { open: true, url };
}
function closeTrackingModal() {
    trackingModal.value = { open: false, url: '' };
}

function closeTrackingNumbersModal() {
    trackingNumbersModal.value = { open: false, entries: [] };
}

async function downloadInvoice() {
    const kid = authStore.user?.kid || order.value?.kid;
    const reference = order.value?.reference;

    if (!kid || !reference) return

    try {
        const response = await ppapiClient.getRaw(`users/${kid}/accounting/${reference}/invoice.pdf`);
        if (!response.ok) {
            throw new Error(t('userOrderDetails.invoiceDownloadError'))
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const contentDisposition = response.headers.get('content-disposition') || '';
        const filenameMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);

        link.href = blobUrl;
        link.download = filenameMatch?.[1] || `rechnung-${reference}.pdf`;
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(blobUrl);
    } catch (err) {
        error.value = toErrorText(err) || t('userOrderDetails.invoiceDownloadError');
    }
}

function toLookupKey(value) {
    if (typeof value === 'number') return String(value)
    if (typeof value !== 'string') return ''

    const key = value.trim();
    if (!key) return ''

    return key
}

function closeImageOverlay() {
    previewModal.value = false;
    previewList.value = [];
    previewIndex.value = 0;
}

function openPositionImagesOverlay(images, startIndex = 0) {
    if (!images?.length) return
    previewList.value = images;
    previewIndex.value = startIndex;
    previewModal.value = true;
}

function collectPurchaseImages(purchase) {
    if (!purchase) return []

    const purchaseItems = getPurchaseItems(purchase);
    const itemImages = purchaseItems.flatMap((item) => Array.isArray(item?.itemImages) ? item.itemImages : []);
    return resolveItemImages(itemImages)
}

async function openPurchaseProofPreview(purchase) {
    proofPreviewError.value = '';
    proofPreviewLoading.value = true;

    try {
        await ensureOrderMediaLoaded();
        rebuildOrderMediaLookup();

        const resolvedImages = collectPurchaseImages(purchase);
        if (!resolvedImages.length) {
            proofPreviewError.value = t('userOrderDetails.noImagesForItem');
            return
        }

        openPositionImagesOverlay(resolvedImages);
    } catch (err) {
        proofPreviewError.value = toErrorText(err);
    } finally {
        proofPreviewLoading.value = false;
    }
}

async function ensureAllFilesViewData() {
    allFilesError.value = '';
    allFilesLoading.value = true;

    try {
        await ensureOrderMediaLoaded();
        rebuildOrderMediaLookup();
    } catch (err) {
        allFilesError.value = toErrorText(err);
    } finally {
        allFilesLoading.value = false;
    }
}

async function toggleDetailsView() {
    if (detailsView.value == 'summary') {
        detailsView.value = 'all-files';
        await ensureAllFilesViewData();
        return
    }

    detailsView.value = 'summary';
}

const invoiceAddresses = computed(() =>
    Array.isArray(order.value?.invoiceAddress) ? order.value.invoiceAddress : []
);
const shippingAddresses = computed(() =>
    Array.isArray(order.value?.shippingAddress) ? order.value.shippingAddress : []
);

function getPurchaseForShippingAddress(address, index) {
    const purchases = Array.isArray(order.value?.purchases) ? order.value.purchases : [];
    if (!purchases.length) return null

    const addressAid = toLookupKey(address?.aid ?? address?.id);
    if (addressAid) {
        const byAid = purchases.find((p) => toLookupKey(p?.aid) === addressAid);
        if (byAid) return byAid
    }

    return purchases[index] ?? null
}

function getShippingAddressTrackingLabel(address, index) {
    const purchase = getPurchaseForShippingAddress(address, index);
    if (!purchase) return ''

    const raw = purchase?.versandopt || purchase?.shippingOpt || '';
    const rows = parseVersandopt(raw);
    const numbers = rows.flatMap((row) => getTrackingNumbersFromRow(row));
    const unique = [...new Set(numbers)];

    if (unique.length) return unique.join(', ')

    const kid = toLookupKey(purchase?.kid);
    const aid = toLookupKey(purchase?.aid);
    if (kid && aid) return `${kid}-${aid}`

    return ''
}

function toErrorText(err) {
    if (!err) return ''
    if (typeof err === 'string') return err
    if (typeof err?.message === 'string') return err.message

    try {
        return JSON.stringify(err)
    } catch {
        return t('userOrderDetails.unknownError')
    }
}

function toDisplay(value) {
    if (value === null || typeof value === 'undefined' || value === '') return '-'
    return value
}

function normalizePid(pid) {
    if (typeof pid === 'number') return String(pid)
    if (typeof pid !== 'string') return ''

    const found = pid.match(/[A-Za-z0-9_-]+/);
    if (found) return found[0]

    return ''
}

function getPurchaseItems(purchase) {
    if (Array.isArray(purchase?.items)) return purchase.items
    if (Array.isArray(purchase?.orderItems)) return purchase.orderItems
    if (Array.isArray(purchase?.purchaseItems)) return purchase.purchaseItems
    return []
}

function toNumber(value) {
    if (value === null || typeof value === 'undefined' || value === '') return null
    const num = Number(value);
    return Number.isFinite(num) ? num : null
}

function formatPrice(value, currency) {
    const num = toNumber(value);
    if (num === null) return '-'
    if (!currency) return String(num)
    return n(num, currency)
}

function getItemSinglePrice(item) {
    const singlePrice =
        toNumber(item?.singleprice) ??
        toNumber(item?.singlePrice) ??
        toNumber(item?.unitPrice) ??
        toNumber(item?.unitprice);

    if (singlePrice !== null) return singlePrice

    // Fallback for APIs that only provide one price field per item.
    return toNumber(item?.price)
}

function getItemId(item) {
    const id = item?.id ?? item?.itemId ?? item?.orderItemId;
    if (id === null || typeof id === 'undefined' || id === '') return null
    return String(id)
}

function getApiPrefix() {
    if (authStore.user?.dbKey) return `/${authStore.user.dbKey}`
    if (authStore.setup?.dbKey) return `/${authStore.setup.dbKey}`
    if (configStore.defaultDbKey) return `/${configStore.defaultDbKey}`
    return ''
}

function toApiStorageUrl(path) {
    if (!path) return ''
    if (!configStore.apiUrl) return path

    const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
    return `${configStore.apiUrl}${getApiPrefix()}/${normalizedPath}`
}

function getItemThumbnailUrl(purchase, item) {
    const itemId = getItemId(item);
    if (itemId === null || !purchase?.kid || !purchase?.aid) return ''

    const storagePath = `/storage/media/order/K/0/${purchase.kid}/${purchase.aid}-${itemId}`;
    return toApiStorageUrl(storagePath)
}

function getItemImageCount(item) {
    if (!Array.isArray(item?.itemImages)) return 0
    return item.itemImages.length
}

function toOptionIdKey(value) {
    const raw = toLookupKey(value);
    if (!raw) return ''

    if (!/^\d+$/.test(raw)) return ''
    return String(Number(raw))
}

function toOptionDisplayLabel(optionName) {
    const normalizedName = toLookupKey(optionName);
    if (!normalizedName) return ''

    const translated = t(`product.${normalizedName}`);
    return translated !== `product.${normalizedName}` ? translated : normalizedName
}

function toProductOptionDisplayLabel(option) {
    if (!option || typeof option !== 'object') {
        return toOptionDisplayLabel(option)
    }

    const name = toLookupKey(option.name ?? option.label ?? option.title);
    const value = toLookupKey(option.value ?? option.val);
    return toOptionDisplayLabel([name, value].filter(Boolean).join(' '))
}

function parseItemOptionValues(source) {
    if (source === null || typeof source === 'undefined' || source === '') return []

    if (Array.isArray(source)) {
        return source.flatMap((entry) => parseItemOptionValues(entry))
    }

    if (typeof source === 'number') return [source]

    if (typeof source === 'string') {
        const raw = source.trim();
        if (!raw) return []

        const hasJsonEnvelope =
            (raw.startsWith('[') && raw.endsWith(']'))
            || (raw.startsWith('{') && raw.endsWith('}'));

        if (hasJsonEnvelope) {
            try {
                const parsed = JSON.parse(raw);
                return parseItemOptionValues(parsed)
            } catch {
                // Continue with plain string handling.
            }
        }

        if (/[;,|]/.test(raw)) {
            return raw
                .split(/[;,|]/)
                .map((entry) => entry.trim())
                .filter(Boolean)
        }

        return [raw]
    }

    if (typeof source === 'object') {
        if (typeof source.po !== 'undefined') return [source.po]

        if (typeof source.option !== 'undefined') return parseItemOptionValues(source.option)
        if (typeof source.options !== 'undefined') return parseItemOptionValues(source.options)
    }

    return []
}

function getItemOptionIds(item) {
    const optionIds = [
        ...parseItemOptionValues(item?.options),
        ...parseItemOptionValues(item?.properties?.options)
    ];

    // Neue API-Struktur: PO-Optionen kommen aus itemImages[n].options
    // Erkennungsmerkmal: parameter === value (beide sind die PO-Kennung, numerisch)
    if (Array.isArray(item?.itemImages)) {
        item.itemImages.forEach((img) => {
            if (!Array.isArray(img?.options)) return
            img.options.forEach((opt) => {
                const param = toLookupKey(opt?.parameter);
                const value = toLookupKey(opt?.value);
                if (param && param === value) {
                    optionIds.push(param);
                }
            });
        });
    }

    const productOptions = Array.isArray(item?.productOptions)
        ? item.productOptions
        : (item?.productOptions ? [item.productOptions] : []);

    productOptions.forEach((option) => {
        if (option && typeof option === 'object') {
            optionIds.push(option.po);
            return
        }

        optionIds.push(option);
    });

    return [...new Set(optionIds.map((value) => toOptionIdKey(value)).filter(Boolean))]
}

function getResolvedProductOptionName(optionId) {
    const option = productOptionsByPo.value[optionId];
    return toProductOptionDisplayLabel(option)
}

function getProductOptionNames(item) {
    const productOptions = Array.isArray(item?.productOptions)
        ? item.productOptions
        : (item?.productOptions ? [item.productOptions] : []);

    const explicitNames = productOptions
        .map((option) => {
            if (option && typeof option === 'object') {
                return toProductOptionDisplayLabel(option)
            }

            if (toOptionIdKey(option)) return null

            return toOptionDisplayLabel(option)
        })
        .filter(Boolean);

    const resolvedNames = getItemOptionIds(item)
        .map((optionId) => getResolvedProductOptionName(optionId))
        .filter(Boolean);

    return [...new Set([...explicitNames, ...resolvedNames])]
}

function hasPricedOptionPid(option) {
    if (!option || typeof option !== 'object') return false

    const optionPid = option?.pid ?? option?.productPid ?? option?.product?.pid;
    return !!normalizePid(optionPid)
}

function getPricedOptionPid(option) {
    if (!option || typeof option !== 'object') return ''

    const optionPid = option?.pid ?? option?.productPid ?? option?.product?.pid;
    return normalizePid(optionPid)
}

function getPricedProductOptionNames(item) {
    const productOptions = Array.isArray(item?.productOptions)
        ? item.productOptions
        : (item?.productOptions ? [item.productOptions] : []);

    const explicitNames = productOptions
        .map((option) => {
            if (!option || typeof option !== 'object') return null

            const optionId = toOptionIdKey(option?.po);
            const resolvedOption = optionId ? productOptionsByPo.value[optionId] : null;
            const hasPricedPid = hasPricedOptionPid(option) || hasPricedOptionPid(resolvedOption);
            if (!hasPricedPid) return null

            const displayName = toProductOptionDisplayLabel(option) || toProductOptionDisplayLabel(resolvedOption);
            if (displayName) return displayName

            return getPricedOptionPid(option) || getPricedOptionPid(resolvedOption) || null
        })
        .filter(Boolean);

    const resolvedNames = getItemOptionIds(item)
        .map((optionId) => {
            const option = productOptionsByPo.value[optionId];
            if (!hasPricedOptionPid(option)) return null

            const displayName = toProductOptionDisplayLabel(option);
            if (displayName) return displayName

            return getPricedOptionPid(option) || null
        })
        .filter(Boolean);

    return [...new Set([...explicitNames, ...resolvedNames])]
}

function addItemParameterValue(parameterMap, key, value) {
    const normalizedKey = toLookupKey(key);
    const normalizedValue = toLookupKey(value);

    if (!normalizedKey || !normalizedValue) return

    if (!parameterMap[normalizedKey]) parameterMap[normalizedKey] = [];
    if (!parameterMap[normalizedKey].includes(normalizedValue)) {
        parameterMap[normalizedKey].push(normalizedValue);
    }
}

function parseParameterValueString(rawValue, parameterMap) {
    const source = toLookupKey(rawValue);
    if (!source) return

    source
        .split(/[\n;|]+/)
        .map((entry) => entry.trim())
        .filter(Boolean)
        .forEach((entry) => {
            const match = entry.match(/^([^:=]+)\s*[:=]\s*(.+)$/);
            if (!match) return

            addItemParameterValue(parameterMap, match[1], match[2]);
        });
}

function collectItemParameterValues(source, parameterMap, depth = 0) {
    if (depth > 4) return
    if (source === null || typeof source === 'undefined') return

    if (Array.isArray(source)) {
        source.forEach((entry) => collectItemParameterValues(entry, parameterMap, depth + 1));
        return
    }

    if (typeof source === 'string' || typeof source === 'number' || typeof source === 'boolean') {
        parseParameterValueString(source, parameterMap);
        return
    }

    if (typeof source !== 'object') return

    const pairKey = source.parameter ?? source.param ?? source.key ?? source.name;
    const pairValue = source.value ?? source.wert ?? source.val;
    if (typeof pairKey !== 'undefined' && typeof pairValue !== 'undefined') {
        addItemParameterValue(parameterMap, pairKey, pairValue);
    }

    Object.entries(source).forEach(([entryKey, entryValue]) => {
        if (entryValue === null || typeof entryValue === 'undefined') return

        if (Array.isArray(entryValue) || typeof entryValue === 'object') {
            collectItemParameterValues(entryValue, parameterMap, depth + 1);
            return
        }

        addItemParameterValue(parameterMap, entryKey, entryValue);
        parseParameterValueString(entryValue, parameterMap);
    });
}

function getConfiguredItemParameterLabels(item) {
    const parameterMap = {};
    const parameterSources = [
        item?.parameters,
        item?.parameter,
        item?.params,
        item?.data,
        item?.properties?.parameters,
        item?.properties?.parameter
    ];

    // Neue API-Struktur: mediaSettings kommen aus itemImages[n].mediaSettings
    if (Array.isArray(item?.itemImages)) {
        item.itemImages.forEach((img) => {
            if (img?.mediaSettings && typeof img.mediaSettings === 'object' && !Array.isArray(img.mediaSettings)) {
                parameterSources.push(img.mediaSettings);
            }
        });
    }

    parameterSources.forEach((source) => collectItemParameterValues(source, parameterMap));

    const labels = [];
    const configEntries = Object.entries(userOrderDetailsItemParameterDisplay || {});

    configEntries.forEach(([parameterKey, parameterConfig]) => {
        const normalizedParameterKey = toLookupKey(parameterKey);
        if (!normalizedParameterKey) return

        const values = parameterMap[normalizedParameterKey];
        if (!Array.isArray(values) || values.length === 0) return

        const valuesMap = parameterConfig?.values && typeof parameterConfig.values === 'object'
            ? parameterConfig.values
            : null;
        const label = toLookupKey(parameterConfig?.label) || normalizedParameterKey;
        const hideValue = parameterConfig?.hideValue === true;

        values.forEach((rawValue) => {
            if (valuesMap) {
                const mappedValue = valuesMap[rawValue];
                if (mappedValue) {
                    labels.push(String(mappedValue));
                    return
                }

                if (parameterConfig?.showRawValue !== true) return
            }

            if (hideValue) {
                labels.push(label);
                return
            }

            labels.push(`${label}: ${rawValue}`);
        });
    });

    return [...new Set(labels)]
}

function getItemDetailLabels(item) {
    const labels = [
        ...getProductOptionNames(item),
        ...getConfiguredItemParameterLabels(item)
    ];

    return [...new Set(labels)]
}

function getImageOptionLabels(img) {
    return getConfiguredItemParameterLabels({ itemImages: [img] })
}

function groupItemImagesByOptions(itemImages) {
    const groups = new Map();

    itemImages.forEach((img) => {
        const optionLabels = getImageOptionLabels(img);
        const key = [...optionLabels].sort().join('|');

        if (!groups.has(key)) {
            groups.set(key, { key: key || '__default__', optionLabels, imageRecs: [] });
        }

        groups.get(key).imageRecs.push(img);
    });

    return [...groups.values()]
}

function isChargeItemCategory(value) {
    if (typeof value !== 'string') return false
    return value.toLowerCase() === 'charge_item'
}

function isChargeItem(pid) {
    const product = productsByPid.value[pid];
    if (!Array.isArray(product?.cat)) return false
    return product.cat.some((category) => isChargeItemCategory(category))
}

function getPurchaseProductRows(purchase) {
    const itemRows = getPurchaseItems(purchase)
        .map((item) => {
            const pid = normalizePid(item?.pid || item?.product?.pid || item?.productPid || item);
            if (!pid) return null

            const itemId = getItemId(item);

            const quantity = toNumber(item?.quantity) ?? toNumber(item?.copies) ?? 1;

            return {
                pid,
                itemId,
                singlePrice: getItemSinglePrice(item),
                quantity,
                detailLabels: getItemDetailLabels(item),
                summaryOptionText: getPricedProductOptionNames(item).join(', '),
                thumbnailUrl: getItemThumbnailUrl(purchase, item),
                suppressThumbnail: isChargeItem(pid),
                imageCount: getItemImageCount(item),
                itemImages: Array.isArray(item?.itemImages) ? item.itemImages : []
            }
        })
        .filter(Boolean);

    if (itemRows.length > 0) return itemRows

    const fallbackPid = normalizePid(purchase?.singlePid);
    if (fallbackPid) {
        return [{ pid: fallbackPid, itemId: null, singlePrice: null, detailLabels: [], summaryOptionText: '', thumbnailUrl: '', suppressThumbnail: isChargeItem(fallbackPid), imageCount: 0 }]
    }

    return []
}

function getThumbnailKey(purchase, pkey, item, productIndex) {
    return `${purchase?.id || pkey}-${item?.itemId || item?.pid || 'item'}-${productIndex}`
}

function isThumbnailHidden(purchase, pkey, item, productIndex) {
    return !!hiddenThumbnails.value[getThumbnailKey(purchase, pkey, item, productIndex)]
}

function hideThumbnail(purchase, pkey, item, productIndex) {
    const key = getThumbnailKey(purchase, pkey, item, productIndex);
    hiddenThumbnails.value = {
        ...hiddenThumbnails.value,
        [key]: true
    };
}

function getPurchasePids(purchase) {
    return getPurchaseProductRows(purchase).map((row) => row.pid)
}

function getPurchaseOptionIds(purchase) {
    return [...new Set(getPurchaseItems(purchase).flatMap((item) => getItemOptionIds(item)))]
}

function getPurchaseTotalPrice(purchase) {
    const purchasePrice = toNumber(purchase?.price);
    if (purchasePrice !== null) return purchasePrice

    let total = 0;
    let hasAnyPrice = false;

    getPurchaseItems(purchase).forEach((item) => {
        const rowTotal = toNumber(item?.price);
        if (rowTotal !== null) {
            total += rowTotal;
            hasAnyPrice = true;
            return
        }

        const singlePrice = getItemSinglePrice(item);
        if (singlePrice === null) return

        const quantity = toNumber(item?.quantity) ?? toNumber(item?.copies) ?? 1;
        total += (singlePrice * quantity);
        hasAnyPrice = true;
    });

    if (!hasAnyPrice) return null
    return total
}

function getPurchaseTotalPriceDisplay(purchase) {
    const currency = purchase?.currency || order.value?.currency;
    return formatPrice(getPurchaseTotalPrice(purchase), currency)
}

function getPurchaseCredit(purchase) {
    const credit = toNumber(purchase?.credit);
    if (credit === null || credit === 0) return null
    return credit
}

function getPurchaseCreditDisplay(purchase) {
    const credit = getPurchaseCredit(purchase);
    if (credit === null) return ''

    const currency = purchase?.currency || order.value?.currency;
    return formatPrice(-Math.abs(credit), currency)
}

function parseVersandopt(raw) {
    if (!raw) return []
    const lines = Array.isArray(raw)
        ? raw.map((entry) => String(entry ?? '').trim()).filter(Boolean)
        : String(raw).split(/\r?\n/).map((line) => line.trim()).filter(Boolean);

    return lines.map((line) => {
        const cols = line.split(':').map((c) => c.trim());
        return cols
    })
}

function normalizeCarrierKey(value) {
    return toLookupKey(value).toUpperCase()
}

function normalizeProofStatusKey(value) {
    return toLookupKey(value).toLowerCase()
}

function hasPurchaseProof(purchase) {
    return !!normalizeProofStatusKey(purchase?.proofstat)
}

function shouldShowProofApprovalButton(purchase) {
    return normalizeProofStatusKey(purchase?.proofstat) === 'bestellt'
}

function formatPurchaseProofDate(value) {
    const rawValue = toLookupKey(value);
    if (!rawValue) return ''

    const parsedDate = new Date(rawValue);
    if (Number.isNaN(parsedDate.getTime())) return rawValue

    try {
        return d(parsedDate, 'short')
    } catch {
        return rawValue
    }
}

function getPurchaseProofMessage(purchase) {
    const normalized = normalizeProofStatusKey(purchase?.proofstat);
    const formattedDate = formatPurchaseProofDate(purchase?.proofCompletionDate);

    if (normalized === 'bestellt') {
        if (formattedDate) {
            return t('userOrderDetails.proofSentOn', { date: formattedDate })
        }

        return t('userOrderDetails.proofStatusOrdered')
    }

    const statusLabels = {
        freigegeben: t('userOrderDetails.proofStatusApproved'),
        storno: t('userOrderDetails.proofStatusCanceled')
    };

    return statusLabels[normalized] || toLookupKey(purchase?.proofstat)
}

function triggerProofApproval(purchase) {
    proofApprovalModal.value = { open: true, purchase };
}

function closeProofApprovalModal() {
    proofApprovalModal.value = { open: false, purchase: null };
    proofPreviewError.value = '';
    proofPreviewLoading.value = false;
}

async function submitProofDecision(purchase, proofStat) {
    if (!purchase?.kid || !purchase?.aid) return

    try {
        await ppapiClient.put(`users/${purchase.kid}/purchases/${purchase.aid}/printapproval`, { proofStat });
        purchase.proofstat = proofStat;
        closeProofApprovalModal();
    } catch (err) {
        const alertStore = useAlertStore();
        alertStore.error(err);
    }
}

function handleProofApproval(purchase) {
    submitProofDecision(purchase, 'freigegeben');
}

function handleProofStop(purchase) {
    submitProofDecision(purchase, 'storno');
}

function getCarrierFromRows(rows) {
    if (!Array.isArray(rows)) return ''

    const row = rows.find((entry) => Array.isArray(entry) && toLookupKey(entry[0]));
    return normalizeCarrierKey(row?.[0])
}

function getTrackingRowData(row) {
    if (!Array.isArray(row)) {
        return {
            carrierUpper: '',
            vid: '',
            refNr: '',
            parcelId: ''
        }
    }

    const carrierUpper = normalizeCarrierKey(row[0]);
    const vid = toLookupKey(row[1]);
    const refNr = toLookupKey(row[4]);
    let parcelId = toLookupKey(row[3]);

    // Old logic compatibility: if col4 starts with protocol token, rebuild URL from remaining columns.
    if ((parcelId === 'http' || parcelId === 'https') && row.length > 4) {
        parcelId = `${parcelId}:${row.slice(4).join(':')}`;
    }

    if (!parcelId && refNr) parcelId = refNr;

    return {
        carrierUpper,
        vid,
        refNr,
        parcelId
    }
}

function isHttpUrl(value) {
    const normalized = toLookupKey(value).toLowerCase();
    return normalized.startsWith('http://') || normalized.startsWith('https://')
}

function splitTrackingValues(value) {
    return toLookupKey(value)
        .split(';')
        .map((entry) => entry.trim())
        .filter(Boolean)
}

function getTrackingNumbersFromRow(row) {
    const { parcelId, refNr } = getTrackingRowData(row);

    const parcelNumbers = splitTrackingValues(parcelId).filter((value) => !isHttpUrl(value));
    if (parcelNumbers.length) {
        return [...new Set(parcelNumbers)]
    }

    const fallbackNumbers = splitTrackingValues(refNr).filter((value) => !isHttpUrl(value));
    if (fallbackNumbers.length) {
        return [...new Set(fallbackNumbers)]
    }

    return []
}

function getTrackingEntries(rows) {
    if (!Array.isArray(rows)) return []

    const seen = new Set();
    const entries = [];

    rows.forEach((row, rowIndex) => {
        const { carrierUpper } = getTrackingRowData(row);
        const parcelNumbers = getTrackingNumbersFromRow(row);
        const carrier = carrierUpper || t('userOrderDetails.unknownCarrier');

        parcelNumbers.forEach((parcelNumber, numberIndex) => {
            const dedupeKey = `${carrier}|${parcelNumber}`;
            if (seen.has(dedupeKey)) return

            seen.add(dedupeKey);

            entries.push({
                key: `${dedupeKey}-${rowIndex}-${numberIndex}`,
                carrier,
                parcelNumber
            });
        });
    });

    return entries
}

function openTrackingNumbersModal(rows) {
    const entries = getTrackingEntries(rows);
    if (!entries.length) return

    trackingNumbersModal.value = {
        open: true,
        entries
    };
}

const imagePath = import.meta.env.PROD
    ? '/theme/public/assets/images'
    : '/src/assets/images';

const CARRIER_LOGO_FILES = {
    UPS: 'UPS_logo_square.svg',
    DPD: 'DPD_logo_square.svg',
    ACUT: 'ACUT_logo_square.png',
    DHL: 'DHL_logo_square.svg',
    ABH: 'PICKUP_logo_square.png',
    GLS: 'GLS_logo_square.svg',
    FEDEX: 'FedEx_logo_square.svg',
    HERMES: 'HERMES_logo_square.svg',
    OTHER: 'OTHER_carrier_logo_square.svg',
    PICKUP: 'PICKUP_logo_square.png'
};

function getCarrierLogoUrl(carrier) {
    const fileName = CARRIER_LOGO_FILES[normalizeCarrierKey(carrier)];
    return fileName ? `${imagePath}/${fileName}` : null
}

function resolveTrackingTemplate(template, values) {
    if (!template || typeof template !== 'string') return ''

    return template.replace(/\{([A-Za-z0-9_]+)\}/g, (_, key) => {
        const value = values?.[key];
        if (value === null || typeof value === 'undefined') return ''
        return encodeURIComponent(String(value))
    })
}

/**
 * Returns a delivery info descriptor for the given purchase.
 * shape: { type: 'text'|'carrier'|'tracking'|'pickup', text?: string, carrier?: string, url?: string }
 */
function getPurchaseDeliveryInfo(purchase) {
    const type = (purchase?.deliveryType || '').toLowerCase();
    const state = (purchase?.state || '').toLowerCase();
    const raw = purchase?.versandopt || purchase?.shippingOpt || '';
    const rows = parseVersandopt(raw);
    const carrier = getCarrierFromRows(rows);
    const hasRows = rows.length > 0;
    const hasMultiple = rows.length > 1 || (rows.length === 1 && rows[0].length > 1);

    if (type === 'versand' || type === 'shipping') {
        if (!hasRows) {
            if (state === 'versandfertig') {
                return { type: 'text', text: t('userOrderDetails.trackingUnavailable') }
            }
            return { type: 'text', text: t('userOrderDetails.trackingNotYetAvailable') }
        }
        if (hasMultiple) {
            return { type: 'tracking', rows, carrier }
        }

        return { type: 'carrier', carrier, text:  t('userOrderDetails.shippedVia' + carrier) }
    }

    if (type === 'abholung' || type === 'pickup') {
        if (state === 'versandfertig') {
            return { type: 'pickup', text: t('userOrderDetails.pickupOrder') }
        }
        return { type: 'pickup', text: t('userOrderDetails.orderReadyForPickup') }
    }

    return null
}

function buildTrackingUrl(rows, purchase) {
    if (!Array.isArray(rows) || rows.length === 0) return ''

    const row = rows.find((entry) => Array.isArray(entry) && entry.some((col) => toLookupKey(col)));
    if (!row) return ''

    const { carrierUpper, vid, refNr, parcelId } = getTrackingRowData(row);

    const parcelIds = splitTrackingValues(parcelId);
    const refNumbers = splitTrackingValues(refNr);
    const effectiveParcelId = parcelIds[0] || refNumbers[0] || '';
    const effectiveRefNr = refNumbers[0] || '';

    if (!effectiveParcelId && !effectiveRefNr) return ''

     const scheme = effectiveParcelId.split(':')[0].toLowerCase();
    if (scheme === 'http' || scheme === 'https') {
        return effectiveParcelId
    }

    const templates = configStore?.trackingUrlTemplates || {};
    const template = templates[carrierUpper];
    if (!template) return ''

    const anr = `${toLookupKey(purchase?.kid)}_${toLookupKey(purchase?.aid)}`;

    return resolveTrackingTemplate(template, {
        carrier: carrierUpper,
        kid: toLookupKey(purchase?.kid),
        aid: toLookupKey(purchase?.aid),
        anr,
        vid,
        parcelId: effectiveParcelId,
        refNr: effectiveRefNr
    })
}

function productDisplayByPid(pid) {
    if (!pid) return '-'

    const product = productsByPid.value[pid];
    if (!product) return pid

    const label = [product.label, product.format].filter(Boolean).join(' ');
    if (label) return label

    return pid
}

function getPositionTitle(item) {
    const itemQuantityPrefix = item?.quantity > 1 ? `${item.quantity} x ` : '';
    const itemName = `${itemQuantityPrefix}${productDisplayByPid(item?.pid)}`;
    return itemName
}

// Computed property to gather all deliveries and their associated positions and images for the "All files" view.
// Positions with categories that indicate they are charge items (e.g., shipping, handling) will be filtered out, as they typically don't have associated files.
const allFilesDeliveries = computed(() => {
    const deliveries = [];

    if (!Array.isArray(order.value?.purchases)) return deliveries

    order.value.purchases.forEach((purchase, purchaseIndex) => {
        const positions = getPurchaseProductRows(purchase)
            .filter((item) => !item.suppressThumbnail)
            .map((item, itemIndex) => {
                const rawItemImages = Array.isArray(item.itemImages) ? item.itemImages : [];
                const rawGroups = groupItemImagesByOptions(rawItemImages);
                const imageGroups = rawGroups.map((group) => ({
                    key: `${purchase?.id || purchaseIndex}-${item?.itemId || item?.pid || itemIndex}-${group.key}`,
                    optionLabels: group.optionLabels,
                    images: resolveItemImages(group.imageRecs)
                }));
                const allImages = imageGroups.flatMap((g) => g.images);
                const multipleGroups = imageGroups.length > 1;

                return {
                    key: `${purchase?.id || purchaseIndex}-${item?.itemId || item?.pid || itemIndex}`,
                    title: getPositionTitle(item),
                    detailLabels: Array.isArray(item?.detailLabels) ? item.detailLabels : [],
                    imageGroups,
                    allImages,
                    multipleGroups
                }
            });

        deliveries.push({
            key: `${purchase?.id || purchaseIndex}`,
            orderNumber: `${purchase?.kid || '-'}-${purchase?.aid || '-'}`,
            positions
        });
    });

    return deliveries
});

const hasAnyAllFilesPositions = computed(() => {
    return allFilesDeliveries.value.some((delivery) => delivery.positions.length > 0)
});

async function preloadProductsForPurchases(purchases) {
    const allPids = [...new Set((Array.isArray(purchases) ? purchases : []).flatMap((purchase) => getPurchasePids(purchase)))];
    const missingPids = allPids.filter((pid) => !Object.prototype.hasOwnProperty.call(productsByPid.value, pid));

    if (missingPids.length === 0) return

    const entries = await Promise.all(
        missingPids.map(async (pid) => {
            try {
                const product = await db.products.get(pid);
                return [pid, product || null]
            } catch {
                return [pid, null]
            }
        })
    );

    productsByPid.value = {
        ...productsByPid.value,
        ...Object.fromEntries(entries)
    };
}

async function preloadProductOptionsForPurchases(purchases) {
    const allOptionIds = [...new Set((Array.isArray(purchases) ? purchases : []).flatMap((purchase) => getPurchaseOptionIds(purchase)))];
    const missingOptionIds = allOptionIds.filter((optionId) => !Object.prototype.hasOwnProperty.call(productOptionsByPo.value, optionId));

    if (missingOptionIds.length === 0) return

    const entries = await Promise.all(
        missingOptionIds.map(async (optionId) => {
            const numericOptionId = Number(optionId);

            try {
                let option = null;

                if (!Number.isNaN(numericOptionId)) {
                    option = await db.productOptions.get(numericOptionId);
                }

                if (!option) {
                    option = await db.productOptions.get(optionId);
                }

                if (!option) return null

                return [optionId, option]
            } catch {
                return null
            }
        })
    );

    const resolvedEntries = entries.filter(Boolean);
    if (resolvedEntries.length === 0) return

    productOptionsByPo.value = {
        ...productOptionsByPo.value,
        ...Object.fromEntries(resolvedEntries)
    };
}

async function loadOrder(orderId) {
    if (!orderId) {
        closeImageOverlay();
        detailsView.value = 'summary';
        allFilesLoading.value = false;
        allFilesError.value = '';
        order.value = { loaded: true, purchases: [] };
        return
    }

    order.value = { loaded: false, purchases: [] };
    error.value = '';
    hiddenThumbnails.value = {};
    detailsView.value = 'summary';
    allFilesLoading.value = false;
    allFilesError.value = '';
    closeImageOverlay();

    try {
        const response = await ppapiClient.get(`orders/${orderId}`, null, null, [{ includeItems: 1 }]);
        const data = typeof response?.data === 'function' ? response.data() : response;

        const purchases = Array.isArray(data?.purchases) ? data.purchases : [];

        const [kid, reference] = data.orderId.split("-");
        order.value = {
            ...data,
            kid,
            reference,
            purchases,
            loaded: true
        };

        await preloadProductsForPurchases(purchases);
        await preloadProductOptionsForPurchases(purchases);
        // Load user files in background so itemImages can be resolved to media entities by jid/bid.
        ensureOrderMediaLoaded().catch(() => {});
    } catch (err) {
        order.value = { loaded: true, purchases: [] };
        error.value = toErrorText(err);
    }
}

watch(
    () => authStore.user?.kid,
    () => {
        productOptionsByPo.value = {};
        resetOrderMediaPreview();
    }
);

onUnmounted(() => {
    orderMediaManager.close();
});

watch(
    () => route.params.id,
    (id) => {
        const orderId = Array.isArray(id) ? id[0] : id;
        loadOrder(orderId);
    },
    { immediate: true }
);


return (_ctx, _cache) => {
  const _component_router_link = resolveComponent("router-link");

  return (openBlock(), createElementBlock(Fragment, null, [
    (order.value.loaded)
      ? (openBlock(), createElementBlock("div", _hoisted_1$b, [
          createElementVNode("div", _hoisted_2$b, [
            createVNode(_component_router_link, { to: "/shop/account/orders" }, {
              default: withCtx(() => [
                _cache[0] || (_cache[0] = createElementVNode("i", {
                  "uk-icon": "icon: arrow-left",
                  class: "uk-margin-small-right"
                }, null, -1 /* HOISTED */)),
                createTextVNode(toDisplayString$1(_ctx.$t('userOrderDetails.backToOverview')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            createElementVNode("div", _hoisted_3$a, [
              (order.value.date)
                ? (openBlock(), createElementBlock("h4", _hoisted_4$8, toDisplayString$1(_ctx.$t('userOrderDetails.orderFrom', { date: _ctx.$d(order.value.date, "short") })), 1 /* TEXT */))
                : createCommentVNode("v-if", true),
              (order.value.kid && order.value.reference)
                ? (openBlock(), createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "uk-button uk-button-default uk-button-small invoice-download-button",
                    onClick: downloadInvoice
                  }, [
                    _cache[1] || (_cache[1] = createElementVNode("i", {
                      "uk-icon": "icon: download",
                      class: "uk-margin-small-right"
                    }, null, -1 /* HOISTED */)),
                    createTextVNode(" " + toDisplayString$1(_ctx.$t('userOrderDetails.invoiceDownload')), 1 /* TEXT */)
                  ]))
                : createCommentVNode("v-if", true)
            ]),
            (order.value.date)
              ? (openBlock(), createElementBlock("div", _hoisted_5$8, [
                  createElementVNode("div", null, [
                    createVNode(unref(script$8), {
                      type: order.value.paymentType
                    }, null, 8 /* PROPS */, ["type"])
                  ]),
                  createElementVNode("div", _hoisted_6$7, toDisplayString$1(_ctx.$n((order.value.gross != 0) ? -order.value.gross : 0, order.value.currency)), 1 /* TEXT */)
                ]))
              : createCommentVNode("v-if", true),
            (invoiceAddresses.value.length || shippingAddresses.value.length)
              ? (openBlock(), createElementBlock("div", _hoisted_7$7, [
                  (invoiceAddresses.value.length)
                    ? (openBlock(), createElementBlock("div", _hoisted_8$7, [
                        createElementVNode("div", _hoisted_9$7, toDisplayString$1(_ctx.$t('userOrderDetails.invoiceAddress')), 1 /* TEXT */),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(invoiceAddresses.value, (address) => {
                          return (openBlock(), createElementBlock("div", {
                            key: address.id,
                            class: "address-body"
                          }, [
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.company)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.firstname)) + " " + toDisplayString$1(toDisplay(address.lastname)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.street)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.zip)) + " " + toDisplayString$1(toDisplay(address.city)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.country)), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : createCommentVNode("v-if", true),
                  (shippingAddresses.value.length)
                    ? (openBlock(), createElementBlock("div", _hoisted_10$7, [
                        createElementVNode("div", _hoisted_11$7, toDisplayString$1(_ctx.$t('userOrderDetails.shippingAddress')), 1 /* TEXT */),
                        (openBlock(true), createElementBlock(Fragment, null, renderList(shippingAddresses.value, (address, addressIndex) => {
                          return (openBlock(), createElementBlock("div", {
                            key: address.id,
                            class: "address-body"
                          }, [
                            (shippingAddresses.value.length > 1 && getShippingAddressTrackingLabel(address, addressIndex))
                              ? (openBlock(), createElementBlock("div", _hoisted_12$7, toDisplayString$1(_ctx.$t('userOrderDetails.trackingNumberLabel')) + ": " + toDisplayString$1(getShippingAddressTrackingLabel(address, addressIndex)), 1 /* TEXT */))
                              : createCommentVNode("v-if", true),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.company)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.firstname)) + " " + toDisplayString$1(toDisplay(address.lastname)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.street)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.zip)) + " " + toDisplayString$1(toDisplay(address.city)), 1 /* TEXT */),
                            createElementVNode("div", null, toDisplayString$1(toDisplay(address.country)), 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : createCommentVNode("v-if", true)
                ]))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_13$6, [
              createElementVNode("div", _hoisted_14$5, toDisplayString$1(_ctx.$t("n deliveries", order.value.purchases.length)), 1 /* TEXT */),
              createElementVNode("button", {
                type: "button",
                class: "uk-button uk-button-primary uk-button-small purchases-view-toggle",
                onClick: toggleDetailsView
              }, toDisplayString$1(detailsView.value == 'summary' ? _ctx.$t('userOrderDetails.viewAllFiles') : _ctx.$t('userOrderDetails.viewSummary')), 1 /* TEXT */)
            ]),
            (detailsView.value == 'summary')
              ? (openBlock(), createElementBlock("div", _hoisted_15$5, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(order.value.purchases, (purchase, pkey) => {
                    return (openBlock(), createElementBlock("div", {
                      class: "purchase-card",
                      key: purchase.id || pkey
                    }, [
                      createElementVNode("div", _hoisted_16$4, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(getPurchaseProductRows(purchase), (item, productIndex) => {
                          return (openBlock(), createElementBlock(Fragment, {
                            key: `thumb-${purchase.id || pkey}-${item.pid}-${productIndex}`
                          }, [
                            (!item.suppressThumbnail)
                              ? (openBlock(), createElementBlock("div", _hoisted_17$3, [
                                  (item.thumbnailUrl && !isThumbnailHidden(purchase, pkey, item, productIndex))
                                    ? (openBlock(), createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: normalizeClass(["purchase-thumb-wrap purchase-thumb-clickable", { 'purchase-thumb-stack': item.imageCount > 1 }]),
                                        "aria-label": _ctx.$t('userOrderDetails.viewAllFiles'),
                                        onClick: toggleDetailsView
                                      }, [
                                        createElementVNode("img", {
                                          class: "purchase-thumb",
                                          src: item.thumbnailUrl,
                                          alt: "",
                                          onError: $event => (hideThumbnail(purchase, pkey, item, productIndex))
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19$3),
                                        (item.imageCount > 1)
                                          ? (openBlock(), createElementBlock("span", _hoisted_20$2, toDisplayString$1(item.imageCount), 1 /* TEXT */))
                                          : createCommentVNode("v-if", true)
                                      ], 10 /* CLASS, PROPS */, _hoisted_18$3))
                                    : (openBlock(), createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "purchase-thumb-empty purchase-thumb-clickable",
                                        "aria-label": _ctx.$t('userOrderDetails.viewAllFiles'),
                                        onClick: toggleDetailsView
                                      }, [...(_cache[2] || (_cache[2] = [
                                        createElementVNode("span", { "uk-icon": "icon: album; ratio: 1.5" }, null, -1 /* HOISTED */)
                                      ]))], 8 /* PROPS */, _hoisted_21$2))
                                ]))
                              : createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */)),
                        (getPurchaseProductRows(purchase).length === 0)
                          ? (openBlock(), createElementBlock("div", _hoisted_22$2, [...(_cache[3] || (_cache[3] = [
                              createElementVNode("div", { class: "purchase-thumb-empty" }, [
                                createElementVNode("span", { "uk-icon": "icon: album; ratio: 1.5" })
                              ], -1 /* HOISTED */)
                            ]))]))
                          : createCommentVNode("v-if", true)
                      ]),
                      createElementVNode("div", _hoisted_23$2, [
                        createElementVNode("div", _hoisted_24$2, [
                          createElementVNode("div", _hoisted_25$2, [
                            createElementVNode("span", _hoisted_26$1, toDisplayString$1(purchase.kid) + "-" + toDisplayString$1(purchase.aid), 1 /* TEXT */),
                            (purchase.orderDate)
                              ? (openBlock(), createElementBlock("span", _hoisted_27$1, "|"))
                              : createCommentVNode("v-if", true),
                            (purchase.orderDate)
                              ? (openBlock(), createElementBlock("span", _hoisted_28$1, toDisplayString$1(_ctx.$d(purchase.orderDate, 'short')), 1 /* TEXT */))
                              : createCommentVNode("v-if", true)
                          ]),
                          createVNode(unref(script$9), {
                            state: purchase.state
                          }, null, 8 /* PROPS */, ["state"]),
                          createElementVNode("div", _hoisted_29$1, toDisplayString$1(getPurchaseTotalPriceDisplay(purchase)), 1 /* TEXT */)
                        ]),
                        createElementVNode("div", _hoisted_30$1, [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(getPurchaseProductRows(purchase), (item, productIndex) => {
                            return (openBlock(), createElementBlock("div", {
                              key: `${purchase.id || pkey}-${item.pid}-${productIndex}`,
                              class: "purchase-product-row"
                            }, [
                              createElementVNode("div", _hoisted_31$1, [
                                createElementVNode("div", _hoisted_32, [
                                  (item.quantity > 1)
                                    ? (openBlock(), createElementBlock("span", _hoisted_33, toDisplayString$1(item.quantity) + " x", 1 /* TEXT */))
                                    : createCommentVNode("v-if", true),
                                  createElementVNode("span", null, toDisplayString$1(productDisplayByPid(item.pid)), 1 /* TEXT */),
                                  (item.summaryOptionText)
                                    ? (openBlock(), createElementBlock("span", _hoisted_34, ", " + toDisplayString$1(item.summaryOptionText), 1 /* TEXT */))
                                    : createCommentVNode("v-if", true),
                                  createElementVNode("span", _hoisted_35, "(" + toDisplayString$1(item.pid) + ")", 1 /* TEXT */)
                                ])
                              ]),
                              createElementVNode("span", _hoisted_36, toDisplayString$1(formatPrice(item.quantity > 1 ? item.singlePrice * item.quantity : item.singlePrice, purchase.currency || order.value.currency)), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          (getPurchaseCredit(purchase) !== null)
                            ? (openBlock(), createElementBlock("div", _hoisted_37, [
                                createElementVNode("div", _hoisted_38, [
                                  createElementVNode("div", _hoisted_39, [
                                    createElementVNode("span", null, toDisplayString$1(_ctx.$t('userOrderDetails.credit')), 1 /* TEXT */)
                                  ])
                                ]),
                                createElementVNode("span", _hoisted_40, toDisplayString$1(getPurchaseCreditDisplay(purchase)), 1 /* TEXT */)
                              ]))
                            : createCommentVNode("v-if", true),
                          (getPurchaseProductRows(purchase).length === 0)
                            ? (openBlock(), createElementBlock("div", _hoisted_41, [...(_cache[4] || (_cache[4] = [
                                createElementVNode("div", { class: "purchase-product-name" }, "-", -1 /* HOISTED */),
                                createElementVNode("span", { class: "item-single-price" }, "-", -1 /* HOISTED */)
                              ]))]))
                            : createCommentVNode("v-if", true)
                        ]),
                        createElementVNode("div", _hoisted_42, [
                          (hasPurchaseProof(purchase))
                            ? (openBlock(), createElementBlock("div", _hoisted_43, [
                                createElementVNode("div", _hoisted_44, [
                                  createElementVNode("span", _hoisted_45, toDisplayString$1(getPurchaseProofMessage(purchase)), 1 /* TEXT */)
                                ]),
                                (shouldShowProofApprovalButton(purchase))
                                  ? (openBlock(), createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "uk-button uk-button-primary uk-button-small",
                                      onClick: $event => (triggerProofApproval(purchase))
                                    }, toDisplayString$1(_ctx.$t('userOrderDetails.proofApprovalButton')), 9 /* TEXT, PROPS */, _hoisted_46))
                                  : createCommentVNode("v-if", true)
                              ]))
                            : createCommentVNode("v-if", true),
                          (getPurchaseDeliveryInfo(purchase)?.type === 'tracking')
                            ? (openBlock(), createElementBlock("div", _hoisted_47, [
                                (getCarrierLogoUrl(getPurchaseDeliveryInfo(purchase).carrier))
                                  ? (openBlock(), createElementBlock("img", {
                                      key: 0,
                                      src: getCarrierLogoUrl(getPurchaseDeliveryInfo(purchase).carrier),
                                      class: "purchase-delivery-logo",
                                      alt: getPurchaseDeliveryInfo(purchase).carrier || ''
                                    }, null, 8 /* PROPS */, _hoisted_48))
                                  : (openBlock(), createElementBlock("i", _hoisted_49)),
                                createElementVNode("a", {
                                  href: "#",
                                  onClick: withModifiers($event => (openTrackingModal(purchase, getPurchaseDeliveryInfo(purchase).rows)), ["prevent"])
                                }, toDisplayString$1(_ctx.$t('userOrderDetails.trackingLink')), 9 /* TEXT, PROPS */, _hoisted_50),
                                (getTrackingEntries(getPurchaseDeliveryInfo(purchase).rows).length)
                                  ? (openBlock(), createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "uk-icon-button tracking-info-button",
                                      "uk-icon": "icon: info",
                                      title: _ctx.$t('userOrderDetails.trackingDetailsButton'),
                                      "aria-label": _ctx.$t('userOrderDetails.trackingDetailsButton'),
                                      onClick: $event => (openTrackingNumbersModal(getPurchaseDeliveryInfo(purchase).rows))
                                    }, null, 8 /* PROPS */, _hoisted_51))
                                  : createCommentVNode("v-if", true)
                              ]))
                            : (getPurchaseDeliveryInfo(purchase)?.type === 'pickup')
                              ? (openBlock(), createElementBlock("div", _hoisted_52, [
                                  createElementVNode("img", {
                                    src: getCarrierLogoUrl('PICKUP'),
                                    class: "purchase-delivery-logo",
                                    alt: "Pickup"
                                  }, null, 8 /* PROPS */, _hoisted_53),
                                  createTextVNode(" " + toDisplayString$1(getPurchaseDeliveryInfo(purchase).text), 1 /* TEXT */)
                                ]))
                              : (getPurchaseDeliveryInfo(purchase))
                                ? (openBlock(), createElementBlock("div", _hoisted_54, [
                                    (getCarrierLogoUrl(getPurchaseDeliveryInfo(purchase).carrier))
                                      ? (openBlock(), createElementBlock("img", {
                                          key: 0,
                                          src: getCarrierLogoUrl(getPurchaseDeliveryInfo(purchase).carrier),
                                          class: "purchase-delivery-logo",
                                          alt: getPurchaseDeliveryInfo(purchase).carrier || ''
                                        }, null, 8 /* PROPS */, _hoisted_55))
                                      : (openBlock(), createElementBlock("i", _hoisted_56)),
                                    createTextVNode(" " + toDisplayString$1(getPurchaseDeliveryInfo(purchase).text), 1 /* TEXT */)
                                  ]))
                                : createCommentVNode("v-if", true)
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (openBlock(), createElementBlock("div", _hoisted_57, [
                  (allFilesLoading.value)
                    ? (openBlock(), createElementBlock("div", _hoisted_58, toDisplayString$1(_ctx.$t('userOrderDetails.loadingImages')), 1 /* TEXT */))
                    : (allFilesError.value)
                      ? (openBlock(), createElementBlock("div", _hoisted_59, toDisplayString$1(allFilesError.value), 1 /* TEXT */))
                      : (!hasAnyAllFilesPositions.value)
                        ? (openBlock(), createElementBlock("div", _hoisted_60, toDisplayString$1(_ctx.$t('userOrderDetails.noFilesViewItems')), 1 /* TEXT */))
                        : createCommentVNode("v-if", true),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(allFilesDeliveries.value, (delivery) => {
                    return (openBlock(), createElementBlock("div", {
                      key: delivery.key,
                      class: "all-files-delivery"
                    }, [
                      createElementVNode("div", _hoisted_61, toDisplayString$1(delivery.orderNumber), 1 /* TEXT */),
                      (delivery.positions.length === 0)
                        ? (openBlock(), createElementBlock("div", _hoisted_62, toDisplayString$1(_ctx.$t('userOrderDetails.noFilesViewItems')), 1 /* TEXT */))
                        : createCommentVNode("v-if", true),
                      (openBlock(true), createElementBlock(Fragment, null, renderList(delivery.positions, (position) => {
                        return (openBlock(), createElementBlock("div", {
                          key: position.key,
                          class: "all-files-position"
                        }, [
                          createElementVNode("div", _hoisted_63, toDisplayString$1(position.title), 1 /* TEXT */),
                          createCommentVNode(" Positions-Labels nur anzeigen wenn KEINE Gruppen (sonst zeigen die Gruppen selbst ihre Labels) "),
                          (!position.multipleGroups && position.detailLabels?.length)
                            ? (openBlock(), createElementBlock("div", _hoisted_64, [
                                (openBlock(true), createElementBlock(Fragment, null, renderList(position.detailLabels, (optionLabel, optionIndex) => {
                                  return (openBlock(), createElementBlock("span", {
                                    key: `${position.key}-${optionIndex}`,
                                    class: "all-files-position-option"
                                  }, toDisplayString$1(optionLabel), 1 /* TEXT */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : createCommentVNode("v-if", true),
                          (position.allImages.length)
                            ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                createCommentVNode(" Mehrere Gruppen mit unterschiedlichen Optionen: gruppiert anzeigen "),
                                (position.multipleGroups)
                                  ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(position.imageGroups, (group) => {
                                      return (openBlock(), createElementBlock("div", {
                                        key: group.key,
                                        class: "all-files-image-group"
                                      }, [
                                        (group.optionLabels.length)
                                          ? (openBlock(), createElementBlock("div", _hoisted_65, [
                                              (openBlock(true), createElementBlock(Fragment, null, renderList(group.optionLabels, (label, labelIndex) => {
                                                return (openBlock(), createElementBlock("span", {
                                                  key: `${group.key}-${labelIndex}`,
                                                  class: "all-files-position-option"
                                                }, toDisplayString$1(label), 1 /* TEXT */))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                          : (openBlock(), createElementBlock("div", _hoisted_66, [
                                              createElementVNode("span", _hoisted_67, toDisplayString$1(_ctx.$t('userOrderDetails.noOptions')), 1 /* TEXT */)
                                            ])),
                                        (group.images.length)
                                          ? (openBlock(), createElementBlock("div", _hoisted_68, [
                                              (openBlock(true), createElementBlock(Fragment, null, renderList(group.images, (img, imageIndex) => {
                                                return (openBlock(), createElementBlock("img", {
                                                  key: `${group.key}-${imageIndex}`,
                                                  src: unref(imgsource)(img, 'th'),
                                                  class: "all-files-image",
                                                  alt: "",
                                                  onClick: $event => (openPositionImagesOverlay(position.allImages, position.allImages.indexOf(img)))
                                                }, null, 8 /* PROPS */, _hoisted_69))
                                              }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                          : createCommentVNode("v-if", true)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                      createCommentVNode(" Alle Bilder mit gleichen Optionen: flach anzeigen "),
                                      createElementVNode("div", _hoisted_70, [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(position.allImages, (img, imageIndex) => {
                                          return (openBlock(), createElementBlock("img", {
                                            key: `${position.key}-${imageIndex}`,
                                            src: unref(imgsource)(img, 'th'),
                                            class: "all-files-image",
                                            alt: "",
                                            onClick: $event => (openPositionImagesOverlay(position.allImages, imageIndex))
                                          }, null, 8 /* PROPS */, _hoisted_71))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                              ], 64 /* STABLE_FRAGMENT */))
                            : (openBlock(), createElementBlock("div", _hoisted_72, toDisplayString$1(_ctx.$t('userOrderDetails.noImagesForItem')), 1 /* TEXT */))
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])),
            (error.value)
              ? (openBlock(), createElementBlock("div", _hoisted_73, toDisplayString$1(error.value), 1 /* TEXT */))
              : createCommentVNode("v-if", true)
          ])
        ]))
      : createCommentVNode("v-if", true),
    createVNode(unref(script$g), {
      open: previewModal.value,
      onClose: closeImageOverlay,
      class: "preview-modal"
    }, {
      body: withCtx(() => [
        createVNode(unref(script$G), {
          infoComponent: "FileInfo",
          images: previewList.value,
          index: previewIndex.value
        }, null, 8 /* PROPS */, ["images", "index"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    createVNode(unref(script$g), {
      open: trackingModal.value.open,
      onClose: closeTrackingModal,
      class: "tracking-modal"
    }, {
      body: withCtx(() => [
        (trackingModal.value.open)
          ? (openBlock(), createElementBlock("iframe", {
              key: 0,
              src: trackingModal.value.url,
              class: "tracking-iframe",
              frameborder: "0",
              allowfullscreen: ""
            }, null, 8 /* PROPS */, _hoisted_74))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    createVNode(unref(script$g), {
      open: proofApprovalModal.value.open,
      onClose: closeProofApprovalModal,
      class: "proof-approval-modal"
    }, {
      body: withCtx(() => [
        (proofApprovalModal.value.purchase)
          ? (openBlock(), createBlock(unref(script$a), {
              key: 0,
              purchase: proofApprovalModal.value.purchase,
              canOpenOnlinePreview: true,
              previewLoading: proofPreviewLoading.value,
              previewError: proofPreviewError.value,
              onRelease: handleProofApproval,
              onCancel: handleProofStop,
              onPreviewOnlineDocument: openPurchaseProofPreview,
              onClose: closeProofApprovalModal
            }, null, 8 /* PROPS */, ["purchase", "previewLoading", "previewError"]))
          : createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"]),
    createVNode(unref(script$g), {
      open: trackingNumbersModal.value.open,
      onClose: closeTrackingNumbersModal,
      class: "tracking-numbers-modal"
    }, {
      body: withCtx(() => [
        createElementVNode("div", _hoisted_75, [
          createElementVNode("div", _hoisted_76, toDisplayString$1(_ctx.$t('userOrderDetails.trackingDetailsTitle')), 1 /* TEXT */),
          createElementVNode("div", _hoisted_77, [
            createElementVNode("div", _hoisted_78, [
              createElementVNode("span", null, toDisplayString$1(_ctx.$t('userOrderDetails.trackingCarrierLabel')), 1 /* TEXT */),
              createElementVNode("span", null, toDisplayString$1(_ctx.$t('userOrderDetails.trackingParcelNumberLabel')), 1 /* TEXT */)
            ]),
            (openBlock(true), createElementBlock(Fragment, null, renderList(trackingNumbersModal.value.entries, (entry) => {
              return (openBlock(), createElementBlock("div", {
                key: entry.key,
                class: "tracking-numbers-row"
              }, [
                createElementVNode("span", _hoisted_79, [
                  (getCarrierLogoUrl(entry.carrier))
                    ? (openBlock(), createElementBlock("img", {
                        key: 0,
                        src: getCarrierLogoUrl(entry.carrier),
                        class: "purchase-delivery-logo",
                        alt: entry.carrier
                      }, null, 8 /* PROPS */, _hoisted_80))
                    : createCommentVNode("v-if", true),
                  createElementVNode("span", _hoisted_81, toDisplayString$1(entry.carrier), 1 /* TEXT */)
                ]),
                createElementVNode("span", _hoisted_82, toDisplayString$1(entry.parcelNumber), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$b.__scopeId = "data-v-305531a2";
script$b.__file = "src/components/UserOrderDetails.vue";

const _hoisted_1$a = { class: "print-approval-panel" };
const _hoisted_2$a = { class: "print-approval-title" };
const _hoisted_3$9 = { class: "print-approval-intro" };
const _hoisted_4$7 = { class: "print-approval-stop" };
const _hoisted_5$7 = { class: "print-approval-question" };
const _hoisted_6$6 = { class: "print-approval-choice" };
const _hoisted_7$6 = {
  key: 0,
  class: "print-approval-hint"
};
const _hoisted_8$6 = {
  key: 1,
  class: "print-approval-hint"
};
const _hoisted_9$6 = {
  key: 2,
  class: "uk-text-meta print-approval-preview-status"
};
const _hoisted_10$6 = {
  key: 3,
  class: "uk-text-danger print-approval-preview-status"
};
const _hoisted_11$6 = { class: "print-approval-actions" };
const _hoisted_12$6 = { class: "print-approval-hint" };
const _hoisted_13$5 = { class: "print-approval-checkbox-label" };
const _hoisted_14$4 = { class: "print-approval-actions" };
const _hoisted_15$4 = ["disabled"];


var script$a = {
  __name: 'PrintApprovalPanel',
  props: {
    purchase: {
        type: Object,
        required: true
    },
    canOpenOnlinePreview: {
        type: Boolean,
        default: false
    },
    previewLoading: {
        type: Boolean,
        default: false
    },
    previewError: {
        type: String,
        default: ''
    }
},
  emits: ['release', 'cancel', 'close', 'preview-online-document'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

// 'question' | 'no-proof' | 'with-proof'
const step = ref('question');
const confirmed = ref(false);

const orderLabel = computed(() => {
    const kid = props.purchase?.kid ?? '';
    const aid = props.purchase?.aid ?? '';
    return kid && aid ? `${kid}-${aid}` : aid || kid || ''
});

function selectNoProof() {
    confirmed.value = false;
    step.value = 'no-proof';
}

function selectWithProof() {
    confirmed.value = false;
    step.value = 'with-proof';
}

function goBack() {
    confirmed.value = false;
    step.value = 'question';
}

function triggerRelease() {
    emit('release', props.purchase);
}

// Darf unabhängig vom aktuellen Schritt und auch bei previewError ausgelöst werden.
function triggerStop() {
    emit('cancel', props.purchase);
}

function openOnlinePreview() {
    emit('preview-online-document', props.purchase);
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$a, [
    createElementVNode("h2", _hoisted_2$a, toDisplayString$1(unref(t)('printApprovalPanel.title', { aid: orderLabel.value })), 1 /* TEXT */),
    createElementVNode("p", _hoisted_3$9, toDisplayString$1(unref(t)('printApprovalPanel.intro')), 1 /* TEXT */),
    createElementVNode("div", _hoisted_4$7, [
      createElementVNode("button", {
        type: "button",
        class: "uk-button uk-button-danger uk-button-small",
        onClick: triggerStop
      }, toDisplayString$1(unref(t)('printApprovalPanel.stopButton')), 1 /* TEXT */)
    ]),
    (step.value === 'question')
      ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("p", _hoisted_5$7, toDisplayString$1(unref(t)('printApprovalPanel.questionLabel')), 1 /* TEXT */),
          createElementVNode("div", _hoisted_6$6, [
            createElementVNode("button", {
              type: "button",
              class: "uk-button uk-button-default",
              onClick: selectNoProof
            }, toDisplayString$1(unref(t)('printApprovalPanel.no')), 1 /* TEXT */),
            createElementVNode("button", {
              type: "button",
              class: "uk-button uk-button-primary",
              onClick: selectWithProof
            }, toDisplayString$1(unref(t)('printApprovalPanel.yes')), 1 /* TEXT */)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (step.value === 'no-proof')
        ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createElementVNode("button", {
              type: "button",
              class: "print-approval-back uk-button uk-button-link",
              onClick: goBack
            }, " ← " + toDisplayString$1(unref(t)('printApprovalPanel.back')), 1 /* TEXT */),
            (__props.canOpenOnlinePreview)
              ? (openBlock(), createElementBlock("p", _hoisted_7$6, [
                  createTextVNode(toDisplayString$1(unref(t)('printApprovalPanel.noProofHintPrefix')) + " ", 1 /* TEXT */),
                  createElementVNode("a", {
                    href: "#",
                    class: "print-approval-inline-link",
                    onClick: withModifiers(openOnlinePreview, ["prevent"])
                  }, toDisplayString$1(unref(t)('printApprovalPanel.noProofHintLink')), 1 /* TEXT */),
                  createTextVNode(" " + toDisplayString$1(unref(t)('printApprovalPanel.noProofHintSuffix')), 1 /* TEXT */)
                ]))
              : (openBlock(), createElementBlock("p", _hoisted_8$6, toDisplayString$1(unref(t)('printApprovalPanel.noProofHint')), 1 /* TEXT */)),
            (__props.previewLoading)
              ? (openBlock(), createElementBlock("div", _hoisted_9$6, toDisplayString$1(unref(t)('printApprovalPanel.previewLoading')), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            (__props.previewError)
              ? (openBlock(), createElementBlock("div", _hoisted_10$6, toDisplayString$1(__props.previewError), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_11$6, [
              createElementVNode("button", {
                type: "button",
                class: "uk-button uk-button-primary",
                onClick: triggerRelease
              }, toDisplayString$1(unref(t)('printApprovalPanel.releaseButton')), 1 /* TEXT */)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (step.value === 'with-proof')
          ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
              createElementVNode("button", {
                type: "button",
                class: "print-approval-back uk-button uk-button-link",
                onClick: goBack
              }, " ← " + toDisplayString$1(unref(t)('printApprovalPanel.back')), 1 /* TEXT */),
              createElementVNode("p", _hoisted_12$6, toDisplayString$1(unref(t)('printApprovalPanel.withProofHint')), 1 /* TEXT */),
              createElementVNode("label", _hoisted_13$5, [
                withDirectives(createElementVNode("input", {
                  type: "checkbox",
                  class: "uk-checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((confirmed).value = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [vModelCheckbox, confirmed.value]
                ]),
                createElementVNode("span", null, toDisplayString$1(unref(t)('printApprovalPanel.checkboxLabel')), 1 /* TEXT */)
              ]),
              createElementVNode("div", _hoisted_14$4, [
                createElementVNode("button", {
                  type: "button",
                  class: "uk-button uk-button-primary",
                  disabled: !confirmed.value,
                  onClick: triggerRelease
                }, toDisplayString$1(unref(t)('printApprovalPanel.releaseButton')), 9 /* TEXT, PROPS */, _hoisted_15$4)
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : createCommentVNode("v-if", true)
  ]))
}
}

};

script$a.__scopeId = "data-v-5a33c7f8";
script$a.__file = "src/components/PrintApprovalPanel.vue";

const _hoisted_1$9 = { class: "orderstate-wrap" };
const _hoisted_2$9 = { class: "orderstate-text" };


var script$9 = {
  __name: 'OrderState',
  props: {
    state: String
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

function stateText(str) {

const stateMap = {
       neu : "ordered",
       bestellt: "ordered",
       kontrolle: "inReview",
       pruefung: "inReview",
       wartend: "pending",
       abgeholt: "inProgress",
       versandfertig: "shipped",
       storno: "canceled"
};

const normalizedState = stateMap[str];
if (!normalizedState) return str

const translationKey = `orderState.status.${normalizedState}`;
const translated = t(translationKey);

return translated === translationKey ? str : translated

}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$9, [
    createElementVNode("div", {
      class: normalizeClass(["orderstate", props.state])
    }, null, 2 /* CLASS */),
    createElementVNode("div", _hoisted_2$9, toDisplayString$1(stateText(props.state)), 1 /* TEXT */)
  ]))
}
}

};

script$9.__file = "src/components/OrderState.vue";

const _hoisted_1$8 = { key: 0 };
const _hoisted_2$8 = { class: "uk-text-small" };
const _hoisted_3$8 = { class: "uk-badge" };


var script$8 = {
  __name: 'PaymentType',
  props: {
    type: String
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

function paymentText(str) {

  if (!str) return ""

  const translationKey = `checkout.payment.methods.${str}`;
  const translated = t(translationKey);

  return translated === translationKey ? str : translated

}


return (_ctx, _cache) => {
  return (props.type)
    ? (openBlock(), createElementBlock("div", _hoisted_1$8, [
        createElementVNode("span", _hoisted_2$8, toDisplayString$1(_ctx.$t('checkout.payment.title')) + ": ", 1 /* TEXT */),
        _cache[0] || (_cache[0] = createTextVNode()),
        createElementVNode("span", _hoisted_3$8, toDisplayString$1(paymentText(props.type)), 1 /* TEXT */)
      ]))
    : createCommentVNode("v-if", true)
}
}

};

script$8.__file = "src/components/PaymentType.vue";

const _hoisted_1$7 = { class: "proplist" };
const _hoisted_2$7 = { key: 0 };
const _hoisted_3$7 = { key: 1 };
const _hoisted_4$6 = { key: 2 };
const _hoisted_5$6 = { key: 3 };
const _hoisted_6$5 = { key: 4 };
const _hoisted_7$5 = { key: 5 };
const _hoisted_8$5 = { key: 6 };
const _hoisted_9$5 = { key: 7 };
const _hoisted_10$5 = { style: {"color":"red"} };
const _hoisted_11$5 = { key: 8 };
const _hoisted_12$5 = { key: 9 };
const _hoisted_13$4 = { key: 10 };


var script$7 = {
  __name: 'FileInfo',
  props: ['elem'],
  setup(__props) {

const props = __props;

let pdf = false;
if (props.elem.components) pdf = props.elem.components.find((c) => ( c.type == "pdf" || c.type == "skript" ));
try {
    if (pdf?.info) pdf.param = JSON.parse(pdf.info); 
} catch (e) {
    logger.error(e);
}

let lowestDPI = false;
if (Array.isArray(pdf?.param?.image) && pdf.param.image.length > 0) {
  lowestDPI = pdf.param.image.reduce((a,c) => { if (c.DpiX < a) a = c.DpiX; if (c.DpiY < a) a = c.DpiY; return a}, 100000);
}

let embeddedFonts = [];
if (pdf?.param?.font && Array.isArray( pdf.param.font)) {
    embeddedFonts = pdf.param.font.reduce((a,c) => {  if (c.Embedded == "Yes") {a.push(c.name);} return a },[]);
}


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    _cache[0] || (_cache[0] = createElementVNode("div", null, null, -1 /* HOISTED */)),
    createElementVNode("table", _hoisted_1$7, [
      (props.elem.name)
        ? (openBlock(), createElementBlock("tr", _hoisted_2$7, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Name")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(props.elem.name), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (props.elem.bintyp)
        ? (openBlock(), createElementBlock("tr", _hoisted_3$7, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Format")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(props.elem.bintyp), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (props.elem.width && props.elem.height)
        ? (openBlock(), createElementBlock("tr", _hoisted_4$6, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Size")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(props.elem.width) + " x " + toDisplayString$1(props.elem.height), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(pdf)?.param?.pageinfo?.width && unref(pdf)?.param?.pageinfo?.height)
        ? (openBlock(), createElementBlock("tr", _hoisted_5$6, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Size")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(unref(pdf).param.pageinfo.width) + " x " + toDisplayString$1(unref(pdf).param.pageinfo.height) + " mm", 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(pdf)?.param?.pageinfo?.trimWidth && unref(pdf)?.param?.pageinfo?.trimHeight && unref(pdf).param?.pageinfo?.trimWidth != unref(pdf).param.pageinfo.width)
        ? (openBlock(), createElementBlock("tr", _hoisted_6$5, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Cropped size")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(unref(pdf).param.pageinfo.trimWidth) + " x " + toDisplayString$1(unref(pdf).param.pageinfo.trimHeight) + " mm", 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(pdf)?.param?.pageinfo?.pagecount)
        ? (openBlock(), createElementBlock("tr", _hoisted_7$5, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Pages")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(unref(pdf).param.pageinfo.pagecount), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(pdf)?.param?.font && unref(embeddedFonts).length > 0)
        ? (openBlock(), createElementBlock("tr", _hoisted_8$5, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Embedded fonts")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(unref(embeddedFonts).length), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(pdf)?.param?.pageinfo?.missingFonts)
        ? (openBlock(), createElementBlock("tr", _hoisted_9$5, [
            createElementVNode("td", _hoisted_10$5, toDisplayString$1(_ctx.$t("Missing fonts")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(unref(pdf).param.font.reduce((a,c) => {  if (c.Embedded == "No") {a.push(c.name);} return a },[]).join("")), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(pdf)?.param?.colors?.[0]?.Colorspaces)
        ? (openBlock(), createElementBlock("tr", _hoisted_11$5, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Color space")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(unref(pdf)?.param?.colors?.[0]?.Colorspaces), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (unref(lowestDPI))
        ? (openBlock(), createElementBlock("tr", _hoisted_12$5, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Lowest resolution")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(Math.round(unref(lowestDPI))) + " dpi (" + toDisplayString$1(_ctx.$t("determined from n images", unref(pdf).param.image.length)) + ")", 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true),
      (props.elem.date)
        ? (openBlock(), createElementBlock("tr", _hoisted_13$4, [
            createElementVNode("td", null, toDisplayString$1(_ctx.$t("Date")) + ":", 1 /* TEXT */),
            createElementVNode("td", null, toDisplayString$1(_ctx.$d(props.elem.date)), 1 /* TEXT */)
          ]))
        : createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$7.__scopeId = "data-v-3252c90c";
script$7.__file = "src/components/FileInfo.vue";

const _hoisted_1$6 = { class: "uk-card uk-card-body uk-align-center uk-margin-top" };
const _hoisted_2$6 = { class: "orders-content uk-align-center" };
const _hoisted_3$6 = {
  key: 0,
  class: "uk-card-title uk-margin-bottom"
};
const _hoisted_4$5 = { class: "uk-card-title" };
const _hoisted_5$5 = {
  key: 1,
  class: "orders-year-group"
};
const _hoisted_6$4 = { class: "uk-form-label" };
const _hoisted_7$4 = ["aria-label"];
const _hoisted_8$4 = ["disabled", "onClick"];
const _hoisted_9$4 = ["disabled"];
const _hoisted_10$4 = {
  key: 2,
  class: "custom-filter-panel"
};
const _hoisted_11$4 = { class: "custom-filter-grid" };
const _hoisted_12$4 = {
  class: "uk-form-label",
  for: "accounting-last-days"
};
const _hoisted_13$3 = {
  class: "uk-form-label",
  for: "accounting-from-date"
};
const _hoisted_14$3 = {
  class: "uk-form-label",
  for: "accounting-to-date"
};
const _hoisted_15$3 = {
  key: 0,
  class: "uk-text-danger uk-text-small uk-margin-small-top"
};
const _hoisted_16$3 = {
  key: 1,
  class: "uk-text-danger uk-text-small uk-margin-small-top"
};
const _hoisted_17$2 = { class: "custom-filter-actions" };
const _hoisted_18$2 = ["disabled"];
const _hoisted_19$2 = ["disabled"];
const _hoisted_20$1 = {
  key: 3,
  class: "uk-text-meta uk-margin-small-bottom"
};
const _hoisted_21$1 = {
  key: 4,
  class: "uk-text-meta"
};
const _hoisted_22$1 = { key: 5 };
const _hoisted_23$1 = { class: "ac-details" };
const _hoisted_24$1 = { class: "atype" };
const _hoisted_25$1 = { class: "uk-text-bold" };


var script$6 = {
  __name: 'UserAccounting',
  setup(__props) {

const om = new OrderManager();
const { t } = useI18n();

const accounting = ref(om.accounting);
const loadingAccounting = ref(false);

const currentYear = new Date().getFullYear();
const selectedYear = ref(null);

const showCustomFilter = ref(false);
const customFilter = ref({
    lastDays: '',
    from: '',
    to: ''
});

const allAccountingEntries = computed(() => {

    const list = accounting.value?.list;
    if (!Array.isArray(list)) return []

    return list

});

const availableYears = computed(() => {

    const years = new Set();

    allAccountingEntries.value.forEach((item) => {
        const year = getEntryYear(item);
        if (year) years.add(year);
    });

    return Array.from(years).sort((a, b) => b - a)

});

const filteredAccountingEntries = computed(() => {

    if (showCustomFilter.value || !selectedYear.value) return allAccountingEntries.value

    return allAccountingEntries.value.filter((item) => getEntryYear(item) == selectedYear.value)

});

const hasInvalidDateRange = computed(() => {

    if (!customFilter.value.from || !customFilter.value.to) return false
    return customFilter.value.from > customFilter.value.to

});

const hasInvalidLastDays = computed(() => {

    const rawLastDays = `${customFilter.value.lastDays || ''}`.trim();
    if (!rawLastDays) return false

    const parsedLastDays = Number(rawLastDays);
    return !Number.isInteger(parsedLastDays) || parsedLastDays <= 0

});

function getDefaultDateFilterFrom() {
    return `${currentYear - 2}-01-01`
}

function getRecentYearsDateFilter() {
    return { from: getDefaultDateFilterFrom() }
}

function getEntryYear(item) {

    if (!item?.date) return null

    const date = new Date(item.date);
    if (Number.isNaN(date.getTime())) return null

    return date.getFullYear()

}

function buildCustomDateFilter() {

    const dateFilter = {};
    const rawLastDays = `${customFilter.value.lastDays || ''}`.trim();

    if (rawLastDays) {
        const parsedLastDays = Number(rawLastDays);
        if (Number.isInteger(parsedLastDays) && parsedLastDays > 0) {
            dateFilter.lastDays = parsedLastDays;
            return dateFilter
        }
    }

    if (customFilter.value.from) dateFilter.from = customFilter.value.from;
    if (customFilter.value.to) dateFilter.to = customFilter.value.to;

    return dateFilter

}

async function loadAccounting(dateFilter) {

    if (hasInvalidDateRange.value || hasInvalidLastDays.value) return

    loadingAccounting.value = true;
    try {
        await om.loadAccounting(dateFilter);
    } finally {
        loadingAccounting.value = false;
    }

}

async function loadRecentYears() {
    await loadAccounting(getRecentYearsDateFilter());
}

function selectYear(year) {
    selectedYear.value = year;
}

function openCustomFilter() {
    showCustomFilter.value = true;
}

function getAccountingTypeText(item) {
    const type = `${item?.type || ''}`;
    const label = t(`accounting.${type}`);

    if (type === 'AU' && item?.reference) {
        return `${label} ${item.reference}`
    }

    return label
}

async function applyCustomFilter() {

    const dateFilter = buildCustomDateFilter();

    if (!Object.keys(dateFilter).length) {
        await loadRecentYears();
        return
    }

    await loadAccounting(dateFilter);

}

async function resetCustomFilter() {

    customFilter.value = {
        lastDays: '',
        from: '',
        to: ''
    };
    selectedYear.value = null;
    showCustomFilter.value = false;
    await loadRecentYears();

}

loadRecentYears();

watch(
    availableYears,
    (years) => {

        if (!years.length) {
            selectedYear.value = null;
            return
        }

        if (!selectedYear.value || !years.includes(selectedYear.value)) {
            selectedYear.value = years[0];
        }

    },
    { immediate: true }
);


return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$6, [
    createElementVNode("div", _hoisted_2$6, [
      (typeof accounting.value.rawData?.balance !== 'undefined')
        ? (openBlock(), createElementBlock("div", _hoisted_3$6, [
            createTextVNode(toDisplayString$1(_ctx.$t('balance')) + ": ", 1 /* TEXT */),
            createElementVNode("span", {
              class: normalizeClass((accounting.value.rawData.balance < 0) ? 'red' : '')
            }, toDisplayString$1(_ctx.$n(accounting.value.rawData.balance, 'euro')), 3 /* TEXT, CLASS */)
          ]))
        : createCommentVNode("v-if", true),
      createElementVNode("div", _hoisted_4$5, toDisplayString$1(_ctx.$t('userAccounting.title')), 1 /* TEXT */),
      (availableYears.value.length && !showCustomFilter.value)
        ? (openBlock(), createElementBlock("div", _hoisted_5$5, [
            createElementVNode("div", _hoisted_6$4, toDisplayString$1(_ctx.$t('userAccounting.yearFilter')), 1 /* TEXT */),
            createElementVNode("div", {
              class: "orders-year-switch",
              role: "tablist",
              "aria-label": _ctx.$t('userAccounting.yearFilter')
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(availableYears.value, (year) => {
                return (openBlock(), createElementBlock("button", {
                  key: `year-${year}`,
                  type: "button",
                  class: normalizeClass(["uk-button", selectedYear.value == year ? 'uk-button-primary' : 'uk-button-default']),
                  disabled: loadingAccounting.value,
                  onClick: $event => (selectYear(year))
                }, toDisplayString$1(year), 11 /* TEXT, CLASS, PROPS */, _hoisted_8$4))
              }), 128 /* KEYED_FRAGMENT */)),
              createElementVNode("button", {
                type: "button",
                class: "orders-more-link",
                disabled: loadingAccounting.value,
                onClick: openCustomFilter
              }, toDisplayString$1(_ctx.$t('userAccounting.more')), 9 /* TEXT, PROPS */, _hoisted_9$4)
            ], 8 /* PROPS */, _hoisted_7$4)
          ]))
        : createCommentVNode("v-if", true),
      (showCustomFilter.value)
        ? (openBlock(), createElementBlock("div", _hoisted_10$4, [
            createElementVNode("div", _hoisted_11$4, [
              createElementVNode("div", null, [
                createElementVNode("label", _hoisted_12$4, toDisplayString$1(_ctx.$t('userAccounting.lastDays')), 1 /* TEXT */),
                withDirectives(createElementVNode("input", {
                  id: "accounting-last-days",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((customFilter.value.lastDays) = $event)),
                  class: "uk-input",
                  type: "number",
                  min: "1",
                  step: "1"
                }, null, 512 /* NEED_PATCH */), [
                  [vModelText, customFilter.value.lastDays]
                ])
              ]),
              createElementVNode("div", null, [
                createElementVNode("label", _hoisted_13$3, toDisplayString$1(_ctx.$t('userAccounting.fromDate')), 1 /* TEXT */),
                withDirectives(createElementVNode("input", {
                  id: "accounting-from-date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((customFilter.value.from) = $event)),
                  class: "uk-input",
                  type: "date"
                }, null, 512 /* NEED_PATCH */), [
                  [vModelText, customFilter.value.from]
                ])
              ]),
              createElementVNode("div", null, [
                createElementVNode("label", _hoisted_14$3, toDisplayString$1(_ctx.$t('userAccounting.toDate')), 1 /* TEXT */),
                withDirectives(createElementVNode("input", {
                  id: "accounting-to-date",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((customFilter.value.to) = $event)),
                  class: "uk-input",
                  type: "date"
                }, null, 512 /* NEED_PATCH */), [
                  [vModelText, customFilter.value.to]
                ])
              ])
            ]),
            (hasInvalidLastDays.value)
              ? (openBlock(), createElementBlock("div", _hoisted_15$3, toDisplayString$1(_ctx.$t('userAccounting.invalidLastDays')), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            (hasInvalidDateRange.value)
              ? (openBlock(), createElementBlock("div", _hoisted_16$3, toDisplayString$1(_ctx.$t('userAccounting.invalidDateRange')), 1 /* TEXT */))
              : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_17$2, [
              createElementVNode("button", {
                type: "button",
                class: "uk-button uk-button-primary",
                disabled: loadingAccounting.value || hasInvalidLastDays.value || hasInvalidDateRange.value,
                onClick: applyCustomFilter
              }, toDisplayString$1(_ctx.$t('userAccounting.applyFilter')), 9 /* TEXT, PROPS */, _hoisted_18$2),
              createElementVNode("button", {
                type: "button",
                class: "uk-button uk-button-default",
                disabled: loadingAccounting.value,
                onClick: resetCustomFilter
              }, toDisplayString$1(_ctx.$t('userAccounting.resetFilter')), 9 /* TEXT, PROPS */, _hoisted_19$2)
            ])
          ]))
        : createCommentVNode("v-if", true),
      (loadingAccounting.value)
        ? (openBlock(), createElementBlock("div", _hoisted_20$1, toDisplayString$1(_ctx.$t('userAccounting.loading')), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      (!loadingAccounting.value && filteredAccountingEntries.value.length === 0)
        ? (openBlock(), createElementBlock("div", _hoisted_21$1, toDisplayString$1(_ctx.$t('userAccounting.noEntries')), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      (!loadingAccounting.value)
        ? (openBlock(), createElementBlock("div", _hoisted_22$1, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(filteredAccountingEntries.value, (item, id) => {
              return (openBlock(), createElementBlock("div", {
                class: "ac",
                key: id
              }, [
                createElementVNode("div", _hoisted_23$1, [
                  createElementVNode("div", null, toDisplayString$1(_ctx.$d(item.date, "numeric")), 1 /* TEXT */),
                  createElementVNode("div", _hoisted_24$1, toDisplayString$1(getAccountingTypeText(item)), 1 /* TEXT */),
                  createElementVNode("div", _hoisted_25$1, toDisplayString$1(_ctx.$n((item.gross != 0) ? item.gross : 0, 'euro')), 1 /* TEXT */)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : createCommentVNode("v-if", true)
    ])
  ]))
}
}

};

script$6.__file = "src/components/UserAccounting.vue";

const _hoisted_1$5 = ["src", "width", "height"];
const _hoisted_2$5 = ["src"];
const _hoisted_3$5 = ["src"];


var script$5 = {
  __name: 'ImagePreview',
  props: {

    mediaElement: {
        type: Object,
        required: true
    },

    page: {
        type: Number,
        default: null
    },

    resource: {
        type: String,
        default: 'gal'
    },

    size: {
        type: String,
        default: null
    }

},
  setup(__props) {

const props = __props;

const timestamp = ref();
const waitingForImage = ref(false);
const imageNotAvailable = ref(false);

let previewSize = previewResourceSizes.thumbnail;
if (props.resource == 'gal') {
    previewSize = previewResourceSizes.gallery;
}
if (props.size) {
    previewSize = parseInt(props.size);
}

const aspectRatio1 = props.mediaElement.height / props.mediaElement.width;
const aspectRatio2 = props.mediaElement.width / props.mediaElement.height;
const options = {
    width: previewSize * Math.min(1, aspectRatio2),
    height: previewSize * Math.min(1, aspectRatio1),
    errorImageWidth: (props.resource == 'gal') ? 240 : 80,
    errorImageHeight: (props.resource == 'gal') ? 240 : 80,
};

let releaseMercureStateListener = registerMercureEvent("state", (mess) =>  {
    if (mess["changed"]) {
        if (mess.elementType == 'media' && mess.id == props.mediaElement.id && Array.isArray(mess.pages)) {
            if (mess.pages.find((el) => (el.page == props.page))) {
                // force reload
                console.log("ImagePreview: reload image for media element " + props.mediaElement.id + " page " + props.page);
                timestamp.value = mess.timestamp;
            }

        }

    } 
});

onBeforeUnmount(() => {
    if (typeof releaseMercureStateListener === 'function') {
        releaseMercureStateListener();
        releaseMercureStateListener = null;
    }
});


const imageSrc = computed(() => {

    if (typeof props.mediaElement !== 'object') return ''

    if (props.mediaElement.src) return props.mediaElement.src
    
    let p = props.mediaElement.currentPage;
    if (props.page) p = props.page;
    let r = props.resource;

    let src = imgsource(props.mediaElement, r, p);

    return src + ((timestamp.value) ? "?t=" + timestamp.value : "")

});

function imageLoaded() {
    waitingForImage.value = false;
    imageNotAvailable.value = false;
}

function imageOnerror(e) {
    console.log("ImagePreview: image error " + imageSrc.value);

    let url = e.target.src;

    xhrGet(url,true).then((xhr) => {
        if (xhr.status == 425) {
            console.log("ImagePreview: image not ready yet, will retry later " + imageSrc.value);
            waitingForImage.value = true;        
        } else if (xhr.status == 404) {
            console.log("ImagePreview: image not found " + imageSrc.value);
            imageNotAvailable.value = true;        
        } else {
            imageNotAvailable.value = true;
            console.error("ImagePreview: failed to load image " + imageSrc.value + " - " + xhr.statusText);
        }
    }).catch((error) => {
        console.error("ImagePreview: failed to reload image " + imageSrc.value + " - " + error.message);
    });
        
}



return (_ctx, _cache) => {
  return (openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("img", {
      class: normalizeClass((waitingForImage.value || imageNotAvailable.value)?'hidden':''),
      onError: imageOnerror,
      onLoad: imageLoaded,
      loading: "lazy",
      src: imageSrc.value,
      width: options.width,
      height: options.height,
      alt: "",
      "uk-contain": ""
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1$5),
    (waitingForImage.value)
      ? (openBlock(), createElementBlock("img", {
          key: 0,
          src: unref(pageLoaderIcon)(options),
          class: normalizeClass(props.resource)
        }, null, 10 /* CLASS, PROPS */, _hoisted_2$5))
      : createCommentVNode("v-if", true),
    (imageNotAvailable.value)
      ? (openBlock(), createElementBlock("img", {
          key: 1,
          src: unref(pageLoaderIcon)({...options, useErrorImage:true, errorText:_ctx.$t('imagePreview.notAvailable')}),
          class: normalizeClass(props.resource)
        }, null, 10 /* CLASS, PROPS */, _hoisted_3$5))
      : createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

};

script$5.__scopeId = "data-v-6b8b08c6";
script$5.__file = "src/components/ImagePreview.vue";

const _hoisted_1$4 = {
  key: 0,
  class: "login-sync-overlay"
};
const _hoisted_2$4 = { class: "login-sync-overlay__preview-slot" };
const _hoisted_3$4 = { class: "login-sync-overlay__preview" };
const _hoisted_4$4 = ["src", "alt"];
const _hoisted_5$4 = {
  key: 1,
  class: "login-sync-overlay__name"
};


var script$4 = /*@__PURE__*/Object.assign({ name: 'LoginSyncOverlay' }, {
  __name: 'LoginSyncOverlay',
  setup(__props) {



const authStore = useAuthStore();
const { loginSyncOverlayVisible } = storeToRefs(authStore);
const previewItem = ref(null);

const previewSource = computed(() => imgsource(previewItem.value, 'th'));
const previewName = computed(() => previewItem.value?.name || '');

function showLatestItem(payload) {
    if (!loginSyncOverlayVisible.value) return

    const items = Array.isArray(payload) ? payload : [payload];
    previewItem.value = items.filter(Boolean).at(-1) || null;
}

const releaseImageListener = registerMercureEvent('image', showLatestItem);
const releaseMediaListener = registerMercureEvent('media', showLatestItem);

watch(loginSyncOverlayVisible, (visible) => {
    if (visible) previewItem.value = null;
});

onUnmounted(() => {
    releaseImageListener();
    releaseMediaListener();
});

return (_ctx, _cache) => {
  return (unref(loginSyncOverlayVisible))
    ? (openBlock(), createElementBlock("div", _hoisted_1$4, [
        createElementVNode("div", {
          class: normalizeClass(["login-sync-overlay__content", { 'login-sync-overlay__content--with-preview': previewItem.value }])
        }, [
          _cache[0] || (_cache[0] = createElementVNode("div", { class: "login-sync-overlay__title" }, "Synchronisiere Benutzerdaten", -1 /* HOISTED */)),
          createElementVNode("div", _hoisted_2$4, [
            createElementVNode("div", _hoisted_3$4, [
              (previewItem.value)
                ? (openBlock(), createElementBlock("img", {
                    key: 0,
                    src: previewSource.value,
                    alt: previewName.value
                  }, null, 8 /* PROPS */, _hoisted_4$4))
                : createCommentVNode("v-if", true),
              (previewName.value)
                ? (openBlock(), createElementBlock("div", _hoisted_5$4, toDisplayString$1(previewName.value), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ])
          ]),
          _cache[1] || (_cache[1] = createElementVNode("div", {
            class: "login-sync-overlay__progress",
            "aria-hidden": "true"
          }, [
            createElementVNode("div", { class: "login-sync-overlay__progress-bar" })
          ], -1 /* HOISTED */))
        ], 2 /* CLASS */)
      ]))
    : createCommentVNode("v-if", true)
}
}

});

script$4.__scopeId = "data-v-f3ec0788";
script$4.__file = "src/components/LoginSyncOverlay.vue";

const _hoisted_1$3 = { class: "user-address-form uk-card uk-card-default uk-card-body" };
const _hoisted_2$3 = {
  class: "uk-grid-small uk-form-stacked",
  "uk-grid": ""
};
const _hoisted_3$3 = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_4$3 = {
  class: "uk-form-label",
  for: "user-addr-firstname"
};
const _hoisted_5$3 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_6$3 = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_7$3 = {
  class: "uk-form-label",
  for: "user-addr-lastname"
};
const _hoisted_8$3 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_9$3 = { class: "uk-width-1-1" };
const _hoisted_10$3 = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_11$3 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_12$3 = { class: "uk-form-controls uk-width-1-2@s" };
const _hoisted_13$2 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_14$2 = { class: "uk-form-controls uk-width-1-1" };
const _hoisted_15$2 = {
  class: "uk-form-label",
  for: "user-addr-street"
};
const _hoisted_16$2 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_17$1 = { class: "uk-form-controls uk-width-1-1" };
const _hoisted_18$1 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_19$1 = { class: "uk-form-controls uk-width-1-3@s" };
const _hoisted_20 = {
  class: "uk-form-label",
  for: "user-addr-zip"
};
const _hoisted_21 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_22 = { class: "uk-form-controls uk-width-2-3@s" };
const _hoisted_23 = {
  class: "uk-form-label",
  for: "user-addr-city"
};
const _hoisted_24 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_25 = { class: "uk-form-controls uk-width-1-1" };
const _hoisted_26 = {
  class: "uk-form-label",
  for: "user-addr-country"
};
const _hoisted_27 = ["value"];
const _hoisted_28 = {
  key: 0,
  class: "uk-text-danger uk-text-small"
};
const _hoisted_29 = { class: "uk-margin-top" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = ["disabled"];


var script$3 = {
  __name: 'UserAddressForm',
  props: {
    initialAddress: {
        type: Object,
        default: () => ({})
    },
    countries: {
        type: Object,
        default: () => ({})
    },
    saving: {
        type: Boolean,
        default: false
    },
    submitLabel: {
        type: String,
        default: 'Speichern'
    },
    showCancel: {
        type: Boolean,
        default: true
    }
},
  emits: ['submit', 'cancel'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formData = ref({
    firstname: '',
    lastname: '',
    company: '',
    ustid: '',
    street: '',
    supplement: '',
    zip: '',
    city: '',
    countryISO: 'DE'
});

const fieldErrors = ref({});
const showBusinessFields = ref(false);

function normalizeAddressForForm(item = {}) {
    return {
        firstname: String(item.firstname || '').trim(),
        lastname: String(item.lastname || '').trim(),
        company: String(item.company || '').trim(),
        ustid: String(item.ustid || '').trim(),
        street: String(item.street || '').trim(),
        supplement: String(item.supplement || '').trim(),
        zip: String(item.zip || '').trim(),
        city: String(item.city || item.ort || '').trim(),
        countryISO: String(item.countryISO || item.country || 'DE').trim()
    }
}

watch(() => props.initialAddress, (value) => {
    formData.value = normalizeAddressForForm(value || {});
    showBusinessFields.value = Boolean(formData.value.company || formData.value.ustid);
    fieldErrors.value = {};
}, { immediate: true, deep: true });

function validateForm() {
    fieldErrors.value = {};
    try {
        addressSchema.validateSync(formData.value, { abortEarly: false });
        return true
    } catch (validationError) {
        const nextErrors = {};
        if (Array.isArray(validationError?.inner) && validationError.inner.length > 0) {
            validationError.inner.forEach((err) => {
                if (err?.path && !nextErrors[err.path]) {
                    nextErrors[err.path] = err.message;
                }
            });
        } else if (validationError?.path) {
            nextErrors[validationError.path] = validationError.message;
        }
        fieldErrors.value = nextErrors;
        return false
    }
}

function onSubmit() {
    if (!validateForm()) return
    emit('submit', normalizeAddressForForm(formData.value));
}

function onCancel() {
    emit('cancel');
}

function toggleBusinessFields() {
    showBusinessFields.value = !showBusinessFields.value;
    if (!showBusinessFields.value) {
        formData.value.company = '';
        formData.value.ustid = '';
        delete fieldErrors.value.company;
        delete fieldErrors.value.ustid;
    }
}

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$3, [
    createElementVNode("div", _hoisted_2$3, [
      createElementVNode("div", _hoisted_3$3, [
        createElementVNode("label", _hoisted_4$3, toDisplayString$1(_ctx.$t('checkout.addressForm.firstName')), 1 /* TEXT */),
        withDirectives(createElementVNode("input", {
          id: "user-addr-firstname",
          class: "uk-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((formData.value.firstname) = $event)),
          type: "text"
        }, null, 512 /* NEED_PATCH */), [
          [vModelText, formData.value.firstname]
        ]),
        (fieldErrors.value.firstname)
          ? (openBlock(), createElementBlock("div", _hoisted_5$3, toDisplayString$1(fieldErrors.value.firstname), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      createElementVNode("div", _hoisted_6$3, [
        createElementVNode("label", _hoisted_7$3, toDisplayString$1(_ctx.$t('checkout.addressForm.lastName')), 1 /* TEXT */),
        withDirectives(createElementVNode("input", {
          id: "user-addr-lastname",
          class: "uk-input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((formData.value.lastname) = $event)),
          type: "text"
        }, null, 512 /* NEED_PATCH */), [
          [vModelText, formData.value.lastname]
        ]),
        (fieldErrors.value.lastname)
          ? (openBlock(), createElementBlock("div", _hoisted_8$3, toDisplayString$1(fieldErrors.value.lastname), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      createElementVNode("div", _hoisted_9$3, [
        createElementVNode("button", {
          class: "uk-button uk-button-text uk-button-small business-toggle",
          type: "button",
          onClick: toggleBusinessFields
        }, toDisplayString$1(showBusinessFields.value ? 'Firmendaten ausblenden' : 'Firmendaten angeben'), 1 /* TEXT */)
      ]),
      (showBusinessFields.value)
        ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createElementVNode("div", _hoisted_10$3, [
              _cache[9] || (_cache[9] = createElementVNode("label", {
                class: "uk-form-label",
                for: "user-addr-company"
              }, "Firma", -1 /* HOISTED */)),
              withDirectives(createElementVNode("input", {
                id: "user-addr-company",
                class: "uk-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((formData.value.company) = $event)),
                type: "text"
              }, null, 512 /* NEED_PATCH */), [
                [vModelText, formData.value.company]
              ]),
              (fieldErrors.value.company)
                ? (openBlock(), createElementBlock("div", _hoisted_11$3, toDisplayString$1(fieldErrors.value.company), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ]),
            createElementVNode("div", _hoisted_12$3, [
              _cache[10] || (_cache[10] = createElementVNode("label", {
                class: "uk-form-label",
                for: "user-addr-ustid"
              }, "USt-IdNr.", -1 /* HOISTED */)),
              withDirectives(createElementVNode("input", {
                id: "user-addr-ustid",
                class: "uk-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((formData.value.ustid) = $event)),
                type: "text"
              }, null, 512 /* NEED_PATCH */), [
                [vModelText, formData.value.ustid]
              ]),
              (fieldErrors.value.ustid)
                ? (openBlock(), createElementBlock("div", _hoisted_13$2, toDisplayString$1(fieldErrors.value.ustid), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : createCommentVNode("v-if", true),
      createElementVNode("div", _hoisted_14$2, [
        createElementVNode("label", _hoisted_15$2, toDisplayString$1(_ctx.$t('checkout.addressForm.street')), 1 /* TEXT */),
        withDirectives(createElementVNode("input", {
          id: "user-addr-street",
          class: "uk-input",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((formData.value.street) = $event)),
          type: "text"
        }, null, 512 /* NEED_PATCH */), [
          [vModelText, formData.value.street]
        ]),
        (fieldErrors.value.street)
          ? (openBlock(), createElementBlock("div", _hoisted_16$2, toDisplayString$1(fieldErrors.value.street), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      createElementVNode("div", _hoisted_17$1, [
        _cache[11] || (_cache[11] = createElementVNode("label", {
          class: "uk-form-label",
          for: "user-addr-supplement"
        }, "Zusatz (optional)", -1 /* HOISTED */)),
        withDirectives(createElementVNode("input", {
          id: "user-addr-supplement",
          class: "uk-input",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((formData.value.supplement) = $event)),
          type: "text"
        }, null, 512 /* NEED_PATCH */), [
          [vModelText, formData.value.supplement]
        ]),
        (fieldErrors.value.supplement)
          ? (openBlock(), createElementBlock("div", _hoisted_18$1, toDisplayString$1(fieldErrors.value.supplement), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      createElementVNode("div", _hoisted_19$1, [
        createElementVNode("label", _hoisted_20, toDisplayString$1(_ctx.$t('checkout.addressForm.zip')), 1 /* TEXT */),
        withDirectives(createElementVNode("input", {
          id: "user-addr-zip",
          class: "uk-input",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((formData.value.zip) = $event)),
          type: "text"
        }, null, 512 /* NEED_PATCH */), [
          [vModelText, formData.value.zip]
        ]),
        (fieldErrors.value.zip)
          ? (openBlock(), createElementBlock("div", _hoisted_21, toDisplayString$1(fieldErrors.value.zip), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      createElementVNode("div", _hoisted_22, [
        createElementVNode("label", _hoisted_23, toDisplayString$1(_ctx.$t('checkout.addressForm.city')), 1 /* TEXT */),
        withDirectives(createElementVNode("input", {
          id: "user-addr-city",
          class: "uk-input",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((formData.value.city) = $event)),
          type: "text"
        }, null, 512 /* NEED_PATCH */), [
          [vModelText, formData.value.city]
        ]),
        (fieldErrors.value.city)
          ? (openBlock(), createElementBlock("div", _hoisted_24, toDisplayString$1(fieldErrors.value.city), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ]),
      createElementVNode("div", _hoisted_25, [
        createElementVNode("label", _hoisted_26, toDisplayString$1(_ctx.$t('checkout.addressForm.country')), 1 /* TEXT */),
        withDirectives(createElementVNode("select", {
          id: "user-addr-country",
          class: "uk-select",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((formData.value.countryISO) = $event))
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.countries, (country, code) => {
            return (openBlock(), createElementBlock("option", {
              key: code,
              value: code
            }, toDisplayString$1(country), 9 /* TEXT, PROPS */, _hoisted_27))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */), [
          [vModelSelect, formData.value.countryISO]
        ]),
        (fieldErrors.value.countryISO)
          ? (openBlock(), createElementBlock("div", _hoisted_28, toDisplayString$1(fieldErrors.value.countryISO), 1 /* TEXT */))
          : createCommentVNode("v-if", true)
      ])
    ]),
    createElementVNode("div", _hoisted_29, [
      createElementVNode("button", {
        class: "uk-button uk-button-primary uk-button-small",
        onClick: onSubmit,
        disabled: __props.saving
      }, toDisplayString$1(__props.submitLabel), 9 /* TEXT, PROPS */, _hoisted_30),
      (__props.showCancel)
        ? (openBlock(), createElementBlock("button", {
            key: 0,
            class: "uk-button uk-button-default uk-button-small uk-margin-small-left",
            onClick: onCancel,
            disabled: __props.saving
          }, " Abbrechen ", 8 /* PROPS */, _hoisted_31))
        : createCommentVNode("v-if", true)
    ])
  ]))
}
}

};

script$3.__scopeId = "data-v-62cb7d8d";
script$3.__file = "src/components/UserAddressForm.vue";

const _hoisted_1$2 = { class: "uk-card uk-card-body uk-align-center uk-margin-top user-addresses" };
const _hoisted_2$2 = { class: "uk-card-title" };
const _hoisted_3$2 = { class: "uk-margin-bottom" };
const _hoisted_4$2 = ["disabled"];
const _hoisted_5$2 = {
  key: 0,
  class: "uk-margin-small-top form-wrap"
};
const _hoisted_6$2 = {
  key: 0,
  class: "uk-text-center uk-margin"
};
const _hoisted_7$2 = {
  key: 1,
  class: "uk-table uk-table-small uk-table-divider uk-width-1-1"
};
const _hoisted_8$2 = { key: 0 };
const _hoisted_9$2 = { colspan: "2" };
const _hoisted_10$2 = { key: 1 };
const _hoisted_11$2 = { key: 0 };
const _hoisted_12$2 = { key: 1 };
const _hoisted_13$1 = { key: 2 };
const _hoisted_14$1 = {
  key: 3,
  class: "uk-label uk-label-success uk-margin-small-top"
};
const _hoisted_15$1 = { class: "uk-text-right actions-col" };
const _hoisted_16$1 = ["onClick", "disabled"];
const _hoisted_17 = ["onClick", "disabled"];
const _hoisted_18 = ["onClick", "disabled"];
const _hoisted_19 = { key: 0 };


var script$2 = {
  __name: 'UserAddresses',
  setup(__props) {

const alertStore = useAlertStore();
const addresses = ref(new apiResponse([]));
const loading = ref(false);
const saving = ref(false);
const countries = ref({});
const editingSourceId = ref(null);
const showCreateForm = ref(false);
const createDraft = ref({});
const editDraft = ref({});

const visibleAddresses = computed(() => {
    if (!addresses.value?.loaded) return []
    return addresses.value.data().filter((item) => item && item.type !== 'D')
});

function normalizeAddressForForm(item = {}) {
    return {
        firstname: String(item.firstname || '').trim(),
        lastname: String(item.lastname || '').trim(),
        company: String(item.company || '').trim(),
        ustid: String(item.ustid || '').trim(),
        street: String(item.street || '').trim(),
        supplement: String(item.supplement || '').trim(),
        zip: String(item.zip || '').trim(),
        city: String(item.city || item.ort || '').trim(),
        countryISO: String(item.countryISO || item.country || 'DE').trim()
    }
}

function resetCreateForm() {
    showCreateForm.value = false;
    createDraft.value = normalizeAddressForForm();
}

function resetEditForm() {
    editingSourceId.value = null;
    editDraft.value = normalizeAddressForForm();
}

async function loadAddresses() {
    loading.value = true;
    alertStore.clear('addresses');
    try {
        addresses.value = await ppapiClient.get('addresses');
    } catch (e) {
        alertStore.error(e?.message || String(e || 'Adressen konnten nicht geladen werden.'), 'addresses');
    } finally {
        loading.value = false;
    }
}

function getAddressId(item) {
    return item?.id || item?.sid || null
}

async function setAddressType(addressId, type) {
    if (!addressId) return
    await ppapiClient.put(`addresses/${addressId}`, { type });
}

function startCreate() {
    alertStore.clear('addresses');
    resetEditForm();
    createDraft.value = normalizeAddressForForm();
    showCreateForm.value = true;
}

function startEdit(item) {
    alertStore.clear('addresses');
    showCreateForm.value = false;
    editingSourceId.value = getAddressId(item);
    editDraft.value = normalizeAddressForForm(item);
}

function cancelCreate() {
    resetCreateForm();
}

function cancelEdit() {
    resetEditForm();
}

async function markAsStandard(item) {
    const addressId = getAddressId(item);
    if (!addressId) return

    saving.value = true;
    alertStore.clear('addresses');
    try {
        await setAddressType(addressId, 'S');
        await loadAddresses();
        alertStore.success('Adresse wurde als Rechnungsadresse gesetzt.', 'addresses');
    } catch (e) {
        alertStore.error(e?.message || String(e || 'Adresse konnte nicht als Rechnungsadresse gesetzt werden.'), 'addresses');
    } finally {
        saving.value = false;
    }
}

async function markAsDeleted(item) {
    const addressId = getAddressId(item);
    if (!addressId) return

    saving.value = true;
    alertStore.clear('addresses');
    try {
        await setAddressType(addressId, 'D');
        await loadAddresses();
        if (editingSourceId.value === addressId) {
            resetEditForm();
        }
        alertStore.success('Adresse wurde gelöscht.', 'addresses');
    } catch (e) {
        alertStore.error(e?.message || String(e || 'Adresse konnte nicht gelöscht werden.'), 'addresses');
    } finally {
        saving.value = false;
    }
}

function buildCreatePayload(source) {
    const normalized = normalizeAddressForForm(source);
    return {
        firstname: normalized.firstname,
        lastname: normalized.lastname,
        company: normalized.company,
        ustid: normalized.ustid,
        street: normalized.street,
        supplement: normalized.supplement,
        zip: normalized.zip,
        city: normalized.city,
        ort: normalized.city,
        countryISO: normalized.countryISO
    }
}

async function saveAddress(formPayload, sourceId = null) {
    saving.value = true;
    alertStore.clear('addresses');

    try {
        const payload = buildCreatePayload(formPayload);

        if (sourceId) {
            await setAddressType(sourceId, 'D');
        }

        await ppapiClient.post('addresses', payload);
        await loadAddresses();
        resetEditForm();
        resetCreateForm();
        alertStore.success(sourceId
            ? 'Adresse wurde aktualisiert (alte Adresse auf gelöscht gesetzt).'
            : 'Adresse wurde angelegt.', 'addresses');
    } catch (e) {
        alertStore.error(e?.message || String(e || 'Adresse konnte nicht gespeichert werden.'), 'addresses');
    } finally {
        saving.value = false;
    }
}

onBeforeMount(async () => {
    const countryData = await parameter.country;
    if (countryData?.country_list) {
        countries.value = countryData.country_list;
    }
    resetCreateForm();
    resetEditForm();
    await loadAddresses();
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("h4", _hoisted_2$2, toDisplayString$1(_ctx.$t('accountViews.addresses')), 1 /* TEXT */),
    createVNode(script$M, { scope: "addresses" }),
    createElementVNode("div", _hoisted_3$2, [
      createElementVNode("button", {
        class: "uk-button uk-button-small uk-button-default",
        onClick: startCreate,
        disabled: saving.value
      }, " Neue Adresse ", 8 /* PROPS */, _hoisted_4$2),
      (showCreateForm.value)
        ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
            createVNode(script$3, {
              "initial-address": createDraft.value,
              countries: countries.value,
              saving: saving.value,
              "submit-label": "Adresse anlegen",
              onSubmit: _cache[0] || (_cache[0] = (payload) => saveAddress(payload, null)),
              onCancel: cancelCreate
            }, null, 8 /* PROPS */, ["initial-address", "countries", "saving"])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    (loading.value)
      ? (openBlock(), createElementBlock("div", _hoisted_6$2, _cache[1] || (_cache[1] = [
          createElementVNode("div", { "uk-spinner": "ratio: 0.8" }, null, -1 /* HOISTED */)
        ])))
      : (openBlock(), createElementBlock("table", _hoisted_7$2, [
          createElementVNode("tbody", null, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(visibleAddresses.value, (item) => {
              return (openBlock(), createElementBlock(Fragment, {
                key: getAddressId(item)
              }, [
                (editingSourceId.value === getAddressId(item))
                  ? (openBlock(), createElementBlock("tr", _hoisted_8$2, [
                      createElementVNode("td", _hoisted_9$2, [
                        createVNode(script$3, {
                          "initial-address": editDraft.value,
                          countries: countries.value,
                          saving: saving.value,
                          "submit-label": "Änderung speichern",
                          onSubmit: (payload) => saveAddress(payload, getAddressId(item)),
                          onCancel: cancelEdit
                        }, null, 8 /* PROPS */, ["initial-address", "countries", "saving", "onSubmit"])
                      ])
                    ]))
                  : (openBlock(), createElementBlock("tr", _hoisted_10$2, [
                      createElementVNode("td", null, [
                        (item.company)
                          ? (openBlock(), createElementBlock("div", _hoisted_11$2, toDisplayString$1(item.company), 1 /* TEXT */))
                          : createCommentVNode("v-if", true),
                        createElementVNode("div", null, toDisplayString$1(item.firstname) + " " + toDisplayString$1(item.lastname), 1 /* TEXT */),
                        (item.ustid)
                          ? (openBlock(), createElementBlock("div", _hoisted_12$2, "USt-IdNr.: " + toDisplayString$1(item.ustid), 1 /* TEXT */))
                          : createCommentVNode("v-if", true),
                        createElementVNode("div", null, toDisplayString$1(item.street), 1 /* TEXT */),
                        (item.supplement)
                          ? (openBlock(), createElementBlock("div", _hoisted_13$1, toDisplayString$1(item.supplement), 1 /* TEXT */))
                          : createCommentVNode("v-if", true),
                        createElementVNode("div", null, toDisplayString$1(item.zip) + " " + toDisplayString$1(item.city || item.ort), 1 /* TEXT */),
                        createElementVNode("div", null, toDisplayString$1(item.countryISO || item.country), 1 /* TEXT */),
                        (item.type === 'S')
                          ? (openBlock(), createElementBlock("div", _hoisted_14$1, "Rechnungsadresse"))
                          : createCommentVNode("v-if", true)
                      ]),
                      createElementVNode("td", _hoisted_15$1, [
                        createElementVNode("button", {
                          class: "uk-icon-button",
                          "uk-icon": "icon: file-edit",
                          title: 'Bearbeiten',
                          "aria-label": "Bearbeiten",
                          onClick: $event => (startEdit(item)),
                          disabled: saving.value
                        }, null, 8 /* PROPS */, _hoisted_16$1),
                        createElementVNode("button", {
                          class: "uk-icon-button",
                          "uk-icon": "icon: star",
                          title: 'Als Rechnungsadresse setzen',
                          "aria-label": "Als Rechnungsadresse setzen",
                          onClick: $event => (markAsStandard(item)),
                          disabled: saving.value
                        }, null, 8 /* PROPS */, _hoisted_17),
                        createElementVNode("button", {
                          class: "uk-icon-button action-delete",
                          "uk-icon": "icon: trash",
                          title: 'Löschen',
                          "aria-label": "Löschen",
                          onClick: $event => (markAsDeleted(item)),
                          disabled: saving.value
                        }, null, 8 /* PROPS */, _hoisted_18)
                      ])
                    ]))
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */)),
            (visibleAddresses.value.length === 0)
              ? (openBlock(), createElementBlock("tr", _hoisted_19, _cache[2] || (_cache[2] = [
                  createElementVNode("td", {
                    colspan: "2",
                    class: "uk-text-muted"
                  }, "Keine aktiven Adressen vorhanden.", -1 /* HOISTED */)
                ])))
              : createCommentVNode("v-if", true)
          ])
        ]))
  ]))
}
}

};

script$2.__scopeId = "data-v-063636d2";
script$2.__file = "src/components/UserAddresses.vue";

const _hoisted_1$1 = { class: "user-details uk-card uk-card-default uk-card-body uk-align-center uk-margin-top" };
const _hoisted_2$1 = { class: "uk-card-title" };
const _hoisted_3$1 = {
  key: 0,
  class: "uk-text-muted"
};
const _hoisted_4$1 = {
  key: 1,
  class: "uk-alert-danger",
  "uk-alert": ""
};
const _hoisted_5$1 = {
  key: 2,
  class: "user-details-grid"
};
const _hoisted_6$1 = { key: 0 };
const _hoisted_7$1 = { key: 1 };
const _hoisted_8$1 = {
  key: 2,
  class: "activation-form-spacer"
};
const _hoisted_9$1 = {
  key: 3,
  class: "activation-form"
};
const _hoisted_10$1 = { class: "activation-row" };
const _hoisted_11$1 = ["disabled"];
const _hoisted_12$1 = {
  key: 0,
  class: "activation-error"
};
const _hoisted_13 = {
  key: 1,
  class: "activation-success"
};
const _hoisted_14 = { key: 4 };
const _hoisted_15 = {
  key: 5,
  class: "alert"
};
const _hoisted_16 = {
  key: 3,
  class: "uk-text-muted"
};



var script$1 = {
  __name: 'UserDetails',
  setup(__props) {

const { t } = useI18n();

const loading = ref(false);
const error = ref('');
const user = ref(null);
const showActivationForm = ref(false);
const activationCode = ref('');
const activating = ref(false);
const activationError = ref('');
const activationSuccess = ref('');

const salutation = computed(() => {
	if (!user.value?.gender) return '-'
	return user.value.gender === 'm' ? t('account.salutationMr') : (user.value.gender === 'f' ? t('account.salutationMs') : '-')
});

const activeText = computed(() => {
	if (typeof user.value?.isActive === 'boolean') return user.value.isActive ? t('yes') : t('no')
	return '-'
});

function getValue(value) {
	if (value === null || typeof value === 'undefined' || value === '') return '-'
	return value
}

function openActivationForm() {
	showActivationForm.value = true;
	activationError.value = '';
	activationSuccess.value = '';
}

async function activateUser() {
	if (!activationCode.value.trim()) {
		activationError.value = 'Bitte Freischaltcode eingeben.';
		activationSuccess.value = '';
		return
	}

	if (!user.value?.email) {
		activationError.value = 'Keine E-Mail-Adresse vorhanden.';
		activationSuccess.value = '';
		return
	}

	activating.value = true;
	activationError.value = '';
	activationSuccess.value = '';

	try {
		await ppapiClient.post('activate', {
			email: user.value.email,
			code: activationCode.value.trim(),
		});

		activationCode.value = '';
		showActivationForm.value = false;
		activationSuccess.value = 'Nutzer wurde erfolgreich freigeschaltet.';
		await loadUser();
	} catch (err) {
		activationError.value = typeof err === 'string' ? err : (err?.message || 'Freischaltung fehlgeschlagen.');
	} finally {
		activating.value = false;
	}
}

async function loadUser() {
	loading.value = true;
	error.value = '';

	try {
		user.value = await ppapiClient.get('user');
	} catch (err) {
		error.value = typeof err === 'string' ? err : (err?.message || 'Nutzerdaten konnten nicht geladen werden.');
		user.value = null;
	} finally {
		loading.value = false;
	}
}

onMounted(() => {
	loadUser();
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1$1, [
    createElementVNode("div", _hoisted_2$1, toDisplayString$1(unref(t)('accountViews.userDetails')), 1 /* TEXT */),
    (loading.value)
      ? (openBlock(), createElementBlock("div", _hoisted_3$1, toDisplayString$1(unref(t)('loadingUserData')), 1 /* TEXT */))
      : (error.value)
        ? (openBlock(), createElementBlock("div", _hoisted_4$1, toDisplayString$1(error.value), 1 /* TEXT */))
        : (user.value)
          ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.customerId')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.kid)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.username')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.username)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.email')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.email)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.firstname')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.firstname)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.lastname')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.lastname)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.title')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.title)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.salutation')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(salutation.value), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.company')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.company)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.supplement')), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(getValue(user.value.supplement)), 1 /* TEXT */),
              createElementVNode("div", null, toDisplayString$1(_ctx.$t('account.active')), 1 /* TEXT */),
              createElementVNode("div", null, [
                createTextVNode(toDisplayString$1(activeText.value) + " ", 1 /* TEXT */),
                (user.value.isActive === false)
                  ? (openBlock(), createElementBlock("a", {
                      key: 0,
                      href: "#",
                      class: "activate-link",
                      onClick: withModifiers(openActivationForm, ["prevent"])
                    }, " jetzt freischalten "))
                  : createCommentVNode("v-if", true)
              ]),
              (user.value.isActive)
                ? (openBlock(), createElementBlock("div", _hoisted_6$1))
                : createCommentVNode("v-if", true),
              (user.value.isActive)
                ? (openBlock(), createElementBlock("div", _hoisted_7$1, toDisplayString$1(_ctx.$t('account.userIsActiveText')), 1 /* TEXT */))
                : createCommentVNode("v-if", true),
              (!user.value.isActive && showActivationForm.value)
                ? (openBlock(), createElementBlock("div", _hoisted_8$1))
                : createCommentVNode("v-if", true),
              (!user.value.isActive && showActivationForm.value)
                ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
                    createElementVNode("div", _hoisted_10$1, [
                      withDirectives(createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((activationCode).value = $event)),
                        type: "text",
                        class: "uk-input uk-form-small",
                        placeholder: "Freischaltcode",
                        onKeyup: withKeys(activateUser, ["enter"])
                      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                        [vModelText, activationCode.value]
                      ]),
                      createElementVNode("button", {
                        type: "button",
                        class: "uk-button uk-button-primary uk-button-small",
                        disabled: activating.value,
                        onClick: activateUser
                      }, toDisplayString$1(activating.value ? '...' : 'freischalten'), 9 /* TEXT, PROPS */, _hoisted_11$1)
                    ]),
                    (activationError.value)
                      ? (openBlock(), createElementBlock("div", _hoisted_12$1, toDisplayString$1(activationError.value), 1 /* TEXT */))
                      : createCommentVNode("v-if", true),
                    (activationSuccess.value)
                      ? (openBlock(), createElementBlock("div", _hoisted_13, toDisplayString$1(activationSuccess.value), 1 /* TEXT */))
                      : createCommentVNode("v-if", true)
                  ]))
                : createCommentVNode("v-if", true),
              (!user.value.isActive && !showActivationForm.value)
                ? (openBlock(), createElementBlock("div", _hoisted_14))
                : createCommentVNode("v-if", true),
              (!user.value.isActive && !showActivationForm.value)
                ? (openBlock(), createElementBlock("div", _hoisted_15, toDisplayString$1(_ctx.$t('account.userIsInactiveText')), 1 /* TEXT */))
                : createCommentVNode("v-if", true)
            ]))
          : (openBlock(), createElementBlock("div", _hoisted_16, "Keine Nutzerdaten vorhanden."))
  ]))
}
}

};

script$1.__file = "src/components/UserDetails.vue";

const _hoisted_1 = { class: "user-activate uk-card uk-card-default uk-card-body uk-align-center uk-margin-top" };
const _hoisted_2 = { class: "uk-form-stacked activation-form" };
const _hoisted_3 = {
  key: 0,
  class: "uk-margin-small"
};
const _hoisted_4 = { class: "uk-form-controls" };
const _hoisted_5 = {
  key: 1,
  class: "uk-margin-small"
};
const _hoisted_6 = { class: "uk-form-controls" };
const _hoisted_7 = {
  key: 2,
  class: "uk-margin-small"
};
const _hoisted_8 = { class: "uk-form-controls" };
const _hoisted_9 = {
  key: 3,
  class: "uk-margin-top"
};
const _hoisted_10 = ["disabled"];
const _hoisted_11 = {
  key: 4,
  class: "uk-text-danger uk-margin-small-top"
};
const _hoisted_12 = {
  key: 5,
  class: "uk-text-success uk-margin-small-top"
};


var script = {
  __name: 'UserActivate',
  setup(__props) {

const route = useRoute();
const authStore = useAuthStore();

const activating = ref(false);
const activationError = ref('');
const activationSuccess = ref('');
const autoActivationTried = ref(false);
const tokenProvidedByUrl = ref(false);

const email = ref('');
const token = ref('');
const password = ref('');

const currentUserEmail = computed(() => String(authStore.user?.email || '').trim().toLowerCase());
const loggedIn = computed(() => !!authStore.user?.token);

function getQueryValue(value) {
    if (Array.isArray(value)) return value[0] || ''
    return value || ''
}

function applyQueryDefaults() {
    const emailFromQuery = String(getQueryValue(route.query.email)).trim();
    const tokenFromQuery = String(getQueryValue(route.query.code)).trim();
    tokenProvidedByUrl.value = tokenFromQuery.length > 0;

    if (emailFromQuery) email.value = emailFromQuery;
    if (tokenFromQuery) token.value = tokenFromQuery;
}

const hideTokenField = computed(() => tokenProvidedByUrl.value);

const hideEmailField = computed(() => {
    const normalizedFormEmail = email.value.trim().toLowerCase();
    if (!normalizedFormEmail || !currentUserEmail.value) return false
    return loggedIn.value && normalizedFormEmail === currentUserEmail.value
});

function buildActivatePayload() {
    return {
        email: email.value.trim(),
        code: token.value.trim(),
    }
}

function validateForm() {
    if (!email.value.trim()) return 'Bitte Email angeben.'
    if (!token.value.trim()) return 'Bitte Freischalttoken angeben.'
    if (!loggedIn.value && !password.value) return 'Bitte Passwort angeben.'
    return ''
}

async function activateUser() {
    const validationError = validateForm();
    if (validationError) {
        activationError.value = validationError;
        activationSuccess.value = '';
        return
    }

    activating.value = true;
    activationError.value = '';
    activationSuccess.value = '';

    try {
        if (!loggedIn.value) {
            const loginResult = await authStore.login(email.value.trim(), password.value);
            if (!loginResult?.token && !loginResult?.kid) {
                throw new Error('Login fehlgeschlagen.')
            }
        }

        const payload = buildActivatePayload();
        const response = await ppapiClient.post('activate', payload);

        if (response?.token && response?.kid) {
            authStore.storeUser(response);
        }

        activationSuccess.value = response?.message || 'Nutzer wurde erfolgreich freigeschaltet.';
    } catch (err) {
        activationError.value = typeof err === 'string' ? err : (err?.message || 'Freischaltung fehlgeschlagen.');
    } finally {
        activating.value = false;
    }
}

async function maybeAutoActivate() {
    if (autoActivationTried.value) return
    if (!hideEmailField.value) return
    if (!hideTokenField.value) return

    autoActivationTried.value = true;
    await activateUser();
}

onMounted(async () => {
    applyQueryDefaults();
    await maybeAutoActivate();
});

watch(() => route.query, () => {
    applyQueryDefaults();
    maybeAutoActivate();
}, { deep: true });

watch([hideEmailField, hideTokenField], () => {
    maybeAutoActivate();
});

return (_ctx, _cache) => {
  return (openBlock(), createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = createElementVNode("h3", { class: "uk-card-title" }, "Konto freischalten", -1 /* HOISTED */)),
    createElementVNode("div", _hoisted_2, [
      (!hideEmailField.value)
        ? (openBlock(), createElementBlock("div", _hoisted_3, [
            _cache[3] || (_cache[3] = createElementVNode("label", {
              class: "uk-form-label",
              for: "activate-email"
            }, "E-Mail", -1 /* HOISTED */)),
            createElementVNode("div", _hoisted_4, [
              withDirectives(createElementVNode("input", {
                id: "activate-email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((email).value = $event)),
                type: "email",
                class: "uk-input",
                autocomplete: "email"
              }, null, 512 /* NEED_PATCH */), [
                [vModelText, email.value]
              ])
            ])
          ]))
        : createCommentVNode("v-if", true),
      (!hideTokenField.value)
        ? (openBlock(), createElementBlock("div", _hoisted_5, [
            _cache[4] || (_cache[4] = createElementVNode("label", {
              class: "uk-form-label",
              for: "activate-token"
            }, "Freischalttoken", -1 /* HOISTED */)),
            createElementVNode("div", _hoisted_6, [
              withDirectives(createElementVNode("input", {
                id: "activate-token",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((token).value = $event)),
                type: "text",
                class: "uk-input",
                autocomplete: "off"
              }, null, 512 /* NEED_PATCH */), [
                [vModelText, token.value]
              ])
            ])
          ]))
        : createCommentVNode("v-if", true),
      (!loggedIn.value)
        ? (openBlock(), createElementBlock("div", _hoisted_7, [
            _cache[5] || (_cache[5] = createElementVNode("label", {
              class: "uk-form-label",
              for: "activate-password"
            }, "Passwort", -1 /* HOISTED */)),
            createElementVNode("div", _hoisted_8, [
              withDirectives(createElementVNode("input", {
                id: "activate-password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((password).value = $event)),
                type: "password",
                class: "uk-input",
                autocomplete: "current-password"
              }, null, 512 /* NEED_PATCH */), [
                [vModelText, password.value]
              ])
            ])
          ]))
        : createCommentVNode("v-if", true),
      (!activationSuccess.value)
        ? (openBlock(), createElementBlock("div", _hoisted_9, [
            createElementVNode("button", {
              type: "button",
              class: "uk-button uk-button-primary",
              disabled: activating.value,
              onClick: activateUser
            }, toDisplayString$1(activating.value ? 'Freischaltung läuft...' : 'Jetzt freischalten'), 9 /* TEXT, PROPS */, _hoisted_10)
          ]))
        : createCommentVNode("v-if", true),
      (activationError.value)
        ? (openBlock(), createElementBlock("div", _hoisted_11, toDisplayString$1(activationError.value), 1 /* TEXT */))
        : createCommentVNode("v-if", true),
      (activationSuccess.value)
        ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString$1(activationSuccess.value), 1 /* TEXT */))
        : createCommentVNode("v-if", true)
    ])
  ]))
}
}

};

script.__scopeId = "data-v-3b4cc1e4";
script.__file = "src/components/UserActivate.vue";

export { script$8 as A, script$7 as B, script$6 as C, script$5 as D, script$4 as E, script$2 as F, script$3 as G, script$1 as H, script as I, script$K as J, script$J as K, script$I as L, script$H as M, script$G as N, script$F as O, script$E as P, useI18n as Q, script$L as a, script$D as b, script$C as c, script$B as d, script$A as e, script$z as f, script$x as g, script$w as h, script$v as i, script$u as j, script$t as k, script$l as l, script$k as m, script$y as n, script$j as o, script$i as p, script$h as q, script$g as r, script$M as s, script$f as t, script$e as u, script$d as v, script$c as w, script$b as x, script$a as y, script$9 as z };
